webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

        this.apiToken = '$2y$10$0JXSvkSvP1hPKTheUBvQcewPYjl2Q0wZmhMuCdPhNJPhqFZ.stKo2';
        this.market_app_name = "lookbookgallery";
        this.app_url = "https://lookbookgallery.com";
        this.app_name = "Lookbook Gallery";
        this.sp_url = "https://wspk.herokuapp.com";
        this.siteUrl = 'http://share.sellpoints.com.ng/';
        this.video_exts = ['mp4', 'mp3'];
        this.general_banner_image = "/static/assets/images/banner-general.jpg";
        this.upload_wait_period = 60000;
        this.max_media_upload = "7MB";
        this.baseURL = 'https://spattle.afiahub.com/api/';

        this.imageSellpointsURL = '';
        this.imageProductsURL = '';
        this.imageUsersURL = '';
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: "getStates",
        value: function getStates(context, id) {
            return context.$http.get(this.baseURL + 'states', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getCities",
        value: function getCities(context, id) {
            return context.$http.get(this.baseURL + 'cities/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "regUser",
        value: function regUser(context, data) {
            return context.$http.post(this.baseURL + 'users', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "loginUser",
        value: function loginUser(context, data) {
            return context.$http.post(this.baseURL + 'users/login', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "activateUserToken",
        value: function activateUserToken(context, id) {
            return context.$http.get(this.baseURL + 'settings/activate/user/token/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "forgotPassword",
        value: function forgotPassword(context, data) {
            return context.$http.post(this.baseURL + 'settings/password/forgot', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "verifyResetPasswordToken",
        value: function verifyResetPasswordToken(context, id) {
            return context.$http.get(this.baseURL + 'settings/verify/reset/token/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "resetForgotPassword",
        value: function resetForgotPassword(context, data) {
            return context.$http.post(this.baseURL + 'settings/password/forgot/reset', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "resetPassword",
        value: function resetPassword(context, data) {
            return context.$http.post(this.baseURL + 'settings/password/reset', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "changeEmail",
        value: function changeEmail(context, data) {
            return context.$http.post(this.baseURL + 'settings/email/reset', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "sessionGuard",
        value: function sessionGuard(context, data) {
            return context.$http.post(this.baseURL + 'auth/sessions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "sessionSyncSet",
        value: function sessionSyncSet(context, id) {
            return context.$http.get(this.baseURL + 'auth/sessions/sync/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "sessionSync",
        value: function sessionSync(context, data) {
            return context.$http.post(this.baseURL + 'auth/sessions/sync', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "checkUserDetails",
        value: function checkUserDetails(context, data) {
            return context.$http.post(this.baseURL + 'users/checks', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProfileDetails",
        value: function editProfileDetails(context, data) {
            return context.$http.put(this.baseURL + 'users', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "makeAppSubscriptionOrder",
        value: function makeAppSubscriptionOrder(context, data) {
            return context.$http.post(this.baseURL + 'app/businesses/subscription/orders', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "updateAppSubscriptionOrder",
        value: function updateAppSubscriptionOrder(context, data) {
            return context.$http.post(this.baseURL + 'app/businesses/subscription/orders/updates', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "can_edit",
        value: function can_edit(context, data) {
            return context.$http.post(this.baseURL + 'auth/validate/ownership', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessMarket",
        value: function getBusinessMarket(context, id) {
            return context.$http.get(this.baseURL + 'businesses/markets/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinesses",
        value: function getBusinesses(context, id) {
            return context.$http.get(this.baseURL + 'businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppBusinesses",
        value: function getAppBusinesses(context, id) {
            return context.$http.get(this.baseURL + 'app/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessByUserName",
        value: function getBusinessByUserName(context, id) {
            return context.$http.get(this.baseURL + 'businesses/usernames/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppBusinessByUserName",
        value: function getAppBusinessByUserName(context, id) {
            return context.$http.get(this.baseURL + 'app/businesses/usernames/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessProducts",
        value: function getBusinessProducts(context, id) {
            return context.$http.get(this.baseURL + 'products/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppProducts",
        value: function getAppProducts(context, id, limit) {
            return context.$http.get(this.baseURL + 'products/markets/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppBusinessProducts",
        value: function getAppBusinessProducts(context, id, limit) {
            return context.$http.get(this.baseURL + 'products/app/businesses/' + id + '/' + limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addNewBusiness",
        value: function addNewBusiness(context, data) {
            return context.$http.post(this.baseURL + 'businesses/new', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addExistingBusiness",
        value: function addExistingBusiness(context, data) {
            return context.$http.post(this.baseURL + 'businesses/existing', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "validateBusinessUserName",
        value: function validateBusinessUserName(context, data) {
            return context.$http.post(this.baseURL + 'businesses/validate/username', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessMarketUpgradeDetails",
        value: function getBusinessMarketUpgradeDetails(context, id) {
            return context.$http.get(this.baseURL + 'app/businesses/markets/upgrades/' + id, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "upgradeBusinessMarketSubscription",
        value: function upgradeBusinessMarketSubscription(context, data) {
            return context.$http.post(this.baseURL + 'app/businesses/markets/upgrades', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "getCategories",
        value: function getCategories(context) {
            return context.$http.get(this.baseURL + 'categories', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getMainCategories",
        value: function getMainCategories(context, id) {
            return context.$http.get(this.baseURL + 'categories/main/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessSubCategories",
        value: function getBusinessSubCategories(context, id) {
            return context.$http.get(this.baseURL + 'categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessCategories",
        value: function getBusinessCategories(context, id) {
            return context.$http.get(this.baseURL + 'businesses/categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addGallery",
        value: function addGallery(context, data) {
            return context.$http.post(this.baseURL + 'posts/gallery', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "getPointGalleryPosts",
        value: function getPointGalleryPosts(context, id, offset, limit, posts_offset, posts_limit) {
            return context.$http.get(this.baseURL + 'posts/gallery/points/' + id + '/' + offset + '/' + limit + '/' + posts_offset + '/' + posts_limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getGallerySearch",
        value: function getGallerySearch(context, id) {
            return context.$http.get(this.baseURL + 'posts/gallery/url/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editBusinessDetails",
        value: function editBusinessDetails(context, data) {
            return context.$http.put(this.baseURL + 'businesses/details', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setShippingFeeStatus",
        value: function setShippingFeeStatus(context, data) {
            return context.$http.put(this.baseURL + 'businesses/setshippingfeestatus', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addDeliveryOption",
        value: function addDeliveryOption(context, data) {
            return context.$http.post(this.baseURL + 'businesses/deliveryoptions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editDeliveryOption",
        value: function editDeliveryOption(context, data) {
            return context.$http.put(this.baseURL + 'businesses/deliveryoptions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteDeliveryOption",
        value: function deleteDeliveryOption(context, id, data) {
            return context.$http.put(this.baseURL + 'businesses/deliveryoptions/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "switchProcessingFeePay",
        value: function switchProcessingFeePay(context, data) {
            return context.$http.put(this.baseURL + 'businesses/processingfees', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "postBusinessProcessingFeeTransactions",
        value: function postBusinessProcessingFeeTransactions(context, data) {
            return context.$http.post(this.baseURL + 'businesses/processingfees/transactions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessProcessingFeesTransactions",
        value: function getBusinessProcessingFeesTransactions(context, id, offset, limit) {
            return context.$http.get(this.baseURL + 'businesses/processingfees/transactions/' + id + '/' + offset, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessDiscountsAndCoupons",
        value: function getBusinessDiscountsAndCoupons(context, id) {
            return context.$http.get(this.baseURL + 'businesses/discounts/coupons/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setDiscountsAndCoupons",
        value: function setDiscountsAndCoupons(context, data) {
            return context.$http.post(this.baseURL + 'businesses/discounts/coupons', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editDiscountsAndCoupons",
        value: function editDiscountsAndCoupons(context, data) {
            return context.$http.put(this.baseURL + 'businesses/discounts/coupons', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deactivateDiscountsAndCoupons",
        value: function deactivateDiscountsAndCoupons(context, data) {
            return context.$http.put(this.baseURL + 'businesses/discounts/coupons/deactivate', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProductImages",
        value: function getProductImages(context, id) {
            return context.$http.get(this.baseURL + 'products/images/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteProductImage",
        value: function deleteProductImage(context, id) {
            return context.$http.delete(this.baseURL + 'products/images/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "uploadDataPhoto",
        value: function uploadDataPhoto(context, data) {
            return context.$http.post(this.baseURL + 'uploads', data, {
                headers: {
                    'Origin-Host': this.apiToken,
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
    }, {
        key: "uploadBusinessDataPhoto",
        value: function uploadBusinessDataPhoto(context, data) {
            return context.$http.post(this.baseURL + 'businesses/uploads', data, {
                headers: {
                    'Origin-Host': this.apiToken,
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
    }, {
        key: "getUser",
        value: function getUser(context, id) {
            return context.$http.get(this.baseURL + 'users/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProductsInBusinessCategories",
        value: function getProductsInBusinessCategories(context, id) {
            return context.$http.get(this.baseURL + 'products/businesses/categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getMarketCategories",
        value: function getMarketCategories(context) {
            return context.$http.get(this.baseURL + 'market/categories', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getFilters",
        value: function getFilters(context) {
            return context.$http.get(this.baseURL + 'filters', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addBusiness",
        value: function addBusiness(context, data) {
            return context.$http.post(this.baseURL + 'businesses', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessNotifications",
        value: function getBusinessNotifications(context, id) {
            return context.$http.get(this.baseURL + 'notifications/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessMessages",
        value: function getBusinessMessages(context, id) {
            return context.$http.get(this.baseURL + 'messages/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessOrders",
        value: function getBusinessOrders(context, id) {
            return context.$http.get(this.baseURL + 'orders/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "readNotifications",
        value: function readNotifications(context, data) {
            return context.$http.post(this.baseURL + 'notifications/general/updates', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addCategory",
        value: function addCategory(context, data) {
            return context.$http.post(this.baseURL + 'businesses/categories', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editCategory",
        value: function editCategory(context, data) {
            return context.$http.put(this.baseURL + 'businesses/categories', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProducts",
        value: function getProducts(context, offset, limit) {
            return context.$http.get(this.baseURL + 'products/all/' + offset + '/' + limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getMarketProducts",
        value: function getMarketProducts(context, id) {
            return context.$http.get(this.baseURL + 'products/markets/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getMarketActivityProducts",
        value: function getMarketActivityProducts(context, id, offset, limit) {
            return context.$http.get(this.baseURL + 'products/markets/activities/' + id + '/' + offset + '/' + limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessMarket",
        value: function getBusinessMarket(context, id) {
            return context.$http.get(this.baseURL + 'businesses/markets/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getCategoryProducts",
        value: function getCategoryProducts(context, id) {
            return context.$http.get(this.baseURL + 'products/categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessesOpenAgentsCategoryProducts",
        value: function getBusinessesOpenAgentsCategoryProducts(context, data) {
            return context.$http.post(this.baseURL + 'products/businesses/agents/categories', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessesOpenAgentsProducts",
        value: function getBusinessesOpenAgentsProducts(context) {
            return context.$http.get(this.baseURL + 'products/agents/businesses', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAgentsBusinessCategoryProducts",
        value: function getAgentsBusinessCategoryProducts(context, id) {
            return context.$http.get(this.baseURL + 'products/agents/business/categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "searchCategoryProducts",
        value: function searchCategoryProducts(context, name, type) {
            return context.$http.get(this.baseURL + 'products/search/categories/' + name + '/' + type, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "searchProducts",
        value: function searchProducts(context, search) {
            return context.$http.get(this.baseURL + 'products/search/' + search, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "searchBusinessProducts",
        value: function searchBusinessProducts(context, search) {
            return context.$http.get(this.baseURL + 'products/search/businesses/' + search, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProductSearch",
        value: function getProductSearch(context, id) {
            return context.$http.get(this.baseURL + 'products/product/url/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addProduct",
        value: function addProduct(context, data) {
            return context.$http.post(this.baseURL + 'products', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "addProductItem",
        value: function addProductItem(context, data) {
            return context.$http.post(this.baseURL + 'products/items', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addAgentProduct",
        value: function addAgentProduct(context, data) {
            return context.$http.post(this.baseURL + 'products/agents', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "addProductDetail",
        value: function addProductDetail(context, data) {
            return context.$http.post(this.baseURL + 'products/details', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "addProductReview",
        value: function addProductReview(context, data) {
            return context.$http.post(this.baseURL + 'products/reviews', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "editProduct",
        value: function editProduct(context, id, data) {
            return context.$http.put(this.baseURL + 'products/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProductSettings",
        value: function editProductSettings(context, id, data) {
            return context.$http.put(this.baseURL + 'products/settings/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProductItemSingle",
        value: function editProductItemSingle(context, id, data) {
            return context.$http.put(this.baseURL + 'products/items/singles/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProductItem",
        value: function editProductItem(context, id, data) {
            return context.$http.put(this.baseURL + 'products/items/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "removeProductItem",
        value: function removeProductItem(context, id, data) {
            return context.$http.put(this.baseURL + 'products/items/remove/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProductItemGroup",
        value: function editProductItemGroup(context, id, data) {
            return context.$http.put(this.baseURL + 'products/itemgroups/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "removeProductItemGroup",
        value: function removeProductItemGroup(context, id, data) {
            return context.$http.put(this.baseURL + 'products/itemgroups/remove/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "removeProduct",
        value: function removeProduct(context, id, data) {
            return context.$http.put(this.baseURL + 'products/remove/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProductDetail",
        value: function editProductDetail(context, id, data) {
            return context.$http.put(this.baseURL + 'products/details/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteProductDetail",
        value: function deleteProductDetail(context, id, data) {
            return context.$http.delete(this.baseURL + 'products/details/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProductDeliveryOptions",
        value: function getProductDeliveryOptions(context, id) {
            return context.$http.get(this.baseURL + 'products/delivery/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setProductDelivery",
        value: function setProductDelivery(context, id, data) {
            return context.$http.put(this.baseURL + 'products/delivery/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setProductShippingFeeStatus",
        value: function setProductShippingFeeStatus(context, data) {
            return context.$http.put(this.baseURL + 'products/set/shippingfeestatus', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setProductDeliveryOption",
        value: function setProductDeliveryOption(context, data) {
            return context.$http.post(this.baseURL + 'products/delivery/fees', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProductInformation",
        value: function getProductInformation(context, id) {
            return context.$http.get(this.baseURL + 'products/information/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addProductInformation",
        value: function addProductInformation(context, data) {
            return context.$http.post(this.baseURL + 'products/information', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "editProductInformation",
        value: function editProductInformation(context, id, data) {
            return context.$http.put(this.baseURL + 'products/information/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteProductInformation",
        value: function deleteProductInformation(context, id, data) {
            return context.$http.delete(this.baseURL + 'products/information/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editGallery",
        value: function editGallery(context, id, data) {
            return context.$http.put(this.baseURL + 'posts/gallery/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteGallery",
        value: function deleteGallery(context, id) {
            return context.$http.delete(this.baseURL + 'posts/gallery/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editGalleryPost",
        value: function editGalleryPost(context, id, data) {
            return context.$http.put(this.baseURL + 'posts/gallery/posts/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteGalleryPost",
        value: function deleteGalleryPost(context, id) {
            return context.$http.delete(this.baseURL + 'posts/gallery/posts/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "resetData",
        value: function resetData(context, type, id) {
            return context.$http.get(this.baseURL + 'data/reset/' + type + '/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteImages",
        value: function deleteImages(context, id, data) {
            return context.$http.put(this.baseURL + 'data/images/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "checkout",
        value: function checkout(context, data) {
            return context.$http.post(this.baseURL + 'orders', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getCheckoutOrder",
        value: function getCheckoutOrder(context, url) {
            return context.$http.get(this.baseURL + 'orders/url/' + url, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getCheckoutOrders",
        value: function getCheckoutOrders(context, id) {
            return context.$http.get(this.baseURL + 'orders/topays/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getUserDeliveryDetails",
        value: function getUserDeliveryDetails(context, id) {
            return context.$http.get(this.baseURL + 'users/deliverydetails/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "updatePayment",
        value: function updatePayment(context, data) {
            return context.$http.post(this.baseURL + 'payments', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getOrders",
        value: function getOrders(context, id) {
            return context.$http.get(this.baseURL + 'orders/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addService",
        value: function addService(context, data) {
            return context.$http.post(this.baseURL + 'businesses/services', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editService",
        value: function editService(context, data) {
            return context.$http.put(this.baseURL + 'businesses/services', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessDeliveryOptions",
        value: function getBusinessDeliveryOptions(context, id) {
            return context.$http.get(this.baseURL + 'businesses/deliveryoptions/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "checkBusinessPayOnDelivery",
        value: function checkBusinessPayOnDelivery(context, id) {
            return context.$http.get(this.baseURL + 'businesses/checkdeliveryoptions/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "sendBusinessContactForm",
        value: function sendBusinessContactForm(context, data) {
            return context.$http.post(this.baseURL + 'businesses/contacts', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setBusinessFilterOptions",
        value: function setBusinessFilterOptions(context, data) {
            return context.$http.put(this.baseURL + 'businesses/filters', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "removeBusinessFilterOption",
        value: function removeBusinessFilterOption(context, data) {
            return context.$http.post(this.baseURL + 'businesses/filters', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setBusinessBankDetails",
        value: function setBusinessBankDetails(context, data) {
            return context.$http.put(this.baseURL + 'businesses/bankdetails', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "postBusinessGeneralOrders",
        value: function postBusinessGeneralOrders(context, data) {
            return context.$http.post(this.baseURL + 'orders/generalorders', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(207)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(266),
  /* scopeId */
  "data-v-8d2a89aa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(208)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(267),
  /* scopeId */
  "data-v-90aa3cc6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_SELLPOINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ALL_SELLPOINTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ALL_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ALL_PRODUCTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PRODUCT_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PRODUCT_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return VIEW_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ADD_TO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return REMOVE_FROM_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ERROR_MSG; });
/* unused harmony export SUCCESS_MSG */
var ALL_SELLPOINTS = 'ALL_SELLPOINTS';
var ALL_SELLPOINTS_SUCCESS = 'ALL_SELLPOINTS_SUCCESS';

var ALL_PRODUCTS = 'ALL_PRODUCTS';
var ALL_PRODUCTS_SUCCESS = 'ALL_PRODUCTS_SUCCESS';

var PRODUCT_BY_ID = 'PRODUCT_BY_ID';
var PRODUCT_BY_ID_SUCCESS = 'PRODUCT_BY_ID_SUCCESS';

var VIEW_CART = 'VIEW_CART';
var ADD_TO_CART = 'ADD_TO_CART';
var REMOVE_FROM_CART = 'REMOVE_FROM_CART';

var ERROR_MSG = 'ERROR_MSG';
var SUCCESS_MSG = 'SUCCESS_MSG';

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(272),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(275),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(256),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: "validate_array",
        value: function validate_array(str_array, error_msg) {
            var process_errors = [];

            var reg_num = /^[0-9]+$/;
            var reg_name = /^[\w\-\s]+$/;
            var reg_email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var reg_phone = /^\d{4}\d{3}\d{4}$/;

            for (var i = 0; i < str_array.length; i++) {
                var arr_in_str_array = str_array[i];
                if (arr_in_str_array[1] == undefined || arr_in_str_array[1] == "") {
                    process_errors.push(error_msg + arr_in_str_array[0]);

                    if (arr_in_str_array[2] == "alpha") {
                        if (!reg_name.test(arr_in_str_array[1])) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }

                    if (arr_in_str_array[2] == "num") {
                        if (!reg_num.test(arr_in_str_array[1])) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }

                    if (arr_in_str_array[2] == "email") {
                        if (!reg_email.test(String(arr_in_str_array[1]).toLowerCase())) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }

                    if (arr_in_str_array[2] == "phone") {
                        if (!reg_phone.test(arr_in_str_array[1])) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }
                }
            }

            return process_errors;
        }
    }, {
        key: "validateEmail",
        value: function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
    }, {
        key: "validateName",
        value: function validateName(name) {
            var re = /^[\w\-\s]+$/;
            return re.test(name);
        }
    }, {
        key: "validatePhoneNumber",
        value: function validatePhoneNumber(phone) {
            var re = /^\d{4}\d{3}\d{4}$/;
            return re.test(phone);
        }
    }, {
        key: "validateWebsite",
        value: function validateWebsite(url) {
            var re = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
            return re.test(url);
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(194)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(250),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(203)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(262),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(197)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(253),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(193)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(249),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(260),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(274),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(196)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(252),
  /* scopeId */
  "data-v-2a4375f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timeline__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__search__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__register__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__login__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__manage__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__account__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sellpoint__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__purchase__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__demos__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__create__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__buypoint__ = __webpack_require__(132);

















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [__WEBPACK_IMPORTED_MODULE_2__home__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__timeline__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__search__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__register__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__login__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__manage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__purchase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__demos__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__account__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__create__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__buypoint__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__sellpoint__["a" /* default */]]
}));

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_persist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(144);








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
var vuexLocalStorage = new __WEBPACK_IMPORTED_MODULE_3_vuex_persist___default.a({
    key: 'vuex',
    storage: window.localStorage,
    reducer: function reducer(state) {
        return {
            cart: state.cart
        };
    }
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
    strict: true,
    plugins: [vuexLocalStorage.plugin],
    state: {
        sellpoints: [],

        sellpoint: {},

        products: [],

        product: {},

        cart: [],

        showLoader: false
    },

    getters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_4__getters__["a" /* productGetters */], __WEBPACK_IMPORTED_MODULE_4__getters__["b" /* sellpointGetters */], __WEBPACK_IMPORTED_MODULE_4__getters__["c" /* cartGetters */]),
    mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* productMutations */], __WEBPACK_IMPORTED_MODULE_5__mutations__["b" /* sellpointMutations */], __WEBPACK_IMPORTED_MODULE_5__mutations__["c" /* cartMutations */]),
    actions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_6__actions__["a" /* productActions */], __WEBPACK_IMPORTED_MODULE_6__actions__["b" /* sellpointActions */])
}));

/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductForm',
    data: function data() {
        return {
            user: {},
            sellpoint: {},
            sellpoint_categories: {},
            sub_categories: {},
            products: {},
            post: {},
            gallery: {},
            product_item: {},
            disable_btn: false,
            loading: true,
            action_loading: false,
            imageForm: "",
            product_info: false,
            product_url: "",
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            file_info: {},
            data_success_message: "",
            data_error_message: ""
        };
    },

    components: {},
    methods: {
        setComponent: function setComponent(attr1, attr2) {},
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        trackevent: function trackevent(e) {
            if (e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined) {
                this.category_type_2 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined) {
                this.category_type_1 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined) {
                this.category_type_1 = true;
                this.category_type_2 = true;
            } else {
                this.category_type_1 = false;
                this.category_type_2 = false;
                this.category_type_3 = false;
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);

                        _this.getSellpointCategories();
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this2 = this;

            service.getBusinessByUserName(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.sellpoint = response.body.data;
                    _this2.loading = false;
                }
            }).catch(function (err) {
                _this2.getSellpointCategories();
            });
        },
        getSubCategories: function getSubCategories(category) {
            var _this3 = this;

            service.getBusinessSubCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this3.sub_categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this4 = this;

            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this4.products = response.body.data;
                }
            }).catch(function (err) {});
        },
        addGallery: function addGallery() {
            var _this6 = this;

            this.activate_processing();
            var credentials = {
                gallery_new_group: true,
                gallery_group_type: 1,
                gallery_group_point: this.sellpoint.business_id,
                gallery_group_name: this.gallery.gallery_name,
                gallery_group_description: this.gallery.gallery_description,
                gallery_post_group: 0,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details || "nill",
                gallery_post_products: []
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    var _this5 = this;

                    if (data.body.status == 201) {
                        this.data_success_message = "processing, please wait.. ..";

                        this.post = data.body.data;

                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type", "gallery_media");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                location.reload(true);
                            }
                        }).catch(function (err) {
                            if (err) {}

                            _this5.data_error_message = "Something went wrong..";
                        });

                        var self = this;
                        setTimeout(function () {
                            location.reload(true);
                        }, 2000);
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');

                        _this6.deactivate_processing();
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        }
    },
    created: function created() {
        this.preset();
    }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductForm',
    data: function data() {
        return {
            open_request: true,
            user: {},
            sellpoint: {},
            sellpoint_categories: {},
            categories: {},
            main_category: {},
            sub_categories: [],
            products: {},
            product: {},
            post: {},
            gallery: {},
            selected_produts: [],
            product_item: {},
            disable_btn: false,
            imageForm: "",
            product_info: false,
            product_url: "",
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            file_info: {},
            addProductPost: false,
            showGalleryForm: true,
            showProductForm: false,
            canAddGallery: false,
            is_product_service: "product",
            data_success_message: "",
            data_error_message: "",
            loading: true,
            action_loading: false,
            executed_kipper: false,
            pinched_products: []
        };
    },

    components: {},
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == "add-to-gallery-product") {
                var if_index = this.selected_produts.indexOf(attr2.product_id);
                if (if_index != -1) {
                    attr2.product_checked = false;

                    this.selected_produts.splice(if_index, 1);
                    document.getElementById(attr2.product_id + "PRD").style.border = "none";
                } else {
                    this.selected_produts.push(attr2.product_id);
                    attr2.product_checked = true;
                    document.getElementById(attr2.product_id + "PRD").style.border = "1px solid #0000CC";
                }
            }
            if (attr1 == "show-add-product-form") {
                this.showProductForm = true;
                this.canAddGallery = false;
            }
        },
        close_request: function close_request() {
            this.open_request = false;
        },
        reset: function reset() {
            this.showProductForm = false;
            this.canAddGallery = true;
        },
        trackevent: function trackevent(e) {
            if (e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined) {
                this.category_type_2 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined) {
                this.category_type_1 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined) {
                this.category_type_1 = true;
                this.category_type_2 = true;
            } else {
                this.category_type_1 = false;
                this.category_type_2 = false;
                this.category_type_3 = false;
            }
        },
        preset: function preset() {
            var _this = this;

            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);

                        _this.getSellpointCategories();
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this2 = this;

            service.getBusinessByUserName(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.sellpoint = response.body.data;

                    service.getBusinessCategories(_this2, _this2.sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this2.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});

                    _this2.getCategories(_this2.sellpoint.business_category_id);
                    _this2.getSellpointProducts();
                }
            }).catch(function (err) {});
        },
        getCategories: function getCategories(category) {
            var _this3 = this;

            service.getMainCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this3.categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSubCategories: function getSubCategories(category) {
            if (category != undefined) {
                this.sub_categories = category.sub_categories;
            } else {
                this.sub_categories = [];
            }
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this4 = this;

            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this4.products = response.body.data;
                    _this4.loading = false;

                    if (_this4.products.length > 0) {
                        _this4.canAddGallery = true;
                    }
                } else {
                    _this4.loading = false;
                }
            }).catch(function (err) {
                _this4.loading = false;
            });
        },
        addGallery: function addGallery() {
            var _this5 = this;

            this.activate_processing();
            this.loading = true;

            var credentials = {
                gallery_new_group: true,
                gallery_group_type: 2,
                gallery_group_point: this.sellpoint.business_id,
                gallery_group_name: this.gallery.gallery_name,
                gallery_group_description: this.gallery.gallery_description,
                gallery_post_group: 0,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details || "nill",
                gallery_post_products: this.selected_produts || []
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_success_message = "Processing, please wait ...";

                        this.gallery = data.body.data;

                        location.reload("/" + this.$route.params.id);

                        this.open_request = false;

                        this.deactivate_processing();
                    }
                }).catch(function (err) {
                    if (err) {
                        _this5.data_error_message = "Something went wrong, preparing report ...";

                        _this5.deactivate_processing();
                    }
                });
            } else {
                this.data_error_message = "Kindly fill all fields ..";
                this.deactivate_processing();
            }
        },
        addProduct: function addProduct() {
            var _this7 = this;

            this.activate_processing();

            var credentials = {
                product_name: this.product.product_name,
                product_is_product_or_service: this.is_product_service,
                product_category: this.product.product_category || 0,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",
                product_business: this.sellpoint.business_id,
                product_description: this.product.product_description || "nill",
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1
            };

            var navi = this.$router;
            if (credentials.product_name != undefined) {
                service.addProduct(this, credentials).then(function (data) {
                    var _this6 = this;

                    if (data.body.status == 201) {
                        this.data_success_message = "Processing, please wait ...";

                        this.product = data.body.data;

                        this.imageForm.append("data_id", this.product.product_id);

                        this.imageForm.append("data_type", "products");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                if (!_this6.executed_kipper) {
                                    _this6.addProductKipper();
                                }
                            }
                        }).catch(function (err) {
                            if (err) {}

                            _this6.data_error_message = "Something went wrong, preparing report ...";

                            _this6.deactivate_processing();
                        });

                        var self = this;
                        setTimeout(function () {
                            self.addProductKipper();
                        }, 2000);
                    }
                }).catch(function (err) {
                    if (err) {
                        _this7.data_error_message = "Something went wrong, preparing report ...";

                        _this7.deactivate_processing();
                    }
                });
            } else {
                this.data_error_message = "Kindly fill all fields ...";

                this.deactivate_processing();
            }
        },
        addProductKipper: function addProductKipper() {
            this.executed_kipper = true;

            this.selected_produts.push(this.product.product_id);

            if (this.addProductPost) {
                this.addProductPostGallery();
            } else {
                this.addGallery();
            }
        },
        addProductPostGallery: function addProductPostGallery() {
            var _this8 = this;

            this.disable_btn = true;
            this.loading = true;

            var set_gallery = 0;
            if (this.$route.params.id1 != undefined) {
                set_gallery = this.gallery.gallery_posts_group_id;
            }

            var credentials = {
                gallery_new_group: false,
                gallery_post_group: set_gallery,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details || "nill",
                gallery_post_products: this.selected_produts || []
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_success_message = "Processing, please wait ...";

                        this.gallery = data.body.data;
                        location.reload("/" + this.$route.params.id);


                        this.open_request = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this8.data_error_message = "Something went wrong, preparing report ...";

                        _this8.disable_btn = false;
                        _this8.loading = false;
                    }
                });
            } else {
                this.data_error_message = "Kindly fill all fields ..";
                this.disable_btn = false;
                this.loading = false;
            }
        },
        setGallery: function setGallery() {
            var _this9 = this;

            service.getGallerySearch(this, this.$route.params.id1).then(function (response) {
                if (response.body.status == 200) {
                    _this9.gallery = response.body.data;
                }
            }).catch(function (err) {});
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        }
    },
    created: function created() {
        if (this.$route.params.id1 != undefined) {
            this.setGallery();

            this.showGalleryForm = false;
            this.addProductPost = true;
        }
        this.preset();
    }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);




var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['productMain', 'productItem'],
  data: function data() {
    return {
      user: {},
      cart: this.$store.state.cart
    };
  },

  computed: {
    canAdd: function canAdd() {
      return this.cart.indexOf(this.productItem) < 0;
    }
  },
  methods: {
    preset: function preset() {
      var _this = this;

      this.loading = true;
      var credentials = {
        session_key: localStorage.getItem("sp_token")
      };
      if (credentials.session_key != null) {
        service.sessionGuard(this, credentials).then(function (response) {
          if (response.body.status == 200) {
            var data = response.body.data;
            data.forEach(function (element) {
              this.user.user_id = element.user_id;

              this.configureCTAButton();
            }, _this);
          } else {
            _this.$router.push('login');
          }
          _this.loading = false;
        }).catch(function (err) {
          if (err) {
            _this.$router.push('login');
          }
        });
      } else {
        this.$router.push('login');
      }
    },
    addToCart: function addToCart() {
      this.productItem.active_order = true;
      this.productItem._id = this.productItem.product_item_id;

      if (this.productItem.product_item_order_quantity == undefined) {
        this.productItem.product_item_order_quantity = 1;
      }
      this.productItem.product_main_id = this.productMain.product_id;
      this.productItem.product_business = this.productMain.product_business_ownername;
      this.productItem.product_name = this.productMain.product_name;
      this.productItem.product_order_url = this.productMain.product_business_ownername + "-" + this.productMain.product_url_name;
      this.productItem.product_url = this.productMain.product_business_ownername + "/" + this.productMain.product_url_name;
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["i" /* ADD_TO_CART */], this.productItem);

      this.redir('order');
    },
    removeFromCart: function removeFromCart(payload) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["j" /* REMOVE_FROM_CART */], payload);
    },
    redir: function redir(rlink) {
      location.replace("/" + rlink);
    },
    configureCTAButton: function configureCTAButton() {}
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['productMain', 'productItemGroup', 'productItem'],
  data: function data() {
    return {
      cart: this.$store.state.cart
    };
  },

  computed: {
    canAdd: function canAdd() {
      var _this = this;

      var index = this.cart.findIndex(function (p) {
        return p.product_item_id === _this.productItem.product_item_id;
      });
      if (index < 0) {
        return true;
      }
    }
  },
  methods: {
    addToCart: function addToCart() {
      this.productItem._id = this.productItem.product_item_id;

      if (this.productItem.product_item_order_quantity == undefined) {
        this.productItem.product_item_order_quantity = 1;
      }
      this.productItem.product_main_id = this.productMain.product_id;
      this.productItem.product_business = this.productMain.product_business_ownername;
      this.productItem.product_name = this.productMain.product_name;
      this.productItem.product_url = this.productMain.product_business_ownername + "/" + this.productMain.product_url_name;

      if (this.productItemGroup.product_item_group_is_color_image == 'IMG' && this.productItemGroup.product_item_group_image != 'error') {
        this.productItem.product_item_image = this.productItemGroup.product_item_group_image;
      } else {
        this.productItem.product_item_image = '';
      }

      this.productItem.product_shipping_calculation_method = this.productMain.product_set_shipping_fee_status;


      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["i" /* ADD_TO_CART */], this.productItem);
    },
    removeFromCart: function removeFromCart(payload) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["j" /* REMOVE_FROM_CART */], payload);
    },
    redir: function redir(rlink) {
      location.replace("/" + rlink);
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductForm',
    data: function data() {
        return {
            user: {},
            sellpoint: {},
            sellpoint_categories: {},
            sub_categories: {},
            product: {},
            product_item: {},
            disable_btn: false,
            imageForm: "",
            product_info: false,
            product_url: "",
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            file_info: {}
        };
    },

    components: {},
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            this.setPanel = true;
            if (attr1 == 'create-sellpoint') {
                this.createSellpointPanel = true;
                this.addProductPanel = false;
                this.addProductItemPanel = false;
            }
            if (attr1 == 'add-product') {
                this.addProductPanel = true;
                this.addProductItemPanel = false;
                this.createSellpointPanel = false;
            }
            if (attr1 == 'add-product-item') {
                this.addProductItemPanel = true;
                this.addProductPanel = false;
                this.createSellpointPanel = false;
            }
        },
        trackevent: function trackevent(e) {
            if (e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined) {
                this.category_type_2 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined) {
                this.category_type_1 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined) {
                this.category_type_1 = true;
                this.category_type_2 = true;
            } else {
                this.category_type_1 = false;
                this.category_type_2 = false;
                this.category_type_3 = false;
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);

                        _this.getSellpointCategories();
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this2 = this;

            service.getBusinessByUserName(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.sellpoint = response.body.data;

                    service.getBusinessCategories(_this2, _this2.sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this2.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});
                    _this2.getSubCategories(_this2.sellpoint.business_category_id);
                }
            }).catch(function (err) {
                console.log(err);
            });
        },
        getSubCategories: function getSubCategories(category) {
            var _this3 = this;

            service.getBusinessSubCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this3.sub_categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        addProduct: function addProduct() {
            var _this5 = this;

            this.disable_btn = true;

            var credentials = {
                product_name: this.product.product_name,
                product_category: this.product.product_category || 0,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",
                product_business: this.sellpoint.business_id,
                product_description: this.product.product_description || "nill",
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1
            };

            var navi = this.$router;
            if (credentials.product_name != undefined) {
                service.addProduct(this, credentials).then(function (data) {
                    var _this4 = this;

                    if (data.body.status == 201) {
                        toastr.success("Product Added Successfully", 'Success!');

                        this.product = data.body.data;

                        this.imageForm.append("data_id", this.product.product_item_id);
                        this.imageForm.append("data_type", "product_items");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                _this4.product_info = true;
                                _this4.product_url = "/" + _this4.$route.params.id + "/" + _this4.product.product_url_name;
                            }
                        }).catch(function (err) {
                            if (err) {}
                            toastr.warning("Something went wrong.", 'Warning!');
                        });
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');

                        _this5.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        }
    },
    created: function created() {
        this.preset();
    }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductItemForm',
    data: function data() {
        return {
            user: {},
            sellpoint: {},
            product: {},
            product_items: {},
            disable_btn: false,
            imageForm: "",
            addProductItemPanel: false
        };
    },

    components: {},
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == 'add-product-item') {
                this.addProductItemPanel = true;
            }
            if (attr1 == 'reset-edit') {}
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);

                        _this.setProduct();
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        setProduct: function setProduct() {
            var _this2 = this;

            service.getProductSearch(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.product = response.body.data;
                }
            }).catch(function (err) {
                _this2.$router.push("/");
            });
        },
        addProductItem: function addProductItem() {
            var _this3 = this;

            this.disable_btn = true;

            var credentials = {
                product_id: this.product.product_id,
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.addProductItem(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        var result = data.body.data;
                        this.imageForm.append("data_id", result.product_item_id);
                        this.imageForm.append("data_type", "product_items");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                location.reload(true);
                            }
                        }).catch(function (err) {
                            if (err) {}
                        });
                    }
                }).catch(function (err) {
                    if (err) {
                        console.log(err);
                        _this3.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);


                this.imageForm = formData;
            }
        }
    },
    created: function created() {
        this.imageForm = new FormData();
        this.setProduct();
    }
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'product-list',
  created: function created() {
    if (this.products.length === 0) {
      this.$store.dispatch('allProducts');
    }
  },

  computed: {
    products: function products() {
      return this.$store.getters.allProducts;
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LeftSidebar',
  data: function data() {
    return {
      user: {},
      loggedIn: false
    };
  },


  methods: {
    checkLoggedIn: function checkLoggedIn() {
      if (localStorage.getItem("sp_token") != null) {
        this.loggedIn = true;
        this.user.user_name = localStorage.getItem("sp_user");
      }
    }
  },
  created: function created() {
    this.checkLoggedIn();
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MenuBottom',
    data: function data() {
        return {};
    }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RightSidebar',
  data: function data() {
    return {
      user: {},
      loggedIn: false
    };
  },


  methods: {
    checkLoggedIn: function checkLoggedIn() {
      if (localStorage.getItem("sp_token") != null) {
        this.loggedIn = true;
        this.user.user_name = localStorage.getItem("sp_user");
      }
    }
  },
  created: function created() {
    this.checkLoggedIn();
  }
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SearchBox',
    data: function data() {
        return {
            search_words: "",
            search_type: "business"
        };
    },


    methods: {
        search: function search() {
            location.replace("search?search=" + this.search_type + "&k=" + this.search_words);
        }
    }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Settings',
    data: function data() {
        return {};
    },


    methods: {
        mountid: function mountid() {
            'use strict';
        }
    },

    created: function created() {
        window.addEventListener('load', this.mountid);
    },
    destroyed: function destroyed() {
        window.removeEventListener('load', this.mountid);
    }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SearchBox',
    data: function data() {
        return {
            products: {}
        };
    },


    methods: {
        getMarketActivityProducts: function getMarketActivityProducts() {
            var _this = this;

            var offset = 0;var limit = 20;
            service.getMarketActivityProducts(this, service.market_app_name, offset, limit).then(function (response) {
                if (response.body.status == 200) {
                    _this.products = response.body.data;
                    _this.loading = false;
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.getMarketActivityProducts();
    }
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_BASE; });
/* unused harmony export imageURL */
var API_BASE = 'http://localhost/kokoeco/dev/koko/v1/api/';
var imageURL = 'http://localhost/kokoeco/dev/koko/v1/api/server/x52rs6c/pr.im.ti.ny.8/';

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_clipboard__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_v_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_swiper_dist_css_swiper_css__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(71);














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vee_validate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_v_clipboard___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  template: '\n    <div id="app">\n      <router-view></router-view>\n    </div>\n    '
}).$mount('#app');

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_validation__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_ProductItemForm_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_ProductItemForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_product_ProductItemForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_util__);








var service = new __WEBPACK_IMPORTED_MODULE_2__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_3__services_validation__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Account',
    data: function data() {
        var _ref;

        return _ref = {
            user: {},
            sellpoints: {},
            sellpoint: {},
            business: {},
            products: {},
            product: {},
            product_item_group: {},
            product_item: {},
            categories: {},
            category: {},
            main_category: {},
            sub_categories: [],
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            sellpoint_gallery: {},
            galleria: {},
            lookbooks: {},
            lookbook: {},
            lookbook_post: {},
            menu_view: {},
            menu_tab_view: {},
            is_view: "",
            is_viewing: "Account",
            is_viewed: "Account",
            is_view_type: "Account",
            img_url: service.imageURL,
            server_query_done: false,
            setPanel: false,
            loading: true,
            action_loading: false,
            disable_btn: false,
            data_processing_message: "",
            data_error_message: "",
            data_success_message: "",
            data_media_error_message: "",
            max_media_info: service.max_upload_image_info,
            max_plan_lookbooks: 0,
            max_plan_lookbook_posts: 0,
            total_lookbooks_added: 0,
            can_add_more_lookbook: false,
            can_add_product_lookbook: false,
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            setSettings: false,
            setting_details: {},

            states: {},
            cities: {},
            delivery_option: {},
            other_delivery_option: false,
            edit_other_delivery_option: false,
            custom_delivery_option: false,
            component_view: { viewProducts: true, viewProduct: false, viewLookbooks: true, viewLookbook: false, viewLookbookPost: false },
            business_details: { delivery_edit: false, delivery_add: false, delivery_option_edit: false, viewDiscounts: true, setDiscount: false },
            product_details: {},
            lookbook_details: {},
            manageList: ["manageBusinesses", "manageProducts", "manageServices", "manageLookbooks"],
            manage: ["manageBusinesses", "manageProducts", "manageServices", "manageLookbooks"],
            discount_coupon: {},
            managePanel: false,
            manageBusinesses: true,
            manageProducts: false,
            manageServices: false,
            manageLookbooks: false,
            managePosts: false,
            manageOrders: false,
            manageBusinessDetails: false,
            businessComponents: ["BusinessEditing", "BusinessDeliveryShipping", "BusinessCoupons", "BusinessPaymentGateway"],
            business_set_shipping_fee_status: 9,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            product_set_shipping_fee_status: 12,
            set_shipping_fee_status_track: false,

            business_agent: 0,
            business_open_agents_products: {},
            business_product_categories: [],
            business_service_categories: [],
            business_category_type: 0,
            validate_user_name_error: false,
            validate_user_name_message: "",

            product_display_image: {}
        }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'product_item', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'imageForm', ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'is_product_service', "product"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'max_upload', service.max_media_upload), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'file_info', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'show_product_setting_box', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showProductItemGroups', ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'tap_01', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'viewing_lookbook', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'viewing_lookbook_post', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'is_viewing_lookbook', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'businessComponentKey', 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'app_orders', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'processing_fee', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'payment_gateways', {}), _ref;
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_4__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_5__MainFooter_index_vue___default.a,
        'product-item-form': __WEBPACK_IMPORTED_MODULE_6__components_product_ProductItemForm_vue___default.a
    },

    methods: {
        back: function back() {
            if (!this.setPanel) {
                window.history.back();
            } else {
                if (this.is_viewed == "Account") {
                    this.setPanel = false;
                } else {
                    this.setMenuComponent(this.is_viewed, '', '');
                }
            }

            this.menu_tab_view = {};
        },
        toggleSingleComponent: function toggleSingleComponent(component) {
            var toggle = document.getElementById(component).style.display;
            if (toggle == "block") {
                document.getElementById(component).style.display = "none";
            } else {
                document.getElementById(component).style.display = "block";
            }
        },
        toggleTrippleComponent: function toggleTrippleComponent(component1, component2, component3) {
            var toggle1 = document.getElementById(component1).style.display;
            var toggle2 = document.getElementById(component2).style.display;
            var toggle3 = document.getElementById(component3).style.display;
            if (toggle1 == "block") {
                document.getElementById(component1).style.display = "none";
            } else {
                document.getElementById(component1).style.display = "block";
            }
            if (toggle2 == "block") {
                document.getElementById(component2).style.display = "none";
            } else {
                document.getElementById(component2).style.display = "block";
            }
            if (toggle3 == "block") {
                document.getElementById(component3).style.display = "none";
            } else {
                document.getElementById(component3).style.display = "block";
            }
        },
        setMenuComponent: function setMenuComponent(view, attr1, attr2) {
            this.setPanel = true;

            var top = document.getElementById("topPanel").offsetTop;
            window.scrollTo(0, top);

            this.menu_view = {};
            this.menu_view[view] = true;
            if (this.is_viewing == '') {
                this.is_viewing = view;
            }

            this.setViewTree();
        },
        setMenuTabView: function setMenuTabView(view, attr1, attr2) {
            this.setComponent('reset-edit', '');
            this.menu_tab_view = {};
            this.menu_tab_view[view] = true;
        },
        setViewTree: function setViewTree() {
            if (this.is_view_type == "business") {
                var view_array_b1 = ["viewBusiness"];

                var view_array_b2 = ["manageBusiness", "viewBusinessCategory", "newBusinessCategory"];

                var view_array_b3 = ["setBusinessProfile", "setBusinessShippingInformation", "setBusinessShippingLocations", "setBusinessDiscountsCoupons", "setBusinessPaymentInformation", "setBusinessDeleteRequest"];

                var view_array_bc1 = ["manageBusinessCategory", "viewBusinessCategoryProduct", "newBusinessCategoryProduct"];

                var view_array_bcp1 = ["manageBusinessCategoryProduct"];
                var view_array_bcp2 = ["setBusinessCategoryProductDetails", "setBusinessCategoryProductItems", "setBusinessCategoryProductDiscountCoupons", "setBusinessCategoryProductDeliveryAndReturanInformation", "setBusinessCategoryProductShippingInformation"];

                if (this.is_view == "viewBusiness") {
                    this.is_viewed = 'sellpoints';
                } else if (this.is_view == "sellpoints") {
                    this.is_viewed = "Account";
                } else {
                    if (view_array_b2.indexOf(this.is_view) != -1) {
                        this.is_viewed = "viewBusiness";
                    } else if (view_array_b3.indexOf(this.is_view) != -1) {
                        this.is_viewed = "manageBusiness";
                    } else if (view_array_bc1.indexOf(this.is_view) != -1) {
                        this.is_viewed = "viewBusinessCategory";this.businessComponentKey++;
                    } else if (view_array_bcp1.indexOf(this.is_view) != -1) {
                        this.is_viewed = "viewBusinessCategoryProduct";
                    } else if (view_array_bcp2.indexOf(this.is_view) != -1) {
                        this.is_viewed = "manageBusinessCategoryProduct";
                    } else {
                        this.is_viewed = "viewBusiness";
                    }
                }
                this.is_view = this.is_viewed;
            }
        },
        setBusinessComponent: function setBusinessComponent(view, attr1, attr2) {
            this.setPanel = true;
            if (view != "sellpoints") {
                this.sellpoint = attr1;
            }

            this.is_view = view;
            this.is_view_type = "business";
            this.is_viewing = this.sellpoint.business_name;
            var category_array = ["viewBusinessCategory", "editBusinessCategory", "removeBusinessCategory"];

            if (category_array.indexOf(view) != -1) {
                this.category = attr2;

                if (view == 'viewBusinessCategory') {
                    this.getBusinessCategoryProducts();
                    if (this.sellpoint.business_agent == 1) {
                        this.getBusinessAgentCategoryProducts();
                        this.getBusinessesIsOpenAgentCategoryProducts();
                    }
                }
            }

            var product_array = ["viewBusinessCategoryProduct", "editBusinessCategoryProduct", "removeBusinessCategoryProduct"];

            if (product_array.indexOf(view) != -1) {
                this.getSetProduct(attr2);
                this.product_display_image = this.product.product_images[0];
                this.product_item = this.product.product_items[0];

                this.is_viewed = "viewBusinessCategory";

                if (view == 'viewBusinessCategoryProduct') {}
            }

            this.menu_view = {};
            this.menu_view[view] = true;
            this.setViewTree();
        },
        getSetProduct: function getSetProduct(item) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.products), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var prd = _step.value;

                    if (prd.product_url_name == item.product_url_name) {
                        this.product = prd;
                    } else {}
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        setComponent: function setComponent(attr1, attr2) {
            this.data_processing_message = "";
            this.deactivate_processing();

            if (attr1 == 'set-settings-inner') {
                this.setSettings = true;
                this.setting_details = {};
                this.setting_details[attr2] = true;
            }

            if (attr1 == 'manage-panel') {
                this.setPanel = true;
                this.managePanel = true;
                this.manage[0] = true;
            }

            if (attr1 == 'set-business-card-details') {
                this.manageBusinessDetails = true;
                this.setBusinessComponent(attr2);
            }

            if (attr1 == 'set-business-details') {
                this.discount_coupon = {};
                this.business_details = {};
                this.business_details[attr2] = true;
            }

            if (attr1 == 'edit-delivery-option') {
                this.delivery_option.edit_set = false;
                this.business_details = {};
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;

                if (this.delivery_option.business_delivery_is_custom == 0) {
                    this.getCities(this.delivery_option.business_delivery_state, 'edit');
                }
                this.business_details["delivery_option_edit"] = true;
            }

            if (attr1 == 'edit-discount-coupon') {
                this.business_details = {};
                this.discount_coupon.edit = false;
                this.discount_coupon = attr2;
                this.discount_coupon.edit = true;
            }

            if (attr1 == 'manage-businesses') {
                this.manageBusinesses = true;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-products') {
                this.manageBusinesses = false;
                this.manageProducts = true;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-services') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = true;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-lookbooks') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = true;
                this.managePosts = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-posts') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.managePosts = true;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-orders') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.managePosts = false;
                this.manageOrders = true;
            }

            if (attr1 == 'reset-edit') {
                this.menu_tab_view = {};
                this.discount_coupon = {};
                this.business_details = {};
                this.product_details = {};
                this.lookbook_details = {};
                this.setting_details = {};
                this.setSettings = false;
                this.data_success_message = "";
                this.data_error_message = "";
                this.data_processing_message = "";
                this.showProductItemGroups = "";
            }

            if (attr1 == 'reset-component-details') {
                this.manageBusinessDetails = false;
            }
        },
        setComponentXX: function setComponentXX(attr1, attr2) {
            this.resetAll();
            this.data_processing_message = "";
            this.deactivate_processing();

            if (attr1 == 'set-settings-inner') {
                this.setSettings = true;
                this.setting_details = {};
                this.setting_details[attr2] = true;
            }

            if (attr1 == 'manage-panel') {
                this.setPanel = true;
                this.managePanel = true;
                this.manage[0] = true;
            }

            if (attr1 == 'set-business-card-details') {
                this.manageBusinessDetails = true;
                this.setBusinessComponent(attr2);
            }

            if (attr1 == 'set-business-details') {
                this.discount_coupon = {};
                this.business_details = {};
                this.business_details[attr2] = true;
            }

            if (attr1 == 'edit-delivery-option') {
                this.delivery_option.edit_set = false;
                this.business_details = {};
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;

                this.getCities(this.delivery_option.business_delivery_state, 'edit');
                this.business_details["delivery_option_edit"] = true;
            }

            if (attr1 == 'edit-discount-coupon') {
                this.business_details = {};
                this.discount_coupon.edit = false;
                this.discount_coupon = attr2;
                this.discount_coupon.edit = true;
            }

            if (attr1 == 'manage-businesses') {
                this.manageBusinesses = true;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-products') {
                this.manageBusinesses = false;
                this.manageProducts = true;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-services') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = true;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-lookbooks') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = true;
                this.managePosts = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-posts') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.managePosts = true;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-orders') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.managePosts = false;
                this.manageOrders = true;
            }

            if (attr1 == 'reset-edit') {
                this.menu_tab_view = {};
                this.discount_coupon = {};
                this.business_details = {};
                this.product_details = {};
                this.lookbook_details = {};
                this.setting_details = {};
                this.setSettings = false;
                this.data_success_message = "";
                this.data_error_message = "";
                this.data_processing_message = "";
            }

            if (attr1 == 'reset-component-details') {
                this.manageBusinessDetails = false;
            }
        },
        setInnerComponent: function setInnerComponent(attr1, attr2) {
            if (attr1 == 'set-product-item-group') {
                this.product.product_item_group = attr2;

                var grps = document.getElementsByClassName('product-item-group');
                for (var i = 0; i < grps.length; i++) {
                    grps[i].style = "border:none;";
                }

                document.getElementById(attr2 + "PRTGR").style = "border:1px solid #0000CC;min-width:65px; max-width:65px;";
            }
            if (attr1 == 'set-product-item-group-image') {
                this.product.product_item_group_image = attr2;
                var imgs = document.getElementsByClassName('product-item-group-image');
                for (var i = 0; i < imgs.length; i++) {
                    imgs[i].style = "border:none;";
                }
                document.getElementById(attr2 + "PRTG").style.border = "1px solid #0000CC";
            }
        },
        resetAll: function resetAll() {
            this.discount_coupon = {};
            this.business_details = {};
            this.product_details = {};
            this.data_success_message = "";
            this.data_error_message = "";
            this.data_processing_message = "";
        },
        setComponentView: function setComponentView(attr1, attr2, attr3) {
            this.resetAll();
            if (attr1 == 'switch-to-viewing-loobook') {
                this.setComponent('manage-lookbooks', '');
                this.lookbook = this.viewing_lookbook;
                this.setComponentView('loobooks', this.viewing_lookbook_post, 'viewLookbookPost');

                this.is_viewing_lookbook = false;
                this.viewing_lookbook = {};
                this.viewing_lookbook_post = {};
            }
            if (attr1 == 'products') {
                if (this.component_view.viewProducts) {
                    this.component_view.viewProducts = false;
                    this.component_view.viewProduct = true;
                    this.product = attr2;

                    this.product_set_shipping_fee_status = this.product.product_set_shipping_fee_status;
                } else if (this.component_view.viewProduct) {
                    this.component_view.viewProducts = true;
                    this.component_view.viewProduct = false;
                }
            }
            if (attr1 == 'lookbooks') {
                if (attr3 == 'viewLookbookPost') {
                    this.component_view.viewLookbooks = false;
                    this.component_view.viewLookbook = false;
                    this.component_view.viewLookbookPost = true;
                    this.lookbook_post = attr2;
                } else if (attr3 == 'viewLookbook') {
                    this.component_view.viewLookbooks = false;
                    this.component_view.viewLookbookPost = false;
                    this.component_view.viewLookbook = true;
                    this.lookbook = attr2;
                } else if (attr3 == 'viewLookbooks') {
                    this.component_view.viewLookbooks = true;
                    this.component_view.viewLookbook = false;
                    this.component_view.viewLookbookPost = false;
                }
            }
        },
        toggleProductItemView: function toggleProductItemView(component, attr2, attr3, attr4) {
            var grps = document.getElementsByClassName('product-item-show-more-details');
            for (var i = 0; i < grps.length; i++) {
                grps[i].style = "display:none;";
            }
            var grps = document.getElementsByClassName('product-item-more-details-hide-btn');
            for (var i = 0; i < grps.length; i++) {
                grps[i].style = "display:none;";
            }
            var grps = document.getElementsByClassName('product-item-more-details-view-btn');
            for (var i = 0; i < grps.length; i++) {
                grps[i].style = "display:block;";
            }

            if (component == "showMoreProductItemDetails") {
                document.getElementById(attr2).style.display = "block";
                document.getElementById(attr3).style.display = "none";
                document.getElementById(attr4).style.display = "block";
            }
            if (component == "hideMoreProductItemDetails") {
                document.getElementById(attr3).style.display = "block";
                document.getElementById(attr4).style.display = "none";
            }
        },
        setProductComponent: function setProductComponent(component, attr2, attr3) {
            this.deactivate_processing();
            this.discount_coupon = {};

            if (component == "show-settings-box") {
                this.show_product_setting_box = true;
            }
            if (component == "hide-settings-box") {
                this.show_product_setting_box = false;
            }

            if (attr2 == 'productitemgroup') {
                this.product_item_group = attr3;
            }
            if (attr2 == 'productitem') {
                this.product_item = attr3;
            }

            if (component == "addProductItemPanel") {
                if (this.product.product_set_groups == 0) {
                    this.showProductItemGroups = 'showfalse';
                }
            }
            if (component == 'setProductDeliveryInformation') {
                this.delivery_option.edit_set = false;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
            }
            if (component == 'editDiscount') {
                this.discount_coupon = attr3;
            }
            if (component == 'deactivateDiscount') {
                this.product_item = attr2;
                this.deactivateDiscountsAndCoupons(attr3);
            }

            this.product_details = {};
            this.product_details[component] = true;
        },
        setLookbookComponent: function setLookbookComponent(component, attr2, attr3) {
            this.deactivate_processing();

            if (component == "viewProductLookbookPost") {
                this.viewing_lookbook = this.lookbook;
                this.viewing_lookbook_post = attr3;
                this.is_viewing_lookbook = true;
                this.setComponent('manage-products', '');
                this.setComponentView('products', attr3.gallery_post_product_details, '');
            } else {

                this.lookbook_details = {};
                this.lookbook_details[component] = true;
            }
        },
        toggleSwitchBusiness: function toggleSwitchBusiness() {
            var x = document.getElementById("businessList");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        switchBusiness: function switchBusiness(sellpoint) {
            this.sellpoint = sellpoint;
            this.galleria = {};
            this.setSellpoint();

            this.toggleSwitchBusiness();
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        checkIfVideo: function checkIfVideo(url) {
            if (url != undefined) {
                var ext = url.split('.').pop();
                if (service.video_exts.includes(ext)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        reset: function reset() {
            this.setPanel = false;
            this.managePanel = false;
        },
        getStates: function getStates() {
            var _this = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state, option) {
            var _this2 = this;

            this.activate_processing();
            if (option == "edit") {
                this.edit_city = true;
            } else {
                this.edit_city = false;
            }
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this2.cities = response.body.data;
                    _this2.deactivate_processing();
                } else {
                    _this2.deactivate_processing();
                }
            }).catch(function (err) {
                _this2.deactivate_processing();
            });
        },
        preset: function preset() {
            var _this3 = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this3.server_query_done = true;
                        var data = response.body.data;
                        data.forEach(function (element) {
                            var _this4 = this;

                            this.user.user_id = element.user_id;

                            service.getUser(this, element.user_id).then(function (data) {
                                if (data.body.status == 200) {
                                    var user_data = data.body.data;
                                    _this4.user.user_email = user_data.user_email;
                                    _this4.user.user_member_id = user_data.user_member_id;
                                    _this4.user.user_name = user_data.user_name;
                                    _this4.user.user_phone = user_data.user_phone;
                                    _this4.user.user_token = user_data.user_token;

                                    _this4.getSellpoints(element.user_id);
                                }
                            }).catch(function (err) {
                                if (err) {}
                            });
                        }, _this3);
                    } else {
                        _this3.$router.push('/login/');
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        syncset: function syncset(request_page) {
            var credentials = {
                session_key: localStorage.getItem("sp_token"),
                request_url: service.app_url,
                request_from: service.app_name,
                request_status: "REQUESTING...",
                request: request_page
            };
            if (credentials.session_key != null) {
                service.sessionSync(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var ref = response.body.data;
                        window.location.href = service.sp_url + '/manage/' + ref;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        editProfileDetails: function editProfileDetails() {
            var _this5 = this;

            this.activate_processing();
            var payload = {
                user_name: this.user.user_name,
                user_phone: this.user.user_phone,
                user_email: this.user.user_email
            };

            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.user.user_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.user.user_phone).toLowerCase());
            if (email_test == false || this.user.user_name == " " || phone_test == false) {
                data_test = false;
                this.data_processing_message = "Some errors were found in your form, please fill correctly";
                this.deactivate_processing();
            } else {
                data_test = true;
                this.data_processing_message = "";
            }
            if (data_test) {
                if (payload.user_name != null && payload.user_phone != null) {
                    service.editProfileDetails(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            this.data_processing_message = "Profile Updated";
                            this.user = data.body.data;
                            this.deactivate_processing();
                            this.setSettings = false;
                            this.setting_details = {};
                        } else {
                            this.data_processing_message = "Could not edit details, something went wrong, please try again";
                            this.deactivate_processing();
                            this.setSettings = false;
                            this.setting_details = {};
                        }
                    }).catch(function (err) {
                        _this5.data_processing_message = "Could not edit details, something went wrong, please try again";
                        _this5.deactivate_processing();
                        _this5.setSettings = false;
                        _this5.setting_details = {};
                    });
                }
            }
        },
        getSellpoints: function getSellpoints(user) {
            var _this6 = this;

            this.loading = false;
            service.getAppBusinesses(this, user).then(function (data) {
                if (data.body.status == 200) {
                    _this6.sellpoints = data.body.data;
                    _this6.sellpoint = _this6.sellpoints[0];
                    _this6.business_set_shipping_fee_status = _this6.sellpoint.business_set_shipping_fee_status;

                    _this6.setSellpoint();
                    _this6.loading = false;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        setSellpoint: function setSellpoint() {
            var _this7 = this;

            this.activate_processing();
            service.getAppBusinessByUserName(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this7.sellpoint_gallery = response.body.data;

                    _this7.getSellpointProducts();

                    if (_this7.sellpoint_gallery.business_market_subscription_name == 'Free Plan') {
                        _this7.max_plan_lookbooks = 2;
                        _this7.max_plan_lookbook_posts = 5;
                    }
                    if (_this7.sellpoint_gallery.business_market_subscription_name == 'Basic Plan') {
                        _this7.max_plan_lookbooks = 10;
                        _this7.max_plan_lookbook_posts = 50;
                    }
                    if (_this7.sellpoint_gallery.business_market_subscription_name == 'Premium Plan') {
                        _this7.max_plan_lookbooks = 50;
                        _this7.max_plan_lookbook_posts = 50;
                        _this7.can_add_product_lookbook = true;
                    }

                    var self = _this7;
                    setTimeout(function () {
                        self.setGallery();
                    }, 3000);
                    _this7.getCategories(_this7.sellpoint.business_category_id);

                    _this7.getSellpointCategories();
                }
            }).catch(function (err) {});
        },
        setGallery: function setGallery() {
            var _this8 = this;

            service.getPointGalleryPosts(this, this.sellpoint.business_id, 0, this.max_plan_lookbooks, 0, this.max_plan_lookbook_posts).then(function (response) {
                _this8.galleria = response.body.data;

                _this8.total_lookbooks_added = response.body.total_data;

                if (_this8.total_lookbooks_added < _this8.max_plan_lookbooks) {
                    _this8.can_add_more_lookbook = true;
                }
                _this8.deactivate_processing();
            }).catch(function (err) {});
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this9 = this;

            this.sellpoint.business_market_products_limit = 1000;
            service.getAppBusinessProducts(this, this.sellpoint.business_id, this.sellpoint.business_market_products_limit).then(function (response) {
                if (response.body.status == 200) {
                    _this9.products = response.body.data;
                }
            }).catch(function (err) {});
        },
        getBusinessCategories: function getBusinessCategories() {
            service.getCategories(this).then(function (data) {
                var categories = data.body.data;

                categories.forEach(function (element) {
                    if (element.category_type == 1) {
                        this.business_product_categories.push(element);
                    }
                    if (element.category_type == 2) {
                        this.business_service_categories.push(element);
                    }
                }, this);
            });
        },
        getCategories: function getCategories(category) {
            var _this10 = this;

            service.getMainCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this10.categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSubCategories: function getSubCategories(category) {
            if (category != undefined) {
                this.sub_categories = category.sub_categories;
            } else {
                this.sub_categories = [];
            }
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this11 = this;

            service.getBusinessByUserName(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this11.sellpoint = response.body.data;

                    if (_this11.sellpoint.business_category_type == 1) {
                        _this11.is_product_service = "product";
                    }
                    if (_this11.sellpoint.business_category_type == 2) {
                        _this11.is_product_service = "service";
                    }
                    service.getBusinessCategories(_this11, _this11.sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this11.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});
                }
            }).catch(function (err) {});
        },
        getBusinessCategoryProducts: function getBusinessCategoryProducts() {
            var _this12 = this;

            service.getCategoryProducts(this, this.category.business_category_id).then(function (response) {
                if (response.body.status == 200) {
                    _this12.category.category_products = response.body.data;
                    _this12.businessComponentKey++;
                }
            }).catch(function (err) {});
        },
        getBusinessesIsOpenAgentCategoryProducts: function getBusinessesIsOpenAgentCategoryProducts() {
            var _this13 = this;

            var payload = {
                'business_category': this.category.business_category,
                'business_parent_category': this.category.business_parent_category_id,
                'business_category_type': this.category.business_category_type
            };
            service.getBusinessesOpenAgentsCategoryProducts(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this13.category.category_business_open_for_agent_products = response.body.data;
                    _this13.businessComponentKey++;
                }
            }).catch(function (err) {});
        },
        getBusinessAgentCategoryProducts: function getBusinessAgentCategoryProducts() {
            var _this14 = this;

            service.getAgentsBusinessCategoryProducts(this, this.category.business_category_id).then(function (response) {
                if (response.body.status == 200) {
                    _this14.category.category_products = response.body.data;
                    _this14.businessComponentKey++;
                }
            }).catch(function (err) {});
        },
        getBusinessesOpenAgentsProducts: function getBusinessesOpenAgentsProducts() {
            var _this15 = this;

            service.getBusinessesOpenAgentsProducts(this).then(function (response) {
                if (response.body.status == 200) {
                    _this15.business_open_agents_products = response.body.data;
                }
            }).catch(function (err) {});
        },
        addCategory: function addCategory() {
            var _this16 = this;

            this.activate_processing();
            var payload = {
                category_new: this.category.new_category || 0,
                category_new_listed: this.category.new_listed_category || "nill",
                category_parent: this.main_category.category_id || 0,
                business_id: this.sellpoint.business_id
            };
            if (payload.category_new == 0 && payload.category_new_listed == "nill") {
                this.data_error_message = "You did not pick any category, Select or any enter the category name";
                this.deactivate_processing();
            } else {
                service.addCategory(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_processing_message = "Sellpoint Category Added Successfully";
                        this.sellpoint.business_categories = data.body.data;
                        this.category = {};
                    } else {
                        this.data_error_message = "Sorry could not process request, try again";
                    }
                    this.deactivate_processing();
                    this.setBusinessComponent("viewBusiness", this.sellpoint, '');
                }).catch(function (err) {
                    _this16.data_error_message = "Sorry could not process request, try again";
                    _this16.deactivate_processing();
                });
            }
        },
        editCategory: function editCategory() {
            var _this17 = this;

            this.category.business_id = this.sellpoint.business_id;
            service.editCategory(this, this.category).then(function (data) {
                if (data.body.status == 200) {
                    this.data_processing_message = "Sellpoint Category edited";
                    this.sellpoint.business_categories = data.body.data;
                    this.setComponent('reset-edit', '');
                }
            }).catch(function (err) {
                _this17.data_processing_message = "Sellpoint Category could not be edited";
                _this17.setComponent('reset-edit', '');
            });
        },
        deleteCategory: function deleteCategory() {
            this.setComponent('reset-edit', '');
        },
        validateUserName: function validateUserName() {
            var _this18 = this;

            service.validateBusinessUserName(this, this.business).then(function (response) {
                if (response.body.status != 200) {
                    _this18.validate_user_name_error = true;
                    _this18.validate_user_name_message = "This username already exist";
                    _this18.deactivate_processing();
                }
            }).catch(function (err) {
                _this18.validate_user_name_error = true;
                _this18.validate_user_name_message = "This username already exist";
                _this18.deactivate_processing();
            });
        },
        setUpNewBusiness: function setUpNewBusiness() {
            var _this19 = this;

            this.resetAll();

            this.activate_processing();
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: service.market_app_name,
                business_layout: 1,
                business_agent: this.business_agent };
            var navi = this.$router;
            if (this.validate_user_name_error) {
                this.data_error_message = "This Username already exists..";
                this.deactivate_processing();
            } else {
                if (credentials.business_name != undefined && credentials.business_category != undefined) {
                    service.addNewBusiness(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            this.business.business_user_name = data.body.data_business_username;
                            this.data_processing_message = "Sellpoint Creation Successful.";

                            this.sellpoint = data.body.data;


                            this.setBusinessComponent('viewBusiness', this.sellpoint, '');
                            this.deactivate_processing();
                            this.resetAll();
                        } else {
                            this.data_error_message = "This Username already exists";
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        if (err) {
                            _this19.data_error_message = "Something went wrong";

                            _this19.deactivate_processing();
                        }
                    });
                } else {
                    this.data_error_message = "Kindly fill all fields";

                    this.deactivate_processing();
                }
            }
        },
        editBusinessDetails: function editBusinessDetails(attr) {
            var _this20 = this;

            this.activate_processing();
            if (attr == "delivery") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_delivery_information: this.sellpoint.business_delivery_information
                };
            } else {
                var payload = {
                    business_main_details: true,
                    business_id: this.sellpoint.business_id,
                    business_name: this.sellpoint.business_name,
                    business_tagline: this.sellpoint.business_tagline,
                    business_profile: this.sellpoint.business_profile,
                    business_emails: this.sellpoint.business_emails,
                    business_address: this.sellpoint.business_address,
                    business_phones: this.sellpoint.business_phones
                };
            }
            service.editBusinessDetails(this, payload).then(function (data) {
                if (data.body.status == 200 || data.body.status == 400) {
                    this.data_processing_message = "Sellpoint edited";
                    if (attr == "delivery") {
                        this.business_details = {};
                    } else {
                        this.manageBusinessDetails = false;

                        this.setComponent("reset-edit", "");
                        var top = document.getElementById("top").offsetTop;
                        window.scrollTo(0, top);
                        this.deactivate_processing();
                    }
                } else {
                    this.data_processing_message = "Could not edit details, something went wrong, please try again";
                    this.deactivate_processing();
                }
            }).catch(function (err) {
                _this20.data_processing_message = "Could not edit details, something went wrong, please try again";
                _this20.deactivate_processing();
            });
        },
        setOtherOptions: function setOtherOptions(v, o) {
            if (v != undefined) {
                if (v == "other") {
                    this.other_delivery_option = true;
                    if (o == "edit") {
                        this.edit_other_delivery_option = true;
                    }
                }
                if (v == "all") {
                    this.delivery_option.business_delivery_other_option = "nill";
                    if (o == "edit") {
                        this.edit_other_delivery_option = false;
                    }
                    this.other_delivery_option = false;
                }
            }
        },
        addDeliveryOption: function addDeliveryOption() {
            var _this21 = this;

            this.activate_processing();
            var payload = {
                business_delivery_state: this.delivery_option.state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
                business_delivery_custom_option: this.delivery_option.delivery_custom_option || "nill",
                business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
                business_id: this.sellpoint.business_id
            };
            if (payload.business_delivery_option_price == 0) {
                this.data_processing_message = "Delivery Charge not Added";
                this.deactivate_processing();
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.addDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 201 || data.body.status == 200) {
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.delivery_option = {};
                            this.business_details = {};
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        _this21.delivery_option = {};
                        _this21.deactivate_processing();
                    });
                } else {
                    this.data_processing_message = "Select a delivery option";
                    this.deactivate_processing();
                }
            }
        },
        editDeliveryOption: function editDeliveryOption() {
            var _this22 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id,

                business_delivery_state: this.delivery_option.business_delivery_state_id,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
                business_delivery_custom_option: this.delivery_option.business_delivery_custom_option || "nill",
                business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };

            if (payload.business_delivery_option_price == 0) {
                this.data_processing_message = "Delivery Charge not Added";
                this.deactivate_processing();
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.editDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.business_details = {};

                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        _this22.delivery_option.edit_set = false;
                        _this22.deactivate_processing();
                    });
                } else {
                    this.data_processing_message = "Select a delivery option";
                    this.deactivate_processing();
                }
            }
        },
        deleteDeliveryOption: function deleteDeliveryOption(id) {
            var _this23 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id
            };
            service.deleteDeliveryOption(this, id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.sellpoint.business_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                    this.business_details = {};
                    this.deactivate_processing();
                }
            }).catch(function (err) {
                _this23.delivery_option = {};
                _this23.deactivate_processing();
            });
        },
        addtoProcessingFee: function addtoProcessingFee() {
            this.activate_processing();

            var payload = {
                order_type: 1,
                order_user: this.user.user_id,
                order_business: this.sellpoint.business_id,
                order_amount: this.processing_fee.amount,
                order_service: "Add to Processing Fee Balance"
            };

            service.postBusinessGeneralOrders(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    this.app_orders = data.body.data;
                    this.data_processing_message = "Processing Request";
                    this.processPayment();
                }
            }).catch(function (err) {});
        },
        postBusinessProcessingFeeTransaction: function postBusinessProcessingFeeTransaction(payment_ref) {
            this.data_processing_message = "Adding Processing Fee";

            var payload = {
                processing_fee_transaction_type: 1,
                processing_fee_transaction_amount: this.processing_fee.amount,
                pay_ref: payment_ref,
                business: this.sellpoint.business_id
            };

            service.postBusinessProcessingFeeTransactions(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.processing_fee_transactions = data.body.data;
                    this.sellpoint.business_processing_fee_balance = data.body.data_processing_fee_balance;
                    this.sellpoint.business_processing_fee_debt = data.body.data__processing_fee_debt;
                    this.app_orders = {};
                    this.data_processing_message = "Processed";
                    this.setMenuTabView('');
                    this.deactivate_processing();
                    this.processing_fee = {};
                }
            }).catch(function (err) {});
        },
        setBankDetails: function setBankDetails() {
            this.activate_processing();
            var payload = {
                business_bank_name: this.sellpoint.business_bank_details.bank_name,
                business_bank_account_name: this.sellpoint.business_bank_details.bank_account_name,
                business_bank_account_number: this.sellpoint.business_bank_details.bank_account_number,
                business_id: this.sellpoint.business_id
            };

            service.setBusinessBankDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.data_processing_message = "Bank Details Set";
                    this.deactivate_processing();
                }
            }).catch(function (err) {});
        },
        switchProcessingFee: function switchProcessingFee(to) {
            this.activate_processing();
            var payload = {
                business_process_fee_pay: to,
                business_id: this.sellpoint.business_id
            };

            service.switchProcessingFeePay(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.data_processing_message = "Processing Fee Set";
                    this.sellpoint.business_processing_fee_pay_status = to;
                    this.deactivate_processing();
                }
            }).catch(function (err) {});
        },
        setShippingFeeStatus: function setShippingFeeStatus() {
            this.activate_processing();
            var payload = {
                business_set_shipping_fee_status: this.business_set_shipping_fee_status,
                business_id: this.sellpoint.business_id
            };

            service.setShippingFeeStatus(this, payload).then(function (data) {
                this.sellpoint.business_set_shipping_fee_status = this.business_set_shipping_fee_status;
                this.deactivate_processing();
            }).catch(function (err) {});
        },
        setDiscountsAndCoupons: function setDiscountsAndCoupons() {
            var _this24 = this;

            this.activate_processing();
            this.data_processing_message = "";

            if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                this.discount_coupon.discount_category = 1;
            }

            var entry_arr = [["Discount or Coupon", this.discount_coupon.is_discount_coupon, "str"], ["Coupon Percentage", this.discount_coupon.discount_percentage, "num"], ["Discount Category", this.discount_coupon.discount_category, "num"], ["Start Date", this.discount_coupon.discount_start_date, "date"], ["End Date", this.discount_coupon.discount_end_date, "date"]];
            var validated_arr = validator.validate_array(entry_arr, "Please fill in ");
            if (validated_arr.length == 0) {
                var start_date = new Date(this.discount_coupon.discount_start_date);
                var end_date = new Date(this.discount_coupon.discount_end_date);
                if (end_date <= start_date) {
                    this.data_processing_message = "Please reset Dates, End Date should be pass Start Date";
                    this.deactivate_processing();
                } else {
                    var discount_category = 0;
                    if (this.business_details.setDiscount) {
                        discount_category = this.discount_coupon.discount_category;
                    }

                    var product_id = 0;
                    var product_item_id = 0;

                    if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                        product_id = this.product.product_id;
                    }
                    if (this.product_details.setProductItemDiscount) {
                        product_item_id = this.product_item.product_item_id;
                    }


                    var payload = {
                        business_id: this.sellpoint.business_id,
                        business_market: service.apiToken,
                        product_id: product_id,
                        product_item_id: product_item_id,
                        is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'C',
                        coupon_business_category: discount_category,
                        coupon_percentage: this.discount_coupon.discount_percentage,
                        coupon_start_date: this.discount_coupon.discount_start_date,
                        coupon_end_date: this.discount_coupon.discount_end_date
                    };
                    service.setDiscountsAndCoupons(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            this.business_details.setDiscount = false;
                            this.business_details.viewDiscounts = true;
                            if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                                var res = data.body.data;
                                var _iteratorNormalCompletion2 = true;
                                var _didIteratorError2 = false;
                                var _iteratorError2 = undefined;

                                try {
                                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.product.product_items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                        var item = _step2.value;
                                        var _iteratorNormalCompletion3 = true;
                                        var _didIteratorError3 = false;
                                        var _iteratorError3 = undefined;

                                        try {
                                            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                                var row = _step3.value;

                                                if (row.product_item_id == item.product_item_id) {
                                                    item.product_item_discounts = row.product_item_discounts;
                                                }
                                            }
                                        } catch (err) {
                                            _didIteratorError3 = true;
                                            _iteratorError3 = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                                    _iterator3.return();
                                                }
                                            } finally {
                                                if (_didIteratorError3) {
                                                    throw _iteratorError3;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                            _iterator2.return();
                                        }
                                    } finally {
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                            } else {
                                this.sellpoint.business_discounts_coupons = data.body.data;
                            }
                            this.deactivate_processing();
                            this.product_details = {};
                        }
                    }).catch(function (err) {
                        _this24.deactivate_processing();
                    });
                }
            } else {
                validated_arr.forEach(function (error) {
                    this.data_processing_message = this.data_processing_message + " . " + error;
                }, this);
                this.deactivate_processing();
            }
        },
        editDiscountsAndCoupons: function editDiscountsAndCoupons() {
            var _this25 = this;

            this.data_processing_message = "";

            var entry_arr = [["Coupon Percentage", this.discount_coupon.discount_percentage, "num"], ["Discount Category", this.discount_coupon.discount_category, "num"], ["Start Date", this.discount_coupon.discount_start_date, "date"], ["End Date", this.discount_coupon.discount_end_date, "date"]];
            var validated_arr = validator.validate_array(entry_arr, "Please fill in ");
            if (validated_arr.length == 0) {
                var start_date = new Date(this.discount_coupon.discount_start_date);
                var end_date = new Date(this.discount_coupon.discount_end_date);
                if (end_date <= start_date) {
                    this.data_processing_message = "Please reset Dates, End Date should be pass Start Date";
                    this.deactivate_processing();
                } else {
                    this.activate_processing();
                    this.discount_coupon.business_id = this.sellpoint.business_id;
                    this.discount_coupon.business_market = service.apiToken;
                    service.editDiscountsAndCoupons(this, this.discount_coupon).then(function (data) {
                        if (data.body.status == 200) {
                            this.discount_coupon = {};
                            this.business_details.viewDiscounts = true;
                            if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                                var res = data.body.data;
                                var _iteratorNormalCompletion4 = true;
                                var _didIteratorError4 = false;
                                var _iteratorError4 = undefined;

                                try {
                                    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.product.product_items), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                        var item = _step4.value;
                                        var _iteratorNormalCompletion5 = true;
                                        var _didIteratorError5 = false;
                                        var _iteratorError5 = undefined;

                                        try {
                                            for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                                var row = _step5.value;

                                                if (row.product_item_id == item.product_item_id) {
                                                    item.product_item_discounts = row.product_item_discounts;
                                                }
                                            }
                                        } catch (err) {
                                            _didIteratorError5 = true;
                                            _iteratorError5 = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                                    _iterator5.return();
                                                }
                                            } finally {
                                                if (_didIteratorError5) {
                                                    throw _iteratorError5;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError4 = true;
                                    _iteratorError4 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                            _iterator4.return();
                                        }
                                    } finally {
                                        if (_didIteratorError4) {
                                            throw _iteratorError4;
                                        }
                                    }
                                }
                            } else {
                                this.sellpoint.business_discounts_coupons = data.body.data;
                            }
                            this.deactivate_processing();
                            this.product_details = {};
                        }
                    }).catch(function (err) {
                        _this25.deactivate_processing();
                    });
                }
            } else {
                validated_arr.forEach(function (error) {
                    this.data_processing_message = this.data_processing_message + " . " + error;
                }, this);
                this.deactivate_processing();
            }
        },
        deactivateDiscountsAndCoupons: function deactivateDiscountsAndCoupons(payload) {
            var _this26 = this;

            this.activate_processing();
            payload.business_id = this.sellpoint.business_id;
            payload.business_market = service.apiToken;
            service.deactivateDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.business_details.viewDiscounts = true;
                    if (this.product.product_id) {
                        var res = data.body.data;
                        var _iteratorNormalCompletion6 = true;
                        var _didIteratorError6 = false;
                        var _iteratorError6 = undefined;

                        try {
                            for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.product.product_items), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                var item = _step6.value;
                                var _iteratorNormalCompletion7 = true;
                                var _didIteratorError7 = false;
                                var _iteratorError7 = undefined;

                                try {
                                    for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                                        var row = _step7.value;

                                        if (row.product_item_id == item.product_item_id) {
                                            item.product_item_discounts = row.product_item_discounts;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError7 = true;
                                    _iteratorError7 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                            _iterator7.return();
                                        }
                                    } finally {
                                        if (_didIteratorError7) {
                                            throw _iteratorError7;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError6 = true;
                            _iteratorError6 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                    _iterator6.return();
                                }
                            } finally {
                                if (_didIteratorError6) {
                                    throw _iteratorError6;
                                }
                            }
                        }
                    } else {
                        this.sellpoint.business_discounts_coupons = data.body.data;
                    }
                    this.deactivate_processing();
                    this.product_details = {};
                }
            }).catch(function (err) {
                _this26.deactivate_processing();
            });
        },
        addProduct: function addProduct() {
            var _this28 = this;

            this.activate_processing();

            var credentials = {
                product_name: this.product.product_name,
                product_is_product_or_service: this.is_product_service,
                product_category_is_set: this.category.business_category_id || 0,
                product_business: this.sellpoint.business_id,
                product_description: this.product.product_description || "nill",
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1
            };

            var navi = this.$router;
            if (credentials.product_name != undefined) {
                service.addProduct(this, credentials).then(function (data) {
                    var _this27 = this;

                    if (data.body.status == 201) {
                        this.data_success_message = "Processing, please wait ...";

                        this.product = data.body.data;

                        this.imageForm.append("data_id", this.product.product_id);

                        this.imageForm.append("data_type", "products");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                _this27.setBusinessComponent('viewBusinessCategory', _this27.sellpoint, _this27.category);
                            }
                        }).catch(function (err) {
                            if (err) {}
                            _this27.data_error_message = "Something went wrong, preparing report ...";
                            _this27.deactivate_processing();
                        });

                        var self = this;
                        setTimeout(function () {
                            self.setBusinessComponent('viewBusinessCategory', this.sellpoint, this.category);
                        }, service.upload_wait_period);
                    }
                }).catch(function (err) {
                    if (err) {
                        _this28.data_error_message = "Something went wrong, preparing report ...";
                        _this28.deactivate_processing();
                    }
                });
            } else {
                this.data_error_message = "Kindly fill all fields ...";
                this.deactivate_processing();
            }
        },
        addNewAgentProduct: function addNewAgentProduct(product, add_to_agent_category_type) {
            this.product = product;
            this.activate_processing();

            product.product_agent_business = this.sellpoint.business_id;
            product.product_agent_category = this.category.business_category_id;
            product.product_agent_category_type = add_to_agent_category_type;

            var navi = this.$router;

            service.addAgentProduct(this, product).then(function (data) {
                if (data.body.status == 201) {
                    this.data_success_message = "Processing, please wait ...";
                    this.deactivate_processing = "";
                }
            }).catch(function (err) {});
        },
        getProductImages: function getProductImages() {
            var _this29 = this;

            service.getProductImages(this, this.product.product_id).then(function (response) {
                if (response.body.status == 200) {
                    _this29.product.product_images = response.body.data;
                    _this29.product_display_image = _this29.product.product_images[0];

                    _this29.data_media_error_message = "";
                    _this29.deactivate_processing();
                }
            }).catch(function (err) {});
        },
        deleteProductImage: function deleteProductImage(image) {
            var _this30 = this;

            this.activate_processing();
            service.deleteProductImage(this, image).then(function (data) {
                if (data.body.status == 200) {
                    this.getProductImages();
                }
                this.deactivate_processing();
            }).catch(function (err) {
                _this30.deactivate_processing();
            });
        },
        editProduct: function editProduct() {
            var _this31 = this;

            this.activate_processing();

            var set_product_category = this.product.product_category_id;
            if (this.product.product_sub_category != undefined || this.product.product_listed_category != undefined) {
                set_product_category = 0;
            } else {
                if (this.product.product_category != undefined) {
                    set_product_category = this.product.product_category;
                } else {
                    set_product_category = this.product.product_category_id;
                }
            }
            var credentials = {
                product_id: this.product.product_id,
                product_name: this.product.product_name,

                product_category: set_product_category,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",


                product_url_name: this.product.product_url_name,
                product_description: this.product.product_description || "nill",
                product_business: this.product.product_business_id };

            var navi = this.$router;
            if (credentials.product_name != undefined) {
                service.editProduct(this, this.product.product_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this31.product = response.body.data;
                        _this31.product_details = {};
                    } else {
                        _this31.product_details = {};
                        _this31.deactivate_processing();
                    }
                }).catch(function (err) {
                    if (err) {
                        _this31.data_processing_message = "Something went wrong";
                        _this31.product_details = {};
                        _this31.deactivate_processing();
                    }
                });
            } else {
                this.data_processing_message = "Kindly fill all fields";
                this.disable_btn = false;
            }
        },
        editProductSingleProductItem: function editProductSingleProductItem() {
            var _this32 = this;

            this.activate_processing();

            var set_product_item = 0;
            var current_set_product_item_actual_price = this.product.product_items[0].product_item_actual_price;
            if (this.product.product_items[0].product_item_actual_price != 0) {
                set_product_item = this.product.product_items[0].product_item_actual_price;
            } else {
                set_product_item = this.product.product_items[0].product_item_price;
            }
            var credentials = {
                product_item_id: this.product.product_items[0].product_item_id,

                product_item_price: set_product_item,
                product_item_weight: this.product.product_items[0].product_item_weight || 1,
                product_item_quantity: this.product.product_items[0].product_item_quantity || 10
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.editProductItemSingle(this, this.product.product_items[0].product_item_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this32.product.product_items[0] = response.body.data;
                        _this32.product.product_items[0].product_item_actual_price = current_set_product_item_actual_price;
                        _this32.deactivate_processing();
                        _this32.product_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this32.data_processing_message = "Update failed, Something went wrong";
                        _this32.deactivate_processing();
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        editProductSettings: function editProductSettings() {
            var _this33 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_groups_set_name: this.product.product_groups_set_name || 'Group/Types',
                product_groups_items_set_name: this.product.product_groups_items_set_name || 'Select Item'
            };

            var navi = this.$router;
            service.editProductSettings(this, this.product.product_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this33.product = response.body.data;
                    _this33.product_details = {};
                } else {
                    _this33.product_details = {};
                    _this33.deactivate_processing();
                }
            }).catch(function (err) {
                if (err) {
                    _this33.data_processing_message = "Something went wrong";
                    _this33.product_details = {};
                    _this33.deactivate_processing();
                }
            });
        },
        addProductItem: function addProductItem() {
            var _this34 = this;

            this.activate_processing();
            if (this.product_details.addProductItemToGroup) {
                var credentials = {
                    product_item_group: this.product_item_group.product_item_group_id || 1,

                    product_id: this.product.product_id,
                    product_item_price: this.product.product_item_price,
                    product_item_weight: this.product.product_item_weight || 1,
                    product_item_quantity: this.product.product_item_quantity || 1,
                    product_item_size: this.product.product_item_size || "Nill",
                    product_item_service_tag: this.product.product_item_service_tag || "Nill",
                    product_item_service_duration: this.product.product_item_service_duration + this.service_duration || '1 year'
                };
            } else {
                var new_product_item_group = false;
                var product_item_group_is_color_image = 'IMG';
                if (this.product.product_item_group == undefined) {
                    new_product_item_group = true;
                }
                if (this.product.product_item_group_color == undefined) {
                    product_item_group_is_color_image = 'IMG';
                } else {
                    product_item_group_is_color_image = 'COL';
                    this.product.product_item_group_color = '#000000';
                }
                var credentials = {
                    product_new_product_item_group: new_product_item_group,
                    product_item_group_product: this.product.product_id,
                    product_item_group_name: this.product.product_item_group_name || "Group/Type",
                    product_item_group_is_color_image: product_item_group_is_color_image,
                    product_item_group_color: this.product.product_item_group_color || "Nill",
                    product_item_group_image: this.product.product_item_group_image || 0,


                    product_item_group: this.product.product_item_group || 1,

                    product_id: this.product.product_id,
                    product_item_price: this.product.product_item_price,
                    product_item_weight: this.product.product_item_weight || 1,
                    product_item_quantity: this.product.product_item_quantity || 1,
                    product_item_size: this.product.product_item_size || "Nill",
                    product_item_service_tag: this.product.product_item_service_tag || "Nill",
                    product_item_service_duration: this.product.product_item_service_duration + this.service_duration || '1 year'
                };
            }
            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.addProductItem(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_success_message = "Product Item Added Successfully";
                        this.product = data.body.data_product;

                        this.setComponent('reset-edit', '');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this34.data_error_message = "Something went wrong";

                        _this34.deactivate_processing();
                    }
                });
            } else {
                this.data_error_message = "Kindly fill all fields";

                this.deactivate_processing();
            }
        },
        editProductItem: function editProductItem() {
            var _this35 = this;

            this.activate_processing();

            var set_product_item = 0;
            if (this.product_item.product_item_actual_price != 0) {
                set_product_item = this.product_item.product_item_actual_price;
            } else {
                set_product_item = this.product_item.product_item_price;
            }
            var credentials = {
                product_item_id: this.product_item.product_item_id,

                product_item_price: set_product_item,
                product_item_weight: this.product_item.product_item_weight || 1,
                product_item_size: this.product_item.product_item_size || "Nill",
                product_item_service_tag: this.product_item.product_item_service_tag || "Nill",
                product_item_quantity: this.product_item.product_item_quantity || 10
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.editProductItem(this, this.product_item.product_item_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this35.product_item = response.body.data;
                        _this35.deactivate_processing();
                        _this35.product_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this35.data_processing_message = "Update failed, Something went wrong";
                        _this35.deactivate_processing();
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        editProductItemGroup: function editProductItemGroup() {
            var _this36 = this;

            this.activate_processing();
            var product_item_group_is_color_image = 'IMG';
            if (this.product_item_group.product_item_group_color == undefined) {
                product_item_group_is_color_image = 'IMG';
            } else {
                product_item_group_is_color_image = 'COL';
            }

            if (this.product_item_group.product_item_group_color_new != undefined) {
                product_item_group_is_color_image = 'COL';
                this.product_item_group.product_item_group_color = this.product_item_group.product_item_group_color_new;
                this.product_item_group.product_item_group_image = 0;
            } else {
                product_item_group_is_color_image = 'IMG';
                this.product_item_group.product_item_group_color = "Nill";
            }
            var credentials = {
                product_item_group_product: this.product.product_id,
                product_item_group_name: this.product_item_group.product_item_group_name || "Type",
                product_item_group_is_color_image: product_item_group_is_color_image,
                product_item_group_color: this.product_item_group.product_item_group_color || "Nill",
                product_item_group_image: this.product_item_group.product_item_group_image || 0
            };

            var navi = this.$router;
            if (credentials.product_item_group_name != undefined) {
                service.editProductItemGroup(this, this.product_item_group.product_item_group_id, credentials).then(function (response) {
                    if (response.body.status == 200) {

                        _this36.product.product_item_groups = response.body.data;

                        _this36.deactivate_processing();
                        _this36.product_details = {};
                    } else {
                        _this36.deactivate_processing();
                        _this36.product_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this36.data_processing_message = 'Update failed, Something went wrong';
                        _this36.deactivate_processing();
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        removeProduct: function removeProduct() {
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id
            };
            var navi = this.$router;
            service.removeProduct(this, this.product.product_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    location.reload(true);
                }
            }).catch(function (err) {
                if (err) {
                    location.reload(true);
                }
            });
        },
        removeProductItem: function removeProductItem() {
            var _this37 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_id: this.product_item.product_item_id
            };
            var navi = this.$router;
            service.removeProductItem(this, this.product_item.product_item_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this37.redir(_this37.$route.params.id);
                    }
                    _this37.product.product_item_groups = response.body.data;

                    _this37.deactivate_processing();
                    _this37.removeItemPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this37.deactivate_processing();
                }
            });
        },
        removeProductItemGroup: function removeProductItemGroup() {
            var _this38 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_group_id: this.product_item_group.product_item_group_id
            };
            var navi = this.$router;
            service.removeProductItemGroup(this, this.product_item_group.product_item_group_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this38.redir(_this38.$route.params.id);
                    }
                    _this38.product.product_item_groups = response.body.data;
                    _this38.deactivate_processing();
                    _this38.removeItemGroupPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this38.deactivate_processing();
                }
            });
        },
        setProductDelivery: function setProductDelivery() {
            var _this39 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_delivery_details: this.product.product_delivery_returns
            };
            service.setProductDelivery(this, 1, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product_details = {};
                }
                this.deactivate_processing();
            }).catch(function (err) {
                _this39.product_details = {};
                _this39.deactivate_processing();
            });
        },
        setProductShippingFeeStatus: function setProductShippingFeeStatus() {
            this.set_shipping_fee_status_track = true;
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_set_shipping_fee_status: this.product_set_shipping_fee_status
            };
            service.setProductShippingFeeStatus(this, payload).then(function (data) {
                this.product.product_set_shipping_fee_status = this.product_set_shipping_fee_status;
                this.set_shipping_fee_status_track = false;
                this.deactivate_processing();
            }).catch(function (err) {});
        },
        setProductDeliveryOption: function setProductDeliveryOption() {
            var _this40 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id,
                business_product_id: this.product.product_id,
                business_product_delivery_fee: this.delivery_option.product_delivery_fee || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };
            if (payload.business_product_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_product_delivery_option != 0) {
                    service.setProductDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200 || data.body.status == 201) {
                            this.product.product_business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.product_details = {};

                            this.deactivate_processing();
                        } else {
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        _this40.delivery_option.edit_set = false;
                        _this40.product_details = {};
                        _this40.deactivate_processing();
                    });
                } else {
                    this.deactivate_processing();
                }
            }
        },
        addPostToGallery: function addPostToGallery() {
            var _this42 = this;

            this.disable_btn = true;

            var credentials = {
                gallery_new_group: false,
                gallery_post_group: this.gallery.gallery_posts_group_id,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    var _this41 = this;

                    if (data.body.status == 201) {
                        toastr.success("Post Created", 'Success!');

                        this.post = data.body.data;

                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type", "gallery_media");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                _this41.setGallery();
                                _this41.gallery = data.body.data_gallery;
                                _this41.addNewPost = false;
                                _this41.edit_mode = false;
                            }
                        }).catch(function (err) {
                            if (err) {
                                console.log(err);
                            }
                            toastr.warning("Something went wrong.", 'Warning!');
                        });
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');

                        _this42.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        editLookbook: function editLookbook() {
            var _this43 = this;

            this.activate_processing();

            var credentials = {
                gallery_group_name: this.lookbook.gallery_posts_group_name,
                gallery_group_description: this.lookbook.gallery_posts_group_text,
                gallery_group_point: this.sellpoint.business_id
            };

            var navi = this.$router;
            if (credentials.gallery_group_name != undefined) {
                service.editGallery(this, this.lookbook.gallery_posts_group_id, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        this.data_processing_message = "Lookbook Edited";

                        this.deactivate_processing();
                        this.lookbook_details = {};
                    } else {
                        this.deactivate_processing();
                        this.editGalleryPanel = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this43.data_processing_message = "Something went wrong";

                        _this43.deactivate_processing();
                        _this43.lookbook_details = {};
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.disable_btn = false;
            }
        },
        deleteLookbook: function deleteLookbook() {
            var _this44 = this;

            this.activate_processing();
            var navi = this.$router;
            service.deleteGallery(this, this.lookbook.gallery_posts_group_id).then(function (data) {
                if (data.body.status == 200) {} else {
                    this.data_processing_message = "Something went wrong";
                    this.deactivate_processing();
                    this.lookbook_details = {};
                }
            }).catch(function (err) {
                if (err) {
                    _this44.deactivate_processing();
                    _this44.lookbook_details = {};
                    _this44.data_processing_message = "Something went wrong";
                }
            });
        },
        editLookbookPost: function editLookbookPost() {
            var _this45 = this;

            this.activate_processing();

            var credentials = {
                gallery_post_caption: this.lookbook_post.gallery_post_caption,
                gallery_post_details: this.lookbook_post.gallery_post_details,
                gallery_post_group: this.lookbook.gallery_posts_group_id
            };

            var navi = this.$router;
            if (credentials.gallery_post_caption != undefined) {
                service.editGalleryPost(this, this.lookbook_post.gallery_post_id, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        this.data_processing_message = "Lookbook Post Edited";

                        this.deactivate_processing();
                        this.lookbook_details = {};
                        this.lookbook = data.body.data;
                    } else {
                        this.deactivate_processing();
                        this.lookbook_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this45.data_processing_message = "Something went wrong";

                        _this45.deactivate_processing();
                        _this45.lookbook_details = {};
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        deleteLookbookPost: function deleteLookbookPost() {
            var _this46 = this;

            this.activate_processing();
            var navi = this.$router;
            service.deleteGalleryPost(this, this.lookbook_post.gallery_post_id).then(function (data) {
                if (data.body.status == 200) {
                    this.lookbook = data.body.data;
                    this.resetComponentData("lookbook");
                    this.deactivate_processing();
                    this.lookbook_details = {};
                } else {
                    this.data_processing_message = "Something went wrong";
                    this.deactivate_processing();
                    this.lookbook_details = {};
                }
            }).catch(function (err) {
                if (err) {
                    _this46.deactivate_processing();
                    _this46.data_processing_message = "Something went wrong";
                    _this46.lookbook_details = {};
                }
            });
        },
        deletePostImage: function deletePostImage(image) {
            this.activate_processing();
            var payload = {
                data_type: "gallery_media"
            };
            service.deleteImages(this, image, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.resetComponentData("lookbook");
                    this.deactivate_processing();
                }
            }).catch(function (err) {});
        },
        resetComponentData: function resetComponentData(component) {
            var _this47 = this;

            if (component == 'lookbook') {
                service.resetData(this, "gallery", this.lookbook.gallery_posts_group_url_name).then(function (response) {
                    if (response.body.status == 200) {
                        var lookbook = response.body.data;
                        var _iteratorNormalCompletion8 = true;
                        var _didIteratorError8 = false;
                        var _iteratorError8 = undefined;

                        try {
                            for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(lookbook.gallery_posts_group_posts), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                                var post = _step8.value;

                                if (post.gallery_post_id == _this47.lookbook_post.gallery_post_id) {
                                    _this47.lookbook_post = post;
                                }
                            }
                        } catch (err) {
                            _didIteratorError8 = true;
                            _iteratorError8 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                    _iterator8.return();
                                }
                            } finally {
                                if (_didIteratorError8) {
                                    throw _iteratorError8;
                                }
                            }
                        }

                        _this47.deactivate_processing();
                    }
                }).catch(function (err) {});
            }
        },
        onFileChange: function onFileChange(e, type, data_id) {
            var _this48 = this;

            this.product_details = {};
            this.product_details.uploading_image = true;
            this.activate_processing();
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);


                this.imageForm = formData;

                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "products") {
                            _this48.getProductImages();
                            if (_this48.product_details.editProductItemGroup) {
                                _this48.product_item_group.product_item_group_image = data.body.data_id;
                            }
                        }

                        if (type == "product_information") {
                            _this48.getProductInformation();
                        }
                        _this48.deactivate_processing();
                    } else {
                        _this48.data_processing_message = "Something went wrong uploading media, please try again";
                        _this48.deactivate_processing();
                    }
                    _this48.product_details.uploading_image = false;
                }).catch(function (err) {
                    _this48.data_processing_message = "Something went wrong uploading media, please try again";
                    _this48.deactivate_processing();
                    _this48.product_details.uploading_image = false;
                });
            }
        },
        onFileChangeNewProduct: function onFileChangeNewProduct(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        },
        onFileChangeProductItems: function onFileChangeProductItems(e, type, data_id) {
            var _this49 = this;

            this.activate_processing();
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);
                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "products") {
                            _this49.product.product_item_group_image = data.body.data_id;

                            _this49.getProductImages();
                        }
                    }
                }).catch(function (err) {
                    if (err) {}
                });

                this.data_media_error_message = service.media_upload_timeout_msg;
                var self = this;
                setTimeout(function () {
                    self.data_media_error_message;
                }, 65000);
                setTimeout(function () {
                    self.data_media_error_message = "";
                }, 95000);
            }
        },
        onFileChangeLookbook: function onFileChangeLookbook(e, type, data_id) {
            var _this50 = this;

            this.activate_processing();
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);

                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "gallery_media") {
                            _this50.resetComponentData("lookbook");
                        }
                    } else {
                        _this50.data_processing_message = "Sorry Upload Failed";
                    }
                    _this50.deactivate_processing();
                }).catch(function (err) {
                    if (err) {
                        _this50.data_processing_message = "Sorry Upload Failed";
                        _this50.deactivate_processing();
                    }
                });
            }
        },
        processPayment: function processPayment() {
            this.data_processing_message = "Preparing Payment Information";

            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.app_orders.payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.app_orders.payer_phone).toLowerCase());
            if (email_test == false || this.app_orders.payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
                his.deactivate_processing();
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                var obj = this;

                var handler = PaystackPop.setup({
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.app_orders.payer_name,

                    email: this.app_orders.payer_email,
                    amount: Math.round(this.app_orders.pay_amount * 100),
                    ref: this.app_orders.pay_ref,
                    metadata: {
                        custom_fields: [{
                            display_name: "Service",
                            variable_name: "service_type",
                            value: this.app_orders.pay_service_details
                        }]
                    },

                    callback: function callback(response) {
                        obj.updatePayment(response.trxref);
                    },
                    onClose: function onClose() {
                        alert('window closed');
                    }
                });
                handler.openIframe();
            }
        },
        updatePayment: function updatePayment(payment_ref) {
            this.postBusinessProcessingFeeTransaction(payment_ref);
        }
    },
    created: function created() {
        document.title = "Account" + "";
        this.getStates();
        this.getBusinessCategories();
        this.getBusinessesOpenAgentsProducts();
        this.preset();
    }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Buypoint',
    data: function data() {
        return {
            child_route_view: false,
            loading: false,
            loggedIn: false,
            user: {},
            sellpoint: {},
            set_gallery_banner_image: ""
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        setSellpoint: function setSellpoint() {
            var _this = this;

            this.loading = true;
            service.getAppBusinessByUserName(this, service.business_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this.sellpoint = response.body.data;
                    document.title = _this.sellpoint.business_name + " | SP";

                    if (_this.sellpoint.business_banner_image == _this.default_banner_image || _this.sellpoint.business_banner_image == 'error') {
                        _this.set_gallery_banner_image = service.general_banner_image;
                    } else {
                        _this.set_gallery_banner_image = _this.sellpoint.business_banner_image;
                    }

                    if (_this.sellpoint.business_market_subscription_name == 'Bird Plan') {
                        _this.max_plan_lookbooks = 2;
                        _this.max_plan_lookbook_posts = 5;
                    }
                    if (_this.sellpoint.business_market_subscription_name == 'Mid Bird Plan') {
                        _this.max_plan_lookbooks = 10;
                        _this.max_plan_lookbook_posts = 50;
                    }
                    if (_this.sellpoint.business_market_subscription_name == 'Max Bird Plan') {
                        _this.max_plan_lookbooks = 50;
                        _this.max_plan_lookbook_posts = 50;
                        _this.can_add_product_lookbook = true;
                    }

                    _this.preset();
                    _this.loading = false;
                } else {
                    _this.business_load_error_msg = "Sorry, this Business Information could not be found.";
                }
            }).catch(function (err) {
                _this.loading = false;
            });
        }
    },

    created: function created() {
        this.setSellpoint();
    }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__(8);





var service = new __WEBPACK_IMPORTED_MODULE_3__services_service__["a" /* default */]();



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Cart',
    data: function data() {
        return {
            loading: false,
            user: {},
            group_products: {},
            item_product: {},
            checked_out: [],
            processed_checkout_orders: [],
            sorted_cart: [],
            orders: [],
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            coupon_code: [],
            product_delivery_fee: "",
            sellpoint_delivery_fee: "",
            payment_option: "",
            total_order_amt: 0.0,
            total_delivery_fee: 0.0,
            processed_groups: 0,
            process_count: 0,
            loggedIn: false,
            buy_now_order: false
        };
    },

    components: {},
    computed: {},
    methods: {
        setComponent: function setComponent(attr1, attr2) {},
        toggleProductDelivery: function toggleProductDelivery(attr1, i, product_index) {
            if (attr1 == 'item-delivery-options') {
                this.sorted_cart[i][1][product_index].display_delivery_details = true;
            }
            if (attr1 == 'hide-item-delivery-options') {
                this.sorted_cart[i][1][product_index].display_delivery_details = false;
            }
        },
        toggleSellpointDelivery: function toggleSellpointDelivery(attr1, i) {
            if (attr1 == 'group-delivery-options') {
                this.sorted_cart[i].display_delivery_details++;
            }
            if (attr1 == 'hide-group-delivery-options') {
                this.sorted_cart[i].display_delivery_details = false;
            }
        },
        removeFromCart: function removeFromCart(item_id, group_index, item) {
            this.removeFromSortedCart(group_index, item);
            this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["j" /* REMOVE_FROM_CART */], item_id);

            this.prepCart();
        },
        removeFromSortedCart: function removeFromSortedCart(group_index, item) {
            var index = this.sorted_cart[group_index][1].findIndex(function (p) {
                return p._id === item._id;
            });
            this.sorted_cart[group_index][1].splice(index, 1);
        },
        prepCart: function prepCart() {
            var sorted_cart = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.cart.reduce(function (result, obj) {
                (result[obj.product_business] || (result[obj.product_business] = [])).push(obj);
                return result;
            }, {}));


            var count = 0;var sorted_cart_array = [];
            sorted_cart.forEach(function (element) {
                var _this = this;

                var pre_sort = [];

                pre_sort.products_with_delivery_details_count = 0;
                pre_sort.products_without_delivery_details_count = 0;
                pre_sort.products_with_delivery_details_checked = [];
                pre_sort.products_without_delivery_details_checked = [];

                element.forEach(function (item) {
                    item.can_remove = true;
                    item.display_delivery_details = false;

                    item.has_delivery = false;
                    if (item.product_checked) {
                        item.product_checked = false;
                    }

                    service.getProductDeliveryOptions(this, item.product_main_id).then(function (response) {
                        if (response.body.status == 200) {
                            item.has_delivery = true;
                            item.delivery_option = 0;
                            pre_sort.products_with_delivery_details_count += 1;
                        } else {
                            pre_sort.products_without_delivery_details_count += 1;
                        }
                    }).catch(function (err) {
                        pre_sort.products_without_delivery_details_count += 1;
                    });
                }, this);
                pre_sort.display_delivery_details = 0;
                pre_sort[0] = element[0].product_business;
                pre_sort[1] = element;
                pre_sort.items_in_checkout = 0;
                pre_sort.total_order_amt = 0.0;
                pre_sort.delivery_option_fee = 0.0;
                pre_sort.total_delivery_charge = 0.0;
                pre_sort.order_coupons_discounts = [];
                var promises = [];
                for (var i = 0; i < 5; ++i) {
                    if (i == 1) {
                        promises.push(service.getBusinessDiscountsAndCoupons(this, element[0].product_business).then(function (response) {
                            if (response.body.status == 200) {
                                pre_sort[4] = response.body.data;
                            }
                        }).catch(function (err) {}));
                    }

                    if (i == 2) {
                        promises.push(service.getBusinessDeliveryOptions(this, element[0].product_business).then(function (response) {
                            if (response.body.status == 200) {
                                var delivery_options = response.body.data;

                                if (element.length == 1) {
                                    delivery_options.forEach(function (item) {
                                        var fees = item.business_products_delivery_fees;

                                        if (fees.length != 0) {
                                            fees.forEach(function (fee) {
                                                if (element[0].product_main_id == fee.product_delivery_product) {
                                                    item.has_product_delivery_fee = true;
                                                    item.business_product_delivery_fee = fee.product_delivery_fee;
                                                    pre_sort[2] = delivery_options;
                                                }
                                            }, this);
                                        } else {
                                            pre_sort[2] = delivery_options;
                                        }
                                    }, _this);
                                } else {
                                    pre_sort[2] = delivery_options;
                                }

                                pre_sort.business_shipping_calculation_method = response.body.data_business_set_shipping_fee_status;
                            } else {
                                pre_sort.delivery_option = "Free Delivery";
                            }
                        }).catch(function (err) {}));
                    }

                    if (i == 3) {
                        promises.push(service.checkBusinessPayOnDelivery(this, element[0].product_business).then(function (response) {
                            if (response.body.status == 200) {
                                pre_sort[3] = response.body.data;
                            }
                        }).catch(function (err) {}));
                    }
                }

                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
                    sorted_cart_array.push(pre_sort);
                }).catch(function (e) {});
            }, this);

            this.sorted_cart = sorted_cart_array;

            return this.sorted_cart;
        },
        preset: function preset() {
            var _this2 = this;

            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;

                            this.prepCart();
                        }, _this2);
                        _this2.loggedIn = true;
                    } else {}
                    _this2.loading = false;
                }).catch(function (err) {
                    if (err) {}
                });
            } else {
                this.$router.push('login');
            }
        },
        set_coupons: function set_coupons(i, coupon, coupon_percentage) {
            var calc = 0;
            if (this.sorted_cart[i].total_order_amt != 0) {
                if (!coupon.added) {
                    calc = coupon_percentage / 100 * this.sorted_cart[i].total_order_amt;

                    coupon.added = true;
                    coupon.value = calc;
                    this.sorted_cart[i].order_coupons_discounts.push(coupon);

                    this.sorted_cart[i].total_order_amt -= calc;

                    this.total_order_amt -= calc;
                } else {
                    calc = coupon.value;

                    coupon.added = false;
                    var index = this.sorted_cart[i].order_coupons_discounts.findIndex(function (c) {
                        return c.discount_id === coupon.discount_id;
                    });
                    this.sorted_cart[i].order_coupons_discounts.splice(index, 1);

                    this.sorted_cart[i].total_order_amt += calc;

                    this.total_order_amt += calc;
                    coupon.value = 0;
                }
            } else {
                toastr.warning("Select an Order", 'Warning!');
                this.coupon_code.checked = false;
            }
        },
        calc_product_delivery_fee: function calc_product_delivery_fee(i, option, product_index) {
            if (this.sorted_cart[i][1][product_index].delivery_option_fee != undefined) {
                if (this.sorted_cart[i][1][product_index].delivery_option_fee != 0.0) {
                    this.total_delivery_fee -= this.sorted_cart[i][1][product_index].delivery_option_fee;
                    this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i][1][product_index].delivery_option_fee;
                }
            }

            this.sorted_cart[i][1][product_index].selected_product_delivery_option = option;

            this.sorted_cart[i][1][product_index].delivery_option = option.business_delivery_option_id;
            this.sorted_cart[i][1][product_index].delivery_option_fee = Number(option.business_delivery_option_price);

            this.sorted_cart[i].total_delivery_charge += Number(option.business_delivery_option_price);
            this.total_delivery_fee += Number(option.business_delivery_option_price);
        },
        calc_sellpoint_delivery_fee_XXX: function calc_sellpoint_delivery_fee_XXX(i, option) {
            if (this.sorted_cart[i].delivery_option_fee != 0.0) {
                this.total_delivery_fee -= this.sorted_cart[i].delivery_option_fee;
                this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i].delivery_option_fee;
            }

            this.sorted_cart[i].selected_business_delivery_option = option;

            this.sorted_cart[i].delivery_option = option.business_delivery_option_id;
            this.sorted_cart[i].delivery_option_fee = Number(option.business_delivery_option_price);

            this.sorted_cart[i].total_delivery_charge += Number(option.business_delivery_option_price);

            this.total_delivery_fee += Number(option.business_delivery_option_price);
        },
        calc_sellpoint_delivery_fee: function calc_sellpoint_delivery_fee(i, option) {
            if (this.sorted_cart[i].delivery_option_fee != 0.0) {
                this.total_delivery_fee -= this.sorted_cart[i].delivery_option_fee;
                this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i].delivery_option_fee;
            }

            this.sorted_cart[i].selected_business_delivery_option = option;
            this.sorted_cart[i].delivery_option = option.business_delivery_option_id;

            this.sorted_cart[i].delivery_option_total_delivery_fee = 0;

            var fees = option.business_products_delivery_fees;
            if (fees.length == 0) {
                if (this.sorted_cart[i].business_shipping_calculation_method == 9) {
                    this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price);
                } else {
                    var items_to_checkout = this.sorted_cart[i][1].filter(function (item) {
                        return item.product_checked == true;
                    });
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(items_to_checkout), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var item = _step.value;

                            if (this.sorted_cart[i].business_shipping_calculation_method == 10) {
                                this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price);
                            }
                            if (this.sorted_cart[i].business_shipping_calculation_method == 11) {
                                this.sorted_cart[i].delivery_option_total_delivery_fee += Number(item.product_item_order_quantity * option.business_delivery_option_price);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            } else {
                var _items_to_checkout = this.sorted_cart[i][1].filter(function (item) {
                    return item.product_checked == true;
                });

                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_items_to_checkout), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var _item = _step2.value;

                        if (_item.has_calculated_product_delivery_fee == true) {
                            _item.has_calculated_product_delivery_fee = false;
                            _item.calculated_product_delivery_fee = 0;
                        };
                        var _iteratorNormalCompletion4 = true;
                        var _didIteratorError4 = false;
                        var _iteratorError4 = undefined;

                        try {
                            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(fees), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                var fee = _step4.value;

                                if (_item.product_main_id == fee.product_delivery_product) {
                                    if (_item.product_shipping_calculation_method == 13) {
                                        this.sorted_cart[i].delivery_option_total_delivery_fee += Number(_item.product_item_order_quantity * fee.product_delivery_fee);
                                    }
                                    if (_item.product_shipping_calculation_method == 12) {
                                        this.sorted_cart[i].delivery_option_total_delivery_fee += Number(fee.product_delivery_fee);
                                    }

                                    _item.has_calculated_product_delivery_fee = true;
                                }
                            }
                        } catch (err) {
                            _didIteratorError4 = true;
                            _iteratorError4 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                    _iterator4.return();
                                }
                            } finally {
                                if (_didIteratorError4) {
                                    throw _iteratorError4;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                var sorted_fees = _items_to_checkout.filter(function (item) {
                    return item.has_calculated_product_delivery_fee == true;
                });

                if (sorted_fees.length < _items_to_checkout.length) {
                    if (this.sorted_cart[i].business_shipping_calculation_method == 9) {
                        this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price);
                    } else {
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_items_to_checkout), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var _item2 = _step3.value;

                                if (this.sorted_cart[i].business_shipping_calculation_method == 10) {
                                    this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price);
                                }
                                if (this.sorted_cart[i].business_shipping_calculation_method == 11) {
                                    this.sorted_cart[i].delivery_option_total_delivery_fee += Number(_item2.product_item_order_quantity * option.business_delivery_option_price);
                                }
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                    }
                }
            }

            this.sorted_cart[i].delivery_option_fee = Number(this.sorted_cart[i].delivery_option_total_delivery_fee);

            this.sorted_cart[i].total_delivery_charge += Number(this.sorted_cart[i].delivery_option_total_delivery_fee);

            this.total_delivery_fee += Number(this.sorted_cart[i].delivery_option_total_delivery_fee);
        },
        calc_total_delivery_fee: function calc_total_delivery_fee() {
            this.sorted_cart.forEach(function (element) {});
        },
        setPaymentOption: function setPaymentOption(i, option) {
            this.sorted_cart[i].payment_mode = option;
        },
        pre_checkout: function pre_checkout() {
            this.preset();
        },
        refreshCheckout: function refreshCheckout(it, group_index, item_index) {
            this.sorted_cart[group_index].total_order_amt = 0;
            this.total_order_amt = 0;
            this.checked_out.forEach(function (item) {
                this.sorted_cart[group_index].total_order_amt += item.product_item_order_quantity * item.product_item_price;

                this.total_order_amt += item.product_item_order_quantity * item.product_item_price;
            }, this);
        },
        addToCheckout: function addToCheckout(item, group_index, item_index) {
            this.sorted_cart[group_index][1][item_index].can_remove = false;
            this.sorted_cart[group_index].products_in_checkout = true;
            if (this.sorted_cart[group_index][1][item_index].has_delivery) {
                this.sorted_cart[group_index].products_with_delivery_details_checked.push(item);
            } else {
                this.sorted_cart[group_index].products_without_delivery_details_checked.push(item);
            }

            this.checked_out.push(item);
            this.sorted_cart[group_index][1][item_index].product_checked = true;
            this.sorted_cart[group_index].total_order_amt += item.product_item_order_quantity * item.product_item_price;

            this.total_order_amt += item.product_item_order_quantity * item.product_item_price;
            this.sorted_cart[group_index].items_in_checkout++;

            if (this.sorted_cart[group_index][1][item_index].has_delivery) {
                this.sorted_cart[group_index][1][item_index].display_delivery_details = true;
            }

            if (this.sorted_cart[group_index].selected_business_delivery_option) {
                this.calc_sellpoint_delivery_fee(group_index, this.sorted_cart[group_index].selected_business_delivery_option);
            }

            if (this.buy_now_order) {
                document.getElementById(item.item_index + "PRT_CART").style = "display:block;";
            }
        },
        removeFromCheckout: function removeFromCheckout(item, group_index, item_index) {
            var index = this.checked_out.findIndex(function (p) {
                return p._id === item._id;
            });
            this.checked_out.splice(index, 1);
            this.sorted_cart[group_index][1][item_index].product_checked = false;

            if (this.sorted_cart[group_index][1][item_index].has_delivery) {
                var _index = this.sorted_cart[group_index].products_with_delivery_details_checked.findIndex(function (p) {
                    return p._id === item._id;
                });
                this.sorted_cart[group_index].products_with_delivery_details_checked.splice(_index, 1);;
            } else {
                var _index2 = this.sorted_cart[group_index].products_without_delivery_details_checked.findIndex(function (p) {
                    return p._id === item._id;
                });
                this.sorted_cart[group_index].products_without_delivery_details_checked.splice(_index2, 1);;
            }

            this.sorted_cart[group_index].total_order_amt -= item.product_item_order_quantity * item.product_item_price;

            this.total_order_amt -= item.product_item_order_quantity * item.product_item_price;
            this.sorted_cart[group_index].items_in_checkout--;

            this.sorted_cart[group_index][1][item_index].can_remove = true;
            if (this.sorted_cart[group_index].items_in_checkout == 0 && this.sorted_cart[group_index].delivery_option != "Free Delivery") {
                this.total_delivery_fee -= this.sorted_cart[group_index].delivery_option_fee;
                this.sorted_cart[group_index].delivery_option_fee = 0;
                this.sorted_cart[group_index].delivery_option = 0;
                this.sorted_cart[group_index].total_delivery_charge = 0;
            }

            if (this.sorted_cart[group_index].selected_business_delivery_option) {
                this.calc_sellpoint_delivery_fee(group_index, this.sorted_cart[group_index].selected_business_delivery_option);
            }
        },
        process_checkout: function process_checkout(group) {
            var processed_checkout = {};

            processed_checkout.order_user_id = this.user.user_id;
            processed_checkout.order_mode = 1;
            processed_checkout.order_business = group[0];
            var order_url = group[0] + new Date().getTime();
            processed_checkout.order_url = order_url, processed_checkout.order_delivery_option = group.delivery_option;
            processed_checkout.order_payment_mode = group.payment_mode || 1;
            processed_checkout.order_coupons_discounts = group.order_coupons_discounts;
            processed_checkout.order_items = [];
            this.checked_out.forEach(function (element) {
                if (element.product_business == group[0]) {
                    processed_checkout.order_items.push(element);
                }
                processed_checkout.status = "processed";
            }, this);
            if (processed_checkout.status == "processed") {
                if (this.loggedIn) {
                    service.checkout(this, processed_checkout).then(function (data) {
                        if (data.body.status == 201) {
                            this.process_count++;

                            processed_checkout.order_items.forEach(function (item) {
                                this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["j" /* REMOVE_FROM_CART */], item._id);
                                var index = this.checked_out.findIndex(function (p) {
                                    return p._id === item._id;
                                });
                                this.checked_out.splice(index, 1);
                            }, this);
                        }

                        if (this.process_count == this.processed_groups) {
                            this.total_delivery_fee = 0;
                            this.total_order_amt = 0;

                            location.replace("/checkout/" + order_url);
                        }
                    }).catch(function (err) {
                        if (err) {
                            toastr.warning("Something went wrong", 'Warning!');
                        }
                    });
                } else {
                    this.process_count++;

                    processed_checkout.order_items.forEach(function (item) {
                        this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["j" /* REMOVE_FROM_CART */], item._id);
                        var index = this.checked_out.findIndex(function (p) {
                            return p._id === item._id;
                        });
                        this.checked_out.splice(index, 1);
                    }, this);

                    if (this.process_count == this.processed_groups) {
                        this.total_delivery_fee = 0;
                        this.total_order_amt = 0;

                        return processed_checkout;
                    }
                }
            }
        },
        process_orders: function process_orders() {
            var processed = [];
            var product_errors = 0;

            this.checked_out.forEach(function (item) {
                if (item.has_delivery && item.delivery_option == 0) {
                    product_errors++;
                    toastr.error("Please select a delivery option for " + item.product_name, 'Warning!');
                }
            }, this);

            this.sorted_cart.forEach(function (group) {
                var with_delivery = group.products_with_delivery_details_checked.length;
                var without_delivery = group.products_without_delivery_details_checked.length;

                if (with_delivery != 0 && without_delivery == 0) {
                    group.delivery_option = "Product Specific Delivery Set";
                }

                if (group.items_in_checkout) {
                    if (group.delivery_option != 0 && group.delivery_option != undefined) {
                        processed.push(group);
                    } else {
                        product_errors++;
                        toastr.error("Please select a delivery option for " + group[0], 'Warning!');
                    }
                }
            }, this);

            if (this.loggedIn) {
                if (processed.length != 0 && product_errors == 0) {
                    this.processed_groups = processed.length;
                    processed.forEach(function (group) {
                        this.process_checkout(group);
                    }, this);
                }
            } else {
                var processed_to_store_in_forage = [];
                if (processed.length != 0 && product_errors == 0) {
                    this.processed_groups = processed.length;
                    processed.forEach(function (group) {
                        processed_to_store_in_forage.push(this.process_checkout(group));
                    }, this);
                    localforage.setItem('buy_now_order', processed_to_store_in_forage).then(function (value) {}).catch(function (err) {});
                }

                this.$router.push("checkout");
            }
        },
        processPayment: function processPayment(data) {
            var obj = this;

            var handler = PaystackPop.setup({
                key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                Name: data.payment_payer_name,

                email: "keneinfostream@gmail.com",
                amount: Math.round(data.payment_amount * 100),
                ref: data.payment_ref,
                metadata: {
                    custom_fields: [{
                        display_name: "",
                        variable_name: "",
                        value: data.payment_payer_name
                    }, {
                        display_name: "Service",
                        variable_name: "service_type",
                        value: data.payment_service
                    }]
                },

                callback: function callback(response) {
                    obj.updatePayment(response.trxref);
                },
                onClose: function onClose() {
                    alert('window closed');
                }
            });
            handler.openIframe();
        },
        updatePayment: function updatePayment(payment_ref) {
            var _this3 = this;

            var payload = {
                payment_order_ref: payment_ref,
                payment_user_id: this.user.user_id
            };
            var navi = this.$router;

            if (payment_ref != "") {
                service.updatePayment(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Payment Processed!", "Success!");

                        if (_this3.request_page != '') {
                            _this3.$router.push(_this3.request_page);
                        } else {
                            _this3.$router.go('/');
                        }
                    } else {
                        toastr.error('Sorry, could not update payment', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Something went wrong', 'Warning!');
            }
        }
    },
    created: function created() {
        if (this.$route.path == '/order') {
            this.buy_now_order = true;
        }
        document.title = "Cart" + " | SP";

        if (localStorage.getItem("sp_token") != undefined) {
            this.preset();
        } else {
            this.prepCart();
        }
    }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(8);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Cart',
    data: function data() {
        return {
            loading: false,
            user: {},
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            loggedIn: false
        };
    },

    components: {
        'cart-widget': __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue___default.a
    },
    computed: {},
    methods: {},
    created: function created() {
        document.title = "Cart" + " | SP";
    }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(8);


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Cart',
    data: function data() {
        return {
            user: {},
            selected_order: [],
            checkout_orders: {},
            delivery_details: [],
            payment_details: {},
            payment_mode: "",
            request_page: "orders",
            checked_out: [],
            processed_checkout_orders: [],
            sorted_cart: [],
            orders: [],
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            item_delivery_fee: "",
            delivery_fee: "",
            payment_option: "",
            total_order_amt: 0.0,
            total_orders_amount: 0.0,
            total_shipping_fee: 0.0,
            states: {},
            cities: [],
            loggedIn: false,
            new_account: true,
            process_count: 0,
            checkout_processed: false,
            data_error_message: "",
            data_success_message: "",
            is_logged_in_order_mode: 0,
            disable_btn: false,
            loading: true,
            action_loading: false,
            selected_order_shipping_details_state: "",
            selected_order_shipping_details_city: "",
            selected_order_shipping_details_address: ""
        };
    },

    components: {},
    computed: {},
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == 'login') {
                this.new_account = false;
            }
            if (attr1 == 'new-account') {
                this.new_account = true;
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        removeFromCart: function removeFromCart(payload) {
            this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["j" /* REMOVE_FROM_CART */], payload);
        },
        getStates: function getStates() {
            var _this = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state) {
            var _this2 = this;

            this.activate_processing();
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this2.cities = response.body.data;
                    _this2.deactivate_processing();
                }
            }).catch(function (err) {
                _this2.deactivate_processing();
            });
        },
        login: function login() {
            var _this3 = this;

            this.activate_processing();
            service.loginUser(this, this.user).then(function (response) {
                if (response.body.status == 200) {
                    var data = response.body.data;
                    localStorage.setItem("sp_user", data.user_name);
                    localStorage.setItem("sp_token", data.user_session_key);
                    localStorage.setItem("sp_token_key", data.user_token_key);
                    _this3.user = data;
                    if (!_this3.new_account) {
                        _this3.is_logged_in_order_mode = 1;
                        _this3.process_checkout();
                        _this3.deactivate_processing();
                    }
                } else {
                    _this3.data_error_message = "Sorry, these login details are invalid.";
                    _this3.deactivate_processing();
                }
            }).catch(function (err) {
                _this3.deactivate_processing();
            });
        },
        preset: function preset() {
            var _this4 = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;

                            this.loggedIn = true;

                            if (this.$route.params.ckid != null) {
                                this.order_url = this.$route.params.ckid;
                                this.getCheckoutOrdersByURL();
                            } else {
                                this.getCheckoutOrders();
                            }
                            this.checkout_processed = true;
                            this.loading = false;

                            this.getUserDeliveryDetails();
                        }, _this4);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        getCheckoutLocalOrder: function getCheckoutLocalOrder() {
            this.loading = false;

            this.activate_processing();
            var self = this;

            setTimeout(function () {
                localforage.getItem('buy_now_order').then(function (value) {
                    if (value != null) {
                        self.checkout_orders = value;
                    }
                }).catch(function (err) {
                    this.deactivate_processing();
                    this.$router.push("orders");
                });
            }, 500);
        },
        getCheckoutOrders: function getCheckoutOrders() {
            var _this5 = this;

            this.activate_processing();
            service.getCheckoutOrders(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this5.setCheckoutOrders(response);
                } else {
                    _this5.$router.push("orders");
                }
            }).catch(function (err) {
                _this5.deactivate_processing();
                _this5.$router.push("orders");
            });
        },
        getCheckoutOrdersByURL: function getCheckoutOrdersByURL() {
            var _this6 = this;

            this.activate_processing();
            service.getCheckoutOrder(this, this.order_url).then(function (response) {
                if (response.body.status == 200) {
                    _this6.setCheckoutOrders(response);
                } else {
                    _this6.deactivate_processing();
                    _this6.$router.push("orders");
                }
            }).catch(function (err) {
                _this6.deactivate_processing();
                _this6.$router.push("orders");
            });
        },
        setCheckoutOrders: function setCheckoutOrders(response) {
            this.checkout_orders = response.body.data;
            this.total_orders_amount = response.body.data_total_orders_amount;
            this.total_shipping_fee = response.body.data_calculated_shipping_fee;
            this.delivery_details = response.body.data_user_delivery_details;
            this.payment_details = response.body.payment_data;

            this.checkout_orders.forEach(function (order) {
                order.display_delivery = false;
                order.cities = {};
            }, this);

            this.checkout_processed = true;
            if (this.new_account) {
                this.login();
            }
            this.deactivate_processing();
        },
        getUserDeliveryDetails: function getUserDeliveryDetails() {
            var _this7 = this;

            service.getUserDeliveryDetails(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this7.delivery_details = response.body.data;
                }
            }).catch(function (err) {});
        },
        prep_process_checkout: function prep_process_checkout() {
            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.user.user_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.user.user_phone).toLowerCase());
            if (email_test == false || this.user.user_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                this.user.user_has_shipping_details = true;
                this.user.user_password = this.user.user_name;
                this.user.new_set_account = true;

                this.process_checkout();
            }
        },
        process_checkout: function process_checkout() {
            this.activate_processing();

            this.checkout_orders.forEach(function (processed_checkout) {
                var _this8 = this;

                this.order_url = this.checkout_orders[0].order_business + new Date().getTime();
                processed_checkout.order_mode = this.is_logged_in_order_mode;
                processed_checkout.order_url = this.order_url;
                if (!this.new_account) {
                    processed_checkout.order_user_id = this.user.user_id;
                } else {
                    processed_checkout.order_user_details = this.user;
                }

                service.checkout(this, processed_checkout).then(function (data) {
                    if (data.body.status == 201) {
                        this.process_count++;
                    }
                    if (this.process_count == this.checkout_orders.length) {
                        this.getCheckoutOrdersByURL();
                    }
                    this.deactivate_processing();
                }).catch(function (err) {
                    if (err) {
                        _this8.deactivate_processing();
                    }
                });
            }, this);
        },
        pre_checkout: function pre_checkout() {
            this.preset();
        },
        displayDeliveryOptions: function displayDeliveryOptions(order) {
            this.selected_order = [];
            this.selected_order = order;
            if (this.selected_order.display_delivery) {
                this.selected_order.display_delivery = false;
            } else {
                this.selected_order.display_delivery = true;
            }
        },
        calc_delivery_fee: function calc_delivery_fee(i, option) {
            this.total_order_amt -= this.checkout_orders[i].order_delivery_fee;
            this.checkout_orders[i].order_total -= this.checkout_orders[i].order_delivery_fee;
            this.checkout_orders[i].order_delivery_id = option.business_delivery_option_id;
            this.checkout_orders[i].order_delivery_fee = option.business_delivery_option_price;
            this.checkout_orders[i].order_delivery_city = option.business_delivery_option;

            this.checkout_orders[i].order_delivery_id = option.business_delivery_option_id;
            this.checkout_orders[i].order_delivery_fee = option.business_delivery_option_price;

            this.total_order_amt += option.business_delivery_option_price;
            this.checkout_orders[i].order_total += option.business_delivery_option_price;
            this.delivery_details.forEach(function (detail) {
                if (detail.user_delivery_city == option.business_delivery_option) {
                    this.checkout_orders[i].order_user_delivery_addresses = [];

                    this.checkout_orders[i].order_user_delivery_addresses.push(detail);
                }
            }, this);
        },
        calc_product_specific_delivery_fee: function calc_product_specific_delivery_fee(i, i2, option) {
            this.total_order_amt -= this.checkout_orders[i].order_items[i2].order_delivery_fee;
            this.checkout_orders[i].order_total -= this.checkout_orders[i].order_items[i2].order_delivery_fee;
            this.checkout_orders[i].order_items[i2].order_delivery_id = option.business_delivery_option_id;
            this.checkout_orders[i].order_items[i2].order_delivery_fee = option.business_delivery_option_price;
            this.checkout_orders[i].order_items[i2].order_delivery_city = option.business_delivery_option;

            this.checkout_orders[i].order_items[i2].order_delivery_id = option.business_delivery_option_id;
            this.checkout_orders[i].order_items[i2].order_delivery_fee = option.business_delivery_option_price;

            this.total_order_amt += option.business_delivery_option_price;
            this.checkout_orders[i].order_total += option.business_delivery_option_price;
            this.checkout_orders[i].order_items[i2].order_user_delivery_addresses = [];

            this.delivery_details.forEach(function (detail) {
                if (detail.address_city == option.business_delivery_option_city_id) {
                    this.checkout_orders[i].order_items[i2].order_user_delivery_addresses.push(detail);
                } else {}
            }, this);
        },
        setUserDeliveryAddress: function setUserDeliveryAddress(i, city) {
            this.delivery_details.forEach(function (detail) {
                if (detail.user_delivery_city == city) {
                    this.checkout_orders[i].order_user_delivery_address = detail.user_delivery_address;
                }
            }, this);
        },
        setPaymentOption: function setPaymentOption(option) {
            this.payment_mode = option;
        },
        processPayment: function processPayment() {
            var process_errors = [];

            this.checkout_orders.forEach(function (order) {
                if (order.order_user_delivery_address == undefined && order.order_user_new_delivery_address == undefined) {
                    process_errors.push("Please enter delivery address for " + order.order_business);
                }

                order.order_items.forEach(function (item) {
                    if (item.order_delivery_city) {
                        if (item.order_user_delivery_address == undefined && item.order_user_new_delivery_address == undefined) {
                            process_errors.push("Please enter delivery address for " + item.product_name);
                        }
                    }
                }, this);
            }, this);
            if (process_errors.length != 0) {
                process_errors.forEach(function (error) {
                    toastr.error(error);
                }, this);
            } else {
                this.processCardPayment(this.payment_details);
            }
        },
        processPaymentMini: function processPaymentMini() {
            var process_errors = [];

            if (this.selected_order_shipping_details_state != '' && this.selected_order_shipping_details_city != '' && this.selected_order_shipping_details_address != '') {
                this.processCardPayment(this.payment_details);
            }
        },
        processCardPayment: function processCardPayment(data) {
            var obj = this;

            var handler = PaystackPop.setup({
                key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                Name: data.payment_payer_name,

                email: "keneinfostream@gmail.com",
                amount: Math.round(data.payment_amount * 100),
                ref: data.payment_ref,
                metadata: {
                    custom_fields: [{
                        display_name: "",
                        variable_name: "",
                        value: data.payment_payer_name
                    }, {
                        display_name: "Service",
                        variable_name: "service_type",
                        value: data.payment_service
                    }]
                },

                callback: function callback(response) {
                    obj.updatePayment(response.trxref);
                },
                onClose: function onClose() {
                    alert('window closed');
                }
            });
            handler.openIframe();
        },
        updatePayment: function updatePayment(payment_ref) {
            var _this9 = this;

            var payload = {
                payment_order_ref: payment_ref,
                payment_order_amount_paid: this.payment_details.payment_amount,
                payment_user_id: this.user.user_id,
                payment_orders: this.checkout_orders,
                payment_details: this.payment_details.payment_service,
                payment_order_delivery_details: { state: this.selected_order_shipping_details_state,
                    city: this.selected_order_shipping_details_city,
                    address: this.selected_order_shipping_details_address }
            };
            var navi = this.$router;

            if (payment_ref != "") {
                service.updatePayment(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Payment Processed!", "Success!");

                        if (_this9.request_page != '') {
                            _this9.$router.push(_this9.request_page);
                        } else {
                            _this9.$router.go('/');
                        }
                    } else {
                        toastr.error('Sorry, could not update payment', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Something went wrong', 'Warning!');
            }
        }
    },
    created: function created() {
        document.title = "Checkout" + " | Gallery";

        this.loading = true;
        if (localStorage.getItem("sp_token") != undefined || localStorage.getItem("sp_token") != null) {
            this.new_account = false;
            this.preset();
        } else {
            this.getCheckoutLocalOrder();
        }
        this.getStates();
    }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Order',
    data: function data() {
        return {
            loading: false,
            user: {},
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            loggedIn: false
        };
    },

    components: {
        'cart-widget': __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue___default.a
    },
    computed: {},
    methods: {},
    created: function created() {
        document.title = "Order" + " | Gallery";
    }
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Orders',
    data: function data() {
        return {
            user: {},
            orders: {},
            order: {},
            img_product_url: service.imageProductsURL
        };
    },

    components: {},

    methods: {
        setOrder: function setOrder(order) {
            this.order = order;
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.getOrders();
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getOrders: function getOrders() {
            var _this2 = this;

            service.getOrders(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.orders = response.body.data;
                    _this2.orders.set = true;
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        document.title = "Orders" + " | SP";

        this.preset();
    }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CreateSellpoint',
    data: function data() {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints: {},
            categories: {},
            market_categories: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error: false,
            validate_user_name_message: "",
            group_isset: false,
            add_sellpoint: false,
            add_business: false,
            get_flag: false,
            loading: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        validateUserName: function validateUserName() {
            var _this = this;

            service.validateBusinessUserName(this, this.business).then(function (response) {
                if (response.body.status == 200) {
                    _this.validate_user_name_error = false;
                    _this.validate_user_name_message = "This sellpoint does not exist";
                } else {
                    _this.validate_user_name_error = true;
                    _this.validate_user_name_message = "This username already exist";
                }
            }).catch(function (err) {
                _this.validate_user_name_error = true;
                _this.validate_user_name_message = "This username already exist";
            });
        },
        preset: function preset() {
            var _this2 = this;

            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this2);

                        _this2.getBusinessCategories();
                        _this2.getMarketCategories();
                        _this2.getSellpoints(_this2.user.user_id);

                        _this2.loading = false;
                    } else {
                        _this2.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this2.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getStates: function getStates() {
            service.getStates(this).then(function (data) {
                this.states = data.body;
            });
        },
        getCities: function getCities(state) {
            service.getCities(this, state).then(function (data) {
                this.cities = data.body;
            });
        },
        getBusinessCategories: function getBusinessCategories() {
            service.getCategories(this).then(function (data) {
                this.categories = data.body.data;
            });
        },
        getMarketCategories: function getMarketCategories() {
            service.getMarketCategories(this).then(function (data) {
                this.market_categories = data.body.data;
            });
        },
        getSellpoints: function getSellpoints(user) {
            var _this3 = this;

            service.getBusinesses(this, user).then(function (data) {
                if (data.body.status == 200) {
                    var result = data.body.data;
                    var arr = [];
                    result.forEach(function (element) {
                        if (element.business_type == 1) {
                            arr.push(element);
                        }
                    });
                    _this3.sellpoints = arr;
                }
            }).catch(function (err) {
                if (err) {
                    console.log(err);
                }
            });
        },
        createSellpoint: function createSellpoint() {
            var _this4 = this;

            this.disable_btn = true;
            this.business.agree = true;
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_market_category: this.business.market_category || 0,
                business_owner: this.user.user_id
            };
            var navi = this.$router;
            if (this.validate_user_name_error) {
                toastr.error('This Username already exists', 'Warning!');
            } else {
                if (credentials.business_name != undefined && credentials.business_category != undefined) {
                    if (this.business.agree) {
                        service.addBusiness(this, credentials).then(function (data) {
                            if (data.body.status == 201) {
                                toastr.success("Sellpoint Creation Successfull", 'Success!');

                                this.business = data.body.data;
                                navi.push('/' + this.business.business_user_name);
                            }
                        }).catch(function (err) {
                            if (err) {
                                toastr.warning("Something went wrong", 'Warning!');
                                _this4.disable_btn = false;
                            }
                        });
                    } else {
                        toastr.error('Please agree to Terms', 'Warning!');
                        this.disable_btn = false;
                    }
                } else {
                    toastr.error('Kindly fill all fields', 'Warning!');
                    this.disable_btn = false;
                }
            }
        },
        addSelectedExistingSellpoint: function addSelectedExistingSellpoint() {
            var _this5 = this;

            this.disable_btn = true;
            this.business.agree = true;
            var credentials = {
                business_user_name: this.business.business_user_name,
                business_group: localStorage.getItem("sp_#_sellpoint") || "nill"
            };
            var navi = this.$router;
            if (credentials.business_user_name != undefined) {
                service.addExistingBusiness(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Sellpoint Added Successfull", 'Success!');

                        navi.push('/' + localStorage.getItem("sp_#_sellpoint"));
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');
                        _this5.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        addExistingSellpoint: function addExistingSellpoint() {
            var _this6 = this;

            this.disable_btn = true;
            this.business.agree = true;
            var credentials = {
                business_user_name: this.business.business_user_name,
                business_group: localStorage.getItem("sp_#_sellpoint") || "nill"
            };
            var navi = this.$router;
            if (!this.validate_user_name_error) {
                toastr.error('This Sellpoint does not exist', 'Warning!');
            } else {
                if (credentials.business_user_name != undefined) {
                    service.addExistingBusiness(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            toastr.success("Sellpoint Added Successfull", 'Success!');

                            navi.push('/' + localStorage.getItem("sp_#_sellpoint"));
                        }
                    }).catch(function (err) {
                        if (err) {
                            toastr.warning("Something went wrong", 'Warning!');
                            _this6.disable_btn = false;
                        }
                    });
                } else {
                    toastr.error('Kindly fill all fields', 'Warning!');
                    this.disable_btn = false;
                }
            }
        },
        addNewSellpoint: function addNewSellpoint() {
            var _this7 = this;

            this.disable_btn = true;
            this.business.agree = true;
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: localStorage.getItem("sp_#_sellpoint") || "nill"
            };
            var navi = this.$router;
            if (this.validate_user_name_error) {
                toastr.error('This Username already exists', 'Warning!');
            } else {
                if (credentials.business_name != undefined && credentials.business_category != undefined) {
                    if (this.business.agree) {
                        service.addNewBusiness(this, credentials).then(function (data) {
                            if (data.body.status == 201) {
                                toastr.success("Sellpoint Creation Successfull", 'Success!');

                                navi.push('/' + localStorage.getItem("sp_#_sellpoint"));
                            }
                        }).catch(function (err) {
                            if (err) {
                                toastr.warning("Something went wrong", 'Warning!');
                                _this7.disable_btn = false;
                            }
                        });
                    } else {
                        toastr.error('Please agree to Terms', 'Warning!');
                        this.disable_btn = false;
                    }
                } else {
                    toastr.error('Kindly fill all fields', 'Warning!');
                    this.disable_btn = false;
                }
            }
        }
    },
    created: function created() {
        this.preset();
        if (this.$route.query.create == "new") {
            this.add_sellpoint = true;
        }
        if (this.$route.query.create == "add") {
            this.add_sellpoint = true;
            this.add_business = true;
        }
    }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_posts_newgallery_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_posts_newgallery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_posts_newgallery_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_posts_newproductgallery_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_posts_newproductgallery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_posts_newproductgallery_vue__);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Sellpoint',
    data: function data() {
        return {
            user: {},
            market: {},
            sellpoint: {},
            categories: {},
            galleria: {},
            gallery: {},
            gallery_post: {},
            gallery_post_set_image: {},
            post: {},
            products: {},
            product: {},
            productMain: {},
            productItem: {},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            edit_mode: false,
            loading: true,
            online: false,
            place_order: false,
            ordered_product: {},
            ordered_product_item: {},
            swipe_index: 0,

            data_error_message: "",
            data_success_message: "",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name: "",
            payment_payer_email: "",
            payment_payer_phone: "",
            payment_service: "",

            addPanel: false,
            business_load_error_msg: "",
            newLookbookForm: false,
            newProductLookbookForm: false,
            max_plan_lookbooks: 0,
            max_plan_lookbook_posts: 0,
            total_lookbooks_added: 0,
            can_add_more_lookbook: false,
            can_add_product_lookbook: false,
            addNewPost: false,
            file_info: {},
            refresh_button: false,
            disable_btn: false,
            action_loading: false,
            default_banner_image: "https://res.cloudinary.com/diprbfy7s/image/upload/v1550754799/businesses_files/sp-default-banner.jpg"

        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'add-lookbook': __WEBPACK_IMPORTED_MODULE_3__components_posts_newgallery_vue___default.a,
        'add-product-lookbook': __WEBPACK_IMPORTED_MODULE_4__components_posts_newproductgallery_vue___default.a
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        mobileSideNavToggle: function mobileSideNavToggle(action) {
            if (action == "open") {
                var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

                if (isMobile) {
                    document.getElementById("mobileSideNav").style.width = "100%";
                } else {
                    document.getElementById("mobileSideNav").style.width = "50%";
                }
            }
            if (action == "close") {
                document.getElementById("mobileSideNav").style.width = "0";
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        checkIfVideo: function checkIfVideo(url) {
            if (url != undefined) {
                var ext = url.split('.').pop();
                if (service.video_exts.includes(ext)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        addComponent: function addComponent(attr1, attr2) {
            this.addPanel = true;

            if (attr1 == "add-new-lookbook") {
                this.newLookbookForm = true;
            }
            if (attr1 == "add-new-product-lookbook") {
                this.newProductLookbookForm = true;
            }
            if (attr1 == "add-new-product-post") {
                this.$router.push("/" + this.$route.params.id + "/" + this.gallery.gallery_posts_group_url_name);
                $('#quickviewModal').modal('hide');

                this.newProductLookbookForm = true;
            }
            if (attr1 == "add-new-post") {
                this.addNewPost = true;
                $('#quickviewModal').modal('hide');
                this.gallery = attr2;
            }

            var top = document.getElementById("addPanelView").offsetTop;
            window.scrollTo(0, top);
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == "refresh-store") {
                this.getGalleryPosts();
            }
        },
        reset: function reset() {
            this.addPanel = false, this.addNewPost = false;
            this.newLookbookForm = false;
            this.newProductLookbookForm = false;
            this.data_error_message = "";
            this.data_success_message = "";
        },
        preset: function preset() {
            var _this = this;

            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                            this.is_editing();
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        is_editing: function is_editing() {
            var _this2 = this;

            if (this.user.user_id != "") {
                var payload = {
                    validate_user: this.user.user_id,
                    validate_business: this.sellpoint.business_id
                };
                service.can_edit(this, payload).then(function (response) {
                    if (response.body.status == 200) {
                        _this2.edit_mode = true;
                    } else {
                        _this2.edit_mode = false;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        setGallery: function setGallery() {
            var _this3 = this;

            this.loading = true;
            service.getGallerySearch(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this3.gallery = response.body.data;

                    _this3.loading = false;
                }
            }).catch(function (err) {
                console.log(err);
            });
        },
        setSellpoint: function setSellpoint() {
            var _this4 = this;

            this.loading = true;
            service.getAppBusinessByUserName(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this4.sellpoint = response.body.data;

                    if (_this4.sellpoint.business_market_subscription_name == 'Bird Plan') {
                        _this4.max_plan_lookbooks = 2;
                        _this4.max_plan_lookbook_posts = 5;
                    }
                    if (_this4.sellpoint.business_market_subscription_name == 'Mid Bird Plan') {
                        _this4.max_plan_lookbooks = 10;
                        _this4.max_plan_lookbook_posts = 50;
                    }
                    if (_this4.sellpoint.business_market_subscription_name == 'Max Bird Plan') {
                        _this4.max_plan_lookbooks = 50;
                        _this4.max_plan_lookbook_posts = 50;
                        _this4.can_add_product_lookbook = true;
                    }

                    var self = _this4;
                    setTimeout(function () {
                        self.getGalleryPosts();
                    }, 3000);
                    _this4.preset();
                    _this4.loading = false;
                } else {
                    _this4.business_load_error_msg = "Sorry, we could not load this Business Information";
                }
            }).catch(function (err) {
                _this4.loading = false;
            });
        },
        getProductsInBusinessCategories: function getProductsInBusinessCategories() {
            var _this5 = this;

            this.loading = true;
            service.getProductsInBusinessCategories(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this5.categories = response.body.data;
                }
                _this5.loading = false;
            }).catch(function (err) {
                _this5.loading = false;
            });
        },
        getGalleryPosts: function getGalleryPosts() {
            var _this6 = this;

            this.loading = true;
            service.getPointGalleryPosts(this, this.sellpoint.business_id, 0, this.max_plan_lookbooks, 0, this.max_plan_lookbook_posts).then(function (response) {
                _this6.galleria = response.body.data;

                _this6.total_lookbooks_added = response.body.total_data;

                if (_this6.total_lookbooks_added < _this6.max_plan_lookbooks) {
                    _this6.can_add_more_lookbook = true;
                }

                _this6.loading = false;
            }).catch(function (err) {
                _this6.loading = false;
            });
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this7 = this;

            this.loading = true;
            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {

                    _this7.products = response.body.data;
                    _this7.loading = false;
                }
            }).catch(function (err) {});
        },
        getPostsInGallery: function getPostsInGallery(gallery) {
            this.gallery = gallery;
            this.gallery_post = gallery.gallery_posts_group_posts[0];

            this.gallery_post_set_image = this.gallery_post.gallery_post_media[0];
            $('#quickviewModal').modal('show');
        },
        getCategoryProducts: function getCategoryProducts(category) {
            this.loading = true;
            this.product = category.business_category_products[0];
            this.products = category.business_category_products;
            $('#quickviewModal').modal('show');
            this.loading = false;
        },
        getCategoryProductsXX: function getCategoryProductsXX(category) {
            var _this8 = this;

            this.loading = true;
            var self = this;
            service.getCategoryProducts(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this8.products = response.body.data;

                    var count = 0;
                    _this8.products.forEach(function (element) {
                        count++;
                        if (count == 1) {
                            _this8.product = element;
                            $('#quickviewModal').modal('show');
                        }
                    });
                    _this8.loading = false;
                }
            }).catch(function (err) {
                _this8.loading = false;
            });
        },
        showPost: function showPost(post) {
            this.gallery_post = post;

            this.gallery_post_set_image = post.gallery_post_media[0];
        },
        showPostImage: function showPostImage(post_image) {
            this.gallery_post_set_image = post_image;
        },
        showProduct: function showProduct(product) {
            this.product = product;
        },
        addPostToGallery: function addPostToGallery() {
            var _this10 = this;

            this.disable_btn = true;

            var credentials = {
                gallery_new_group: false,
                gallery_post_group: this.gallery.gallery_posts_group_id,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    var _this9 = this;

                    if (data.body.status == 201) {
                        this.data_success_message = "Post Created";

                        this.post = data.body.data;

                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type", "gallery_media");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                location.reload(true);

                                _this9.gallery = data.body.data_gallery;
                                _this9.addNewPost = false;
                            }
                        }).catch(function (err) {
                            if (err) {}

                            _this9.data_error_message = "Something went wrong";
                        });
                    }
                }).catch(function (err) {
                    if (err) {
                        _this10.data_error_message = "Something went wrong";

                        _this10.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        },
        manageLookbook: function manageLookbook() {
            var _this11 = this;

            this.disable_btn = true;

            var credentials = {
                session_key: localStorage.getItem("sp_token"),
                request_url: service.app_url,
                request_from: service.app_name,
                request_status: "REQUESTING...",
                request: this.sellpoint.business_username + '/g/' + this.gallery.gallery_posts_group_url_name
            };
            if (credentials.session_key != null) {
                service.sessionSync(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var ref = response.body.data;
                        window.location.href = service.sp_url + '/manage/' + ref;
                    } else {
                        _this11.disable_btn = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        console.log(err);
                        _this11.disable_btn = false;
                    }
                });
            }
        },
        addToCart: function addToCart(productMain, productItem) {
            this.productItem = {};
            var cart_index = this.cart.findIndex(function (c) {
                return c.product_item_id === productItem.product_item_id;
            });
            if (cart_index < 0) {
                this.productMain = productMain;
                this.productItem = productItem;
                this.productItem._id = this.productItem.product_item_id;
                this.productItem.is_product_in_cart = true;

                if (this.productItem.product_item_order_quantity == undefined) {
                    this.productItem.product_item_order_quantity = 1;
                }
                this.productItem.product_main_id = this.productMain.product_id;
                this.productItem.product_business = this.productMain.product_business_ownername;
                this.productItem.product_name = this.productMain.product_name;
                this.productItem.product_url_name = this.productMain.product_url_name;
                this.productItem.product_url = this.productMain.product_business_ownername + "/" + this.productMain.product_url_name;
                this.$store.commit(ADD_TO_CART, this.productItem);
            } else {}
        },
        removeFromCart: function removeFromCart(payload) {
            this.$store.commit(REMOVE_FROM_CART, payload);
        },
        placeOrder: function placeOrder(product, product_item) {
            this.ordered_product = product;
            this.ordered_product_item = product_item;
            this.place_order = true;
        },
        resetOptions: function resetOptions() {
            this.ordered_product = {};
            this.ordered_product_item = {};
            this.total_price = 0;
            this.place_order = false;
        },
        processPayment: function processPayment() {
            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                this.payment_service = "HungrillvilleKitchen Order - " + this.ordered_product.product_name + "(" + this.ordered_product_item.product_item_price + ")";
                var obj = this;

                var handler = PaystackPop.setup({
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.payment_payer_name,

                    email: this.payment_payer_email,
                    amount: Math.round(this.ordered_product_item.product_item_price * 100),
                    ref: "HUNGLOG" + Math.random(),
                    metadata: {
                        custom_fields: [{
                            display_name: "HungrillvilleKitchen Order",
                            variable_name: "",
                            value: this.payment_payer_name + " - " + this.payment_payer_phone + " - ORDER - " + this.ordered_product.product_name
                        }, {
                            display_name: "Service",
                            variable_name: "service_type",
                            value: this.ordered_product.product_name
                        }]
                    },

                    callback: function callback(response) {
                        obj.updatePayment(response.trxref);
                    },
                    onClose: function onClose() {
                        alert('window closed');
                    }
                });
                handler.openIframe();
            }
        },
        updatePayment: function updatePayment(payment_ref) {
            var navi = this.$router;

            var payer_name = this.payment_payer_name;
            this.data = {};

            this.payment_successful = true;
            this.payment_successful_message = "Hi " + payer_name + ", Your Payment was successful, we would proceed to prepare your order. Thank You.";
        }
    },
    mounted: function mounted() {
        this.preset();
    },

    created: function created() {
        if (this.$route.params.idg) {
            this.$router.push('/' + this.$route.params.id);
        }
        if (this.addPanel) {
            this.refresh_button = true;
        }
        this.reset();
        this.setSellpoint();
    }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_menubottom_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_menubottom_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_templates_menubottom_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tools_settings_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tools_settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_tools_settings_vue__);






var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    data: function data() {
        return {
            user: {},
            market: {},
            business: {},
            categories: {},
            subscriptions: {},
            plan1: {},
            plan2: {},
            plan3: {},
            selected_plan: {},
            place_order: false,

            data_boarding_message: "",
            set_up_with_existing_account: false,
            set_up_with_new_account: false,
            set_up_business: false,
            validate_user_name_error: false,
            data_error_message: "",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name: "",
            payment_payer_email: "",
            payment_payer_phone: "",
            payment_service: "",
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            disable_btn: false
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a,
        'component-menu-bottom': __WEBPACK_IMPORTED_MODULE_4__components_templates_menubottom_vue___default.a,
        'c-settings': __WEBPACK_IMPORTED_MODULE_5__components_tools_settings_vue___default.a
    },
    computed: {},
    methods: {
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                            this.$router.push('/timeline');
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == 'setup-existing') {
                this.set_up_with_existing_account = true;
            }
        },
        toggleFAQComponent: function toggleFAQComponent(action, show, hide, head, body) {
            if (action == 'show') {
                document.getElementById(show).style.display = "none";
                document.getElementById(hide).style.display = "block";
                document.getElementById(head).style.color = "#ff0000";
                document.getElementById(body).style.display = "block";
            }
            if (action == 'hide') {
                document.getElementById(show).style.display = "block";
                document.getElementById(hide).style.display = "==none";
                document.getElementById(head).style.color = "#777b92";
                document.getElementById(body).style.display = "none";
            }
        },
        getSellpointMarket: function getSellpointMarket() {
            var _this2 = this;

            service.getBusinessByUserName(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this2.market = response.body.data;

                    _this2.getMarketMainProductsAsSubscriptions();

                    _this2.loading = false;
                }
            }).catch(function (err) {});
        },
        getMarketMainProductsAsSubscriptions: function getMarketMainProductsAsSubscriptions() {
            var _this3 = this;

            service.getBusinessProducts(this, this.market.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this3.subscriptions = response.body.data;
                    _this3.plan1 = _this3.subscriptions[2];
                    _this3.plan2 = _this3.subscriptions[1];
                    _this3.plan3 = _this3.subscriptions[0];
                }
            }).catch(function (err) {});
        },
        purchase_plan: function purchase_plan(plan, plan_product_service_item_index) {
            this.loading = true;
            this.selected_plan = plan;
            this.place_order = true;

            this.$router.push('/purchase/?purchase=' + plan.product_url_name + '&item=' + plan_product_service_item_index);
        },
        resetOptions: function resetOptions() {
            this.selected_plan = {};
            this.total_price = 0;
            this.place_order = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        proceedNewAccount: function proceedNewAccount() {
            this.resetMessages();
            this.set_up_with_new_account = true;

            if (this.selected_plan.product_items[0].product_item_price == 0) {
                this.updatePayment("gw-free-account");
            } else {
                this.processPayment();
            }
        },
        proceedWithAccount: function proceedWithAccount() {
            this.resetMessages();
            var payload = {
                user_email: this.user.user_email,
                user_password: this.user.user_password,
                user_business: this.user.user_business
            };
            service.checkUserDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    if (data.body.status_2 != 200) {
                        this.data_error_message = "Sorry, Sellpoint does not exist on this account";
                    } else {
                        this.payment_payer_name = data.body.data.user_name;
                        this.payment_payer_email = data.body.data.user_email;
                        this.payment_payer_phone = data.body.data.user_phone;

                        if (this.selected_plan.product_items[0].product_item_price == 0) {
                            this.updatePayment("gw-free-account");
                        } else {
                            this.processPayment();
                        }
                    }
                } else {
                    this.data_error_message = "Sorry, Account does not exist";
                }
            }).catch(function (err) {});
        },
        processPayment: function processPayment() {
            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                this.payment_service = "Gallery Website Order - " + this.selected_plan.product_name + "(" + this.selected_plan.product_items[0].product_item_price + ")";
                var obj = this;

                var handler = PaystackPop.setup({
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.payment_payer_name,

                    email: this.payment_payer_email,
                    amount: Math.round(this.selected_plan.product_items[0].product_item_price * 100),
                    ref: "GWLOG" + Math.random(),
                    metadata: {
                        custom_fields: [{
                            display_name: "GalleryWebsite Order",
                            variable_name: "",
                            value: this.payment_payer_name + " - " + this.payment_payer_phone + " - ORDER - " + this.selected_plan.product_name
                        }, {
                            display_name: "Service",
                            variable_name: "service_type",
                            value: this.selected_plan.product_name
                        }]
                    },

                    callback: function callback(response) {
                        obj.updatePayment(response.trxref);
                    },
                    onClose: function onClose() {
                        alert('window closed');
                    }
                });
                handler.openIframe();
            }
        },
        updatePayment: function updatePayment(payment_ref) {

            var navi = this.$router;
            this.payment_successful = true;
            this.payment_successful_message = "Payment Successful...";

            if (this.set_up_with_existing_account) {
                this.setUpExistingAccount();
            }
            if (this.set_up_with_new_account) {
                this.setUpNewAccount();
            }
        },
        setUpExistingAccount: function setUpExistingAccount() {
            var _this5 = this;

            this.disable_btn = true;
            var credentials = {
                business_user_name: this.user.user_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan.product_id
            };

            var navi = this.$router;
            service.addExistingBusiness(this, credentials).then(function (data) {
                var _this4 = this;

                if (data.body.status == 201) {
                    this.boarding_messages.push("Sellpoint Setup Successful...");

                    var credentials = {
                        user_email: this.user.user_email,
                        user_password: this.user.user_password
                    };
                    service.loginUser(this, credentials).then(function (response) {
                        if (response.body.status == 200) {
                            var _data = response.body.data;
                            localStorage.setItem("sp_user", _data.user_name);
                            localStorage.setItem("sp_token", _data.user_session_key);
                            localStorage.setItem("sp_token_key", _data.user_token_key);

                            $('#purchaseModal').modal('hide');
                            navi.push('/' + _this4.user.user_business);
                        }
                    }).catch(function (err) {
                        if (err.status == 404) {
                            toastr.warning("invalid login credentials", 'Warning!');
                            _this4.disable_btn = false;
                        }
                    });
                }
            }).catch(function (err) {
                if (err) {
                    toastr.warning("Something went wrong", 'Warning!');
                    _this5.disable_btn = false;
                }
            });
        },
        setUpNewAccount: function setUpNewAccount() {
            this.disable_btn = true;
            this.loading = true;
            var credentials = {
                user_name: this.payment_payer_name,
                user_phone: this.payment_payer_phone,
                user_email: this.payment_payer_email,
                user_address: '',
                user_state: '',
                user_city: '',
                user_password: this.user.user_password
            };

            var navi = this.$router;

            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                if (credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null && credentials.user_email != null && credentials.user_password != null) {
                    service.regUser(this, credentials).then(function (data) {
                        var _this6 = this;

                        if (data.body.status == 201) {
                            this.data_boarding_message = "Registration Successful...";

                            var credentials = {
                                user_email: data.body.data.user_email,
                                user_password: data.body.data.user_password
                            };
                            service.loginUser(this, credentials).then(function (response) {
                                if (response.body.status == 200) {
                                    var _data2 = response.body.data;
                                    localStorage.setItem("sp_user", _data2.user_name);
                                    localStorage.setItem("sp_token", _data2.user_session_key);
                                    localStorage.setItem("sp_token_key", _data2.user_token_key);

                                    _this6.preset();

                                    setTimeout(function () {
                                        this.set_up_business = true;
                                        $('#purchaseModal').modal('hide');
                                        $('#newBusinessModal').modal('show');
                                    }, 3000);
                                }
                            }).catch(function (err) {
                                if (err.status == 404) {
                                    _this6.data_error_message = "invalid login credentials..";
                                    _this6.disable_btn = false;
                                }
                            });
                        } else if (data.body.status == 409) {
                            this.data_error_message = "This User is already registered..";
                            this.disable_btn = false;
                        }
                    });
                } else {
                    this.data_error_message = "Kindly fill all fields...";
                    this.disable_btn = false;
                }
            }
        },
        validateUserName: function validateUserName() {
            var _this7 = this;

            service.validateBusinessUserName(this, this.business).then(function (response) {
                if (response.body.status != 200) {
                    _this7.validate_user_name_error = true;
                    _this7.validate_user_name_message = "This username already exist";
                }
            }).catch(function (err) {
                _this7.validate_user_name_error = true;
                _this7.validate_user_name_message = "This username already exist";
            });
        },
        setUpNewAccountBusiness: function setUpNewAccountBusiness() {
            var _this8 = this;

            this.resetMessages();
            this.disable_btn = true;
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: service.market_app_name,
                business_layout: this.business.business_view_layout || 3,
                business_subscription: this.selected_plan.product_id
            };
            var navi = this.$router;
            if (this.validate_user_name_error) {
                this.data_error_message = "This Username already exists..";
            } else {
                if (credentials.business_name != undefined && credentials.business_category != undefined) {
                    service.addNewBusiness(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            this.data_boarding_message = "Sellpoint Creation Successful.";

                            $('#newBusinessModal').modal('hide');
                            navi.push('/' + this.business.business_user_name);
                        } else {
                            this.data_error_message = "This Username already exists";
                        }
                    }).catch(function (err) {
                        if (err) {
                            _this8.data_error_message = "Something went wrong";
                            _this8.disable_btn = false;
                        }
                    });
                } else {
                    this.data_error_message = "Kindly fill all fields";
                    this.disable_btn = false;
                }
            }
        },
        getBusinessCategories: function getBusinessCategories() {
            service.getCategories(this).then(function (data) {
                this.categories = data.body.data;
            });
        },
        creation_thread: function creation_thread() {
            var promises = [];
            for (var i = 0; i < 9; ++i) {
                if (i == 1) {
                    promises.push(this.preset());
                }
                if (i == 2) {
                    promises.push(this.getSellpointMarket());
                }
            }

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
                var result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
                promises.forEach(function (promise) {
                    result.then(function () {});
                });
            }).catch(function (e) {});
        }
    },

    created: function created() {
        var self = this;
        setTimeout(function () {
            var menu = self.$route.params.menu;
            if (menu == "features") {
                var top = document.getElementById("features").offsetTop;
                window.scrollTo(0, top);
            }
            if (menu == "pricing") {
                var top = document.getElementById("pricing").offsetTop;
                window.scrollTo(0, top);
            }
            if (menu == "blog") {
                var top = document.getElementById("blog").offsetTop;
                window.scrollTo(0, top);
            }
        }, 1500);
        this.creation_thread();
    }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Register',
    data: function data() {
        var _ref;

        return _ref = {
            users: {},
            user: {},
            states: {},
            cities: {},
            disable_btn: false,
            data_error_message: ""
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'disable_btn', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'action_loading', false), _ref;
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a
    },
    methods: {
        reset: function reset() {
            localStorage.removeItem("sp_user");
            localStorage.removeItem("sp_token");
            localStorage.removeItem("sp_token_key");
            localStorage.removeItem("sp_#_sellpoint");
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        login: function login() {
            var _this = this;

            this.activate_processing();
            this.data_error_message = "";
            var credentials = {
                user_email: this.user.email,
                user_password: this.user.password
            };

            var navi = this.$router;
            if (credentials.user_email != null && credentials.user_password != null) {
                service.loginUser(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        localStorage.setItem("sp_user", data.user_name);
                        localStorage.setItem("sp_token", data.user_session_key);
                        localStorage.setItem("sp_token_key", data.user_token_key);
                        navi.push('/timeline');
                    } else {
                        _this.data_error_message = "invalid login credentials";

                        _this.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this.data_error_message = "Sorry, could not process request";

                    _this.deactivate_processing();
                });
            } else {
                this.data_error_message = "Kindly fill all fields";
                this.disable_btn = false;
            }
        }
    },
    created: function created() {
        this.reset();
    }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_templates_menubottom_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_templates_menubottom_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_templates_menubottom_vue__);


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "MainFooter",
    data: function data() {
        return {
            user: {},
            user_slug: {}
        };
    },

    components: {
        'component-menu-bottom': __WEBPACK_IMPORTED_MODULE_1__components_templates_menubottom_vue___default.a
    }

});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tools_settings_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tools_settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_tools_settings_vue__);


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "MainHeader",
    data: function data() {
        return {
            path: this.$route.path.replace('/', ''),
            user: {},
            user_slug: {},
            market: {},
            products: {},
            product: {},
            items: [],
            checked_out_items: [],
            img_url: service.imageURL,
            loggedIn: false,
            server_query_done: false
        };
    },


    components: {
        'c-settings': __WEBPACK_IMPORTED_MODULE_1__components_tools_settings_vue___default.a

    },
    methods: {
        back: function back() {
            window.history.back();
        },
        display_menu: function display_menu() {
            var status = document.getElementById("main-nav-bar").style.display;
            if (status == "none") {
                document.getElementById("main-nav-bar").style.display = "block";
            } else {
                document.getElementById("main-nav-bar").style.display = "none";
            }
        },
        checkLoggedIn: function checkLoggedIn() {
            if (localStorage.getItem("sp_token") != null) {
                this.loggedIn = true;
                this.user = localStorage.getItem("sp_user");
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this.server_query_done = true;
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, _this);
                    } else {}
                    _this.server_query_done = true;
                }).catch(function (err) {
                    if (err) {
                        _this.server_query_done = true;
                    }
                });
            } else {
                this.server_query_done = true;
            }
        },
        setMarketRemote: function setMarketRemote() {
            var _this2 = this;

            service.getBusinessByUserName(this, "").then(function (response) {
                if (response.body.status == 200) {
                    _this2.market = response.body.data;
                }
            }).catch(function (err) {});
        },
        setMarketLocal: function setMarketLocal() {}
    },
    created: function created() {
        this.checkLoggedIn();
    }
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Account',
    data: function data() {
        return {
            user: {},
            sellpoints: {},
            img_url: service.imageURL,
            user_business_interests: {}
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        syncset: function syncset() {
            var navi = this.$router;
            service.sessionSyncSet(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    var data = response.body.data;

                    localStorage.setItem("sp_user", data.user_name);
                    localStorage.setItem("sp_token", data.user_session_key);
                    localStorage.setItem("sp_token_key", data.user_token_key);

                    navi.push('/' + data.request);
                }
            }).catch(function (err) {
                if (err) {
                    console.log(err);
                }
            });
        }
    },
    created: function created() {
        document.title = "Account" + " | SP";
        this.syncset();
    }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_commons__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductList_vue__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_product_ProductList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_templates_searchbox_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_templates_searchbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_templates_searchbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_tools_settings_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_tools_settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_tools_settings_vue__);









var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
var set = new __WEBPACK_IMPORTED_MODULE_1__services_commons__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    data: function data() {
        return {
            user: {},
            market: {},
            business: {},
            categories: {},
            subscriptions: {},
            business_service_categories: [],
            business_product_categories: [],
            business_category_type: 0,
            plan1: {},
            plan2: {},
            plan3: {},
            selected_plan: {},
            selected_plan_product_service_item: {},
            upgradable_plans: {},
            upgrade_business: "",
            set_upgrade_plans: false,
            place_order: false,

            data_boarding_message: "",
            set_up_with_existing_account: false,
            set_up_with_new_account: false,
            set_up_business: false,
            validate_user_name_error: false,
            data_error_message: "",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name: "",
            payment_payer_email: "",
            payment_payer_phone: "",
            payment_service: "",
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            action_loading: false,
            disable_btn: false,
            setup_error_message: "",
            newBusinessForm: false,
            product_service_items_select: "",
            set_upgrade_plan_process: false
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a,
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue___default.a,
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue___default.a,
        'search-box': __WEBPACK_IMPORTED_MODULE_7__components_templates_searchbox_vue___default.a,
        'c-settings': __WEBPACK_IMPORTED_MODULE_8__components_tools_settings_vue___default.a
    },
    computed: {},
    methods: {
        setCurrency: function setCurrency(currency) {
            return set.formatCurrency(currency);
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == 'setup-existing') {
                this.set_up_with_existing_account = true;
            }
            if (attr1 == 'not-setup-existing') {
                this.set_up_with_existing_account = false;
            }
            if (attr1 == 'show-new-business-form') {
                this.newBusinessForm = true;
            }
            if (attr1 == 'display-product_service_items') {
                var x = document.getElementById("productServiceItems");
                if (x.style.display === "none") {
                    x.style.display = "block";
                } else {
                    x.style.display = "none";
                }
            }
        },
        reset: function reset() {
            this.set_upgrade_plan_process = false;
        },
        toggleDisplayFeatures: function toggleDisplayFeatures() {
            var x = document.getElementById("seeFeatures");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        selectProductServiceItem: function selectProductServiceItem(item) {
            this.selected_plan_product_service_item = item;
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;

                            if (this.$route.query.upgrade) {
                                this.prepareUpgradePlans();
                            }
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        setPurchase: function setPurchase() {
            var query_plan = this.$route.query.purchase;
            var query_plan_item = this.$route.query.item;
            var found = false;

            this.subscriptions.forEach(function (element) {
                if (element.product_url_name == query_plan) {
                    this.selected_plan = element;
                    if (query_plan_item != 'n') {
                        if (element.product_items[query_plan_item]) {
                            this.selected_plan_product_service_item = element.product_items[query_plan_item];
                        } else {
                            this.selected_plan_product_service_item = element.product_items[0];
                        }
                    } else {
                        this.selected_plan_product_service_item = element.product_items[0];
                    }

                    found = true;

                    this.loading = false;
                }
            }, this);

            if (!found) {
                this.setup_error_message = "Something went wrong with your selection, please pick another plan";
            }

            this.loading = false;
        },
        prepareUpgradePlans: function prepareUpgradePlans() {
            this.loading = true;

            var navi = this.$router;
            service.getBusinessMarketUpgradeDetails(this, this.$route.query.upgrade).then(function (data) {
                this.upgradable_plans = data.body.data;
                this.upgrade_business = this.$route.query.upgrade;

                this.payment_payer_name = data.body.data_user_payment_details["user_name"];
                this.payment_payer_email = data.body.data_user_payment_details["user_email"];
                this.payment_payer_phone = data.body.data_user_payment_details["user_phone"];

                this.set_upgrade_plans = true;
                this.loading = false;
            });
        },
        getSellpointMarket: function getSellpointMarket() {
            var _this2 = this;

            service.getBusinessByUserName(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this2.market = response.body.data;

                    _this2.getMarketMainProductsAsSubscriptions();

                    _this2.loading = false;
                }
            }).catch(function (err) {
                _this2.loading = true;
            });
        },
        getMarketMainProductsAsSubscriptions: function getMarketMainProductsAsSubscriptions() {
            var _this3 = this;

            service.getBusinessProducts(this, this.market.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this3.subscriptions = response.body.data;
                    _this3.plan1 = _this3.subscriptions[2];
                    _this3.plan2 = _this3.subscriptions[1];
                    _this3.plan3 = _this3.subscriptions[0];
                }

                if (_this3.$route.query.purchase) {
                    _this3.setPurchase();
                }
            }).catch(function (err) {});
        },
        purchase_plan_2: function purchase_plan_2(plan, plan_product_service_item_index) {
            this.loading = true;
            this.$router.push('/purchase/?purchase=' + plan.product_url_name + '&item=' + plan_product_service_item_index);
            this.setPurchase();

            var top = document.getElementById("topwrap").offsetTop;
            window.scrollTo(0, top);
        },
        purchase_plan: function purchase_plan(plan) {
            this.loading = true;
            this.selected_plan = plan;
            this.selected_plan_product_service_item = plan.product_items[0];
        },
        upgrade_plan: function upgrade_plan(plan) {
            this.loading = true;
            this.set_upgrade_plan_process = true;
            this.selected_plan = plan;
            this.selected_plan_product_service_item = plan.product_items[0];
            this.loading = false;
        },
        resetOptions: function resetOptions() {
            this.selected_plan = {};
            this.selected_plan_product_service_item = {}, this.total_price = 0;
            this.place_order = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        proceedUpgradePlan: function proceedUpgradePlan() {
            var found = false;
            this.selected_plan.product_items_upgrade_details.forEach(function (element) {
                if (this.selected_plan_product_service_item.product_item_id == element.subscription_new_product_item_id) {
                    this.selected_plan_product_service_item.product_item_price = element.subscription_new_product_total_amount_to_pay;
                    found = true;
                }
            }, this);

            if (found) {
                this.processPayment();
            }
        },
        proceedNewAccount: function proceedNewAccount() {
            this.resetMessages();
            this.set_up_with_new_account = true;

            if (this.selected_plan_product_service_item.product_item_price == 0) {
                this.updatePayment("gw-free-account");
            } else {
                this.processPayment();
            }
        },
        proceedWithAccount: function proceedWithAccount() {
            this.resetMessages();
            this.activate_processing();
            var payload = {
                user_email: this.user.user_email,
                user_password: this.user.user_password,
                user_business: this.user.user_business
            };
            service.checkUserDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    if (data.body.status_2 != 200) {
                        this.data_error_message = "Sorry, Sellpoint does not exist on this account";
                        this.deactivate_processing();
                    } else {
                        this.data_boarding_message = "Account verified...";

                        this.payment_payer_name = data.body.data.user_name;
                        this.payment_payer_email = data.body.data.user_email;
                        this.payment_payer_phone = data.body.data.user_phone;

                        if (this.selected_plan_product_service_item.product_item_price == 0) {
                            this.updatePayment("gw-free-account");
                        } else {
                            this.processPayment();
                        }
                    }
                } else {
                    this.data_error_message = "Sorry, Account does not exist";
                    this.deactivate_processing();
                }
            }).catch(function (err) {});
        },
        processPayment: function processPayment() {
            this.data_boarding_message = "Preparing Payment Information";

            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                this.payment_service = "Gallery Website Order - " + this.selected_plan.product_name + "(" + this.selected_plan.product_items[0].product_item_price + ")";
                var obj = this;

                var handler = PaystackPop.setup({
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.payment_payer_name,

                    email: this.payment_payer_email,
                    amount: Math.round(this.selected_plan_product_service_item.product_item_price * 100),
                    ref: "GWLOG" + new Date().getTime(),
                    metadata: {
                        custom_fields: [{
                            display_name: "GalleryWebsite Order",
                            variable_name: "",
                            value: this.payment_payer_name + " - " + this.payment_payer_phone + " - ORDER - " + this.selected_plan.product_name
                        }, {
                            display_name: "Service",
                            variable_name: "service_type",
                            value: this.selected_plan.product_name
                        }]
                    },

                    callback: function callback(response) {
                        obj.updatePayment(response.trxref);
                    },
                    onClose: function onClose() {
                        alert('window closed');
                    }
                });
                handler.openIframe();
            }
        },
        updatePayment: function updatePayment(payment_ref) {
            var navi = this.$router;

            this.payment_successful = true;
            if (this.selected_plan_product_service_item.product_item_price != 0) {
                this.payment_successful_message = "Payment Successful...";
            }

            if (this.set_up_with_existing_account) {
                this.setUpExistingAccount();
            }
            if (this.set_up_with_new_account) {
                this.setUpNewAccount();
            }

            if (this.set_upgrade_plan_process) {
                this.upgradePlan();
            }
        },
        setUpExistingAccount: function setUpExistingAccount() {
            var _this5 = this;

            this.activate_processing();
            var credentials = {
                business_user_name: this.user.user_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan_product_service_item.product_item_id
            };

            var navi = this.$router;
            service.addExistingBusiness(this, credentials).then(function (data) {
                var _this4 = this;

                if (data.body.status == 201 || data.body.status == 200) {
                    this.data_boarding_message = "Sellpoint Setup Successful...";

                    var credentials = {
                        user_email: this.user.user_email,
                        user_password: this.user.user_password
                    };
                    service.loginUser(this, credentials).then(function (response) {
                        if (response.body.status == 200) {
                            var _data = response.body.data;
                            localStorage.setItem("sp_user", _data.user_name);
                            localStorage.setItem("sp_token", _data.user_session_key);
                            localStorage.setItem("sp_token_key", _data.user_token_key);

                            navi.push('/' + _this4.user.user_business);
                        }
                    }).catch(function (err) {
                        if (err.status == 404) {
                            toastr.warning("invalid login credentials", 'Warning!');

                            _this4.deactivate_processing();
                        }
                    });
                }
            }).catch(function (err) {
                if (err) {
                    _this5.deactivate_processing();
                }
            });
        },
        setUpNewAccount: function setUpNewAccount() {
            this.activate_processing();
            var credentials = {
                user_name: this.payment_payer_name,
                user_phone: this.payment_payer_phone,
                user_email: this.payment_payer_email,
                user_address: '',
                user_state: '',
                user_city: '',
                user_password: this.user.user_password
            };

            var navi = this.$router;

            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
                this.deactivate_processing();
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                if (credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null && credentials.user_email != null && credentials.user_password != null) {
                    service.regUser(this, credentials).then(function (data) {
                        var _this6 = this;

                        if (data.body.status == 201) {
                            this.data_boarding_message = "Registration Successful...";

                            var credentials = {
                                user_email: data.body.data.user_email,
                                user_password: data.body.data.user_password
                            };
                            service.loginUser(this, credentials).then(function (response) {
                                if (response.body.status == 200) {
                                    var _data2 = response.body.data;
                                    localStorage.setItem("sp_user", _data2.user_name);
                                    localStorage.setItem("sp_token", _data2.user_session_key);
                                    localStorage.setItem("sp_token_key", _data2.user_token_key);

                                    _this6.preset();

                                    var self = _this6;
                                    setTimeout(function () {
                                        self.set_up_business = true;

                                        self.data_boarding_message = " ";
                                        self.setComponent('show-new-business-form', '');
                                        self.deactivate_processing();

                                        var top = document.getElementById("banner").offsetTop;
                                        window.scrollTo(0, top);
                                    }, 3000);
                                }
                            }).catch(function (err) {
                                if (err.status == 404) {
                                    _this6.data_error_message = "invalid login credentials..";

                                    _this6.deactivate_processing();
                                }
                            });
                        } else if (data.body.status == 409) {
                            this.data_error_message = "This User is already registered..";

                            this.deactivate_processing();
                        }
                    });
                } else {
                    this.data_error_message = "Kindly fill all fields...";

                    this.deactivate_processing();
                }
            }
        },
        validateUserName: function validateUserName() {
            var _this7 = this;

            service.validateBusinessUserName(this, this.business).then(function (response) {
                if (response.body.status != 200) {
                    _this7.validate_user_name_error = true;
                    _this7.validate_user_name_message = "This username already exist";
                    _this7.deactivate_processing();
                }
            }).catch(function (err) {
                _this7.validate_user_name_error = true;
                _this7.validate_user_name_message = "This username already exist";
                _this7.deactivate_processing();
            });
        },
        setUpNewAccountBusiness: function setUpNewAccountBusiness() {
            var _this8 = this;

            this.resetMessages();

            this.activate_processing();
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: service.market_app_name,
                business_layout: 3,
                business_subscription: this.selected_plan_product_service_item.product_item_id
            };
            var navi = this.$router;
            if (this.validate_user_name_error) {
                this.data_error_message = "This Username already exists..";
                this.deactivate_processing();
            } else {
                if (credentials.business_name != undefined && credentials.business_category != undefined) {
                    service.addNewBusiness(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            this.data_boarding_message = "Sellpoint Creation Successful.";

                            navi.push('/' + this.business.business_user_name);
                        } else {
                            this.data_error_message = "This Username already exists";
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        if (err) {
                            _this8.data_error_message = "Something went wrong";

                            _this8.deactivate_processing();
                        }
                    });
                } else {
                    this.data_error_message = "Kindly fill all fields";

                    this.deactivate_processing();
                }
            }
        },
        upgradePlan: function upgradePlan() {
            var _this9 = this;

            this.activate_processing();
            var credentials = {
                business_user_name: this.upgrade_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan_product_service_item.product_item_id,
                business_subscription_amount_paid: this.selected_plan_product_service_item.product_item_price
            };

            var navi = this.$router;
            service.upgradeBusinessMarketSubscription(this, credentials).then(function (data) {
                if (data.body.status == 200) {
                    navi.push('/' + this.upgrade_business);
                }
            }).catch(function (err) {
                if (err) {
                    _this9.data_error_message = "Something went wrong";
                    _this9.deactivate_processing();
                }
            });
        },
        getBusinessCategories: function getBusinessCategories() {
            service.getCategories(this).then(function (data) {
                this.categories = data.body.data;

                this.categories.forEach(function (element) {
                    if (element.category_type == 1) {
                        this.business_product_categories.push(element);
                    }
                    if (element.category_type == 2) {
                        this.business_service_categories.push(element);
                    }
                }, this);
            });
        }
    },
    mounted: function mounted() {
        var top = document.getElementById("topwrap").offsetTop;
        window.scrollTo(0, top);
    },

    created: function created() {
        if (this.$route.query.upgrade) {
            this.set_upgrade_plans = true;
        }
        this.preset();
        this.getSellpointMarket();
        this.getBusinessCategories();
    }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Register',
    data: function data() {
        return {
            users: {},
            user: {},
            states: {},
            cities: {},
            user_type: "bo",
            terms: true,
            disable_btn: false,
            loading: false,
            action_loading: false,
            data_error_message: ""
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        reset: function reset() {
            localStorage.removeItem("sp_user");
            localStorage.removeItem("sp_token");
            localStorage.removeItem("sp_token_key");
        },
        getStates: function getStates() {
            service.getStates(this).then(function (data) {
                this.states = data.body;
            });
        },
        getCities: function getCities(state) {
            service.getCities(this, state).then(function (data) {
                this.cities = data.body;
            });
        },
        reg: function reg() {
            this.disable_btn = true;
            this.user.agree = true;
            var credentials = {
                user_name: this.user.name,
                user_phone: this.user.phone,
                user_email: this.user.email,
                user_address: this.user.address || '',
                user_state: this.user.state || '',
                user_city: this.user.city || '',
                user_password: this.user.password
            };

            var navi = this.$router;
            if (credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null && credentials.user_email != null && credentials.user_password != null) {
                if (this.terms) {
                    this.loading = true;
                    service.regUser(this, credentials).then(function (data) {
                        var _this = this;

                        if (data.body.status == 201) {
                            this.data_processing_message = "Account Created";

                            var credentials = {
                                user_email: data.body.data.user_email,
                                user_password: data.body.data.user_password
                            };
                            service.loginUser(this, credentials).then(function (response) {
                                if (response.body.status == 200) {
                                    var _data = response.body.data;
                                    localStorage.setItem("sp_user", _data.user_name);
                                    localStorage.setItem("sp_token", _data.user_session_key);
                                    localStorage.setItem("sp_token_key", _data.user_token_key);
                                    if (_this.user_type == "bo") {
                                        navi.push("create?t=new");
                                    } else {
                                        navi.push("/?a=tops");
                                    }
                                }
                            }).catch(function (err) {
                                if (err.status == 404) {
                                    _this.data_error_message = "invalid login credentials";
                                    _this.disable_btn = false;
                                }
                            });
                        } else if (data.body.status == 409) {
                            this.data_error_message = "You already have a Sellpoint Account";
                            navi.push("login?u=connect");
                            this.disable_btn = false;
                        }
                    });
                } else {
                    this.data_error_message = 'Please agree to Terms';
                    this.disable_btn = false;
                }
            } else {
                this.data_error_message = 'Kindly fill all fields';
                this.disable_btn = false;
            }
        }
    },
    created: function created() {}
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_searchbox_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_searchbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_templates_searchbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_activeproducts_vue__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_activeproducts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_activeproducts_vue__);








var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Search',
    data: function data() {
        return {
            user: {},
            products: {},
            product: {},
            search_data: "",
            loggedIn: false
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue___default.a,
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue___default.a,
        'search-box': __WEBPACK_IMPORTED_MODULE_5__components_templates_searchbox_vue___default.a,
        'active-products': __WEBPACK_IMPORTED_MODULE_6__components_widgets_activeproducts_vue___default.a
    },
    methods: {
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        getSearchProducts: function getSearchProducts() {
            var _this2 = this;

            service.searchProducts(this, this.$route.query.k).then(function (response) {
                if (response.body.status == 200) {
                    _this2.products = response.body.data;
                    _this2.search_data = _this2.$route.query.k;
                }
            }).catch(function (err) {});
        },
        getBusinessSearchProducts: function getBusinessSearchProducts() {
            var _this3 = this;

            service.searchBusinessProducts(this, this.$route.query.k).then(function (response) {
                if (response.body.status == 200) {
                    _this3.products = response.body.data;
                    _this3.search_data = _this3.$route.query.k;
                }
            }).catch(function (err) {});
        },
        getCategorySearchProducts: function getCategorySearchProducts() {
            var _this4 = this;

            service.searchCategoryProducts(this, this.$route.query.s, this.$route.query.k).then(function (response) {
                if (response.body.status == 200) {
                    _this4.products = response.body.data;
                    _this4.search_data = response.body.data_search;
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.preset();
        if (this.$route.query.search == "business") {
            this.getBusinessSearchProducts();
        } else if (this.$route.query.search == "product") {
            this.getSearchProducts();
        } else if (this.$route.query.s) {
            this.getCategorySearchProducts();
        }
    }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductCartActions_vue__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductCartActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_product_ProductCartActions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_ProductCTAActions_vue__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_ProductCTAActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_product_ProductCTAActions_vue__);









var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Product',
    props: ['productItem'],
    data: function data() {
        return {
            user: {},
            loggedIn: false,
            cart: this.$store.state.cart,
            sellpoint: {},
            categories: {},
            main_category: {},
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            sub_categories: [],
            product: {},
            details: {},
            reviews: {},
            information: {},
            states: {},
            cities: {},
            other_products: {},
            delivery_option: {},
            discount_coupon: {},
            product_item_group: {},
            product_item: {},
            sellpoint_categories: {},
            seller_mode: false,
            can_edit: false,
            edit_mode: false,
            disable_btn: false,
            setPanel: false,
            other_delivery_option: false,
            edit_other_delivery_option: false,
            edit_city: false,
            editProductPanel: false,
            addProductItemPanel: false,
            editProductItemPanel: false,
            removeItemPanel: false,
            editProductItemGroupPanel: false,
            removeItemGroupPanel: false,
            removeProductPanel: false,
            product_details_descr: true,
            product_details_reviews: false,
            product_details_information: false,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            setProductDeliveryInformation: false,
            setDiscount: false,
            editDiscount: false,
            img_product_url: service.imageProductsURL,
            img_user_url: service.imageUsersURL,
            siteUrl: "",
            is_product_in_cart: false,
            loading: false,
            copied: false,
            descr_active: 'active',
            user_type: "buyer",
            new_added: false,
            product_display_image: {},
            action_loading: false,
            product_is_ready_to_cart: false,
            product_item_selected: [],
            product_item_group_selected: [],
            data_cart_message: "",
            data_cart_group_message: "",
            data_cart_item_message: "",
            product_set_shipping_fee_status: 12,
            set_shipping_fee_status_track: false,
            check_order_quantity: ""

        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'product-form': __WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue___default.a,
        "product-item-form": __WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue___default.a,
        'add-to-cart-button': __WEBPACK_IMPORTED_MODULE_5__components_product_ProductCartActions_vue___default.a,
        'product-cta-button': __WEBPACK_IMPORTED_MODULE_6__components_product_ProductCTAActions_vue___default.a
    },

    computed: {},

    methods: {
        redir: function redir(rlink) {
            location.replace("/" + rlink);
        },
        copyLink: function copyLink() {
            this.$clipboard(this.siteUrl);
            this.copied = true;
        },
        mobileSideNavToggle: function mobileSideNavToggle(action) {
            if (action == "open") {
                document.getElementById("mobileSideNav").style.width = "300px";
            }
            if (action == "close") {
                document.getElementById("mobileSideNav").style.width = "0";
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        checkOrderQuantity: function checkOrderQuantity(qty) {
            if (this.product_item_selected.product_item_price > 0 && this.product_item.product_item_order_quantity != 0) {
                if (qty > this.product_item.product_item_quantity) {
                    this.check_order_quantity = "The quantity you entered is above Item Quantity";
                    this.product_is_ready_to_cart = false;
                    this.data_cart_message = "The quantity you entered is above Item Quantity";
                } else {
                    this.check_order_quantity = "";
                    this.product_is_ready_to_cart = true;
                    this.data_cart_message = "";
                }
            } else {
                this.check_order_quantity = "";
            }
        },
        trackevent: function trackevent(e) {
            if (e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined) {
                this.category_type_2 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined) {
                this.category_type_1 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined) {
                this.category_type_1 = true;
                this.category_type_2 = true;
            } else {
                this.category_type_1 = false;
                this.category_type_2 = false;
                this.category_type_3 = true;
            }
        },
        setComponent: function setComponent(attr1, attr2) {
            this.setPanel = true;
            if (attr1 == 'edit-product') {
                this.editProductPanel = true;
            }
            if (attr1 == 'remove-product') {
                this.removeProductPanel = true;
            }
            if (attr1 == 'add-product-item') {
                this.addProductItemPanel = true;
            }
            if (attr1 == 'edit-product-item') {
                this.editProductItemPanel = true;
            }
            if (attr1 == 'set-edit-product-item') {
                this.product_item = attr2;
                this.editProductItemPanel = true;
            }
            if (attr1 == 'remove-product-item') {
                this.product_item = attr2;
                this.removeItemPanel = true;
            }
            if (attr1 == 'edit-product-item_group') {
                this.product_item_group = attr2;
                this.editProductItemGroupPanel = true;
            }
            if (attr1 == 'remove-product-item_group') {
                this.product_item_group = attr2;
                this.removeItemGroupPanel = true;
            }
            if (attr1 == 'set-product-item-group-image') {
                this.product_item_group.product_item_group_image = attr2;
                var imgs = document.getElementsByClassName('product-item-group-image');
                for (var i = 0; i < imgs.length; i++) {
                    imgs[i].style = "border:none;";
                }
                document.getElementById(attr2 + "PRTG").style.border = "1px solid #0000CC";
            }
            if (attr1 == 'edit-product-detail') {
                this.details.edit_product_detail = false;
                this.details = attr2;
                this.details.edit_product_detail = true;
            }
            if (attr1 == 'edit-product-delivery') {
                this.details.edit_product_delivery = false;
                this.details = {};
                this.details.edit_product_delivery = true;
            }
            if (attr1 == 'add-delivery-option') {
                this.addDeliveryInformation = true;
            }
            if (attr1 == 'set-product-delivery-option') {
                this.delivery_option.edit_set = false;
                this.setProductDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
            }
            if (attr1 == 'edit-delivery-option') {
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;

                this.getCities(this.delivery_option.business_delivery_state, 'edit');
            }
            if (attr1 == 'set-product-item') {
                this.check_order_quantity = "";
                this.data_cart_message = '';

                this.product_item = attr2;
                this.product_item_selected = attr2;

                var itms = document.getElementsByClassName('product-item');
                for (var i = 0; i < itms.length; i++) {
                    itms[i].style = "border:none;";
                }

                if (attr2.product_item_size != "Nill" && attr2.product_item_size != "") {
                    document.getElementById(attr2.product_item_id + "PRT").style = "border:1px solid #0000CC;";
                }

                this.data_cart_item_message = '';
                this.data_cart_message = '';
                this.prep_set_product_is_ready_to_cart();
            }
            if (attr1 == 'set-product-item-group') {
                this.check_order_quantity = "";
                this.data_cart_message = '';

                this.product_item_group = attr2;
                this.product_item_group_selected = attr2;

                this.product_display_image.product_image = attr2.product_item_group_image;

                this.product_is_ready_to_cart = false;
                this.product_item_selected = [];

                var itms = document.getElementsByClassName('product-item');
                for (var i = 0; i < itms.length; i++) {
                    itms[i].style = "border:none;";
                }

                var grps = document.getElementsByClassName('product-item-group');
                for (var i = 0; i < grps.length; i++) {
                    grps[i].style = "border:none;";
                }

                document.getElementById(attr2.product_item_group_id + "PRTGR").style = "border:1px solid #0000CC;";

                this.data_cart_group_message = '';

                if (attr2.product_items[0].product_item_size == "Nill" || attr2.product_items[0].product_item_size == "") {
                    this.setComponent('set-product-item', attr2.product_items[0]);
                } else {
                    if (this.product.product_service == 'P') {
                        this.data_cart_item_message = "please select a Size";
                    } else {
                        this.data_cart_item_message = "please select a Service item";
                    }
                }
            }
            if (attr1 == 'set-product-display-image') {
                this.product_display_image = attr2;
            }
            if (attr1 == 'set-descr') {
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails', ''));

                this.product_details_descr = true;
                this.product_details_reviews = false;
                this.product_details_information = false;
                window.location.hash = "";
            }
            if (attr1 == 'set-reviews') {
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails', ''));
                this.descr_active = '';
                this.product_details_reviews = true;
                this.product_details_descr = false;
                this.product_details_information = false;
            }
            if (attr1 == 'set-information') {
                this.descr_active = '';
                this.product_details_information = true;
                this.product_details_reviews = false;
                this.product_details_descr = false;
            }
            if (attr1 == 'set-discount') {
                this.setDiscount = true;
                this.editDiscount = false;
            }
            if (attr1 == 'edit-discount') {
                this.editDiscount = true;
                this.setDiscount = false;
                this.discount_coupon = attr2;
            }
            if (attr1 == 'reset-edit') {
                this.addProductItemPanel = false;
                this.editProductPanel = false;
                this.editProductItemPanel = false;
                this.removeItemPanel = false;
                this.editProductItemGroupPanel = false;
                this.removeItemGroupPanel = false;
                this.removeProductPanel = false;
                this.addDeliveryInformation = false;
                this.editDeliveryInformation = false;
                this.delivery_option.edit_set = false;
                this.setDiscounts = false;
                this.editDiscount = false;
            }
            var self = this;

            setTimeout(function () {
                self.action_loading = false;
            }, 2000);
        },
        setComponentActions: function setComponentActions(attr1, attr2) {
            if (attr1 == 'reset-edit') {
                this.details = {};
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.sellpoint.business_id = this.product.product_business_id;

                            this.is_editing();

                            this.loggedIn = true;
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        is_editing: function is_editing() {
            var _this2 = this;

            var payload = {
                validate_user: this.user.user_id,
                validate_business: this.sellpoint.business_id
            };
            service.can_edit(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this2.seller_mode = true;
                    _this2.edit_mode = true;
                    _this2.can_edit = true;
                } else {
                    _this2.edit_mode = false;
                    _this2.seller_mode = false;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        switchMode: function switchMode() {
            if (this.edit_mode == false) {
                this.is_editing();
            } else {
                this.edit_mode = false;
                this.can_edit = true;
            }
        },
        getStates: function getStates() {
            var _this3 = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this3.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state, option) {
            var _this4 = this;

            if (option == "edit") {
                this.edit_city = true;
            } else {
                this.edit_city = false;
            }
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this4.cities = response.body.data;
                }
            }).catch(function (err) {});
        },
        setOtherOptions: function setOtherOptions(v, o) {
            if (v != undefined) {
                if (v == "other") {
                    this.other_delivery_option = true;
                    if (o == "edit") {
                        this.edit_other_delivery_option = true;
                    }
                }
                if (v == "all") {
                    this.delivery_option.business_delivery_other_option = "nill";
                    if (o == "edit") {
                        this.edit_other_delivery_option = false;
                    }
                    this.other_delivery_option = false;
                }
            }
        },
        set_data_messages: function set_data_messages(data, action) {
            if (this.product.product_service == 'P') {
                if (action == 'set') {
                    if (data == 'product-item') {}
                }
                if (action == 'unset') {}
            } else {}
        },
        prep_set_product_is_ready_to_cart: function prep_set_product_is_ready_to_cart() {
            if (this.product_item_selected.length != 0) {
                this.product_is_ready_to_cart = true;
            } else {
                this.data_cart_message = "make a selection before you proceed";
                if (this.product_item_group_selected.length != 0) {
                    if (this.product.product_service == 'P') {
                        this.data_cart_item_message = "please select a Size";
                    } else {
                        this.data_cart_item_message = "please select a Service item";
                    }
                } else {
                    if (this.product.product_service == 'P') {
                        this.data_cart_group_message = "please select Colour";
                    } else {
                        this.data_cart_group_message = "please select a Service Package";
                    }
                }
            }
        },
        isEmpty: function isEmpty(obj) {
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) return false;
            }
            return true;
        },
        set_product_is_ready_to_cart: function set_product_is_ready_to_cart() {
            if (this.product.product_set_groups <= 1 && this.product.product_set_items <= 1) {
                this.product_item_selected = this.product_item;
                this.product_item_group_selected = this.product_item_group;
                this.product_is_ready_to_cart = true;
            }
        },
        setProduct: function setProduct() {
            var _this5 = this;

            this.loading = true;
            service.getProductSearch(this, this.$route.params.id1).then(function (response) {
                if (response.body.status == 200) {
                    _this5.product = response.body.data;

                    document.title = _this5.product.product_name + " | " + _this5.product.product_business_name + " | SP";

                    _this5.product_display_image = _this5.product.product_images[0];
                    _this5.product_item = _this5.product.product_items[0];
                    if (_this5.product.product_item_groups.length != 0) {
                        _this5.product_item_group = _this5.product.product_item_groups[0];
                    } else {
                        _this5.product_item_group = [];
                    }

                    _this5.product_set_shipping_fee_status = _this5.product.product_set_shipping_fee_status;

                    _this5.set_product_is_ready_to_cart();

                    _this5.siteUrl = service.siteUrl + "?p=" + _this5.product.product_url_name + "&p1=" + _this5.product.product_business_ownername + "&p2=" + _this5.product.product_url_name + "&p3=" + encodeURI(_this5.product.product_name) + "&p4=" + encodeURI(_this5.product.product_description) + "&p5=" + _this5.product_item.product_item_image + " ";

                    _this5.product.product_share_url = "http://sellpoints.com.ng/" + _this5.product.product_business_ownername + "/" + _this5.product.product_url_name;

                    _this5.preset();

                    _this5.setOtherProducts(_this5.product.product_business_id);

                    _this5.getCategories(_this5.product.product_business_category_id);

                    _this5.getSellpointCategories();

                    _this5.check_in_cart();
                    _this5.loading = false;
                }
            }).catch(function (err) {});
        },
        getCategories: function getCategories(category) {
            var _this6 = this;

            service.getMainCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this6.categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSubCategories: function getSubCategories(category) {
            if (category != undefined) {
                this.sub_categories = category.sub_categories;
            } else {
                this.sub_categories = [];
            }
        },
        check_in_cart: function check_in_cart() {
            this.cart.forEach(function (element) {
                if (element.product_item_id == this.product_item.product_item_id) {
                    this.is_product_in_cart = true;
                }
            }, this);
        },
        setOtherProducts: function setOtherProducts(sellpoint_id) {
            var _this7 = this;

            service.getBusinessProducts(this, sellpoint_id).then(function (response) {
                if (response.body.status == 200) {
                    _this7.other_products = response.body.data;
                }
            }).catch(function (err) {});
        },
        getProductImages: function getProductImages() {
            var _this8 = this;

            service.getProductImages(this, this.product.product_id).then(function (response) {
                if (response.body.status == 200) {
                    _this8.product.product_images = response.body.data;
                    _this8.product_display_image = _this8.product.product_images[0];
                }
            }).catch(function (err) {});
        },
        deleteProductImage: function deleteProductImage(image) {
            service.deleteProductImage(this, image).then(function (data) {
                if (data.body.status == 200) {
                    this.getProductImages();
                }
            }).catch(function (err) {});
        },
        editProduct: function editProduct() {
            var _this9 = this;

            this.activate_processing();

            var set_product_category = this.product.product_category_id;
            if (this.product.product_sub_category != undefined || this.product.product_listed_category != undefined) {
                set_product_category = 0;
            } else {
                if (this.product.product_category != undefined) {
                    set_product_category = this.product.product_category;
                } else {
                    set_product_category = this.product.product_category_id;
                }
            }
            var credentials = {
                product_id: this.product.product_id,
                product_name: this.product.product_name,

                product_category: set_product_category,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",


                product_url_name: this.product.product_url_name,
                product_description: this.product.product_description || "nill",
                product_business: this.product.product_business_id };

            var navi = this.$router;
            if (credentials.product_name != undefined) {
                service.editProduct(this, this.product.product_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this9.editProductPanel = false;
                        _this9.product = response.body.data;
                        navi.push("/" + _this9.product.product_business_ownername + "/" + _this9.product.product_url_name);
                    } else {
                        _this9.editProductPanel = false;
                        _this9.deactivate_processing();
                    }
                }).catch(function (err) {
                    if (err) {
                        _this9.editProductPanel = false;
                        _this9.deactivate_processing();
                    }
                });
            } else {
                this.disable_btn = false;
            }
        },
        editProductItem: function editProductItem() {
            var _this10 = this;

            this.activate_processing();
            var credentials = {
                product_item_id: this.product_item.product_item_id,
                product_item_price: this.product_item.product_item_price,
                product_item_weight: this.product_item.product_item_weight || 1,
                product_item_size: this.product_item.product_item_size || "Nill",
                product_item_service_tag: this.product_item.product_item_service_tag || "Nill",
                product_item_quantity: this.product_item.product_item_quantity || 1
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.editProductItem(this, this.product_item.product_item_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this10.product_item = response.body.data;
                        _this10.deactivate_processing();
                        _this10.editProductItemPanel = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this10.deactivate_processing();
                    }
                });
            } else {
                this.deactivate_processing();
            }
        },
        editProductItemGroup: function editProductItemGroup() {
            var _this11 = this;

            this.activate_processing();
            var product_item_group_is_color_image = 'IMG';
            if (this.product_item_group.product_item_group_color == undefined) {
                product_item_group_is_color_image = 'IMG';
            } else {
                product_item_group_is_color_image = 'COL';
            }

            if (this.product_item_group.product_item_group_color_new != undefined) {
                product_item_group_is_color_image = 'COL';
                this.product_item_group.product_item_group_color = this.product_item_group.product_item_group_color_new;
                this.product_item_group.product_item_group_image = 0;
            } else {
                product_item_group_is_color_image = 'IMG';
                this.product_item_group.product_item_group_color = "Nill";
            }
            var credentials = {
                product_item_group_product: this.product.product_id,
                product_item_group_name: this.product_item_group.product_item_group_name || "Type",
                product_item_group_is_color_image: product_item_group_is_color_image,
                product_item_group_color: this.product_item_group.product_item_group_color || "Nill",
                product_item_group_image: this.product_item_group.product_item_group_image || 0
            };

            var navi = this.$router;
            if (credentials.product_item_group_name != undefined) {
                service.editProductItemGroup(this, this.product_item_group.product_item_group_id, credentials).then(function (response) {
                    if (response.body.status == 200) {

                        _this11.product.product_item_groups = response.body.data;

                        _this11.deactivate_processing();
                        _this11.editProductItemGroupPanel = false;
                    } else {
                        _this11.deactivate_processing();
                        _this11.editProductItemGroupPanel = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this11.deactivate_processing();
                    }
                });
            } else {
                this.deactivate_processing();
            }
        },
        removeProduct: function removeProduct() {
            var _this12 = this;

            this.disable_btn = true;
            var payload = {
                product_id: this.product.product_id
            };
            var navi = this.$router;
            service.removeProduct(this, this.product.product_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this12.redir(_this12.$route.params.id1);

                    _this12.removeProductPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this12.disable_btn = false;
                    _this12.redir(_this12.$route.params.id1);
                }
            });
        },
        removeProductItem: function removeProductItem() {
            var _this13 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_id: this.product_item.product_item_id
            };
            var navi = this.$router;
            service.removeProductItem(this, this.product_item.product_item_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this13.redir(_this13.$route.params.id);
                    }
                    _this13.product.product_item_groups = response.body.data;

                    _this13.deactivate_processing();
                    _this13.removeItemPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this13.deactivate_processing();
                }
            });
        },
        removeProductItemGroup: function removeProductItemGroup() {
            var _this14 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_group_id: this.product_item_group.product_item_group_id
            };
            var navi = this.$router;
            service.removeProductItemGroup(this, this.product_item_group.product_item_group_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this14.redir(_this14.$route.params.id);
                    }
                    _this14.product.product_item_groups = response.body.data;
                    _this14.deactivate_processing();
                    _this14.removeItemGroupPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this14.deactivate_processing();
                }
            });
        },
        addProductDetail: function addProductDetail() {
            var _this15 = this;

            this.activate_processing();
            var payload = {
                product_detail: this.details.new_product_detail || "nill",
                product_id: this.product.product_id
            };
            service.addProductDetail(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    this.product.product_details = data.body.data;
                    this.details = {};
                    this.deactivate_processing();
                } else {
                    this.deactivate_processing();
                }
            }).catch(function (err) {
                _this15.details = {};
                _this15.deactivate_processing();
            });
        },
        editProductDetail: function editProductDetail() {
            var _this16 = this;

            this.details.product_id = this.product.product_id;
            service.editProductDetail(this, 1, this.details).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                _this16.service = {};
            });
        },
        deleteProductDetail: function deleteProductDetail(details) {
            var _this17 = this;

            var payload = {
                product_detail_id: details.product_detail_id
            };
            service.deleteProductDetail(this, details.product_detail_id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                _this17.service = {};
            });
        },
        setProductDelivery: function setProductDelivery() {
            var payload = {
                product_id: this.product.product_id,
                product_delivery_details: this.product.product_delivery_returns
            };
            service.setProductDelivery(this, 1, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.details = {};

                    this.details.edit_product_delivery = false;
                }
            }).catch(function (err) {});
        },
        setProductShippingFeeStatus: function setProductShippingFeeStatus() {
            this.set_shipping_fee_status_track = true;
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_set_shipping_fee_status: this.product_set_shipping_fee_status
            };
            service.setProductShippingFeeStatus(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_set_shipping_fee_status = this.product_set_shipping_fee_status;
                    this.set_shipping_fee_status_track = false;
                    this.deactivate_processing();
                }
            }).catch(function (err) {});
        },
        addProductReview: function addProductReview() {
            var _this18 = this;

            var payload = {
                product_reviewed_by: this.user.user_id || 1,
                product_review: this.reviews.review || "nill",
                product_id: this.product.product_id
            };
            service.addProductReview(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    this.product.product_reviews = data.body.data;
                    this.reviews = {};
                }
            }).catch(function (err) {
                _this18.reviews = {};
            });
        },
        getProductInformation: function getProductInformation() {
            var _this19 = this;

            service.getProductInformation(this, this.product.product_id).then(function (response) {
                if (response.body.status == 200) {
                    _this19.product.product_information = response.body.data;
                }
            }).catch(function (err) {});
        },
        addProductInformation: function addProductInformation() {
            var _this20 = this;

            var payload = {
                product_info_detail: this.information.product_info_detail || "nill",
                product_info_type: "text",
                product_id: this.product.product_id
            };
            if (payload.product_information != "nill") {
                service.addProductInformation(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        this.product.product_information = data.body.data;
                        this.information = {};
                    }
                }).catch(function (err) {
                    _this20.details = {};
                });
            }
        },
        editProductInformation: function editProductInformation() {
            var _this21 = this;

            this.details.product_id = this.product.product_id;
            service.editProductInformation(this, 1, this.details).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                _this21.service = {};
            });
        },
        deleteProductInformation: function deleteProductInformation(details) {
            var _this22 = this;

            var payload = {
                product_detail_id: details.product_detail_id
            };
            service.deleteProductDetail(this, details.product_detail_id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                _this22.service = {};
            });
        },
        setProductDeliveryOption: function setProductDeliveryOption() {
            var _this23 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id,
                business_product_id: this.product.product_id,
                business_product_delivery_fee: this.delivery_option.product_delivery_fee || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };
            if (payload.business_product_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_product_delivery_option != 0) {
                    service.setProductDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200 || data.body.status == 201) {
                            this.product.product_business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.setProductDeliveryInformation = false;

                            this.deactivate_processing();
                        } else {
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        _this23.delivery_option.edit_set = false;
                        _this23.setProductDeliveryInformation = false;
                        _this23.deactivate_processing();
                    });
                } else {
                    this.deactivate_processing();
                }
            }
        },
        deleteDeliveryFee: function deleteDeliveryFee(id) {
            var _this24 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_product: this.product.product_id
            };
            service.deleteDeliveryOption(this, id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                }
            }).catch(function (err) {
                _this24.delivery_option = {};
            });
        },
        addDeliveryOption: function addDeliveryOption() {
            var _this25 = this;

            var payload = {
                business_delivery_state: this.delivery_option.state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
                business_delivery_product: this.product.product_id,
                business_id: this.sellpoint.business_id
            };
            if (payload.business_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.addDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            this.product.product_delivery_options = data.body.data;
                            this.delivery_option = {};
                            this.addDeliveryInformation = false;
                        }
                    }).catch(function (err) {
                        _this25.delivery_option = {};
                    });
                } else {
                    toastr.warning("Select a delivery option", 'Warning!');
                }
            }
        },
        editDeliveryOption: function editDeliveryOption() {
            var _this26 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_product: this.product.product_id,
                business_delivery_state: this.delivery_option.business_delivery_state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };

            if (payload.business_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.editDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            this.product.product_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.editDeliveryInformation = false;
                        }
                    }).catch(function (err) {
                        _this26.delivery_option.edit_set = false;
                        _this26.editDeliveryInformation = false;
                    });
                } else {}
            }
        },
        deleteDeliveryOption: function deleteDeliveryOption(id) {
            var _this27 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_product: this.product.product_id
            };
            service.deleteDeliveryOption(this, id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                }
            }).catch(function (err) {
                _this27.delivery_option = {};
            });
        },
        setDiscountsAndCoupons: function setDiscountsAndCoupons() {
            var payload = {
                business_id: this.sellpoint.business_id,
                product_item_id: this.product_item.product_item_id,
                is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'D',
                coupon_business_category: 0,
                coupon_percentage: this.discount_coupon.discount_percentage,
                coupon_start_date: this.discount_coupon.discount_start_date,
                coupon_end_date: this.discount_coupon.discount_end_date
            };
            service.setDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("New Discount Set", 'Update!');
                    this.sellpoint.business_discounts_coupons = data.body.data;
                    this.setDiscount = false;
                }
            }).catch(function (err) {});
        },
        editDiscountsAndCoupons: function editDiscountsAndCoupons() {
            this.discount_coupon.business_id = this.sellpoint.business_id;
            service.editDiscountsAndCoupons(this, this.discount_coupon).then(function (data) {
                if (data.body.status == 200) {
                    this.editDiscount = false;
                }
            }).catch(function (err) {});
        },
        deactivateDiscountsAndCoupons: function deactivateDiscountsAndCoupons(payload) {
            payload.business_id = this.sellpoint.business_id;
            service.deactivateDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    payload.discount_status_id = 6;
                }
            }).catch(function (err) {});
        },
        onFileChange: function onFileChange(e, type, data_id) {
            var _this28 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);


                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "products") {
                            _this28.getProductImages();
                            if (_this28.editProductItemGroupPanel) {
                                _this28.product_item_group.product_item_group_image = data.body.data_id;
                            }
                        }

                        if (type == "product_information") {
                            _this28.getProductInformation();
                        }
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this29 = this;

            service.getBusinessByUserName(this, this.product.product_business_ownername).then(function (response) {
                if (response.body.status == 200) {
                    var sellpoint = response.body.data;
                    service.getBusinessCategories(_this29, sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this29.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});
                }
            }).catch(function (err) {});
        },
        handleScrollFix: function handleScrollFix(event) {
            var x = document.getElementById("menuHeader");

            var isMobile = false;
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
                isMobile = true;
            }
            if (isMobile) {
                if (document.documentElement.scrollTop >= 300) {
                    x.style.display = "block";
                } else {
                    x.style.display = "none";
                }
            }
        }
    },
    mounted: function mounted() {
        var top = document.getElementById("wrap").offsetTop;
        window.scrollTo(0, top);
    },
    created: function created() {
        if (this.$route.query.setup == "yes") {
            this.new_added = true;
        }
        this.setProduct();
        this.getStates();

        window.addEventListener('scroll', this.handleScrollFix);
    },
    destroyed: function destroyed() {
        window.removeEventListener('scroll', this.handleScrollFix);
    }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_validation__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductForm_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_product_ProductForm_vue__);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_1__services_validation__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SellpointTemplate',
    data: function data() {
        return {
            sellpoint: {}
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a,
        'product-form': __WEBPACK_IMPORTED_MODULE_4__components_product_ProductForm_vue___default.a
    },
    methods: {},
    created: function created() {}
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_posts_newgallery_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_posts_newgallery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_posts_newgallery_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_posts_newproductgallery_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_posts_newproductgallery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_posts_newproductgallery_vue__);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Sellpoint',
    data: function data() {
        return {
            user: {},
            market: {},
            sellpoint: {},
            categories: {},
            galleria: {},
            gallery: {},
            gallery_post: {},
            gallery_post_set_image: {},
            post: {},
            products: {},
            product: {},
            productMain: {},
            productItem: {},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            edit_mode: false,
            loading: true,
            online: false,
            place_order: false,
            ordered_product: {},
            ordered_product_item: {},
            swipe_index: 0,

            data_error_message: "",
            data_success_message: "",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name: "",
            payment_payer_email: "",
            payment_payer_phone: "",
            payment_service: "",

            addPanel: false,
            business_load_error_msg: "",
            newLookbookForm: false,
            newProductLookbookForm: false,
            max_plan_lookbooks: 0,
            max_plan_lookbook_posts: 0,
            total_lookbooks_added: 0,
            can_add_more_lookbook: false,
            can_add_product_lookbook: false,
            addNewPost: false,
            file_info: {},
            refresh_button: false,
            disable_btn: false,
            action_loading: false,
            default_banner_image: "https://res.cloudinary.com/diprbfy7s/image/upload/v1550754799/businesses_files/sp-default-banner.jpg",
            set_gallery_banner_image: '',

            gallery_view: false,

            swiperOption: {
                pagination: {
                    el: '.swiper-pagination'
                }
            }

        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'add-lookbook': __WEBPACK_IMPORTED_MODULE_3__components_posts_newgallery_vue___default.a,
        'add-product-lookbook': __WEBPACK_IMPORTED_MODULE_4__components_posts_newproductgallery_vue___default.a
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        mobileSideNavToggle: function mobileSideNavToggle(action) {
            if (action == "open") {
                var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

                if (isMobile) {
                    document.getElementById("mobileSideNav").style.width = "100%";
                } else {
                    document.getElementById("mobileSideNav").style.width = "50%";
                }
            }
            if (action == "close") {
                document.getElementById("mobileSideNav").style.width = "0";
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        checkIfVideo: function checkIfVideo(url) {
            if (url != undefined) {
                var ext = url.split('.').pop();
                if (service.video_exts.includes(ext)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        addComponent: function addComponent(attr1, attr2) {

            this.addPanel = true;

            if (attr1 == "add-new-lookbook") {
                this.newLookbookForm = true;
            }
            if (attr1 == "add-new-product-lookbook") {
                this.newProductLookbookForm = true;
            }
            if (attr1 == "add-new-product-post") {
                this.$router.push("/" + this.$route.params.id + "/" + this.gallery.gallery_posts_group_url_name);

                this.newProductLookbookForm = true;
            }
            if (attr1 == "add-new-post") {
                this.addNewPost = true;

                this.gallery = attr2;
            }

            if (this.gallery_view) {
                this.gallery_view = false;

                var self = this;
                setTimeout(function () {
                    self.mobileSideNavToggle("open");
                }, 150);
            }

            var top = document.getElementById("addPanelView").offsetTop;
            window.scrollTo(0, top);
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == "refresh-store") {
                this.getGalleryPosts();
            }
            if (attr1 == "close-gallery-view") {
                this.gallery_view = false;
            }
        },
        reset: function reset() {
            this.addPanel = false, this.addNewPost = false;
            this.newLookbookForm = false;
            this.newProductLookbookForm = false;
            this.data_error_message = "";
            this.data_success_message = "";
        },
        preset: function preset() {
            var _this = this;

            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                            this.is_editing();
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        is_editing: function is_editing() {
            var _this2 = this;

            if (this.user.user_id != "") {
                var payload = {
                    validate_user: this.user.user_id,
                    validate_business: this.sellpoint.business_id
                };
                service.can_edit(this, payload).then(function (response) {
                    if (response.body.status == 200) {
                        _this2.edit_mode = true;
                    } else {
                        _this2.edit_mode = false;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        setGallery: function setGallery() {
            var _this3 = this;

            this.loading = true;
            service.getGallerySearch(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this3.gallery = response.body.data;

                    _this3.loading = false;
                }
            }).catch(function (err) {});
        },
        setSellpoint: function setSellpoint() {
            var _this4 = this;

            this.loading = true;
            service.getAppBusinessByUserName(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this4.sellpoint = response.body.data;
                    document.title = _this4.sellpoint.business_name + " | SP";

                    _this4.getSellpointProducts();
                    if (_this4.sellpoint.business_banner_image == _this4.default_banner_image || _this4.sellpoint.business_banner_image == 'error') {
                        _this4.set_gallery_banner_image = service.general_banner_image;
                    } else {
                        _this4.set_gallery_banner_image = _this4.sellpoint.business_banner_image;
                    }

                    if (_this4.sellpoint.business_market_subscription_name == 'Bird Plan') {
                        _this4.max_plan_lookbooks = 2;
                        _this4.max_plan_lookbook_posts = 5;
                    }
                    if (_this4.sellpoint.business_market_subscription_name == 'Mid Bird Plan') {
                        _this4.max_plan_lookbooks = 10;
                        _this4.max_plan_lookbook_posts = 50;
                    }
                    if (_this4.sellpoint.business_market_subscription_name == 'Max Bird Plan') {
                        _this4.max_plan_lookbooks = 50;
                        _this4.max_plan_lookbook_posts = 50;
                        _this4.can_add_product_lookbook = true;
                    }

                    var self = _this4;
                    setTimeout(function () {
                        self.getGalleryPosts();
                    }, 3000);
                    _this4.preset();
                    _this4.loading = false;
                } else {
                    _this4.business_load_error_msg = "Sorry, this Business Information could not be found.";
                }
            }).catch(function (err) {
                _this4.loading = false;
            });
        },
        getProductsInBusinessCategories: function getProductsInBusinessCategories() {
            var _this5 = this;

            this.loading = true;
            service.getProductsInBusinessCategories(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this5.categories = response.body.data;
                }
                _this5.loading = false;
            }).catch(function (err) {
                _this5.loading = false;
            });
        },
        getGalleryPosts: function getGalleryPosts() {
            var _this6 = this;

            this.loading = true;
            service.getPointGalleryPosts(this, this.sellpoint.business_id, 0, this.max_plan_lookbooks, 0, this.max_plan_lookbook_posts).then(function (response) {
                _this6.galleria = response.body.data;

                _this6.total_lookbooks_added = response.body.total_data;

                if (_this6.total_lookbooks_added < _this6.max_plan_lookbooks) {
                    _this6.can_add_more_lookbook = true;
                }

                _this6.loading = false;
            }).catch(function (err) {
                _this6.loading = false;
            });
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this7 = this;

            this.loading = true;
            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this7.products = response.body.data;
                    _this7.loading = false;
                }
            }).catch(function (err) {});
        },
        getPostsInGallery: function getPostsInGallery(gallery) {
            this.gallery = gallery;
            this.gallery_post = gallery.gallery_posts_group_posts[0];


            if (this.gallery_post.gallery_post_media[0]) {
                this.gallery_post_set_image = this.gallery_post.gallery_post_media[0];
            } else {
                this.gallery_post_set_image = {};
            }


            this.gallery_view = true;
        },
        getCategoryProducts: function getCategoryProducts(category) {
            this.loading = true;
            this.product = category.business_category_products[0];
            this.products = category.business_category_products;
            $('#quickviewModal').modal('show');
            this.loading = false;
        },
        getCategoryProductsXX: function getCategoryProductsXX(category) {
            var _this8 = this;

            this.loading = true;
            var self = this;
            service.getCategoryProducts(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this8.products = response.body.data;

                    var count = 0;
                    _this8.products.forEach(function (element) {
                        count++;
                        if (count == 1) {
                            _this8.product = element;
                            $('#quickviewModal').modal('show');
                        }
                    });
                    _this8.loading = false;
                }
            }).catch(function (err) {
                _this8.loading = false;
            });
        },
        showPost: function showPost(post) {
            this.gallery_post = post;

            if (this.gallery_post.gallery_post_media[0]) {
                this.gallery_post_set_image = this.gallery_post.gallery_post_media[0];
            } else {
                this.gallery_post_set_image = {};
            }
        },
        showPostImage: function showPostImage(post_image) {
            this.gallery_post_set_image = post_image;
        },
        showProduct: function showProduct(product) {
            this.product = product;
        },
        addPostToGallery: function addPostToGallery() {
            var _this10 = this;

            this.activate_processing();

            var credentials = {
                gallery_new_group: false,
                gallery_post_group: this.gallery.gallery_posts_group_id,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    var _this9 = this;

                    if (data.body.status == 201) {
                        this.data_success_message = "Post Created";

                        this.post = data.body.data;

                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type", "gallery_media");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                location.reload(true);
                                _this9.gallery = data.body.data_gallery;
                                _this9.addNewPost = false;
                            }
                            _this9.deactivate_processing();
                        }).catch(function (err) {
                            if (err) {}

                            _this9.data_error_message = "Something went wrong";
                            _this9.deactivate_processing();
                        });

                        var self = this;
                        setTimeout(function () {
                            location.reload(true);
                        }, 2000);
                    }
                }).catch(function (err) {
                    if (err) {
                        _this10.data_error_message = "Something went wrong";

                        _this10.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        },
        onFileChangeBannerImage: function onFileChangeBannerImage(e, type) {
            var _this11 = this;

            this.activate_processing();
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', this.sellpoint.business_id);
                formData.append('data_type', type);
                service.uploadBusinessDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "business_banner_image") {
                            _this11.sellpoint.business_banner_image = data.body.data;
                            _this11.set_gallery_banner_image = _this11.sellpoint.business_banner_image;
                        }
                        if (type == "business_brand_image") {
                            _this11.sellpoint.business_brand_image = data.body.data;
                        }

                        var self = _this11;
                        setTimeout(function () {
                            self.deactivate_processing();
                            self.mobileSideNavToggle('close');

                            self.loading = true;
                            setTimeout(function () {
                                self.loading = false;
                            }, 1200);
                        }, 1000);
                    } else {
                        _this11.data_error_message = "Could not update, something went wrong. Please try again";
                        _this11.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this11.data_error_message = "Could not update, something went wrong. Please try again";
                    _this11.deactivate_processing();
                });
            }
        },
        manageLookbook: function manageLookbook() {
            var _this12 = this;

            this.disable_btn = true;

            var credentials = {
                session_key: localStorage.getItem("sp_token"),
                request_url: service.app_url,
                request_from: service.app_name,
                request_status: "REQUESTING...",
                request: this.sellpoint.business_username + '/g/' + this.gallery.gallery_posts_group_url_name
            };
            if (credentials.session_key != null) {
                service.sessionSync(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var ref = response.body.data;
                        window.location.href = service.sp_url + '/manage/' + ref;
                    } else {
                        _this12.disable_btn = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this12.disable_btn = false;
                    }
                });
            }
        },
        addToCart: function addToCart(productMain, productItem) {
            this.productItem = {};
            var cart_index = this.cart.findIndex(function (c) {
                return c.product_item_id === productItem.product_item_id;
            });
            if (cart_index < 0) {
                this.productMain = productMain;
                this.productItem = productItem;
                this.productItem._id = this.productItem.product_item_id;
                this.productItem.is_product_in_cart = true;

                if (this.productItem.product_item_order_quantity == undefined) {
                    this.productItem.product_item_order_quantity = 1;
                }
                this.productItem.product_main_id = this.productMain.product_id;
                this.productItem.product_business = this.productMain.product_business_ownername;
                this.productItem.product_name = this.productMain.product_name;
                this.productItem.product_url_name = this.productMain.product_url_name;
                this.productItem.product_url = this.productMain.product_business_ownername + "/" + this.productMain.product_url_name;
                this.$store.commit(ADD_TO_CART, this.productItem);
            } else {}
        },
        removeFromCart: function removeFromCart(payload) {
            this.$store.commit(REMOVE_FROM_CART, payload);
        },
        placeOrder: function placeOrder(product, product_item) {
            this.ordered_product = product;
            this.ordered_product_item = product_item;
            this.place_order = true;
        },
        resetOptions: function resetOptions() {
            this.ordered_product = {};
            this.ordered_product_item = {};
            this.total_price = 0;
            this.place_order = false;
        },
        processPayment: function processPayment() {
            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                this.payment_service = "HungrillvilleKitchen Order - " + this.ordered_product.product_name + "(" + this.ordered_product_item.product_item_price + ")";
                var obj = this;

                var handler = PaystackPop.setup({
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.payment_payer_name,

                    email: this.payment_payer_email,
                    amount: Math.round(this.ordered_product_item.product_item_price * 100),
                    ref: "HUNGLOG" + Math.random(),
                    metadata: {
                        custom_fields: [{
                            display_name: "HungrillvilleKitchen Order",
                            variable_name: "",
                            value: this.payment_payer_name + " - " + this.payment_payer_phone + " - ORDER - " + this.ordered_product.product_name
                        }, {
                            display_name: "Service",
                            variable_name: "service_type",
                            value: this.ordered_product.product_name
                        }]
                    },

                    callback: function callback(response) {
                        obj.updatePayment(response.trxref);
                    },
                    onClose: function onClose() {
                        alert('window closed');
                    }
                });
                handler.openIframe();
            }
        },
        updatePayment: function updatePayment(payment_ref) {
            var navi = this.$router;

            var payer_name = this.payment_payer_name;
            this.data = {};

            this.payment_successful = true;
            this.payment_successful_message = "Hi " + payer_name + ", Your Payment was successful, we would proceed to prepare your order. Thank You.";
        },
        handleResize: function handleResize() {
            this.$refs.swipe.reset();
        }
    },
    mounted: function mounted() {
        this.preset();
    },
    destroyed: function destroyed() {},

    created: function created() {
        if (this.$route.params.idg) {
            this.$router.push('/' + this.$route.params.id);
        }
        if (this.addPanel) {
            this.refresh_button = true;
        }
        this.reset();
        this.setSellpoint();
    }
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    data: function data() {
        return {
            user: {},
            market: {},
            products: {},
            product: {},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue___default.a,
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue___default.a
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        setMarketRemote: function setMarketRemote() {
            var _this2 = this;

            service.getBusinessByUserName(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this2.market = response.body.data;
                    _this2.loading = false;
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.preset();
        this.setMarketRemote();
    }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Account__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Account___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Account__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/account',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Account___default.a,
  children: []
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Buypoint_Buypoint__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Buypoint_Buypoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Buypoint_Buypoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Buypoint_Cart__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Buypoint_Cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Buypoint_Cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Buypoint_Checkout__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Buypoint_Checkout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Buypoint_Checkout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Buypoint_Orders__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Buypoint_Orders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Buypoint_Orders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Buypoint_Order__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Buypoint_Order___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Buypoint_Order__);






/* harmony default export */ __webpack_exports__["a"] = ({
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Buypoint_Buypoint___default.a,
    children: [{
        path: '/cart',
        name: 'Cart',
        component: __WEBPACK_IMPORTED_MODULE_1__pages_Buypoint_Cart___default.a
    }, {
        path: '/checkout',
        name: 'Checkout',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Buypoint_Checkout___default.a
    }, {
        path: '/checkout/:ckid',
        name: 'CheckoutOrderURL',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Buypoint_Checkout___default.a
    }, {
        path: '/orders',
        name: 'Orders',
        component: __WEBPACK_IMPORTED_MODULE_3__pages_Buypoint_Orders___default.a
    }, {
        path: '/order',
        name: 'Order',
        component: __WEBPACK_IMPORTED_MODULE_4__pages_Buypoint_Order___default.a
    }]
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_CreateSellpoint__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_CreateSellpoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_CreateSellpoint__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/create',
  name: 'CreateSellpoint',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_CreateSellpoint___default.a
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Demos__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Demos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Demos__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/demos',
  name: 'demos',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Demos___default.a
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Home__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Home__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/',
  name: 'Home',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Home___default.a,
  children: [{
    path: 'go/:menu',
    name: 'Home2',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Home___default.a
  }]
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Login__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Login__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/login',
  name: 'login',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Login___default.a
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Manage__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Manage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Manage__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/manage/:id',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Manage___default.a,
  children: [{
    path: '',
    name: 'Manage',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Manage___default.a
  }]
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Purchase__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Purchase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Purchase__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/purchase',
  name: 'purchase',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Purchase___default.a
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Register__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Register__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/register',
  name: 'register',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Register___default.a
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Search__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Search__);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '/search',
    name: 'Search',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Search___default.a
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Sellpoint_SellpointTemplate__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Sellpoint_SellpointTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Sellpoint_SellpointTemplate__);





/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/:id',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_Sellpoint_SellpointTemplate___default.a,
  children: [{
    path: '',
    name: 'Sellpoint',
    component: __WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint___default.a
  }, {
    path: ':id1',
    name: 'Product',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product___default.a
  }, {
    path: 'g/:idg',
    name: 'Gallery',
    component: __WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint___default.a
  }]
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Timeline__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Timeline__);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '/timeline',
    name: 'Timeline',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Timeline___default.a
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: 'formatCurrency',
        value: function formatCurrency(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            currency = currency.replace("₦", "");
            currency = currency.replace("NGN", "");
            currency = currency.replace(".00", "");
            return currency.replace(/\s/g, '');
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sellpointActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(8);





var sellpointActions = {
  allSellpoints: function allSellpoints(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* ALL_SELLPOINTS */]);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* API_BASE */] + '/businesses', {
      headers: {
        'Api-Token': this.apiToken
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* ALL_SELLPOINTS_SUCCESS */], response.data);
    });
  }
};

var productActions = {
  allProducts: function allProducts(_ref2) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* ALL_PRODUCTS */]);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* API_BASE */] + '/products', {
      headers: {
        'Api-Token': this.apiToken
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* ALL_PRODUCTS_SUCCESS */], response.data);
    });
  }
};

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sellpointGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cartGetters; });

var sellpointGetters = {
  allSellpoints: function allSellpoints(state, getters) {
    return state.sellpoints;
  },

  sellpointById: function sellpointById(state, getters) {
    return function (id) {
      if (getters.allSellpoints.length > 0) {
        return getters.allSellpoints.filter(function (p) {
          return p._id === id;
        })[0];
      } else {
        return state.sellpoint;
      }
    };
  }
};

var productGetters = {
  allProducts: function allProducts(state, getters) {
    return state.products;
  },

  productById: function productById(state, getters) {
    return function (id) {
      if (getters.allProducts.length > 0) {
        return getters.allProducts.filter(function (p) {
          return p._id === id;
        })[0];
      } else {
        return state.product;
      }
    };
  }
};

var cartGetters = {
  cartProducts: function cartProducts(state) {
    return state.added.map(function (_ref) {
      var id = _ref.id,
          quantity = _ref.quantity;

      var product_item = state.all.find(function (p) {
        return p._id === id;
      });

      return {
        name: product.name,
        price: product.price,
        quantity: quantity
      };
    });
  }
};

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sellpointMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cartMutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(8);


var _sellpointMutations, _productMutations, _cartMutations;



var sellpointMutations = (_sellpointMutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_sellpointMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* ALL_SELLPOINTS */], function (state) {
  state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_sellpointMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* ALL_SELLPOINTS_SUCCESS */], function (state, payload) {
  state.showLoader = false;
  state.sellpoints = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_sellpointMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* ERROR_MSG */], function (state, payload) {}), _sellpointMutations);

var productMutations = (_productMutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* ALL_PRODUCTS */], function (state) {
  state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* ALL_PRODUCTS_SUCCESS */], function (state, payload) {
  state.showLoader = false;
  state.products = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* PRODUCT_BY_ID */], function (state) {
  state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* PRODUCT_BY_ID_SUCCESS */], function (state, payload) {
  state.showLoader = false;
  state.product = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* ERROR_MSG */], function (state, payload) {}), _productMutations);

var cartMutations = (_cartMutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cartMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* VIEW_CART */], function (state) {
  return state.cart;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cartMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* ADD_TO_CART */], function (state, payload) {
  state.cart.push(payload);
  state.cart = state.cart;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cartMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* REMOVE_FROM_CART */], function (state, payload) {
  var index = state.cart.findIndex(function (p) {
    return p._id === payload;
  });
  state.cart.splice(index, 1);
}), _cartMutations);

/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(209)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(268),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(195)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(251),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(245),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(259),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(202)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(261),
  /* scopeId */
  "data-v-7118a3a8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(188)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(243),
  /* scopeId */
  "data-v-08263d0e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(206)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(265),
  /* scopeId */
  "data-v-7caff338",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(201)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(258),
  /* scopeId */
  "data-v-6bf6b6ec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(213)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(273),
  /* scopeId */
  "data-v-bbd4c440",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(210)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(269),
  /* scopeId */
  "data-v-a66154ae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(192)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(248),
  /* scopeId */
  "data-v-1d9df4be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(204)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(263),
  /* scopeId */
  "data-v-74fe042f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(199)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(255),
  /* scopeId */
  "data-v-555a7296",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(200)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(257),
  /* scopeId */
  "data-v-68cfb168",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(190)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(246),
  /* scopeId */
  "data-v-1384c49c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(212)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(271),
  /* scopeId */
  "data-v-b8539b90",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(191)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(247),
  /* scopeId */
  "data-v-1863395a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(205)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(264),
  /* scopeId */
  "data-v-7a9555c2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(211)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(270),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(187)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(242),
  /* scopeId */
  "data-v-05e19f26",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(198)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(254),
  /* scopeId */
  "data-v-51ef2fe8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(189)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(244),
  /* scopeId */
  "data-v-0f1bf178",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('router-view')], 1)])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row card-box-o"
  }, _vm._l((_vm.market.business_markets), function(user, index) {
    return _c('div', {
      staticClass: "card card-01 timeline-user-card"
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + user.business_username
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-circle"
    }, [_c('img', {
      attrs: {
        "src": user.business_banner_image
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right"
    }, [_c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(user.business_name)), _c('br'), _c('span', [_vm._v("@" + _vm._s(user.business_username))])])]), _vm._v(" "), _vm._m(1, true)])])])
  }))])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-thumb-up-left"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-arm-alt-bottom"
  }, [_c('div', {
    staticClass: "card-analytics"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-tag"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-users"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-certificate"
  })])])])])
}]}

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "products"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n     vbvbvb " + _vm._s(_vm.products) + "bvbvbv\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('component-footer')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "shop-page padding-top-100 padding-bottom-100"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v("setting up your account....")])])])])
}]}

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container card-box",
    staticStyle: {
      "height": "100vh",
      "padding": "2em 3em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "login"
    }
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("create an account")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-xs-offset-5",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _c('form', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "firstname",
      "type": "text",
      "name": "firstname",
      "title": "Enter  name",
      "placeholder": "Your Full Name"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "email",
      "type": "text",
      "name": "Email",
      "title": "Enter Email",
      "placeholder": "Your Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone),
      expression: "user.phone"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "phone",
      "type": "text",
      "name": "Phone",
      "title": "Enter Phone Number",
      "placeholder": "Your Phone Number"
    },
    domProps: {
      "value": (_vm.user.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "password",
      "type": "password",
      "title": "Enter password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.terms),
      expression: "terms"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.terms) ? _vm._i(_vm.terms, null) > -1 : (_vm.terms)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.terms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.terms = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.terms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.terms = $$c
        }
      }
    }
  }), _vm._v("I agree to "), _c('a', {
    attrs: {
      "href": "know#terms"
    }
  }, [_vm._v("Terms and Conditions")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#0400ff",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.reg
    }
  }, [_vm._v("Register Now")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(0)])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Already have a "), _c('u', [_vm._v("Sellpoint")]), _vm._v(" account? - Login")])])
}]}

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row card-box-o"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "3em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-6 col-sm-offset-1"
  }, [_c('div', {
    staticClass: "sp1-reg",
    staticStyle: {
      "background": "#ffffff",
      "padding": "2em",
      "border-radius": "2px"
    }
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "register"
    }
  }, [_c('h3', [_vm._v("Create A Sellpoint")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Set up a Store for your Business!")]), _vm._v(" "), _c('form', {
    staticClass: "form-inline",
    attrs: {
      "name": "registration_form",
      "id": "registration_form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "business_name"
    }
  }, [_vm._v("Business Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_name),
      expression: "business.business_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "business_name",
      "type": "text",
      "name": "business_name",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.business.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "business_user_name"
    }
  }, [_vm._v("Business Username"), (_vm.validate_user_name_error) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.validate_user_name_message))]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_user_name),
      expression: "business.business_user_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "business_user_name",
      "type": "text",
      "name": "business_name",
      "title": "Enter  name",
      "placeholder": "Your unique Business User Name"
    },
    domProps: {
      "value": (_vm.business.business_user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_user_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Business Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select a Category")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)])])]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    on: {
      "click": _vm.createSellpoint
    }
  }, [_vm._v("Create")])])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-8 contact_form add-prd-item"
  }, [_c('h6', [_vm._v("Add New Item ")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Price\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Weight\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Quantity\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" Product Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addProductItem
    }
  }, [_vm._v("Add")])])])])])
},staticRenderFns: []}

/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h6', [_vm._v("Add a New Lookbook to your Gallery")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "loading-md"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px",
      "color": "#000000"
    }
  }, [_vm._v("Preparing and Checking your Sellpoint")])]) : _c('form', {
    staticClass: "gw-form"
  }, [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_name),
      expression: "gallery.gallery_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "What's the Name of your Lookbook"
    },
    domProps: {
      "value": (_vm.gallery.gallery_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_description),
      expression: "gallery.gallery_description"
    }],
    attrs: {
      "placeholder": "What's this Lookbook all about"
    },
    domProps: {
      "value": (_vm.gallery.gallery_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('h6', [_vm._v("Add a Post to "), _c('span', {
    staticStyle: {
      "color": "#ff0055"
    }
  }, [_vm._v(_vm._s(_vm.gallery.gallery_name))]), _vm._v(" Lookbook")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_caption),
      expression: "post.post_caption"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Caption/Title this Post"
    },
    domProps: {
      "value": (_vm.post.post_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_caption = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_details),
      expression: "post.post_details"
    }],
    attrs: {
      "placeholder": "Full Post Details"
    },
    domProps: {
      "value": (_vm.post.post_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_details = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "upload-btn-wrapper"
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add Post's media (Image/Video)")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*,video/*",
      "capture": ""
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ee87a6"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addGallery
    }
  }, [_vm._v("All Done, Add Lookbook")])])]), _vm._v(" "), _c('hr')])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(your lookbook is a collection or group of posts you want to keep together)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Lookbook Name"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Description"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(This would be the first post added to this lookbook)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Caption"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Details"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(You can always add more images or video on this post)")])])
}]}

/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.canAdd) ? _c('button', {
    staticClass: "cart-btn",
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v("Add to Cart")]) : _c('span', [_c('button', {
    staticClass: "cart-btn remove-btn",
    staticStyle: {
      "background": "#e05024"
    },
    on: {
      "click": function($event) {
        _vm.removeFromCart(_vm.productItem)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Remove from Cart")]), _vm._v(" "), _c('button', {
    staticClass: "cart-btn view-btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")])])])
},staticRenderFns: []}

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(this.$route.path == '/cart') ? _c('div', [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cart-summ"
  }, [_c('div', {
    staticClass: " cart-summ-card-left card col-sm-1",
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.cart.length)), _c('br'), _vm._v("items")])])]), _vm._v(" "), _c('div', {
    staticClass: " cart-summ-card-right card col-md-8",
    staticStyle: {
      "float": "right"
    }
  }, [_vm._m(1), _vm._v(" "), _c('li', [_vm._v("₦" + _vm._s(_vm.total_order_amt))]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Shipping Fee: ")]), _vm._v("₦" + _vm._s(_vm.total_delivery_fee))]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.process_orders()
      }
    }
  }, [_vm._v("Process Orders")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12  text-center",
    staticStyle: {
      "background": "#ffffff"
    }
  }, _vm._l((_vm.sorted_cart), function(group, index) {
    return _c('div', {
      staticClass: "row group-row",
      staticStyle: {
        "margin-bottom": "6em"
      }
    }, [_c('h5', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(group[0]) + "'s Sellpoint")]), _c('br'), _vm._v(" "), _c('div', {}, [_vm._l((group[1]), function(item, index2) {
      return _c('ul', {
        staticClass: "row cart-details"
      }, [_c('li', {
        staticClass: "col-md-6 col-sm-12"
      }, [_c('div', {
        staticClass: "col-md-6 col-sm-12"
      }, [_c('div', {
        staticClass: "pull-left"
      }, [(item.product_checked) ? _c('button', {
        staticClass: "btn order-btn",
        on: {
          "click": function($event) {
            _vm.removeFromCheckout(item, index, index2)
          }
        }
      }, [_c('del', [_vm._v("Selected")])]) : _c('button', {
        staticClass: "btn order-btn",
        on: {
          "click": function($event) {
            _vm.addToCheckout(item, index, index2)
          }
        }
      }, [_vm._v("Select "), _c('br'), _vm._v("Order")])]), _vm._v(" "), _c('a', {
        staticClass: "item-img cart-img",
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "href": item.product_url
        }
      }, [((item.product_item_image && (item.product_item_image != ''))) ? _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": _vm.img_product_url + item.product_item_image
        }
      }) : _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-md-6 col-sm-12"
      }, [_c('h5', [_vm._v(_vm._s(item.product_name))])])]), _vm._v(" "), _c('li', {
        staticClass: "col-sm-1"
      }, [_c('div', {}, [_c('div', {
        staticClass: "quinty"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.product_item_order_quantity),
          expression: "item.product_item_order_quantity"
        }],
        staticStyle: {
          "max-width": "52px",
          "max-height": "32px"
        },
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": (item.product_item_order_quantity)
        },
        on: {
          "change": function($event) {
            _vm.refreshCheckout(item, index, index2)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            item.product_item_order_quantity = $event.target.value
          }
        }
      })])])]), _vm._v(" "), _c('li', {
        staticClass: "col-sm-2"
      }, [_c('div', {}, [_c('label', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v("Price: ")]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_price))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v("Total: ")]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_order_quantity * item.product_item_price))])])]), _vm._v(" "), _c('li', {
        staticClass: "col-sm-2"
      }, [(group.selected_business_delivery_option && item.product_checked) ? _c('p', [(!group.selected_business_delivery_option.has_product_delivery_fee) ? _c('span', _vm._l((group.selected_business_delivery_option.business_products_delivery_fees), function(pd_fee) {
        return _c('span', [(item.product_main_id == pd_fee.product_delivery_product) ? _c('span', [_vm._v("\r\n                          ₦" + _vm._s(pd_fee.product_delivery_fee) + "\r\n                      ")]) : _vm._e()])
      })) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('li', {
        staticClass: "col-sm-1"
      }, [(item.can_remove) ? _c('div', {}, [_c('label', [_vm._v("Remove: ")]), _vm._v(" "), _c('a', {
        staticStyle: {
          "cursor": "pointer",
          "background": "#000000",
          "color": "#ffffff"
        },
        on: {
          "click": function($event) {
            _vm.removeFromCart(item._id, index, item)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-close"
      })])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })])
    }), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })], 2), _vm._v(" "), (group.items_in_checkout > 0) ? _c('div', {
      staticClass: "row"
    }, [(group.items_in_checkout > 0) ? _c('div', [(group[4]) ? _c('div', {
      staticClass: "pull-left coupons-sec"
    }, [_vm._m(2, true), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _vm._l((group[4]), function(coupon) {
      return _c('p', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.coupon_code),
          expression: "coupon_code"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": coupon.discount_id,
          "checked": Array.isArray(_vm.coupon_code) ? _vm._i(_vm.coupon_code, coupon.discount_id) > -1 : (_vm.coupon_code)
        },
        on: {
          "click": function($event) {
            _vm.set_coupons(index, coupon, coupon.discount_percentage)
          },
          "__c": function($event) {
            var $$a = _vm.coupon_code,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = coupon.discount_id,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.coupon_code = $$a.concat($$v))
              } else {
                $$i > -1 && (_vm.coupon_code = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.coupon_code = $$c
            }
          }
        }
      }), _vm._v(" " + _vm._s(coupon.discount_coupon_code) + " - " + _vm._s(coupon.discount_percentage) + "% Off "), _c('b', [_vm._v("From " + _vm._s(coupon.discount_provider))])])
    })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [(group.products_without_delivery_details_count >= 1) ? _c('div', [(group[2]) ? _c('div', [(group[2].length != 0 && !group.delivery_option) ? _c('span', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Please select a delivery option"), _c('br')]) : _vm._e(), _vm._v(" "), (group[2].length != 0) ? _c('div', [_c('div', {
      staticClass: "dropdown"
    }, [(group.selected_business_delivery_option) ? _c('button', {
      staticClass: "dropbtn"
    }, [(group.selected_business_delivery_option.has_product_delivery_fee) ? _c('span', [_vm._v("\r\n                        " + _vm._s(group.selected_business_delivery_option.business_delivery_option) + " -  ₦" + _vm._s(group.selected_business_delivery_option.business_product_delivery_fee) + "▼\r\n                      ")]) : _c('span', [_vm._v("\r\n                          " + _vm._s(group.selected_business_delivery_option.business_delivery_option) + " -  ₦" + _vm._s(group.selected_business_delivery_option.business_delivery_option_price) + "▼\r\n                      ")])]) : _c('button', {
      staticClass: "dropbtn"
    }, [_vm._v("Select Delivery Option " + _vm._s(group[0]) + " Orders▼")]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-content"
    }, _vm._l((group[2]), function(option) {
      return _c('div', [(option.business_delivery_product == 0) ? _c('span', [_c('label', [((group.items_in_checkout > 0) && (group.products_without_delivery_details_checked.length > 0)) ? _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.sellpoint_delivery_fee),
          expression: "sellpoint_delivery_fee"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": option.business_delivery_option_id,
          "checked": _vm._q(_vm.sellpoint_delivery_fee, option.business_delivery_option_id)
        },
        on: {
          "click": function($event) {
            _vm.calc_sellpoint_delivery_fee(index, option)
          },
          "__c": function($event) {
            _vm.sellpoint_delivery_fee = option.business_delivery_option_id
          }
        }
      })]) : _vm._e(), _vm._v(" "), (option.has_product_delivery_fee) ? _c('span', [_vm._v("\r\n                              " + _vm._s(option.business_delivery_option) + " -  ₦" + _vm._s(option.business_product_delivery_fee) + "\r\n                            ")]) : _c('span', [_vm._v("\r\n                              " + _vm._s(option.business_delivery_option) + " -  ₦" + _vm._s(option.business_delivery_option_price) + "\r\n                            ")])])]) : _vm._e()])
    }))])]) : _c('div', [_c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Free Delivery")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_c('p', {
      staticClass: "tiny-part"
    }, [_vm._v("Total Orders from "), _c('b', [_vm._v(_vm._s(group[0]) + ":")]), _vm._v(" ₦" + _vm._s(group.total_order_amt))]), _vm._v(" "), (group[2]) ? _c('span', [_c('p', {
      staticClass: "tiny-part"
    }, [_vm._v("Shipping Fee:  ₦" + _vm._s(group.total_delivery_charge))]), _vm._v(" "), _c('p', {
      staticClass: "tiny-part"
    }, [_vm._v("Total: ₦" + _vm._s(group.total_order_amt + group.total_delivery_charge))])]) : _c('span', [_c('p', {
      staticClass: "tiny-part"
    }, [_c('b', [_vm._v("Shipping Details:")]), _vm._v(" " + _vm._s(group.delivery_option))])]), _vm._v(" "), (group[3]) ? _c('div', {
      staticClass: "row"
    }, [_vm._m(4, true), _vm._v(" "), (!group.payment_mode) ? _c('span', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Please select a payment option"), _c('br')]) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.payment_option),
        expression: "payment_option"
      }],
      attrs: {
        "type": "radio",
        "value": "pay_on_delivrey"
      },
      domProps: {
        "checked": _vm._q(_vm.payment_option, "pay_on_delivrey")
      },
      on: {
        "click": function($event) {
          _vm.setPaymentOption(index, 2)
        },
        "__c": function($event) {
          _vm.payment_option = "pay_on_delivrey"
        }
      }
    }), _c('label', [_vm._v("Pay On Delivery")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.payment_option),
        expression: "payment_option"
      }],
      attrs: {
        "type": "radio",
        "value": "pay_now"
      },
      domProps: {
        "checked": _vm._q(_vm.payment_option, "pay_now")
      },
      on: {
        "click": function($event) {
          _vm.setPaymentOption(index, 1)
        },
        "__c": function($event) {
          _vm.payment_option = "pay_now"
        }
      }
    }), _c('label', [_vm._v("Pay Now")])]) : _c('div', {
      staticClass: "row"
    }, [_vm._m(5, true)]), _vm._v(" "), (_vm.buy_now_order && (_vm.checked_out.length != 0)) ? _c('div', {
      staticClass: "text-align"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      staticStyle: {
        "background": "#000000"
      },
      on: {
        "click": function($event) {
          _vm.process_orders()
        }
      }
    }, [_vm._v("Process Orders")])]) : _vm._e()])])]) : _vm._e()])
  })), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.buy_now_order) ? _c('div', [(_vm.checked_out.length != 0) ? _c('div', {
    staticClass: "col-sm-12 orders-panel pull-right",
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('span', {
    staticClass: "col-sm-3"
  }, [_c('h5', [_vm._v("Your Orders")]), _vm._v(" "), _c('p', [_vm._v("₦" + _vm._s(_vm.total_order_amt))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Shipping Fee: ")]), _vm._v("₦" + _vm._s(_vm.total_delivery_fee))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.process_orders()
      }
    }
  }, [_vm._v("Process Orders")])])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (this.$route.path == '/order') ? _c('div', [_c('div', {
    staticClass: "col-md-12 col-sm-12",
    staticStyle: {
      "background": "#ffffff"
    }
  }, [_c('h2', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Process your Order")]), _vm._v(" "), _vm._l((_vm.sorted_cart), function(group, index) {
    return _c('div', {
      staticClass: "row group-row",
      staticStyle: {
        "margin-top": "4em",
        "margin-bottom": "6em"
      }
    }, _vm._l((group[1]), function(item, index2) {
      return _c('ul', {
        staticClass: "col-md-8 col-md-offset-4 col-sm-12"
      }, [(item.active_order) ? _c('div', [_c('div', [_c('li', {
        staticClass: "col-md-4 col-sm-12"
      }, [_c('div', {}, [_c('a', {
        staticClass: "item-img cart-img",
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "href": item.product_url
        }
      }, [((item.product_item_image && (item.product_item_image != ''))) ? _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": _vm.img_product_url + item.product_item_image
        }
      }) : _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })])])]), _vm._v(" "), _c('li', {
        staticClass: "col-md-8"
      }, [_c('div', {}, [_c('h4', [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), _c('label', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v("Price: ")]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_price))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
        staticClass: "quinty"
      }, [_c('label', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v("Qty: ")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.product_item_order_quantity),
          expression: "item.product_item_order_quantity"
        }],
        staticStyle: {
          "max-width": "52px",
          "max-height": "32px"
        },
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": (item.product_item_order_quantity)
        },
        on: {
          "change": function($event) {
            _vm.refreshCheckout(item, index, index2)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            item.product_item_order_quantity = $event.target.value
          }
        }
      })]), _vm._v(" "), _c('label', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v("Total: ")]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_order_quantity * item.product_item_price))])]), _vm._v(" "), _c('div', [(item.product_checked) ? _c('a', {
        staticClass: "btn order-btn",
        staticStyle: {
          "margin-top": "3px",
          "float": "right"
        },
        attrs: {
          "href": "/"
        }
      }, [_vm._v("Cancel Order")]) : _c('button', {
        staticClass: "btn order-btn",
        on: {
          "click": function($event) {
            _vm.addToCheckout(item, index, index2)
          }
        }
      }, [_vm._v("Process Order")])])]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })]), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "none"
        },
        attrs: {
          "id": item.index2 + 'PRT_CART'
        }
      }, [(group.items_in_checkout > 0) ? _c('div', {
        staticClass: "col-md-4"
      }, [(group[4] && (group[4].length > 0)) ? _c('div', {}, [_vm._m(6, true), _vm._v(" "), _vm._m(7, true), _vm._v(" "), _vm._l((group[4]), function(coupon) {
        return _c('p', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.coupon_code),
            expression: "coupon_code"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "value": coupon.discount_id,
            "checked": Array.isArray(_vm.coupon_code) ? _vm._i(_vm.coupon_code, coupon.discount_id) > -1 : (_vm.coupon_code)
          },
          on: {
            "click": function($event) {
              _vm.set_coupons(index, coupon, coupon.discount_percentage)
            },
            "__c": function($event) {
              var $$a = _vm.coupon_code,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = coupon.discount_id,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.coupon_code = $$a.concat($$v))
                } else {
                  $$i > -1 && (_vm.coupon_code = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.coupon_code = $$c
              }
            }
          }
        }), _vm._v(" " + _vm._s(coupon.discount_coupon_code) + " - " + _vm._s(coupon.discount_percentage) + "% Off "), _c('b', [_vm._v("From " + _vm._s(coupon.discount_provider))])])
      })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "col-md-8"
      }, [(group.products_without_delivery_details_count >= 1) ? _c('div', [(group[2]) ? _c('div', [(group[2].length != 0 && !group.delivery_option) ? _c('span', {
        staticStyle: {
          "color": "#ff0000",
          "font-size": "12px"
        }
      }, [_vm._v("Please select a delivery option"), _c('br')]) : _vm._e(), _vm._v(" "), (group[2].length != 0) ? _c('div', [_c('div', {
        staticClass: "dropdown"
      }, [(group.selected_business_delivery_option) ? _c('button', {
        staticClass: "dropbtn"
      }, [_vm._v(_vm._s(group.selected_business_delivery_option.business_delivery_option) + " -  ₦" + _vm._s(group.selected_business_delivery_option.business_delivery_option_price) + "▼")]) : _c('button', {
        staticClass: "dropbtn"
      }, [_vm._v("Select Delivery Location▼")]), _vm._v(" "), _c('div', {
        staticClass: "dropdown-content"
      }, _vm._l((group[2]), function(option) {
        return _c('div', [(option.business_delivery_product == 0) ? _c('span', [_c('label', [((group.items_in_checkout > 0) && (group.products_without_delivery_details_checked.length > 0)) ? _c('span', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.sellpoint_delivery_fee),
            expression: "sellpoint_delivery_fee"
          }],
          attrs: {
            "type": "radio"
          },
          domProps: {
            "value": option.business_delivery_option_id,
            "checked": _vm._q(_vm.sellpoint_delivery_fee, option.business_delivery_option_id)
          },
          on: {
            "click": function($event) {
              _vm.calc_sellpoint_delivery_fee(index, option)
            },
            "__c": function($event) {
              _vm.sellpoint_delivery_fee = option.business_delivery_option_id
            }
          }
        })]) : _vm._e(), _vm._v("\r\n                                  " + _vm._s(option.business_delivery_option) + " -  ₦" + _vm._s(option.business_delivery_option_price) + "\r\n                                ")])]) : _vm._e()])
      }))])]) : _c('div', [_c('p', {
        staticStyle: {
          "color": "#ff0000",
          "font-size": "12px"
        }
      }, [_vm._v("Free Delivery")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [(group[2]) ? _c('span', [_c('p', {
        staticClass: "tiny-part"
      }, [_vm._v("Shipping Fee:  ₦" + _vm._s(group.total_delivery_charge))]), _vm._v(" "), _c('p', {
        staticClass: "tiny-part"
      }, [_vm._v("Total: ₦" + _vm._s(group.total_order_amt + group.total_delivery_charge))])]) : _c('span', [_c('p', {
        staticClass: "tiny-part"
      }, [_c('b', [_vm._v("Shipping Details:")]), _vm._v(" " + _vm._s(group.delivery_option))])]), _vm._v(" "), (group[3]) ? _c('div', {}, [_vm._m(8, true), _vm._v(" "), (!group.payment_mode) ? _c('span', {
        staticStyle: {
          "color": "#ff0000",
          "font-size": "12px"
        }
      }, [_vm._v("Please select a payment option"), _c('br')]) : _vm._e(), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.payment_option),
          expression: "payment_option"
        }],
        attrs: {
          "type": "radio",
          "value": "pay_on_delivrey"
        },
        domProps: {
          "checked": _vm._q(_vm.payment_option, "pay_on_delivrey")
        },
        on: {
          "click": function($event) {
            _vm.setPaymentOption(index, 2)
          },
          "__c": function($event) {
            _vm.payment_option = "pay_on_delivrey"
          }
        }
      }), _c('label', [_vm._v("Pay On Delivery")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.payment_option),
          expression: "payment_option"
        }],
        attrs: {
          "type": "radio",
          "value": "pay_now"
        },
        domProps: {
          "checked": _vm._q(_vm.payment_option, "pay_now")
        },
        on: {
          "click": function($event) {
            _vm.setPaymentOption(index, 1)
          },
          "__c": function($event) {
            _vm.payment_option = "pay_now"
          }
        }
      }), _c('label', [_vm._v("Pay Now")])]) : _c('div', {}, [_vm._m(9, true)]), _vm._v(" "), (_vm.buy_now_order && (_vm.checked_out.length != 0)) ? _c('div', {
        staticClass: "text-align"
      }, [_c('button', {
        staticClass: "btn btn-primary",
        staticStyle: {
          "background": "#000000"
        },
        on: {
          "click": function($event) {
            _vm.process_orders()
          }
        }
      }, [_vm._v("Proceed")])]) : _vm._e()])])])]) : _vm._e()])
    }))
  })], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart-summ",
    staticStyle: {
      "text-align": "center",
      "width": "100%",
      "margin-bottom": "2em"
    }
  }, [_c('h3', {
    staticClass: "cart-title",
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Your Cart")]), _vm._v(" "), _c('p', {}, [_vm._v("Checkout items from each sellpoint, then click *Process Orders* to continue.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Total to checkout")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Applied Coupons")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "14px"
    }
  }, [_vm._v("Please select coupons"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tiny-part"
  }, [_c('b', [_vm._v("Payment Mode")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tiny-part"
  }, [_vm._v("Payment Mode: "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Pay Now")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Applied Coupons")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "14px"
    }
  }, [_vm._v("Please select coupons"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tiny-part"
  }, [_c('b', [_vm._v("Payment Mode")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tiny-part"
  }, [_vm._v("Payment Mode: "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Pay Now")])])
}]}

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.product_info) ? _c('div', {
    staticClass: "margin-top-50 pretty-banner"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("Same product but different variations")]), _vm._v(" "), _c('p', [_vm._v("if this product has different colours, sizes, etc... no need filling this long form again, go to this product view and set them.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  }), _c('a', {
    attrs: {
      "href": _vm.product_url
    }
  }, [_vm._v("Proceed to this Product's View ")])])]) : _vm._e(), _vm._v(" "), (!_vm.product_info) ? _c('div', {
    staticClass: "col-sm-10 col-sm-offset-4"
  }, [_c('h6', [_vm._v("Add Product / Service")]), _vm._v(" "), _c('form', [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Product Name\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.sellpoint_categories.length != 0) ? _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" Select Product Category\n                        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    attrs: {
      "id": "category-type-1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-1')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_1
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      key: category.business_category_id,
      attrs: {
        "disabled": _vm.category_type_1
      },
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.sellpoint_categories.length != 0) ? _c('li', {
    staticClass: "col-sm-4 col-sm-offset-4"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Select from related Shop Categories\n                        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_sub_category),
      expression: "product.product_sub_category"
    }],
    staticClass: "category-type-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_sub_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_2
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(category) {
    return _c('option', {
      key: category.sub_category_id,
      attrs: {
        "disabled": _vm.category_type_2
      },
      domProps: {
        "value": category.sub_category_id
      }
    }, [_vm._v(_vm._s(category.sub_category_name))])
  })], 2)])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_c('b', [_vm._v(" *Or ")]), _vm._v(" Enter a specific Category\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_listed_category),
      expression: "product.product_listed_category"
    }],
    attrs: {
      "disabled": _vm.category_type_3,
      "type": "text",
      "placeholder": "",
      "id": "category-type-3"
    },
    domProps: {
      "value": (_vm.product.product_listed_category)
    },
    on: {
      "change": function($event) {
        _vm.trackevent('category-type-3')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_listed_category = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Description\n                            "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Price\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Weight\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Quantity\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Add Product Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("Add")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" *Or ")])])
}]}

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row card-box-o"
  }, _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "card card-01 timeline-user-card"
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + _vm.sellpoint.business_username + '/' + product.product_url_name
      }
    }, [_c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-square"
    }, [(product.product_images[0]) ? _c('img', {
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right"
    }, [_c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price) + " - ₦" + _vm._s(product.product_items[0].product_item_price))]) : _vm._e()])]), _vm._v(" "), _vm._m(0, true)])])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-arm-alt-bottom"
  }, [_c('div', {
    staticClass: "card-analytics"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-tag"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })])])])])
}]}

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager"
  }, [_c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "12em",
      "text-align": "center"
    }
  }, [_c('h2', [_vm._v("AfiaApp"), _c('br'), _vm._v("Chat & Buy")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "2em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "margin": "1em"
    },
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("login")]), _vm._v(" | \r\n                    "), _c('a', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "margin": "1em"
    },
    attrs: {
      "href": "/register"
    }
  }, [_vm._v("signup")])])])])])
}]}

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container card-box",
    staticStyle: {
      "height": "100vh",
      "padding": "7em 3em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "login"
    }
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Log into your account")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-xs-offset-5",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "my-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "my-email",
      "type": "text",
      "name": "Email",
      "title": "Enter Email",
      "placeholder": "Your Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "my-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "my-password",
      "type": "password",
      "name": "password",
      "title": "Enter password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticStyle: {
      "color": "#777777"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Forgot Password?")]), _vm._v(" or "), _c('a', {
    staticStyle: {
      "color": "#888888"
    },
    attrs: {
      "href": "/register"
    }
  }, [_vm._v("Register?")])])
}]}

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gw-info-wrap",
    staticStyle: {
      "background": "#ffffff"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "col-md-6 col-md-offset-4 col-xs-12"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', [(!_vm.checkout_processed) ? _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('h1', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Checkout")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#000000",
      "margin-left": "10px"
    }
  }, [_vm._v("Enter the details below to Checkout"), _c('br'), _vm._v(" "), (_vm.new_account) ? _c('span', [_vm._v("Do you have a "), _c('b', [_vm._v("Buypoint Account? ")]), _vm._v(" "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('login', '')
      }
    }
  }, [_vm._v("Please Provide")])])]) : _c('span', [_vm._v("Don't have a "), _c('b', [_vm._v("Buypoint Account? ")]), _vm._v(" "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('new-account', '')
      }
    }
  }, [_vm._v("Click Here")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 gw-left-pan"
  }, [_c('div', {
    staticClass: "gw-form",
    staticStyle: {
      "margin-top": "-1em"
    }
  }, [(_vm.new_account) ? _c('form', {
    attrs: {
      "name": "",
      "id": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticStyle: {
      "margin": "1em 1em 2.2em 0.5em"
    }
  }, [_vm._v("Personal Details")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Email"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "-5em",
      "display": "none"
    }
  }, [_c('h4', {
    staticStyle: {
      "margin": "1em 1em 2.2em 0.5em"
    }
  }, [_vm._v("Shipping Details")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12",
    staticStyle: {
      "margin-top": "-2em"
    }
  }, [_c('label', [_vm._v("Select State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_shipping_details_state),
      expression: "user.user_shipping_details_state"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.user.user_shipping_details_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12",
    staticStyle: {
      "margin-top": "0.3em"
    }
  }, [_c('label', [_vm._v("Shipping Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_shipping_details_address),
      expression: "user.user_shipping_details_address"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Shipping Address"
    },
    domProps: {
      "value": (_vm.user.user_shipping_details_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_shipping_details_address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.data_success_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]) : _vm._e(), _vm._v(" "), (_vm.data_error_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background": "#000000"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.prep_process_checkout
    }
  }, [_vm._v("Process Checkout")])])]) : _c('form', {
    attrs: {
      "name": "",
      "id": ""
    }
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h5', {
    staticStyle: {
      "margin": "1em 1em 3em 0.5em"
    }
  }, [_vm._v("Enter your Buypoint Login Details Below")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Email"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_password),
      expression: "user.user_password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Your Password"
    },
    domProps: {
      "value": (_vm.user.user_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_password = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.data_success_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]) : _vm._e(), _vm._v(" "), (_vm.data_error_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background": "#000000"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Process Checkout")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 gw-right-pan"
  }, [_c('div', {
    staticClass: "gw-right-pan",
    staticStyle: {
      "margin": "-5em 0 0 1em"
    }
  }, [_c('h4', {
    staticStyle: {
      "margin": "1em",
      "text-transform": "uppercase",
      "font-weight": "500"
    }
  }, [_vm._v("Items to Checkout")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1em",
      "padding": "1em",
      "border": "#000000 solid 1px"
    }
  }, _vm._l((_vm.checkout_orders), function(group, index) {
    return _c('div', {
      staticClass: "group-row",
      staticStyle: {
        "margin-bottom": "6em"
      }
    }, _vm._l((group.order_items), function(item) {
      return _c('div', {
        staticClass: "row cart-details"
      }, [_c('div', {
        staticClass: "col-xs-2",
        staticStyle: {
          "width": "50px",
          "height": "50px"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "href": item.product_url
        }
      }, [((item.product_item_image && (item.product_item_image != ''))) ? _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": _vm.img_product_url + item.product_item_image
        }
      }) : _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-3"
      }, [_c('h5', [_vm._v(_vm._s(item.product_name))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-2"
      }, [_vm._v("\r\n                                        QTY: " + _vm._s(item.product_item_order_quantity) + "\r\n                                    ")]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-2"
      }, [_c('label', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v("Price: ")]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_price))])])])
    }))
  }))])])])]) : _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 col-xs-12"
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Checkout")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "border": "solid 1px #e0dfdf",
      "padding": "2em"
    }
  }, [_c('div', {
    staticClass: "row cktop ck-card-row"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_payer_name))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_payer_phone))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_payer_email))])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right "
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_ref))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("₦" + _vm._s(_vm.total_orders_amount))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "ckbody"
  }, _vm._l((_vm.checkout_orders), function(group, index) {
    return _c('div', {
      staticClass: "group-row",
      staticStyle: {
        "margin-bottom": "6em"
      }
    }, [_vm._l((group.order_items), function(item) {
      return _c('div', {
        staticClass: "row ck-card-row"
      }, [_c('div', {
        staticClass: "col-md-2",
        staticStyle: {
          "width": "75px",
          "height": "75px"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "href": item.product_url
        }
      }, [((item.product_item_group_image && (item.product_item_group_image != ''))) ? _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": item.product_item_group_image
        }
      }) : _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-md-5"
      }, [_c('h5', [_vm._v(_vm._s(item.product_name))])]), _vm._v(" "), _c('div', {
        staticClass: "col-md-2"
      }, [_vm._v("\r\n                                            QTY: " + _vm._s(item.order_item_quantity) + "\r\n                                        ")]), _vm._v(" "), _c('div', {
        staticClass: "col-md-3"
      }, [_c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_price))])]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      }), _vm._v(" "), (item.order_item_delivery_fee != 0) ? _c('div', {
        staticClass: "row pull-right",
        staticStyle: {
          "margin-right": "3px"
        }
      }, [_c('span', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Product Shipping Fee: ")]), _vm._v("₦" + _vm._s(item.order_item_delivery_fee) + "\r\n                                        ")]) : _vm._e()])
    }), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "pull-left col-md-6"
    }, [_vm._m(0, true), _vm._v(" "), ((group.order_business_delivery_options && (group.order_business_delivery_options.length != 0))) ? _c('div', [_c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "-2em"
      }
    }, [_c('label', [_vm._v("Select State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_order_shipping_details_state),
        expression: "selected_order_shipping_details_state"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.selected_order_shipping_details_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities()
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state.state_id
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2)]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), (_vm.cities.length != 0) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "-2em"
      }
    }, [_c('label', [_vm._v("Select Location")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_order_shipping_details_city),
        expression: "selected_order_shipping_details_city"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.selected_order_shipping_details_city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city.city_id
        }
      }, [_vm._v(_vm._s(city.city_name))])
    })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "0.3em"
      }
    }, [_c('label', [_vm._v("Shipping Address")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_order_shipping_details_address),
        expression: "selected_order_shipping_details_address"
      }],
      staticClass: "form-control input-group-lg",
      attrs: {
        "type": "text",
        "placeholder": "Shipping Address"
      },
      domProps: {
        "value": (_vm.selected_order_shipping_details_address)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.selected_order_shipping_details_address = $event.target.value
        }
      }
    })])]) : _c('div', [_c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "-2em"
      }
    }, [_c('label', [_vm._v("Select State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_order_shipping_details_state),
        expression: "selected_order_shipping_details_state"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.selected_order_shipping_details_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities(_vm.selected_order_shipping_details_state)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state.state_id
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e()]), _vm._v(" "), (_vm.cities.length != 0) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('label', [_vm._v("Select Location")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_order_shipping_details_city),
        expression: "selected_order_shipping_details_city"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.selected_order_shipping_details_city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city.city_id
        }
      }, [_vm._v(_vm._s(city.city_name))])
    })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "0.3em"
      }
    }, [_c('label', [_vm._v("Shipping Address")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_order_shipping_details_address),
        expression: "selected_order_shipping_details_address"
      }],
      staticClass: "form-control input-group-lg",
      attrs: {
        "type": "text",
        "placeholder": "Shipping Address"
      },
      domProps: {
        "value": (_vm.selected_order_shipping_details_address)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.selected_order_shipping_details_address = $event.target.value
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [_c('div', [_c('p', {
      staticClass: "tiny-part"
    }, [_vm._v("Total Orders ₦" + _vm._s(_vm.total_orders_amount))]), _vm._v(" "), (_vm.checkout_orders) ? _c('span', [_c('p', {
      staticClass: "tiny-part"
    }, [_vm._v("Shipping Fee:  ₦" + _vm._s(_vm.total_shipping_fee))]), _vm._v(" "), _c('p', {
      staticClass: "tiny-part"
    }, [_vm._v("Total: ₦" + _vm._s(_vm.total_orders_amount + _vm.total_shipping_fee))])]) : _c('span', [_vm._m(1, true)])])])])], 2)
  }))]), _vm._v(" "), ((_vm.selected_order_shipping_details_state != '') && (_vm.selected_order_shipping_details_city != '') && (_vm.selected_order_shipping_details_address != '')) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background": "#000000"
    },
    on: {
      "click": _vm.processPaymentMini
    }
  }, [_vm._v("Make Payment")])]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticStyle: {
      "margin": "1em 1em 2.2em 0.5em"
    }
  }, [_vm._v("Shipping Details\r\n                                                    "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Please enter your Shipping Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tiny-part"
  }, [_c('b', [_vm._v("Shipping Details:")]), _vm._v(" {{}}")])
}]}

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "friend-list"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticStyle: {
      "color": "#ff5566",
      "padding": "1em"
    }
  }, [_vm._v("Top activity products")]), _vm._v(" "), _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      key: index,
      staticClass: "col-md-4 col-sm-4 col-xs-6"
    }, [((product.product_items.length != 0)) ? _c('div', {
      staticStyle: {
        "min-height": "23em",
        "max-height": "22em"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "inherit",
        "text-decoration": "none"
      },
      attrs: {
        "href": '/' + product.product_business_username + '/' + product.product_url_name
      }
    }, _vm._l((product.product_items), function(product_item, index2) {
      return _c('div', {
        key: index2,
        staticClass: "friend-card",
        staticStyle: {
          "min-height": "22em",
          "max-height": "22em",
          "border-bottom-color": "rgb(182, 176, 176)"
        }
      }, [(index2 == 0) ? _c('div', [_c('div', {
        staticStyle: {
          "height": "10em"
        }
      }, [_c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": product_item.product_item_image,
          "alt": "photo"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "card-info"
      }, [_c('div', {
        staticClass: "friend-info"
      }, [_c('a', {
        staticClass: "pull-right text-green",
        staticStyle: {
          "font-size": "12px"
        },
        attrs: {
          "href": "#"
        }
      }, [_vm._v("@" + _vm._s(product.product_business_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', {
        staticStyle: {
          "height": "3em"
        }
      }, [_c('a', {
        staticClass: "profile-link",
        attrs: {
          "href": "#"
        }
      }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('p', [_vm._v("₦" + _vm._s(product_item.product_item_price.toLocaleString('en', {
        useGrouping: true
      })))]), _vm._v(" "), _vm._m(0, true)])])]) : _vm._e()])
    }))]) : _vm._e()])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('a', {
    staticClass: "btn text-red",
    attrs: {
      "title": "Like"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o",
    staticStyle: {
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn text-red",
    attrs: {
      "title": "Add to Cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart",
    staticStyle: {
      "font-size": "14px"
    }
  })])])
}]}

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bottombar-large",
    staticStyle: {
      "margin-top": "5em",
      "margin-left": "-2em",
      "width": "400px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _c('br'), _c('span', [_vm._v("Timeline")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/shop"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _c('br'), _c('span', [_vm._v("Shop")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/account"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _c('br'), _c('span', [_vm._v("Account")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/notifications"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), _c('br'), _c('span', [_vm._v("Notifications")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  }), _c('br'), _c('span', [_vm._v("Bag")])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottombar",
    staticStyle: {
      "margin-top": "15em",
      "margin-left": "-2em",
      "width": "150%"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "2.5em"
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _c('br'), _c('span', [_vm._v("Timeline")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/account"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _c('br'), _c('span', [_vm._v("Account")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/notifications"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), _c('br'), _c('span', [_vm._v("Notifications")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  }), _c('br'), _c('span', [_vm._v("Bag")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/account"
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _c('br'), _c('span', [_vm._v("Settings")])])])])])
}]}

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('header', {
    staticStyle: {
      "background": "#ffffff",
      "width": "100%",
      "height": "4.5em",
      "top": "0",
      "position": "fixed",
      "z-index": "9999"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #e7e7e7",
      "display": "inline",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "float": "left",
      "padding-left": "8px",
      "color": "#000000",
      "font-size": "32px",
      "font-weight": "500",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin": "5px 1em",
      "color": "#000000"
    }
  }, [_c('span', {
    staticStyle: {
      "text-transform": "uppercase",
      "text-align": "center",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.is_viewing))]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "pager",
    attrs: {
      "id": "topPanel"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "5em"
    }
  }, [(!_vm.setPanel) ? _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "banner-menu"
  }, [_c('div', {
    staticClass: "menu-links"
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('profile')
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "padding": "1em"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.user.user_name))])])])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('orders')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('sellpoints')
      }
    }
  }, [_vm._m(5), _vm._v(" "), _vm._m(6)])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setComponent('manage-panel')
      }
    }
  }, [_vm._m(7), _vm._v(" "), _vm._m(8)])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('sidehustle')
      }
    }
  }, [_vm._m(9), _vm._v(" "), _vm._m(10)])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('settings')
      }
    }
  }, [_vm._m(11), _vm._v(" "), _vm._m(12)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('settings')
      }
    }
  }, [_vm._m(13), _vm._v(" "), _vm._m(14)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('settings')
      }
    }
  }, [_vm._m(15), _vm._v(" "), _vm._m(16)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('settings')
      }
    }
  }, [_vm._m(17), _vm._v(" "), _vm._m(18)])])])])])]) : _vm._e(), _vm._v(" "), (_vm.setPanel) ? _c('div', {
    staticClass: "panel"
  }, [(_vm.menu_view.profile) ? _c('div', [_vm._v("\r\n              hi pro\r\n          ")]) : _vm._e(), _vm._v(" "), (_vm.menu_view.sellpoints) ? _c('div', [_vm._l((_vm.sellpoints), function(sellpoint, index) {
    return _c('div', {
      staticClass: "card card-01"
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setBusinessComponent('viewBusiness', sellpoint)
        }
      }
    }, [_vm._m(19, true), _vm._v(" "), _c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-circle"
    }, [_c('img', {
      attrs: {
        "src": sellpoint.business_banner_image
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right"
    }, [_c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(sellpoint.business_name)), _c('br'), _c('span', [_vm._v("@" + _vm._s(sellpoint.business_username))])])]), _vm._v(" "), _vm._m(20, true)])])])
  }), _vm._v(" "), (!_vm.sellpoints.length) ? _c('div', [_c('p', {}, [_vm._v("You have not added any Business yet")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottombtn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('newBusiness', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])], 2) : _vm._e(), _vm._v(" "), (_vm.menu_view.viewBusiness) ? _c('div', [(_vm.sellpoint) ? _c('div', {
    staticStyle: {
      "text-align": "left",
      "padding": "1em",
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "card card-flat"
  }, [(_vm.sellpoint.business_agent == 0) ? _c('h6', [_vm._v("Business Name")]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_agent == 1) ? _c('h6', [_vm._v("Agent Business Name")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.sellpoint.business_category))])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('newBusinessCategory', _vm.sellpoint)
      }
    }
  }, [_vm._v("Add New Category")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat"
  }, [_c('h6', [_vm._v("Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(category, index) {
    return _c('div', {
      staticClass: "card"
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setBusinessComponent('viewBusinessCategory', _vm.sellpoint, category)
        }
      }
    }, [_c('div', {
      staticClass: "card card-flat-pad"
    }, [_c('p', [(category.business_parent_category != 'None') ? _c('span', [_c('b', [_vm._v(_vm._s(category.business_parent_category))]), _vm._v("-" + _vm._s(category.business_category) + "\r\n                        ")]) : _c('span', [_vm._v(_vm._s(category.business_category))])])])])])
  }), _vm._v(" "), (!_vm.sellpoint.business_categories) ? _c('div', [_c('p', {}, [_vm._v("You have not added any Category yet")])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1",
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('newBusinessCategory', _vm.sellpoint)
      }
    }
  }, [_vm._v("Add New Category")])], 2), _vm._v(" "), _c('div', {
    staticClass: "bottombtn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('manageBusiness', _vm.sellpoint, '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.menu_view.viewBusinessCategory) ? _c('div', {
    key: _vm.businessComponentKey
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "padding": "1em",
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "card card-flat"
  }, [_c('h6', [_vm._v(_vm._s(_vm.category.business_category) + "\r\n                  "), (_vm.category.category_products && (_vm.category.category_products.length != 0)) ? _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Total:" + _vm._s(_vm.category.category_products.length))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.sellpoint.business_agent == 0) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('newBusinessCategoryProduct', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Add New Product")]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_agent == 1) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('newBusinessAgentCategoryProduct', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Add New Business and Products")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('p', [_vm._v("products in " + _vm._s(_vm.category.business_category))]), _vm._v(" "), (_vm.category.category_products && (_vm.category.category_products.length != 0)) ? _c('div', _vm._l((_vm.category.category_products), function(product, index) {
    return _c('div', {
      staticClass: "card card-01 timeline-user-card"
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setBusinessComponent('viewBusinessCategoryProduct', _vm.sellpoint, product)
        }
      }
    }, [_c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-square"
    }, [(product.product_images[0]) ? _c('img', {
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right"
    }, [_c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price) + " - ₦" + _vm._s(product.product_items[0].product_item_price))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "card-arm-alt-bottom"
    }, [_c('div', {
      staticClass: "card-analytics"
    }, [_c('ul', [_c('li', {
      staticClass: "card-tag-qty"
    }, [_c('i', {
      staticClass: "fa fa-tag"
    }), _c('span', [_vm._v(_vm._s(product.product_total_quantity))])]), _vm._v(" "), _c('li', {
      staticClass: "card-tag-orders"
    }, [_c('i', {
      staticClass: "fa fa-shopping-cart"
    }), _c('span', [_vm._v(_vm._s(product.product_total_orders))])])])])])])])])
  })) : _c('div', [_c('p', [_vm._v("No products in this category")])]), _vm._v(" "), (_vm.sellpoint.business_agent == 0) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('newBusinessCategoryProduct', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Add New Product")]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_agent == 1) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('newBusinessAgentCategoryProduct', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Add New Business and Products")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "bottombtn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('manageBusinessCategory', _vm.sellpoint, _vm.category)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.viewBusinessCategoryProduct) ? _c('div', [_c('div', {
    staticClass: "card card-pad"
  }, [_c('h4', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('h4', [_vm._v("₦" + _vm._s(_vm.product_item.product_item_price))]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat"
  }, [_c('div', {
    staticStyle: {
      "height": "250px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "75%"
    }
  }, [(_vm.product_display_image.product_image != '' && _vm.product_display_image.product_image != 'error') ? _c('img', {
    staticClass: "sp-prd-img",
    attrs: {
      "src": _vm.img_product_url + _vm.product_display_image.product_image,
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "img-responsive sp-prd-img",
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "img-row",
    staticStyle: {
      "height": "25%",
      "width": "100%",
      "padding": "0",
      "overflow": "aut"
    }
  }, _vm._l((_vm.product.product_images), function(img) {
    return _c('div', {
      staticClass: "img-column"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-display-image', img)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + img.product_image,
        "alt": ""
      }
    })])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat"
  }, [_c('h4', [_vm._v("Product Details")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat"
  }, [_c('h4', [_vm._v("Orders")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(category, index) {
    return _c('div', {
      staticClass: "card card-flat"
    })
  }), _vm._v(" "), (!_vm.sellpoint.business_categories) ? _c('div', [_c('p', {}, [_vm._v("You have not added any Category yet")])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "bottombtn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('manageBusinessCategoryProduct', _vm.sellpoint, _vm.product)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.newBusiness) ? _c('div', [_c('div', {
    staticClass: "form-card"
  }, [_c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_agent),
      expression: "business_agent"
    }],
    attrs: {
      "type": "radio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.business_agent, "0")
    },
    on: {
      "__c": function($event) {
        _vm.business_agent = "0"
      }
    }
  }), _vm._v(" Personal Business")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_agent),
      expression: "business_agent"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.business_agent, "1")
    },
    on: {
      "__c": function($event) {
        _vm.business_agent = "1"
      }
    }
  }), _vm._v(" Agent/Side Hustle Business")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Business Name  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_name),
      expression: "business.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.business.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Business Username "), (_vm.validate_user_name_error) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.validate_user_name_message))]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_user_name),
      expression: "business.business_user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.business.business_user_name)
    },
    on: {
      "change": _vm.validateUserName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Business Category Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_category_type),
      expression: "business_category_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business_category_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Services")])])]), _vm._v(" "), (_vm.business_category_type == 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select a Product Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.business_product_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.business_category_type == 2) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select a Service Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.business_service_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.setUpNewBusiness
    }
  }, [_vm._v("Create")])])])])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.newBusinessCategory) ? _c('div', [_c('div', {
    staticClass: "form-card"
  }, [_c('form', {
    staticClass: "sp-form"
  }, [_c('h6', [_vm._v("New Category")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select From")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main_category),
      expression: "main_category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.main_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getSubCategories(_vm.main_category)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(ct) {
    return _c('option', {
      domProps: {
        "value": ct
      }
    }, [_vm._v(_vm._s(ct.category_name))])
  })], 2)]), _vm._v(" "), (_vm.sub_categories.length != 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select a Category under " + _vm._s(_vm.main_category.category_name))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.new_category),
      expression: "category.new_category"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "30px",
      "width": "245px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.category.new_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(ct) {
    return _c('option', {
      domProps: {
        "value": ct.sub_category_id
      }
    }, [_vm._v(_vm._s(ct.sub_category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("OR")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.new_listed_category),
      expression: "category.new_listed_category"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Category Name"
    },
    domProps: {
      "value": (_vm.category.new_listed_category)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.category.new_listed_category = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#084c8b"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.addCategory
    }
  }, [_vm._v("Add Category")])])])])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.newBusinessCategoryProduct) ? _c('div', [_c('div', {
    staticClass: "form-card"
  }, [_c('h4', [_c('u', [_vm._v(_vm._s(_vm.category.business_category))])]), _vm._v(" "), _c('form', {
    staticClass: "sp-form"
  }, [_c('h6', [_vm._v("Add New "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.is_product_service))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "sp-form-descr"
  }, [_vm._v("is this a Product or Service?")]), _vm._v(" "), _c('label', {
    staticClass: "line-wrap"
  }, [_vm._v("Product")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.is_product_service),
      expression: "is_product_service"
    }],
    staticClass: "sp-radio-btn",
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "type": "radio",
      "value": "product"
    },
    domProps: {
      "checked": _vm._q(_vm.is_product_service, "product")
    },
    on: {
      "__c": function($event) {
        _vm.is_product_service = "product"
      }
    }
  }), _vm._v("\r\n                         \r\n                    "), _c('label', [_vm._v(" Service ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.is_product_service),
      expression: "is_product_service"
    }],
    staticClass: "sp-radio-btn",
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "type": "radio",
      "value": "service"
    },
    domProps: {
      "checked": _vm._q(_vm.is_product_service, "service")
    },
    on: {
      "__c": function($event) {
        _vm.is_product_service = "service"
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(21), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name of Product / Service"
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Provide details of your product/service"
    },
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(22), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.is_product_service == 'product') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Weight(Kg)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Quantity ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "sp-form-descr"
  }, [_vm._v("Maximum Upload Size " + _vm._s(_vm.max_upload))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.is_product_service))]), _vm._v(" Media")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeNewProduct($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()]), _vm._v(" "), _vm._m(23)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#1a73da"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message)), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("Add Product")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")])])])])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.newBusinessAgentCategoryProduct) ? _c('div', [_c('div', {
    staticClass: "form-card"
  }, [_c('button', {
    staticClass: "pull-right btn sp-button-1",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("Add Business")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_c('u', [_vm._v("Select Products in  " + _vm._s(_vm.category.business_category))])]), _vm._v(" "), _c('div', [(_vm.category.category_business_open_for_agent_products && (_vm.category.category_business_open_for_agent_products.length != 0)) ? _c('div', _vm._l((_vm.category.category_business_open_for_agent_products), function(product, index) {
    return _c('div', {
      staticClass: "card card-01 timeline-user-card"
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + _vm.sellpoint.business_username + '/' + product.product_url_name
      }
    }, [_c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-square"
    }, [(product.product_images[0]) ? _c('img', {
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right"
    }, [_c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price) + " - ₦" + _vm._s(product.product_items[0].product_item_price))]) : _vm._e()])]), _vm._v(" "), _vm._m(24, true)])])])
  })) : _c('div', [_c('p', [_vm._v("No products here yet")])])]), _vm._v(" "), _c('h4', [_vm._v("Other Products that would interest you")]), _vm._v(" "), _c('div', [(_vm.business_open_agents_products) ? _c('div', _vm._l((_vm.business_open_agents_products), function(product, index) {
    return _c('div', {
      staticClass: "card card-01 timeline-user-card"
    }, [_c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-square"
    }, [(product.product_images[0]) ? _c('img', {
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right"
    }, [_c('a', {
      staticClass: "pull-right",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.addNewAgentProduct(product, 'addToCreatedAgentBusinessCategory')
        }
      }
    }, [_vm._v("Add to " + _vm._s(_vm.category.business_category))]), _vm._v(" "), _c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price) + " - ₦" + _vm._s(product.product_items[0].product_item_price))]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.addNewAgentProduct(product, 'addToCreatedAgentBusinessCategory')
        }
      }
    }, [_vm._v("Add to " + _vm._s(product.product_category_name))])]), _vm._v(" "), _vm._m(25, true)])])
  })) : _c('div', [_c('p', [_vm._v("No products here yet")])])])])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.manageBusiness) ? _c('div', [(_vm.sellpoint) ? _c('div', {
    staticStyle: {
      "text-align": "left",
      "padding": "1em",
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "card card-flat component-tabs"
  }, [_c('h6', [_vm._v("Business Settings")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('setBusinessProfile', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(26)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('setBusinessShippingInformation', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(27)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('setBusinessShippingLocations', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(28)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('setBusinessDiscountsCoupons', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(29)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('setBusinessPaymentInformation', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(30)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('setBusinessCommisssions', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(31)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('setBusinessDeleteRequest', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(32)])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.menu_view.manageBusinessCategory) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "left",
      "padding": "1em",
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "card card-flat"
  }, [_c('h6', [_vm._v("Category Settings")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Category Name: ")]), _vm._v(_vm._s(_vm.category.business_category))]), _vm._v(" "), (_vm.category.can_edit == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You can not edit this category name, it has a default setting")]) : _vm._e(), _vm._v(" "), (_vm.category.can_edit == 1) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setMenuTabView('editBusinessCategory', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Rename "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.category.business_category))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setMenuTabView('deleteBusinessCategory', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Delete Category")]), _vm._v(" "), (_vm.menu_tab_view.editBusinessCategory) ? _c('div', [_c('div', {
    staticClass: "form-card"
  }, [_c('h6', [_vm._v("Rename " + _vm._s(_vm.category.business_category))]), _vm._v(" "), _c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "info info-processing"
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.business_category),
      expression: "category.business_category"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.category.business_category)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.category.business_category = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editCategory
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-check"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel "), _c('i', {
    staticClass: "fa fa-ban"
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.deleteBusinessCategory) ? _c('div', [_c('div', {
    staticClass: "form-card"
  }, [_c('p', [_vm._v("Do you want to Delete this Category and all products within it")]), _vm._v(" "), _c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "info info-processing"
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteCategory
    }
  }, [_vm._v("Yes,Request Delete")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel ")])])])])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.manageBusinessCategoryProduct) ? _c('div', [(_vm.sellpoint) ? _c('div', {
    staticStyle: {
      "text-align": "left",
      "padding": "1em",
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "card card-flat component-tabs"
  }, [_c('h6', [_vm._v("Product Settings")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('setBusinessCategoryProductDetails', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(33)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('setBusinessCategoryProductItems', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(34)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('setBusinessCategoryProductDiscountCoupons', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(35)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('setBusinessCategoryProductDeliveryAndReturanInformation', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(36)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('setBusinessCategoryProductShippingInformation', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(37)])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.menu_view.setBusinessProfile) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(38), _vm._v(" "), (!_vm.menu_tab_view.editBusinessProfile) ? _c('div', {
    staticClass: "card"
  }, [_c('p', [_c('b', [_vm._v("Business Name: ")]), _vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Business Tagline: ")]), _vm._v(_vm._s(_vm.sellpoint.business_tagline))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Business Brief: ")]), _vm._v(_vm._s(_vm.sellpoint.business_profile))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Business Address: ")]), _vm._v(_vm._s(_vm.sellpoint.business_address))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Business Emails: ")]), _vm._v(_vm._s(_vm.sellpoint.business_emails))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Business Phone: ")]), _vm._v(_vm._s(_vm.sellpoint.business_phones))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('editBusinessProfile', '', '')
      }
    }
  }, [_vm._v("Edit Business Profile")])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.editBusinessProfile) ? _c('div', [_c('hr'), _vm._v(" "), _c('h6', [_vm._v("Edit Business Details")]), _vm._v(" "), _c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_name),
      expression: "sellpoint.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Tagline")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_tagline),
      expression: "sellpoint.business_tagline"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_tagline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_tagline = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Brief")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_profile),
      expression: "sellpoint.business_profile"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.sellpoint.business_profile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_profile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_address),
      expression: "sellpoint.business_address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Emails")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_emails),
      expression: "sellpoint.business_emails"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_emails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_emails = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_phones),
      expression: "sellpoint.business_phones"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_phones)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_phones = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('main')
      }
    }
  }, [_vm._v("Save Details")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.setBusinessShippingInformation) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(39), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(40), _vm._v(" "), (_vm.business_details.delivery_edit) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('label', [_vm._v("Your Delivery Information")]), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_delivery_information),
      expression: "sellpoint.business_delivery_information"
    }],
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    domProps: {
      "value": (_vm.sellpoint.business_delivery_information)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_delivery_information = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('delivery')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" cancel")])]) : _c('div', [(_vm.sellpoint.business_delivery_information) ? _c('div', [_c('p', {
    staticClass: "sp-info-text-box"
  }, [_vm._v(_vm._s(_vm.sellpoint.business_delivery_information))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'delivery_edit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" edit")])]) : _c('p', [_vm._v("You have not set any delivery information\r\n                    "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'delivery_edit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Set")]), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set How Shipping Fee would affect Buyers Checkout Ordering")]), _vm._v(" "), _c('p', [_vm._v("This setting affects all products orders shipping fees on th this Business. If you would like any product \r\n                      to have its on shipping fee, specify it when setting up your product.\r\n                  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#363535"
    }
  }, [_vm._v("How would your Business Shipping Fee be calculated?")]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_set_shipping_fee_status),
      expression: "business_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "9",
      "value": "9"
    },
    domProps: {
      "checked": _vm._q(_vm.business_set_shipping_fee_status, "9")
    },
    on: {
      "click": function($event) {
        _vm.setShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.business_set_shipping_fee_status = "9"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" One Charge Business Shipping Fee on all Items Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_set_shipping_fee_status),
      expression: "business_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "10",
      "value": "10"
    },
    domProps: {
      "checked": _vm._q(_vm.business_set_shipping_fee_status, "10")
    },
    on: {
      "click": function($event) {
        _vm.setShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.business_set_shipping_fee_status = "10"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Same Charge Business Shipping Fee on each Product Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_set_shipping_fee_status),
      expression: "business_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "11",
      "value": "11"
    },
    domProps: {
      "checked": _vm._q(_vm.business_set_shipping_fee_status, "11")
    },
    on: {
      "click": function($event) {
        _vm.setShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.business_set_shipping_fee_status = "11"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Same Charge Business Shipping Fee on each Product and its quantities Ordered")])])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.setBusinessShippingLocations) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_c('h6', [_vm._v("Delivery Locations and Prices")]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._l((_vm.sellpoint.business_delivery_options), function(delivery_option) {
    return _c('div', [(_vm.business_details.delivery_option_edit && delivery_option.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('h5', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Editing " + _vm._s(delivery_option.business_delivery_option))]), _vm._v(" "), (delivery_option.business_delivery_is_custom && (delivery_option.business_delivery_is_custom == 1)) ? _c('div', [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Delivery Location")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_custom_option),
        expression: "delivery_option.business_delivery_custom_option"
      }],
      staticClass: "form-control",
      domProps: {
        "value": (delivery_option.business_delivery_custom_option)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery_option.business_delivery_custom_option = $event.target.value
        }
      }
    })])]) : _c('div', [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("State: "), _c('b', [_vm._v(_vm._s(delivery_option.business_delivery_state))])]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_state_id),
        expression: "delivery_option.business_delivery_state_id"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          delivery_option.business_delivery_state_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities(delivery_option.business_delivery_state_id, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state.state_id
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("City: "), _c('b', [_vm._v(_vm._s(delivery_option.business_delivery_option))])]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.city),
        expression: "delivery_option.city"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.setOtherOptions(delivery_option.city, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "all"
      }
    }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city.city_id
        }
      }, [_vm._v(_vm._s(city.city_name))])
    }), _vm._v(" "), _c('option', {
      attrs: {
        "value": "other"
      }
    }, [_vm._v("Other Areas / Cities ")])], 2)]), _vm._v(" "), (_vm.edit_other_delivery_option) ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_other_option),
        expression: "delivery_option.business_delivery_other_option"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "eg. Abuja"
      },
      domProps: {
        "value": (delivery_option.business_delivery_other_option)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery_option.business_delivery_other_option = $event.target.value
        }
      }
    }), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_option_price),
        expression: "delivery_option.business_delivery_option_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (delivery_option.business_delivery_option_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery_option.business_delivery_option_price = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.editDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _c('div', [(delivery_option.business_delivery_product == 0) ? _c('p', [_vm._v("\r\n                        " + _vm._s(delivery_option.business_delivery_option) + " - " + _vm._s(delivery_option.business_delivery_option_price) + " \r\n                        "), _c('button', {
      staticClass: "btn sp-button-1 sp-button-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-delivery-option', delivery_option)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1 sp-button-sm",
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteDeliveryOption(delivery_option.business_delivery_option_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e()])])
  }), _vm._v(" "), (!_vm.business_details.delivery_add) ? _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'delivery_add')
      }
    }
  }, [_vm._v("Add New Delivery Information")]) : _vm._e(), _vm._v(" "), _c('hr')], 2), _vm._v(" "), (_vm.business_details.delivery_add) ? _c('div', {
    staticClass: "card"
  }, [_c('h5', [_vm._v("Add a Delivery Location and Price")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custom_delivery_option),
      expression: "custom_delivery_option"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.custom_delivery_option) ? _vm._i(_vm.custom_delivery_option, null) > -1 : (_vm.custom_delivery_option)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.custom_delivery_option,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.custom_delivery_option = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.custom_delivery_option = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.custom_delivery_option = $$c
        }
      }
    }
  }), _vm._v(" Do you want to add customised delivery locations(Suitable for Countries outside Nigeria)\r\n                  "), (_vm.custom_delivery_option) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Delivery Location")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_custom_option),
      expression: "delivery_option.delivery_custom_option"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "eg. Country, City, Location"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_custom_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_custom_option = $event.target.value
      }
    }
  })])]) : _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.action_loading) ? _c('div', [_c('p', [_vm._v("...loading cities")])]) : _vm._e(), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other Areas / Cities ")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.other_delivery_option) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_other_option),
      expression: "delivery_option.delivery_other_option"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "eg. Abuja"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_other_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_other_option = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Delivery Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_price),
      expression: "delivery_option.delivery_option_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "eg. 1000"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_option_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_option_price = $event.target.value
      }
    }
  }), _c('br')]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.addDeliveryOption
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.setBusinessDiscountsCoupons) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set My Sellpoint's Discounts and Coupons")]), _vm._v(" "), _c('p', [_vm._v("Set a general discount and coupons that would apply to all products and services in your sellpoint. \r\n                      You can set individual Product Discounts on thier product pages.\r\n                  ")]), _vm._v(" "), _c('span', [(_vm.business_details.setDiscount) ? _c('button', {
    staticClass: "btn sp-button-1",
    on: {
      "click": function($event) {
        _vm.setComponent('view-discounts', '')
      }
    }
  }, [_vm._v("View your Discounts")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'setDiscount')
      }
    }
  }, [_vm._v("Set New Discount Or Coupon")]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.business_details.setDiscount) ? _c('div', [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(_vm.sellpoint.business_discounts_active == 1) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have an ongoing active Discount")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Set Coupon Or Discount")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.is_discount_coupon),
      expression: "discount_coupon.is_discount_coupon"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.is_discount_coupon = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Discount")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Coupon")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label'), _vm._v(" "), (_vm.sellpoint.business_discounts_active != 1) ? _c('label', [_vm._v("Select Discount Category")]) : _c('label', [_vm._v("Select Coupon Discount Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_category),
      expression: "discount_coupon.discount_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.discount_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v(_vm._s(cat.business_category))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setDiscountsAndCoupons()
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _vm._m(41)]) : _vm._e(), _vm._v(" "), (_vm.discount_coupon.edit && (!_vm.business_details.viewDiscounts || !_vm.business_details.setDiscount)) ? _c('div', [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Edit Discount")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_category),
      expression: "discount_coupon.discount_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.discount_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Another Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v(_vm._s(cat.business_category))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date: " + _vm._s(_vm.discount_coupon.discount_start_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date: " + _vm._s(_vm.discount_coupon.discount_end_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editDiscountsAndCoupons()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), ((!_vm.business_details.setDiscount && !_vm.discount_coupon.edit) && _vm.sellpoint.business_discounts_coupons) ? _c('div', [(_vm.sellpoint.business_discounts_coupons && (_vm.sellpoint.business_discounts_coupons.length != 0)) ? _c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("View Discounts")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.sellpoint.business_discounts_coupons), function(dc, index) {
    return _c('div', {
      staticClass: "col-md-4 col-xs-12"
    }, [_c('div', {
      staticStyle: {
        "border": "#f1dee4 solid 1px",
        "padding": "1em"
      }
    }, [_c('div', {
      staticStyle: {
        "background": "#d1ddf1",
        "text-align": "center"
      }
    }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('p', [_c('b', [_vm._v("Type: ")]), _vm._v(_vm._s(dc.discount_type_name))]) : _c('p', [_c('b', [_vm._v("Type: ")]), _vm._v(_vm._s(dc.discount_category_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), ((dc.discount_type == 2) || (dc.discount_type == 3)) ? _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-discount-coupon', dc)
        }
      }
    }, [_vm._v("\r\n                                Edit Coupon")]), _vm._v("    \r\n                            "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.deactivateDiscountsAndCoupons(dc)
        }
      }
    }, [_vm._v("\r\n                                Deactivate Coupon")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Edit/Deactivate at Product Settings")]) : _vm._e()])])
  }))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.setBusinessPaymentInformation) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(42), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_vm._m(43), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Set up your Bank Details for direct Transfers")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBankDetails')
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.menu_tab_view.setBankDetails || _vm.menu_tab_view.editBankDetails) ? _c('div', [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set Bank Details")]), _vm._v(" "), _c('p', [_vm._v("This account is where your payout would be sent to.")]), _vm._v(" "), (_vm.sellpoint.business_bank_details) ? _c('div', [(_vm.sellpoint.business_bank_details.length == 0 || _vm.menu_tab_view.editBankDetails) ? _c('form', {
    staticClass: "sp-form",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('label', [_c('b', [_vm._v("Bank Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_bank_details.bank_name),
      expression: "sellpoint.business_bank_details.bank_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_bank_details.bank_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_bank_details.bank_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account Holder's Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_bank_details.bank_account_name),
      expression: "sellpoint.business_bank_details.bank_account_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_bank_details.bank_account_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_bank_details.bank_account_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account No:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_bank_details.bank_account_number),
      expression: "sellpoint.business_bank_details.bank_account_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.sellpoint.business_bank_details.bank_account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_bank_details.bank_account_number = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("your details are securley saved")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.setBankDetails
    }
  }, [_vm._v("Save Bank Details")])]) : _c('div', [_c('p', [_c('b', [_vm._v("Bank:")]), _vm._v(" " + _vm._s(_vm.sellpoint.business_bank_details.bank_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account Holder's Name:")]), _vm._v(" " + _vm._s(_vm.sellpoint.business_bank_details.bank_account_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account No:")]), _vm._v(" " + _vm._s(_vm.sellpoint.business_bank_details.bank_account_number))]), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("you can edit or change bank details")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setMenuTabView('editBankDetails', '')
      }
    }
  }, [_vm._v("Edit Bank Details")])]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('')
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_vm._m(44), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Set how you would want to settle your proccessing fees")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setProcessingFees')
      }
    }
  }, [_vm._v("Set")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.menu_tab_view.setProcessingFees || _vm.menu_tab_view.addProcessingFees) ? _c('div', [_c('div', [_c('h6', [_vm._v("Processing Fee Balance")]), _vm._v(" "), _vm._m(45), _vm._v(" "), (_vm.sellpoint.business_processing_fee_balance) ? _c('p', [_vm._v("Processing Fee Balance: "), _c('b', [(_vm.sellpoint.business_processing_fee_balance < 1000) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_processing_fee_balance))]) : _c('span', [_vm._v(_vm._s(_vm.sellpoint.business_processing_fee_balance))])])]) : _vm._e(), _vm._v(" "), ((_vm.sellpoint.business_processing_fee_balance < 2000) && (_vm.sellpoint.business_processing_fee_balance > 0)) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("\r\n                      Processing Fee is running low\r\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_processing_fee_balance == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("\r\n                      Processing Fee is low\r\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_processing_fee_debt > 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("\r\n                      Processing Fee is low and you are owing processing fee charge of "), _c('span', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v(" -" + _vm._s(_vm.sellpoint.business_processing_fee_debt))])]) : _vm._e(), _vm._v(" "), (!_vm.menu_tab_view.addProcessingFees) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-md",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('addProcessingFees')
      }
    }
  }, [_vm._v("Add Processing Fees")]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.addProcessingFees) ? _c('div', [_c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Enter Amount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.processing_fee.amount),
      expression: "processing_fee.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.processing_fee.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.processing_fee.amount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.addtoProcessingFee()
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h6', [_vm._v("Set Processing Fee Option")]), _vm._v(" "), _c('p', [_vm._v("Each sale of an Item attracts a processing fee. The processng fee could\r\n                    be paid by you as you set your product, or by your customers as they buy. \r\n                    Processing Fees are subject to change.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#363535"
    }
  }, [_vm._v("Processing Fee is set to: 13% of your product Item")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "info info-processing"
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.sellpoint.business_processing_fee_pay_status == 3) ? _c('span', [_vm._m(46), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("Switch Pay to your Custmers, notice this would increase the amount they pay on checkout")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.switchProcessingFee(4)
      }
    }
  }, [_vm._v("Switch Pay to your Custmers")])]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_processing_fee_pay_status == 4) ? _c('span', [_vm._m(47), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Switch Pay back to you, and let your Customers enjoy to pay only for their orders on checkout")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.switchProcessingFee(3)
      }
    }
  }, [_vm._v("Switch Pay Back to Me")])]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('')
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_vm._m(48), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('p', [_vm._v("Ravepay  - Direct Personal Integration")]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("You would be directed to Ravepay Website to create and set up your account")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setRavepay')
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.menu_tab_view.setRavepay) ? _c('div', [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set Ravepay Details")]), _vm._v(" "), _c('p', [_vm._v("This account is where your payout would be sent to.")]), _vm._v(" "), (_vm.sellpoint.business_ravepay_accounts && (_vm.sellpoint.business_ravepay_accounts.length > 0)) ? _c('div', [_c('p', [_vm._v("Accounts on Ravepay")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_ravepay_accounts), function(pg) {
    return _c('div', {
      staticClass: "card"
    }, [_vm._v("\r\n                        " + _vm._s(pg.account_email) + "\r\n                      ")])
  })], 2) : _c('p', {
    staticClass: "info-processing"
  }, [_vm._v("No Ravepay Account set yet")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(49), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('')
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51), _vm._v(" "), _vm._m(52), _vm._v(" "), _vm._m(53)])])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.setBusinessCommisssions) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(54), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_vm._m(55), _vm._v(" "), _vm._m(56), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setAgentCommission')
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.menu_tab_view.setAgentCommission || _vm.menu_tab_view.editAgentCommission) ? _c('div', [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set Agents Commission")]), _vm._v(" "), (_vm.sellpoint.business_agent_commission) ? _c('div', [(_vm.sellpoint.business_agent_commission == 0 || _vm.menu_tab_view.editAgentCommission) ? _c('form', {
    staticClass: "sp-form",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('label', [_c('b', [_vm._v("Commissiom:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_bank_details.bank_name),
      expression: "sellpoint.business_bank_details.bank_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_bank_details.bank_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_bank_details.bank_name = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.setAgentCommission
    }
  }, [_vm._v("Save Bank Details")])]) : _c('div', [_c('p', [_c('b', [_vm._v("Agent Commision:")]), _vm._v(" " + _vm._s(_vm.sellpoint.business_agent_commission))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    on: {
      "click": function($event) {
        _vm.setMenuTabView('editBankDetails', '')
      }
    }
  }, [_vm._v("Edit")])]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('')
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_vm._m(57), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Set how you would want to settle your proccessing fees")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setProcessingFees')
      }
    }
  }, [_vm._v("Set")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.menu_tab_view.setProcessingFees || _vm.menu_tab_view.addProcessingFees) ? _c('div', [_c('div', [_c('h6', [_vm._v("Processing Fee Balance")]), _vm._v(" "), _vm._m(58), _vm._v(" "), (_vm.sellpoint.business_processing_fee_balance) ? _c('p', [_vm._v("Processing Fee Balance: "), _c('b', [(_vm.sellpoint.business_processing_fee_balance < 1000) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_processing_fee_balance))]) : _c('span', [_vm._v(_vm._s(_vm.sellpoint.business_processing_fee_balance))])])]) : _vm._e(), _vm._v(" "), ((_vm.sellpoint.business_processing_fee_balance < 2000) && (_vm.sellpoint.business_processing_fee_balance > 0)) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("\r\n                      Processing Fee is running low\r\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_processing_fee_balance == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("\r\n                      Processing Fee is low\r\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_processing_fee_debt > 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("\r\n                      Processing Fee is low and you are owing processing fee charge of "), _c('span', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v(" -" + _vm._s(_vm.sellpoint.business_processing_fee_debt))])]) : _vm._e(), _vm._v(" "), (!_vm.menu_tab_view.addProcessingFees) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-md",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('addProcessingFees')
      }
    }
  }, [_vm._v("Add Processing Fees")]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.addProcessingFees) ? _c('div', [_c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Enter Amount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.processing_fee.amount),
      expression: "processing_fee.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.processing_fee.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.processing_fee.amount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.addtoProcessingFee()
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h6', [_vm._v("Set Processing Fee Option")]), _vm._v(" "), _c('p', [_vm._v("Each sale of an Item attracts a processing fee. The processng fee could\r\n                    be paid by you as you set your product, or by your customers as they buy. \r\n                    Processing Fees are subject to change.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#363535"
    }
  }, [_vm._v("Processing Fee is set to: 13% of your product Item")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "info info-processing"
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.sellpoint.business_processing_fee_pay_status == 3) ? _c('span', [_vm._m(59), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("Switch Pay to your Custmers, notice this would increase the amount they pay on checkout")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.switchProcessingFee(4)
      }
    }
  }, [_vm._v("Switch Pay to your Custmers")])]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_processing_fee_pay_status == 4) ? _c('span', [_vm._m(60), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Switch Pay back to you, and let your Customers enjoy to pay only for their orders on checkout")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.switchProcessingFee(3)
      }
    }
  }, [_vm._v("Switch Pay Back to Me")])]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('')
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.setBusinessDeleteRequest) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._v("\r\n              Request all Business Information to be deleted\r\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.setBusinessCategoryProductDetails) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(61), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', [_vm._v("Category: " + _vm._s(_vm.product.product_category_name))]), _vm._v(" "), (_vm.product.product_set_items == 0) ? _c('div', [(_vm.product.product_items[0].product_item_actual_price != 0) ? _c('div', [_c('p', [_vm._v("Price: ₦" + _vm._s(_vm.product.product_items[0].product_item_actual_price))]), _vm._v(" "), _c('p', [_vm._v("Discounted Price: ₦" + _vm._s(_vm.product.product_items[0].product_item_price))])]) : _c('div', [_c('p', [_vm._v("Price: ₦" + _vm._s(_vm.product.product_items[0].product_item_price))])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('p', [_vm._v("Weight: " + _vm._s(_vm.product.product_items[0].product_item_weight) + "(kg)")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Quantity: " + _vm._s(_vm.product.product_items[0].product_item_quantity))])]) : _vm._e(), _vm._v(" "), (_vm.product_details.setProductSingleProductItem) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('h6', {
    staticStyle: {
      "font-size": "14px",
      "text-decoration": "underline"
    }
  }, [_vm._v("Reset Product Details")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-4 col-xs-4"
  }, [_c('label', [_vm._v(" Price\r\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_price),
      expression: "product.product_items[0].product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "form-group col-md-4 col-xs-4"
  }, [_c('label', [_vm._v(" Weight\r\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_weight),
      expression: "product.product_items[0].product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_weight = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4 col-xs-4"
  }, [_c('label', [_vm._v(" Quantity\r\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_quantity),
      expression: "product.product_items[0].product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 col-md-2",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProductSingleProductItem
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 col-md-2",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])])])]) : _c('button', {
    staticClass: "btn btn-xs sp-button-1 sp-button-sm",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('editProductSingleProductItem', '')
      }
    }
  }, [_vm._v("Edit Price/Weight/Quantity")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), (_vm.product_details.editProduct) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('h6', [_vm._v("Edit Product")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" *Product Name\r\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("Category:- " + _vm._s(_vm.product.product_category_name) + " ")]), _vm._v(" "), (_vm.sellpoint_categories.length > 0) ? _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v(" Select from My Shop Categories\r\n                                "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "category-type-1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-1')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_1
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      key: category.business_category_id,
      attrs: {
        "disabled": _vm.category_type_1
      },
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [(_vm.sellpoint_categories.length > 0) ? _c('span', [_c('b', [_vm._v("Or ")])]) : _vm._e(), _vm._v(" Select from Related Categories\r\n                                "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main_category),
      expression: "main_category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.main_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getSubCategories(_vm.main_category)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      key: category.category_id,
      domProps: {
        "value": category
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.sub_categories.length != 0) ? _c('label', [_vm._v(" Select a Category\r\n                                "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_sub_category),
      expression: "product.product_sub_category"
    }],
    staticClass: "form-control category-type-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_sub_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_2
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(category) {
    return _c('option', {
      key: category.sub_category_id,
      attrs: {
        "disabled": _vm.category_type_2
      },
      domProps: {
        "value": category.sub_category_id
      }
    }, [_vm._v(_vm._s(category.sub_category_name))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', [_c('b', [_vm._v("Or ")]), _vm._v(" Enter a specific Category\r\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_listed_category),
      expression: "product.product_listed_category"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.category_type_3,
      "type": "text",
      "placeholder": "",
      "id": "category-type-3"
    },
    domProps: {
      "value": (_vm.product.product_listed_category)
    },
    on: {
      "change": function($event) {
        _vm.trackevent('category-type-3')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_listed_category = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', [_vm._v(" *Product Description\r\n                                "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control txtarea",
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProduct
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])])])]) : _c('button', {
    staticClass: "btn btn-xs sp-button-1",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('editProduct', '')
      }
    }
  }, [_vm._v("Edit Product Details")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("Product Images")]), _vm._v(" "), _c('div', {
    staticClass: "img-row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._l((_vm.product.product_images), function(pt) {
    return _c('div', {
      staticClass: "img-column"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "float": "left"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_c('img', {
      staticClass: "sp-prd-img",
      staticStyle: {
        "height": "50px",
        "width": "80px"
      },
      attrs: {
        "src": _vm.img_product_url + pt.product_image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "btn pull-right",
      staticStyle: {
        "font-size": "12px",
        "padding": "6px",
        "float": "right"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteProductImage(pt.product_image_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v("Delete")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [(_vm.action_loading && _vm.product_details.uploading_image) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "upload-btn",
    staticStyle: {
      "line-height": "0.6",
      "font-size": "12px"
    }
  }, [_vm._v("Add new Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'products', _vm.product.product_id)
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(!_vm.product_details.removeProduct) ? _c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "line-height": "2em",
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('removeProduct', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete this Product")]) : _vm._e(), _vm._v(" "), (_vm.product_details.removeProduct) ? _c('span', {}, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to remove this Product?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs sp-button-1 sp-button-sm",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.removeProduct
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.setBusinessCategoryProductItems) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(62), _vm._v(" "), _c('div', [(_vm.product_details.setProductSettings) ? _c('div', [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('b', [_vm._v("Group Name: ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_groups_set_name),
      expression: "product.product_groups_set_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_groups_set_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_groups_set_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_set_items > 0) ? _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('b', [_vm._v("Group Items Name: ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_groups_items_set_name),
      expression: "product.product_groups_items_set_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_groups_items_set_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_groups_items_set_name = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProductSettings
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), (!_vm.product_details.addProductItemPanel) ? _c('div', [_c('p', [_vm._v("add other variations like groups or types of this product eg. colors, materials, plans, sizes etc")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-bottom": "1em"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('show-settings-box', '', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" Settings ")])]), _vm._v(" "), (_vm.show_product_setting_box) ? _c('div', {
    staticClass: "sp-info-text-box"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v("General Product Group and Group Items Name")]), _vm._v(" "), _c('p', [_vm._v("This is a general name of this Product's Grouping, you may change it whenever you want")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Group Name: ")]), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.product.product_groups_set_name))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Group Items Name: ")]), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.product.product_groups_items_set_name))])]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "line-height": "0.8"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductSettings', '', '')
      }
    }
  }, [_vm._v(" Change this Name")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "line-height": "0.8",
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('hide-settings-box', '', '')
      }
    }
  }, [_vm._v(" Hide")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.product.product_set_groups == 0) ? _c('div') : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "1em 0",
      "display": "none"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('addProductItemPanel', '', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Product Variation")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (!_vm.product_details.addProductItemPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    staticStyle: {
      "float": "right",
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('addProductItemPanel', '', '')
      }
    }
  }, [_vm._v("Add new Variation")]), _vm._v(" "), _c('h5', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-bottom": "-1em"
    }
  }, [_vm._v("Product Groups/Types ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (((_vm.product.product_set_groups > 0) && (_vm.product.product_set_items > 0))) ? _c('div', {}, _vm._l((_vm.product.product_item_groups), function(pg, pgdex) {
    return _c('div', {
      staticClass: "row",
      staticStyle: {
        "border-bottom": "1px solid #e9e6e6",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "col-container"
    }, [_c('div', {
      staticClass: "col-xs-3"
    }, [_c('div', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('h5', {
      staticStyle: {
        "font-size": "10px",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(_vm.product.product_groups_set_name))]), _vm._v(" "), _c('h4', {
      staticStyle: {
        "font-weight": "bold",
        "text-transform": "capitalize",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(pg.product_item_group_name))]), _vm._v(" "), _c('div', {
      staticClass: "box-cube"
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', {
      staticClass: "box-color-cube",
      staticStyle: {
        "z-index": "3"
      }
    }, [((pg.product_item_group_image && (pg.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('button', {
      staticClass: "btn v-tiny-btn sp-button-1 sp-button-sm",
      staticStyle: {
        "z-index": "9"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('pgset' + pgdex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-gear"
    })]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'pgset' + pgdex
      }
    }, [_c('button', {
      staticClass: "btn v-tiny-btn sp-button-1 sp-button-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('editProductItemGroup', 'productitemgroup', pg)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Edit")]), _vm._v(" "), (_vm.product.product_item_groups && _vm.product.product_item_groups.length > 1) ? _c('button', {
      staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('removeItemGroup', 'productitemgroup', pg)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Delete")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('div', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('h5', {
      staticStyle: {
        "font-size": "10px",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(_vm.product.product_groups_items_set_name) + "\r\n                              ")]), _vm._v(" "), _vm._l((pg.product_items), function(pt, ptdex) {
      return _c('div', {
        staticClass: "items-list-tiny",
        staticStyle: {
          "display": "inline"
        }
      }, [_c('div', [(_vm.product.product_service == 'P' && (pt.product_item_size)) ? _c('li', {
        staticClass: "box-wrap",
        staticStyle: {
          "float": "left"
        }
      }, [_vm._v(_vm._s(pt.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (pt.product_item_service_tag)) ? _c('li', {
        staticClass: "box-wrap",
        staticStyle: {
          "float": "left"
        }
      }, [_vm._v(_vm._s(pt.product_item_service_tag))]) : _vm._e(), _vm._v(" "), _c('li', {
        staticStyle: {
          "float": "left"
        }
      }, [_c('button', {
        staticClass: "product-item-more-details-view-btn btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
        staticStyle: {
          "line-height": "0.8"
        },
        attrs: {
          "id": 'viewbtn' + pgdex + ptdex
        },
        on: {
          "click": function($event) {
            _vm.toggleProductItemView('showMoreProductItemDetails', 'showMoreProductItemDetails' + pgdex + ptdex, 'viewbtn' + pgdex + ptdex, 'hidebtn' + pgdex + ptdex)
          }
        }
      }, [_vm._v(" View Details")])]), _vm._v(" "), _c('li', {
        staticStyle: {
          "float": "left"
        }
      }, [_c('button', {
        staticClass: "product-item-more-details-hide-btn btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
        staticStyle: {
          "display": "none",
          "line-height": "0.8"
        },
        attrs: {
          "id": 'hidebtn' + pgdex + ptdex
        },
        on: {
          "click": function($event) {
            _vm.toggleProductItemView('hideMoreProductItemDetails', 'showMoreProductItemDetails' + pgdex + ptdex, 'viewbtn' + pgdex + ptdex, 'hidebtn' + pgdex + ptdex)
          }
        }
      }, [_vm._v(" Hide Details")])]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      }), _vm._v(" "), _c('div', {
        staticClass: "product-item-show-more-details",
        staticStyle: {
          "display": "none"
        },
        attrs: {
          "id": 'showMoreProductItemDetails' + pgdex + ptdex
        }
      }, [(_vm.product.product_service == 'P') ? _c('li', [_c('span', [_vm._v("w(kg):")]), _vm._v(_vm._s(pt.product_item_weight))]) : _vm._e(), _vm._v(" "), (pt.product_item_actual_price != 0) ? _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(pt.product_item_actual_price))]) : _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(pt.product_item_price))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Qty:")]), _vm._v(_vm._s(pt.product_item_quantity))]), _vm._v(" "), _c('li', [_c('a', {
        staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('editProductItem', 'productitem', pt)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil"
      })])]), _vm._v(" "), (_vm.product.product_items.length > 1) ? _c('li', [_c('a', {
        staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('removeProductItem', 'productitem', pt)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })]), _vm._v(" "), (_vm.product_details.editProductItem && (_vm.product_item.product_item_id == pt.product_item_id)) ? _c('div', {
        staticClass: "col-sm-12",
        staticStyle: {
          "margin-top": "1em",
          "margin-bottom": "1em"
        },
        attrs: {
          "id": "editProductItem"
        }
      }, [_c('h6', {
        attrs: {
          "align": "left"
        }
      }, [_vm._v("Edit Product Item")]), _vm._v(" "), _c('form', {
        staticClass: "sp-form"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "form-group col-xs-6"
      }, [_c('label', [(_vm.product.product_service == 'P') ? _c('span', [_vm._v(" Size")]) : _vm._e(), (_vm.product.product_service == 'S') ? _c('span', [_vm._v(" Type")]) : _vm._e(), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_size),
          expression: "product_item.product_item_size"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_size)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_size = $event.target.value
          }
        }
      })])]), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('div', {
        staticClass: "form-group col-xs-6"
      }, [_c('label', [_vm._v(" Service Tag\r\n                                      "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_service_tag),
          expression: "product_item.product_item_service_tag"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_service_tag)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_service_tag = $event.target.value
          }
        }
      })])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "form-group col-xs-6"
      }, [_c('label', [_vm._v(" Price\r\n                                            "), (_vm.product_item.product_item_actual_price != 0) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_actual_price),
          expression: "product_item.product_item_actual_price"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_actual_price)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_actual_price = $event.target.value
          }
        }
      }) : _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_price),
          expression: "product_item.product_item_price"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_price)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_price = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "form-group col-xs-6"
      }, [_c('label', [_vm._v(" Weight\r\n                                          "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_weight),
          expression: "product_item.product_item_weight"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "step": "any",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_weight)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_weight = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "form-group col-xs-6"
      }, [_c('label', [_vm._v(" Quantity\r\n                                          "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_quantity),
          expression: "product_item.product_item_quantity"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_quantity)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_quantity = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-md-12 col-xs-12"
      }, [(_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e(), _vm._v(" "), _c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
        staticClass: "btn sp-button-1 sp-button-md",
        staticStyle: {
          "line-height": "1.2",
          "margin-right": "5px"
        },
        attrs: {
          "disabled": _vm.disable_btn,
          "type": "button"
        },
        on: {
          "click": _vm.editProductItem
        }
      }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
        staticClass: "btn sp-button-1 sp-button-md",
        staticStyle: {
          "line-height": "1.2",
          "margin-right": "5px"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-ban"
      }), _vm._v(" Cancel")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.product_details.removeProductItem && (_vm.product_item.product_item_id == pt.product_item_id)) ? _c('span', {
        staticClass: "pull-left col-sm-12"
      }, [_c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Do you really want to remove this Item?")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs sp-button-1 sp-button-sm",
        attrs: {
          "disabled": _vm.disable_btn
        },
        on: {
          "click": function($event) {
            _vm.removeProductItem()
          }
        }
      }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs sp-button-1 sp-button-sm",
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e()]) : _vm._e()])])
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
      staticStyle: {
        "float": "right",
        "line-height": "0.8"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('addProductItemToGroup', 'productitemgroup', pg)
        }
      }
    }, [_vm._v(" Add New Item")])], 2)]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [(_vm.product_details.editProductItemGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {
      staticClass: "col-sm-12",
      attrs: {
        "id": "editProductItemGroup"
      }
    }, [_c('button', {
      staticClass: "btn sp-button-1 sp-button-sm",
      staticStyle: {
        "float": "right",
        "line-height": "1.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ban"
    }), _vm._v(" Cancel")]), _vm._v(" "), _c('h6', [_vm._v("Edit Product Item Group")]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "form-group col-xs-12"
    }, [_c('label', [_vm._v("Name\r\n                              "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item_group.product_item_group_name),
        expression: "product_item_group.product_item_group_name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.product_item_group.product_item_group_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item_group.product_item_group_name = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-2"
    }, [_c('div', {
      staticClass: "box-cube"
    }, [(_vm.product_item_group.product_item_group_is_color_image == 'IMG') ? _c('div', {}, [((_vm.product_item_group.product_item_group_image && (_vm.product_item_group.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": _vm.product_item_group.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.product_item_group.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "form-group col-xs-10"
    }, [_c('label', [_vm._v("To change Colour/Image, pick Colour or pick from uploaded Images to match the colour you are adding")])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "form-group col-xs-12"
    }, [_c('label', [_vm._v(" Pick Colour\r\n                                    "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item_group.product_item_group_color_new),
        expression: "product_item_group.product_item_group_color_new"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "4em"
      },
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": (_vm.product_item_group.product_item_group_color_new)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item_group.product_item_group_color_new = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12"
    }, [_c('label', [_vm._v("Or Pick Image")]), _vm._v(" "), _c('div', {
      staticClass: "row img-row"
    }, _vm._l((_vm.product.product_images), function(img, index) {
      return _c('div', {
        key: index,
        staticClass: "col-xs-1",
        staticStyle: {
          "height": "40px",
          "width": "100px",
          "margin-bottom": "5px"
        },
        attrs: {
          "id": "groupImage"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('set-product-item-group-image', img.product_image_id)
          }
        }
      }, [_c('img', {
        staticClass: "product-item-group-image sp-prd-img",
        attrs: {
          "id": img.product_image_id + 'PRTG',
          "src": img.product_image,
          "alt": ""
        }
      })])])
    })), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "z-index": "9"
      }
    }, [_c('div', {
      staticClass: "upload-btn-wrapper",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "id": "uploadDiv"
      }
    }, [_c('button', {
      staticClass: "upload-btn",
      staticStyle: {
        "line-height": "1.2"
      }
    }, [_vm._v("Or Add new Image")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "input-file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.onFileChange($event, 'products', _vm.product.product_id)
        }
      }
    })])]), _c('hr')]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      staticStyle: {
        "line-height": "1.2",
        "margin-right": "5px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": _vm.editProductItemGroup
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      staticStyle: {
        "line-height": "1.2",
        "margin-right": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ban"
    }), _vm._v(" Cancel")])])])]) : _vm._e(), _vm._v(" "), (_vm.product_details.removeItemGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {
      staticClass: "row col-xs-12"
    }, [_c('span', {
      staticClass: "pull-left col-sm-12"
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Do you really want to remove this Item Group?")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs sp-button-1 sp-button-sm",
      on: {
        "click": function($event) {
          _vm.removeProductItemGroup()
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs sp-button-1 sp-button-sm",
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e()])]) : _vm._e()]), _vm._v(" "), (_vm.product_details.addProductItemToGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {
      staticClass: "col-xs-12"
    }, [(_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "col-md-6 col-xs-12"
    }, [_c('label', [_vm._v("Attributes (eg: Size, Plan, Length etc,)\r\n                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_size),
        expression: "product.product_item_size"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_size)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_size = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('div', {
      staticClass: "col-md-4 col-xs-4"
    }, [_c('label', [_vm._v(" Service Tag\r\n                                  "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_service_tag),
        expression: "product.product_item_service_tag"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_service_tag)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_service_tag = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 col-xs-4"
    }, [_c('label', [_vm._v(" Price\r\n                                  "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_price),
        expression: "product.product_item_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "value": "",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_price = $event.target.value
        }
      }
    })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "col-md-3 col-xs-4"
    }, [_c('label', [_vm._v(" Weight(KG)\r\n                                  "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_weight),
        expression: "product.product_item_weight"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "step": "any",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_weight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_weight = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 col-xs-4"
    }, [_c('label', [_vm._v(" Quantity\r\n                                  "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_quantity),
        expression: "product.product_item_quantity"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_quantity = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 col-xs-12"
    }, [_c('p', {
      staticClass: "data-error-message"
    }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
      staticClass: "data-success-message"
    }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      staticStyle: {
        "background": "#e7e8e9"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": _vm.addProductItem
      }
    }, [_vm._v("Add Item")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _vm._e()])])
  })) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have not set any Product item variation")])])]) : _vm._e(), _vm._v(" "), (_vm.product_details.addProductItemPanel) ? _c('div', {}, [_c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right",
      "line-height": "1.2"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")]), _vm._v(" "), _c('h6', [_vm._v("Add New Variation "), (_vm.product.product_groups_set_name) ? _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("(Set New " + _vm._s(_vm.product.product_groups_set_name) + ")")]) : _vm._e()]), _vm._v(" "), _c('form', {
    staticClass: "sp-form",
    staticStyle: {
      "margin-top": "1em",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.product.product_set_groups > 0) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showProductItemGroups),
      expression: "showProductItemGroups"
    }],
    staticStyle: {
      "height": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "showtrue"
    },
    domProps: {
      "checked": _vm._q(_vm.showProductItemGroups, "showtrue")
    },
    on: {
      "__c": function($event) {
        _vm.showProductItemGroups = "showtrue"
      }
    }
  }), _vm._v(" "), _vm._v("\r\n                                  Add new Items to "), _c('span', [_vm._v(_vm._s(_vm.product.product_groups_set_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showProductItemGroups),
      expression: "showProductItemGroups"
    }],
    staticStyle: {
      "height": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "showfalse"
    },
    domProps: {
      "checked": _vm._q(_vm.showProductItemGroups, "showfalse")
    },
    on: {
      "__c": function($event) {
        _vm.showProductItemGroups = "showfalse"
      }
    }
  }), _vm._v("\r\n                                      Or Add new " + _vm._s(_vm.product.product_groups_set_name) + "\r\n                              ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.showProductItemGroups == 'showtrue') ? _c('div', [_c('br'), _vm._v(" "), _vm._m(63), _vm._v(" "), ((_vm.product.product_item_groups.length && _vm.product.product_item_groups.length > 0)) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._l((_vm.product.product_item_groups), function(pg, pgdex) {
    return _c('div', {
      key: pgdex
    }, [_c('div', {
      staticClass: "col-xs-2"
    }, [_c('div', {
      staticStyle: {
        "padding": "5px",
        "margin-bottom": "5px",
        "width": "10%"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": pg.product_item_group_name
      },
      on: {
        "click": function($event) {
          _vm.setInnerComponent('set-product-item-group', pg.product_item_group_id)
        }
      }
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', [_c('div', {
      staticClass: "box-color-cube"
    }, [_c('img', {
      staticClass: "product-item-group sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image,
        "id": pg.product_item_group_id + 'PRTGR'
      }
    })])]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "product-item-group",
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    }, [_c('div', {
      staticClass: "box-color-cube",
      staticStyle: {
        "height": "3em",
        "width": "85%"
      },
      style: ({
        background: pg.product_item_group_color
      })
    })])]) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#000000",
        "font-weight": "bold",
        "font-size": "12px",
        "line-height": "1.2",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(pg.product_item_group_name) + " ")])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showProductItemGroups == 'showfalse') ? _c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name of new " + _vm._s(_vm.product.product_groups_set_name) + "\r\n                               "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_group_name),
      expression: "product.product_item_group_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_item_group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_group_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" Pick Colour or Pick from uploaded Images to match the colour you are adding")])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(" Pick Colour\r\n                                 "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_group_color),
      expression: "product.product_item_group_color"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "4em"
    },
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.product.product_item_group_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_group_color = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "border": "1px dashed #eeccee",
      "padding": "1em"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(" Or Pick Images/Videos ")]), _vm._v(" "), _c('div', {
    staticClass: "row img-row"
  }, [_vm._l((_vm.product.product_images), function(img, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-1",
      staticStyle: {
        "height": "50px",
        "width": "70px"
      },
      attrs: {
        "id": "groupImage"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setInnerComponent('set-product-item-group-image', img.product_image_id)
        }
      }
    }, [_c('img', {
      staticClass: "product-item-group-image sp-prd-img",
      attrs: {
        "id": img.product_image_id + 'PRTG',
        "src": img.product_image,
        "alt": ""
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "z-index": "9"
    }
  }, [_c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v(_vm._s(_vm.max_media_info))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "sp-button-1 sp-button-sm",
    staticStyle: {
      "line-height": "0.4",
      "font-size": "14px"
    },
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Or Add new Image or Video ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "video/*,image/*",
      "capture": ""
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeProductItems($event, 'products', _vm.product.product_id)
      }
    }
  })]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_media_error_message))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('br')]), _vm._v(" "), ((_vm.showProductItemGroups == 'showtrue') || (_vm.showProductItemGroups == 'showfalse')) ? _c('div', {
    staticClass: "row col-md-12"
  }, [(_vm.product.product_service == 'S') ? _c('div', {
    staticClass: "col-md-4 col-xs-3"
  }, [_c('label', [_vm._v(" Service Tag "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_service_tag),
      expression: "product.product_item_service_tag"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_service_tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_service_tag = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v(" Price\r\n                              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v(" Weight(KG)\r\n                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v(" Quantity\r\n                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "col-md-12 col-xs-12",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('label', [_vm._v("Attributes (eg: Size, Plan, Length etc,)\r\n                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_size),
      expression: "product.product_item_size"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_size = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticClass: "data-success-message"
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProductItem
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.setBusinessCategoryProductDiscountCoupons) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(64), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.product_details.setProductDiscount || _vm.product_details.setProductItemDiscount) ? _c('div', [_c('div', {
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.product_details.setProductDiscount) ? _c('label', [_vm._v("Set Product Coupon Or Discount")]) : _vm._e(), _vm._v(" "), (_vm.product_details.setProductItemDiscount) ? _c('label', [_vm._v("Set Product Item Coupon Or Discount")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.is_discount_coupon),
      expression: "discount_coupon.is_discount_coupon"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.is_discount_coupon = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Discount")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Coupon")])])]), _vm._v(" "), (((_vm.product.product_discounts_active == 1) || (_vm.product_item.product_item_discounts_active == 1))) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have an active Discount")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "line-height": "1.2"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setDiscountsAndCoupons()
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _vm._m(65)]) : _vm._e(), _vm._v(" "), (_vm.product_details.editDiscount) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Edit Discount")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date: " + _vm._s(_vm.discount_coupon.discount_start_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date: " + _vm._s(_vm.discount_coupon.discount_end_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "line-height": "2em"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editDiscountsAndCoupons()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), (!(_vm.product_details.setProductDiscount || _vm.product_details.setProductItemDiscount) && !_vm.product_details.editDiscount) ? _c('div', [_c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('viewProductDiscounts', '', '')
      }
    }
  }, [_vm._v("View Product Discounts and Coupons")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('viewProductItemsDiscounts', '', '')
      }
    }
  }, [_vm._v("View Product Items Discounts and Coupons")])]) : _vm._e(), _vm._v(" "), (_vm.product_details.viewCoupons) ? _c('div', {
    staticStyle: {
      "margin-top": "2em",
      "border": "#e9e6e6 dashed 1px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('h6', {
    staticClass: "pull-left",
    staticStyle: {
      "text-transform": "uppercase",
      "font-size": "14px"
    }
  }, [_vm._v("Item Coupons and Discounts")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm pull-right",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "items-list-tiny",
    staticStyle: {
      "display": "inline"
    }
  }, [(_vm.product_item.product_item_group_is_color_image == 'IMG') ? _c('li', [((_vm.product_item.product_item_group_image && (_vm.product_item.product_item_group_image != 'error'))) ? _c('img', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "src": _vm.product_item.product_item_group_image
    }
  }) : _c('img', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.product_item.product_item_group_is_color_image == 'COL') ? _c('li', [_c('a', {
    staticClass: "btn box-color-cube",
    style: ({
      background: _vm.product_item.product_item_group_color
    })
  })]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P' && (_vm.product_item.product_item_size)) ? _c('li', {
    staticClass: "box-wrap"
  }, [_vm._v(_vm._s(_vm.product_item.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (_vm.product_item.product_item_service_tag)) ? _c('li', {
    staticClass: "box-wrap"
  }, [_vm._v(_vm._s(_vm.product_item.product_item_service_tag))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', [_c('span', [_vm._v("w(kg):")]), _vm._v(_vm._s(_vm.product_item.product_item_weight))]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(_vm.product_item.product_item_actual_price))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Qty:")]), _vm._v(_vm._s(_vm.product_item.product_item_quantity))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]), _vm._v(" "), _vm._l((_vm.product_item.product_item_discounts), function(dc) {
    return _c('div', [(dc.discount_type == 5) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "#d1ddf1",
        "text-align": "center"
      }
    }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('editDiscount', '', dc)
        }
      }
    }, [_vm._v("\r\n                                Edit Discount")]), _vm._v("    \r\n                              "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('deactivateDiscount', _vm.product_item, dc)
        }
      }
    }, [_vm._v("\r\n                                Deactivate Discount")])]) : _vm._e(), (_vm.action_loading && (_vm.product_item.product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p')]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }), _vm._v(" "), _c('div', [(_vm.product_item.product_item_only_coupon_discount_count == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No set discount or coupon")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductItemDiscount', 'productitem', _vm.product_item)
      }
    }
  }, [_vm._v("Set New Item Discount Or Coupon")])])], 2) : _vm._e(), _vm._v(" "), (_vm.product_details.viewProductItemsDiscounts) ? _c('div', {
    staticStyle: {
      "margin-top": "1em",
      "border": "#0d022b dashed 1px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('h6', {
    staticClass: "pull-left",
    staticStyle: {
      "text-transform": "uppercase",
      "font-size": "14px"
    }
  }, [_vm._v("Items in this Product")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm pull-right",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._l((_vm.product.product_items), function(productItem) {
    return _c('div', {
      staticStyle: {
        "border": "dashed #d1ddf1",
        "padding": "5px",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "items-list-tiny",
      staticStyle: {
        "display": "inline"
      }
    }, [(productItem.product_item_group_is_color_image == 'IMG') ? _c('li', [((productItem.product_item_group_image && (productItem.product_item_group_image != 'error'))) ? _c('img', {
      staticStyle: {
        "height": "30px"
      },
      attrs: {
        "src": productItem.product_item_group_image
      }
    }) : _c('img', {
      staticStyle: {
        "height": "30px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (productItem.product_item_group_is_color_image == 'COL') ? _c('li', [_c('a', {
      staticClass: "btn box-color-cube",
      style: ({
        background: productItem.product_item_group_color
      })
    })]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P' && (productItem.product_item_size)) ? _c('li', {
      staticClass: "box-wrap"
    }, [_vm._v(_vm._s(productItem.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (productItem.product_item_service_tag)) ? _c('li', {
      staticClass: "box-wrap"
    }, [_vm._v(_vm._s(productItem.product_item_service_tag))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', [_c('span', [_vm._v("w(kg):")]), _vm._v(_vm._s(productItem.product_item_weight))]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(productItem.product_item_actual_price))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Qty:")]), _vm._v(_vm._s(productItem.product_item_quantity))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (_vm.product_details.viewCoupons && (productItem.product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
      staticStyle: {
        "display": "none"
      }
    }, [_c('div', [_c('button', {
      staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
      staticStyle: {
        "line-height": "1.2"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
      staticStyle: {
        "line-height": "1.2"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('setProductItemDiscount', 'productitem', productItem)
        }
      }
    }, [_vm._v("Set New Item Discount Or Coupon")])]), _vm._v(" "), _vm._l((productItem.product_item_discounts), function(dc) {
      return _c('div', [_c('div', [((dc.discount_type == 5)) ? _c('p', [_c('b', [_vm._v("Product Item Discount")])]) : _vm._e(), _vm._v(" "), ((dc.discount_type == 4)) ? _c('p', [_c('b', [_vm._v("General Product Discount")])]) : _vm._e(), _vm._v(" "), (!(dc.discount_type == 4) && !(dc.discount_type == 5)) ? _c('p', [_c('b', [_vm._v("General Sellpoint Discount")])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticStyle: {
          "background": "#d1ddf1",
          "text-align": "center"
        }
      }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
        staticStyle: {
          "cursor": "pointer",
          "text-decoration": "underline",
          "font-size": "13px",
          "color": "#448aff"
        },
        attrs: {
          "title": "Edit"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('editDiscount', '', dc)
          }
        }
      }, [_vm._v("\r\n                                  Edit Discount")]), _vm._v("    \r\n                                "), _c('a', {
        staticStyle: {
          "cursor": "pointer",
          "text-decoration": "underline",
          "font-size": "13px",
          "color": "#448aff"
        },
        attrs: {
          "title": "De-Activate"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('deactivateDiscount', productItem, dc)
          }
        }
      }, [_vm._v("\r\n                                  Deactivate Discount")])]) : _vm._e(), (_vm.action_loading && (productItem.product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e(), _vm._v(" "), _c('p')]) : _c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Edit/Deactivate at Business Settings")]), _vm._v(" "), _c('hr')])])
    }), _vm._v(" "), _c('div', [(productItem.product_item_discounts && _vm.product_item.product_item_discounts.length == 0) ? _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("No set discount or coupon")]) : _vm._e()])], 2) : _c('button', {
      staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
      staticStyle: {
        "line-height": "2em"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('viewCoupons', 'productitem', productItem)
        }
      }
    }, [_vm._v("View Coupons and Discounts")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.product_details.viewProductDiscounts) ? _c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [(_vm.product.product_items[0]) ? _c('div', [_c('div', {
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('h6', {
    staticClass: "pull-left",
    staticStyle: {
      "text-transform": "uppercase",
      "font-size": "14px"
    }
  }, [_vm._v("Product Coupons and Discounts")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm pull-right",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._l((_vm.product.product_items[0].product_item_discounts), function(dc) {
    return _c('div', [((dc.discount_type == 4)) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "#d1ddf1",
        "text-align": "center"
      }
    }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('editDiscount', '', dc)
        }
      }
    }, [_vm._v("\r\n                                  Edit Discount")]), _vm._v("    \r\n                                "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('deactivateDiscount', _vm.product.product_items[0], dc)
        }
      }
    }, [_vm._v("\r\n                                  Deactivate Discount")])]) : _vm._e(), (_vm.action_loading && (_vm.product.product_items[0].product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p')]) : _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Edit/Deactivate at Business Settings")]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }), _vm._v(" "), (_vm.product.product_only_coupon_discount_count == 0) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No set discount or coupon")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductDiscount', '', '')
      }
    }
  }, [_vm._v("Set New Product Discount Or Coupon")])]) : _vm._e()]), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.setBusinessCategoryProductDeliveryAndReturanInformation) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_c('div', [_vm._m(66), _vm._v(" "), (_vm.product_details.edit_product_delivery) ? _c('div', {}, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_delivery_returns),
      expression: "product.product_delivery_returns"
    }],
    domProps: {
      "value": (_vm.product.product_delivery_returns)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_delivery_returns = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setProductDelivery()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("submit")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" cancel")])])]) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000",
      "line-height": "1.2",
      "font-size": "13px"
    }
  }, [_vm._v("Set delivery and returns information for this product, Note that this is different from setting delivery places\r\n                    "), (_vm.product.product_delivery_returns) ? _c('span', [_vm._v(_vm._s(_vm.product.product_delivery_returns))]) : _vm._e(), _c('br'), _vm._v(" "), _c('button', {
    staticStyle: {
      "font-size": "13px"
    },
    attrs: {
      "type": "btn sp-button-1",
      "title": "Edit"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('edit_product_delivery', '', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Set Delivery & Return Information")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {}, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set How Product Shipping Fee would affect Buyers Checkout Ordering")]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_set_shipping_fee_status),
      expression: "product_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "12",
      "value": "12"
    },
    domProps: {
      "checked": _vm._q(_vm.product_set_shipping_fee_status, "12")
    },
    on: {
      "click": function($event) {
        _vm.setProductShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.product_set_shipping_fee_status = "12"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Charge Product Delivery Fee only once on all Quantity of Product Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_set_shipping_fee_status),
      expression: "product_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "13",
      "value": "13"
    },
    domProps: {
      "checked": _vm._q(_vm.product_set_shipping_fee_status, "13")
    },
    on: {
      "click": function($event) {
        _vm.setProductShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.product_set_shipping_fee_status = "13"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Charge Product Delivery Fee on each Quantity of Product Ordered")])])]), _vm._v(" "), (_vm.set_shipping_fee_status_track && _vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('br'), _c('br')])])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.setBusinessCategoryProductShippingInformation) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(67), _vm._v(" "), ((_vm.product.product_business_delivery_options) && (_vm.product.product_business_delivery_options.length != 0)) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have set some general delivery settings")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v("You can set a different delivery fee for this product")]), _vm._v(" "), _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" "), (delivery.business_products_delivery_fees.length > 0) ? _c('span', _vm._l((delivery.business_products_delivery_fees), function(fee, fdex) {
      return _c('span', [((fee.product_delivery_product == _vm.product.product_id)) ? _c('span', [_vm._v(" -  ₦" + _vm._s(fee.product_delivery_fee) + "\r\n                          ")]) : _vm._e()])
    })) : _c('span'), _vm._v(" "), (_vm.product_details.setProductDeliveryInformation && delivery.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery.product_delivery_fee),
        expression: "delivery.product_delivery_fee"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (delivery.product_delivery_fee)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery.product_delivery_fee = $event.target.value
        }
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Business Set Shipping Fee: ₦" + _vm._s(delivery.business_delivery_option_price))])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.product_details.setProductDeliveryInformation && _vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.setProductDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "font-size": "10px"
      },
      attrs: {
        "type": "btn",
        "title": "Set Product Delivery Fee"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('setProductDeliveryInformation', delivery)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Set Fee")])])
  })], 2) : _c('div', [_c('p', {
    staticClass: "info"
  }, [_vm._v("You have not set your Business Delivery Locations")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.managePanel) ? _c('section', {
    staticClass: "account-inner-set-panel",
    staticStyle: {
      "background": "#f7fbff",
      "margin-top": "2em"
    },
    attrs: {
      "id": "manage"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(68)]) : _c('div', {
    staticClass: "container",
    staticStyle: {
      "background": "#ffffff",
      "margin-top": "1em",
      "padding": "1em"
    }
  }, [_c('h5', [_vm._v("Manage Gallery")]), _vm._v(" "), _c('div', {
    staticClass: "container banner-menu manage-account-menu"
  }, [_c('div', {
    staticClass: "row menu-links"
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setComponent('manage-businesses', '')
      }
    }
  }, [_vm._v("Business Settings")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setComponent('manage-lookbooks', '')
      }
    }
  }, [_vm._v("Lookbooks Settings")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setComponent('manage-products', '')
      }
    }
  }, [_vm._v("Products")])])])])]), _vm._v(" "), (_vm.manageBusinesses) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row card-row-controls"
  }, [_c('div', [(_vm.manageBusinessDetails) ? _c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-component-details', '')
      }
    }
  }, [_vm._v("Back")]) : _vm._e()])]), _vm._v(" "), (!_vm.manageBusinessDetails) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row cards-grids"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-6",
    attrs: {
      "id": "businessprofile"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-card-details', 0)
      }
    }
  }, [_vm._m(69)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-6",
    attrs: {
      "id": "businessprofile"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-card-details', 1)
      }
    }
  }, [_vm._m(70)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-6",
    attrs: {
      "id": "businessprofile"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-card-details', 2)
      }
    }
  }, [_vm._m(71)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-6",
    attrs: {
      "id": "businessprofile"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-card-details', 3)
      }
    }
  }, [_vm._m(72)])])])]) : _c('div', {
    staticClass: "row"
  }, [(_vm.businessComponents[0]) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-8 offset-md-1 set-panel"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('h4', [_vm._v("Edit Business Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_name),
      expression: "sellpoint.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Tagline")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_tagline),
      expression: "sellpoint.business_tagline"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_tagline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_tagline = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Brief")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_profile),
      expression: "sellpoint.business_profile"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.sellpoint.business_profile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_profile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_address),
      expression: "sellpoint.business_address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Emails")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_emails),
      expression: "sellpoint.business_emails"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_emails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_emails = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_phones),
      expression: "sellpoint.business_phones"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_phones)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_phones = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "float": "left",
      "background": "#f1dee4"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('main')
      }
    }
  }, [_vm._v("Save Details")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "float": "right",
      "background": "#ecb989"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("Cancel")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.businessComponents[1]) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-10  set-panel"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "horizontal-cards"
  }, [_vm._m(73), _vm._v(" "), (_vm.business_details.delivery_edit) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('label', [_vm._v("Your Delivery Information")]), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_delivery_information),
      expression: "sellpoint.business_delivery_information"
    }],
    staticStyle: {
      "width": "70%"
    },
    domProps: {
      "value": (_vm.sellpoint.business_delivery_information)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_delivery_information = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('delivery')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("save")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" cancel")])]) : _c('div', [(_vm.sellpoint.business_delivery_information) ? _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_delivery_information) + "\r\n                            "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'delivery_edit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v("edit")]), _vm._v(" "), _c('br')]) : _c('p', [_vm._v("You have not set any delivery information\r\n                            "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'delivery_edit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v("Set")]), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "horizontal-cards"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set How Shipping Fee would affect Buyers Checkout Ordering")]), _vm._v(" "), _c('p', [_vm._v("This setting affects all products orders shipping fees on th this Business. If you would like any product \r\n                            to have its on shipping fee, specify it when setting up your product.\r\n                        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#363535"
    }
  }, [_vm._v("How would your Business Shipping Fee be calculated?")]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_set_shipping_fee_status),
      expression: "business_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "9",
      "value": "9"
    },
    domProps: {
      "checked": _vm._q(_vm.business_set_shipping_fee_status, "9")
    },
    on: {
      "click": function($event) {
        _vm.setShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.business_set_shipping_fee_status = "9"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" One Charge Business Shipping Fee on all Items Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_set_shipping_fee_status),
      expression: "business_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "10",
      "value": "10"
    },
    domProps: {
      "checked": _vm._q(_vm.business_set_shipping_fee_status, "10")
    },
    on: {
      "click": function($event) {
        _vm.setShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.business_set_shipping_fee_status = "10"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Same Charge Business Shipping Fee on each Product Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_set_shipping_fee_status),
      expression: "business_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "11",
      "value": "11"
    },
    domProps: {
      "checked": _vm._q(_vm.business_set_shipping_fee_status, "11")
    },
    on: {
      "click": function($event) {
        _vm.setShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.business_set_shipping_fee_status = "11"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Same Charge Business Shipping Fee on each Product and its quantities Ordered")])])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('h6', [_vm._v("Delivery Locations and Prices")]), _vm._v(" "), _c('div', [_c('div', [_vm._l((_vm.sellpoint.business_delivery_options), function(delivery_option) {
    return _c('div', [(_vm.business_details.delivery_option_edit && delivery_option.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_state),
        expression: "delivery_option.business_delivery_state"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          delivery_option.business_delivery_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities(delivery_option.business_delivery_state, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state.state_id
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("City: "), _c('b', [_vm._v(_vm._s(delivery_option.business_delivery_option))])]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.city),
        expression: "delivery_option.city"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.setOtherOptions(delivery_option.city, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "all"
      }
    }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city.city_id
        }
      }, [_vm._v(_vm._s(city.city_name))])
    }), _vm._v(" "), _c('option', {
      attrs: {
        "value": "other"
      }
    }, [_vm._v("Other Areas / Cities ")])], 2)]), _vm._v(" "), (_vm.edit_other_delivery_option) ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_other_option),
        expression: "delivery_option.business_delivery_other_option"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "eg. Abuja"
      },
      domProps: {
        "value": (delivery_option.business_delivery_other_option)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery_option.business_delivery_other_option = $event.target.value
        }
      }
    }), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_option_price),
        expression: "delivery_option.business_delivery_option_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (delivery_option.business_delivery_option_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery_option.business_delivery_option_price = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.editDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _c('div', [(delivery_option.business_delivery_product == 0) ? _c('p', [_vm._v("\r\n                                    " + _vm._s(delivery_option.business_delivery_option) + " - " + _vm._s(delivery_option.business_delivery_option_price) + " \r\n                                    "), _c('button', {
      staticClass: "btn sp-button-1",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-delivery-option', delivery_option)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteDeliveryOption(delivery_option.business_delivery_option_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e()])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'delivery_add')
      }
    }
  }, [_vm._v("Add New Delivery Information")]), _vm._v(" "), _c('hr')], 2), _vm._v(" "), (_vm.business_details.delivery_add) ? _c('div', {
    staticClass: "contact_form col-md-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('h5', [_vm._v("Add a Delivery Location and Price")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('div', [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other Areas / Cities ")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.other_delivery_option) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_other_option),
      expression: "delivery_option.delivery_other_option"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "eg. Abuja"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_other_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_other_option = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Delivery Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_price),
      expression: "delivery_option.delivery_option_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "eg. 1000"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_option_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_option_price = $event.target.value
      }
    }
  }), _c('br')]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.addDeliveryOption
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()]), _vm._v(" "), _c('div')])])])])]) : _vm._e(), _vm._v(" "), (_vm.businessComponents[2]) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-10  set-panel"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {}, [_c('div', {
    staticClass: "horizontal-cards"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set My Sellpoint's Discounts and Coupons")]), _vm._v(" "), _c('p', [_vm._v("Set a general discount and coupons that would apply to all products and services in your sellpoint. \r\n                          You can set individual Product Discounts on thier product pages.\r\n                      ")]), _vm._v(" "), _c('span', [(_vm.business_details.setDiscount) ? _c('button', {
    staticClass: "btn sp-button-1",
    on: {
      "click": function($event) {
        _vm.setComponent('view-discounts', '')
      }
    }
  }, [_vm._v("View your Discounts")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'setDiscount')
      }
    }
  }, [_vm._v("Set New Discount Or Coupon")]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.business_details.setDiscount) ? _c('div', [_c('div', {
    staticClass: "contact-form col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(_vm.sellpoint.business_discounts_active == 1) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have an ongoing active Discount")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Set Coupon Or Discount")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.is_discount_coupon),
      expression: "discount_coupon.is_discount_coupon"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.is_discount_coupon = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Discount")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Coupon")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label'), _vm._v(" "), (_vm.sellpoint.business_discounts_active != 1) ? _c('label', [_vm._v("Select Discount Category")]) : _c('label', [_vm._v("Select Coupon Discount Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_category),
      expression: "discount_coupon.discount_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.discount_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v(_vm._s(cat.business_category))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setDiscountsAndCoupons()
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _vm._m(74)]) : _vm._e(), _vm._v(" "), (_vm.discount_coupon.edit && (!_vm.business_details.viewDiscounts || !_vm.business_details.setDiscount)) ? _c('div', [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Edit Discount")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_category),
      expression: "discount_coupon.discount_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.discount_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Another Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v(_vm._s(cat.business_category))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date: " + _vm._s(_vm.discount_coupon.discount_start_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date: " + _vm._s(_vm.discount_coupon.discount_end_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editDiscountsAndCoupons()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), ((!_vm.business_details.setDiscount && !_vm.discount_coupon.edit) && _vm.sellpoint.business_discounts_coupons) ? _c('div', [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("View Discounts")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.sellpoint.business_discounts_coupons), function(dc, index) {
    return _c('div', {
      staticClass: "col-md-4 col-xs-12"
    }, [_c('div', {
      staticStyle: {
        "border": "#f1dee4 solid 1px",
        "padding": "1em"
      }
    }, [_c('div', {
      staticStyle: {
        "background": "#d1ddf1",
        "text-align": "center"
      }
    }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('p', [_c('b', [_vm._v("Type: ")]), _vm._v(_vm._s(dc.discount_type_name))]) : _c('p', [_c('b', [_vm._v("Type: ")]), _vm._v(_vm._s(dc.discount_category_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), ((dc.discount_type == 2) || (dc.discount_type == 3)) ? _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-discount-coupon', dc)
        }
      }
    }, [_vm._v("\r\n                                    Edit Coupon")]), _vm._v("    \r\n                                "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.deactivateDiscountsAndCoupons(dc)
        }
      }
    }, [_vm._v("\r\n                                    Deactivate Coupon")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Edit/Deactivate at Product Settings")]) : _vm._e()])])
  }))]) : _vm._e()])])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.manageProducts) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('h6', {
    staticStyle: {
      "margin-left": "1em",
      "margin-right": "2em"
    }
  }, [_vm._v("Products (" + _vm._s(_vm.sellpoint.business_total_products) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.component_view.viewProducts) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.products), function(product, gndex) {
    return _c('div', {
      staticClass: "col-md-2 col-sm-3 col-xs-3"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponentView('products', product, '')
        }
      }
    }, [_c('div', {
      staticClass: "info-card info-card-lookbook"
    }, [_c('div', {
      staticClass: "container info-card-body"
    }, [_c('div', {
      staticClass: "info-card-row info-card-lookbook-row"
    }, [_c('div', {}, [(product.product_images.length > 0) ? _c('div', {
      staticClass: "info-card-lookbook-image",
      staticStyle: {
        "margin": "5px"
      }
    }, [(_vm.checkIfVideo(product.product_images[0].product_image)) ? _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": product.product_images[0].product_image
      }
    })]) : _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": "0.8"
      }
    }, [_c('p', [_vm._v(_vm._s(product.product_name))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])])])])
  })) : _vm._e(), _vm._v(" "), (_vm.component_view.viewProduct) ? _c('div', {
    staticClass: "row col-md-12",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.is_viewing_lookbook) ? _c('div', [_c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('switch-to-viewing-loobook', '', '')
      }
    }
  }, [_vm._v("<< Back to Lookbook")])]) : _c('div', [_c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('products', '', '')
      }
    }
  }, [_vm._v("<< Back ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('h4', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', [_vm._v("Category: " + _vm._s(_vm.product.product_category_name))]), _vm._v(" "), (_vm.product.product_set_items == 0) ? _c('div', [(_vm.product.product_items[0].product_item_actual_price != 0) ? _c('div', [_c('p', [_vm._v("Price: ₦" + _vm._s(_vm.product.product_items[0].product_item_actual_price))]), _vm._v(" "), _c('p', [_vm._v("Discounted Price: ₦" + _vm._s(_vm.product.product_items[0].product_item_price))])]) : _c('div', [_c('p', [_vm._v("Price: ₦" + _vm._s(_vm.product.product_items[0].product_item_price))])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('p', [_vm._v("Weight: " + _vm._s(_vm.product.product_items[0].product_item_weight) + "(kg)")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Quantity: " + _vm._s(_vm.product.product_items[0].product_item_quantity))])]) : _vm._e(), _vm._v(" "), (_vm.product_details.editProductSingleProductItem) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('h6', {
    staticStyle: {
      "font-size": "14px",
      "text-decoration": "underline"
    }
  }, [_vm._v("Reset Product Details")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-4 col-xs-4"
  }, [_c('label', [_vm._v(" Price\r\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_price),
      expression: "product.product_items[0].product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "form-group col-md-4 col-xs-4"
  }, [_c('label', [_vm._v(" Weight\r\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_weight),
      expression: "product.product_items[0].product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_weight = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4 col-xs-4"
  }, [_c('label', [_vm._v(" Quantity\r\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_quantity),
      expression: "product.product_items[0].product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 col-md-2",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProductSingleProductItem
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 col-md-2",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])])])]) : _c('button', {
    staticClass: "btn btn-xs sp-button-1 sp-button-sm",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('editProductSingleProductItem', '')
      }
    }
  }, [_vm._v("Edit Price/Weight/Quantity")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), (_vm.product_details.editProduct) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('h6', [_vm._v("Edit Product")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" *Product Name\r\n                                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("Category:- " + _vm._s(_vm.product.product_category_name) + " ")]), _vm._v(" "), (_vm.sellpoint_categories.length > 0) ? _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v(" Select from My Shop Categories\r\n                                  "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "category-type-1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-1')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_1
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      key: category.business_category_id,
      attrs: {
        "disabled": _vm.category_type_1
      },
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [(_vm.sellpoint_categories.length > 0) ? _c('span', [_c('b', [_vm._v("Or ")])]) : _vm._e(), _vm._v(" Select from Related Categories\r\n                                  "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main_category),
      expression: "main_category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.main_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getSubCategories(_vm.main_category)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      key: category.category_id,
      domProps: {
        "value": category
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.sub_categories.length != 0) ? _c('label', [_vm._v(" Select a Category\r\n                                  "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_sub_category),
      expression: "product.product_sub_category"
    }],
    staticClass: "form-control category-type-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_sub_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_2
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(category) {
    return _c('option', {
      key: category.sub_category_id,
      attrs: {
        "disabled": _vm.category_type_2
      },
      domProps: {
        "value": category.sub_category_id
      }
    }, [_vm._v(_vm._s(category.sub_category_name))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', [_c('b', [_vm._v("Or ")]), _vm._v(" Enter a specific Category\r\n                                  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_listed_category),
      expression: "product.product_listed_category"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.category_type_3,
      "type": "text",
      "placeholder": "",
      "id": "category-type-3"
    },
    domProps: {
      "value": (_vm.product.product_listed_category)
    },
    on: {
      "change": function($event) {
        _vm.trackevent('category-type-3')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_listed_category = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', [_vm._v(" *Product Description\r\n                                  "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control txtarea",
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProduct
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])])])]) : _c('button', {
    staticClass: "btn btn-xs sp-button-1",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('editProduct', '')
      }
    }
  }, [_vm._v("Edit Product Details")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("Product Images")]), _vm._v(" "), _c('div', {
    staticClass: "img-row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._l((_vm.product.product_images), function(pt) {
    return _c('div', {
      staticClass: "img-column"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "float": "left"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_c('img', {
      staticClass: "sp-prd-img",
      staticStyle: {
        "height": "50px",
        "width": "80px"
      },
      attrs: {
        "src": _vm.img_product_url + pt.product_image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "btn pull-right",
      staticStyle: {
        "margin-top": "-3em",
        "font-size": "10px",
        "padding": "6px",
        "float": "right"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteProductImage(pt.product_image_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [(_vm.action_loading && _vm.product_details.uploading_image) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "upload-btn",
    staticStyle: {
      "line-height": "0.6",
      "font-size": "12px"
    }
  }, [_vm._v("Add new Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'products', _vm.product.product_id)
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(!_vm.product_details.removeProduct) ? _c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "line-height": "2em",
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('removeProduct', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete this Product")]) : _vm._e(), _vm._v(" "), (_vm.product_details.removeProduct) ? _c('span', {}, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to remove this Product?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs sp-button-1 sp-button-sm",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.removeProduct
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-xs-12",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('h6', [_vm._v("Product Items and Variations")]), _vm._v(" "), (_vm.product_details.setProductSettings) ? _c('div', [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('b', [_vm._v("Group Name: ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_groups_set_name),
      expression: "product.product_groups_set_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_groups_set_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_groups_set_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_set_items > 0) ? _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('b', [_vm._v("Group Items Name: ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_groups_items_set_name),
      expression: "product.product_groups_items_set_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_groups_items_set_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_groups_items_set_name = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProductSettings
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('h5', {
    staticStyle: {
      "font-size": "10px",
      "text-transform": "capitalize"
    }
  }, [_c('b', [_vm._v("Name of Group: ")]), _vm._v(_vm._s(_vm.product.product_groups_set_name) + "\r\n                    "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
    staticStyle: {
      "line-height": "0.8"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductSettings', '', '')
      }
    }
  }, [_vm._v(" Change")])]), _vm._v(" "), (((_vm.product.product_set_groups > 0) && (_vm.product.product_set_items > 0))) ? _c('div', _vm._l((_vm.product.product_item_groups), function(pg) {
    return _c('div', {
      staticClass: "row col-xs-12",
      staticStyle: {
        "border-bottom": "1px solid #e9e6e6",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', [(_vm.product_details.editProductItemGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {
      staticClass: "col-sm-12",
      attrs: {
        "id": "editProductItemGroup"
      }
    }, [_c('h6', [_vm._v("Edit Product Item Group")]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('label', [_vm._v("Name\r\n                                    "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item_group.product_item_group_name),
        expression: "product_item_group.product_item_group_name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.product_item_group.product_item_group_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item_group.product_item_group_name = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('div', {
      staticClass: "box-cube col-xs-2"
    }, [(_vm.product_item_group.product_item_group_is_color_image == 'IMG') ? _c('div', {}, [((_vm.product_item_group.product_item_group_image && (_vm.product_item_group.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": _vm.product_item_group.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.product_item_group.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('label', [_vm._v("To change Colour/Image, pick Colour or pick from uploaded Images to match the colour you are adding")])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('label', [_vm._v(" Pick Colour\r\n                                        "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item_group.product_item_group_color_new),
        expression: "product_item_group.product_item_group_color_new"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "4em"
      },
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": (_vm.product_item_group.product_item_group_color_new)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item_group.product_item_group_color_new = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('label', [_vm._v("Or Pick Image")]), _vm._v(" "), _c('div', {
      staticClass: "row img-row"
    }, _vm._l((_vm.product.product_images), function(img, index) {
      return _c('div', {
        key: index,
        staticClass: "col-xs-1",
        staticStyle: {
          "height": "40px",
          "width": "100px",
          "margin-bottom": "5px"
        },
        attrs: {
          "id": "groupImage"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('set-product-item-group-image', img.product_image_id)
          }
        }
      }, [_c('img', {
        staticClass: "product-item-group-image sp-prd-img",
        attrs: {
          "id": img.product_image_id + 'PRTG',
          "src": img.product_image,
          "alt": ""
        }
      })])])
    })), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "z-index": "9"
      }
    }, [_c('div', {
      staticClass: "upload-btn-wrapper",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "id": "uploadDiv"
      }
    }, [_c('button', {
      staticClass: "upload-btn",
      staticStyle: {
        "line-height": "0.6"
      }
    }, [_vm._v("Or Add new Image")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "input-file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.onFileChange($event, 'products', _vm.product.product_id)
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-md-12"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      staticStyle: {
        "line-height": "1.2",
        "margin-right": "5px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": _vm.editProductItemGroup
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      staticStyle: {
        "line-height": "1.2",
        "margin-right": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ban"
    }), _vm._v(" Cancel")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [(_vm.product_details.removeItemGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('span', {
      staticClass: "pull-left col-sm-12"
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Do you really want to remove this Item Group?")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs sp-button-1 sp-button-sm",
      on: {
        "click": function($event) {
          _vm.removeProductItemGroup()
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs sp-button-1 sp-button-sm",
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('div', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('h4', {
      staticStyle: {
        "font-weight": "bold",
        "text-transform": "capitalize",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(pg.product_item_group_name))]), _vm._v(" "), _c('div', {
      staticClass: "box-cube"
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', {
      staticStyle: {
        "height": "40px"
      }
    }, [((pg.product_item_group_image && (pg.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "btn v-tiny-btn sp-button-1 sp-button-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('editProductItemGroup', 'productitemgroup', pg)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Edit")]), _vm._v(" "), (_vm.product.product_item_groups && _vm.product.product_item_groups.length > 1) ? _c('button', {
      staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('removeItemGroup', 'productitemgroup', pg)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Delete")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('div', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('h5', {
      staticStyle: {
        "font-size": "10px",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(_vm.product.product_groups_items_set_name) + "\r\n                            "), _c('button', {
      staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
      staticStyle: {
        "line-height": "0.8"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('setProductSettings', '', '')
        }
      }
    }, [_vm._v(" Change")])]), _vm._v(" "), _vm._l((pg.product_items), function(pt) {
      return _c('div', {
        staticClass: "items-list-tiny",
        staticStyle: {
          "display": "inline"
        }
      }, [_c('div', [(_vm.product.product_service == 'P' && (pt.product_item_size)) ? _c('li', {
        staticClass: "box-wrap"
      }, [_vm._v(_vm._s(pt.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (pt.product_item_service_tag)) ? _c('li', {
        staticClass: "box-wrap"
      }, [_vm._v(_vm._s(pt.product_item_service_tag))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', [_c('span', [_vm._v("w(kg):")]), _vm._v(_vm._s(pt.product_item_weight))]) : _vm._e(), _vm._v(" "), (pt.product_item_actual_price != 0) ? _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(pt.product_item_actual_price))]) : _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(pt.product_item_price))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Qty:")]), _vm._v(_vm._s(pt.product_item_quantity))]), _vm._v(" "), _c('li', [_c('a', {
        staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('editProductItem', 'productitem', pt)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil"
      })])]), _vm._v(" "), (_vm.product.product_items.length > 1) ? _c('li', [_c('a', {
        staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('removeProductItem', 'productitem', pt)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])]) : _vm._e()]), _vm._v(" "), (_vm.product_details.editProductItem && (_vm.product_item.product_item_id == pt.product_item_id)) ? _c('div', {
        staticClass: "col-sm-12",
        staticStyle: {
          "margin-top": "1em"
        },
        attrs: {
          "id": "editProductItem"
        }
      }, [_c('h6', [_vm._v("Edit Product Item")]), _vm._v(" "), _c('form', [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v(" *"), (_vm.product.product_service == 'P') ? _c('span', [_vm._v("Product Item Size")]) : _vm._e(), (_vm.product.product_service == 'S') ? _c('span', [_vm._v("Product Item tYPE")]) : _vm._e(), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_size),
          expression: "product_item.product_item_size"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_size)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_size = $event.target.value
          }
        }
      })])]), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('div', {
        staticClass: "form-group",
        attrs: {
          "cla": ""
        }
      }, [_c('label', [_vm._v(" *Service Tag\r\n                                    "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_service_tag),
          expression: "product_item.product_item_service_tag"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_service_tag)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_service_tag = $event.target.value
          }
        }
      })])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v(" *Product Item Price\r\n                                          "), (_vm.product_item.product_item_actual_price != 0) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_actual_price),
          expression: "product_item.product_item_actual_price"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_actual_price)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_actual_price = $event.target.value
          }
        }
      }) : _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_price),
          expression: "product_item.product_item_price"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_price)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_price = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v(" *Product Item Weight\r\n                                        "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_weight),
          expression: "product_item.product_item_weight"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "step": "any",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_weight)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_weight = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v(" *Product Item Quantity\r\n                                        "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_quantity),
          expression: "product_item.product_item_quantity"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_quantity)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_quantity = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
        staticClass: "col-md-12"
      }, [(_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e(), _vm._v(" "), _c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
        staticClass: "btn sp-button-1",
        staticStyle: {
          "line-height": "1.2",
          "margin-right": "5px"
        },
        attrs: {
          "disabled": _vm.disable_btn,
          "type": "button"
        },
        on: {
          "click": _vm.editProductItem
        }
      }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
        staticClass: "btn sp-button-1",
        staticStyle: {
          "line-height": "1.2",
          "margin-right": "5px"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-ban"
      }), _vm._v(" Cancel")])]), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.product_details.removeProductItem && (_vm.product_item.product_item_id == pt.product_item_id)) ? _c('span', {
        staticClass: "pull-left col-sm-12"
      }, [_c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Do you really want to remove this Item?")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs sp-button-1 sp-button-sm",
        attrs: {
          "disabled": _vm.disable_btn
        },
        on: {
          "click": function($event) {
            _vm.removeProductItem()
          }
        }
      }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs sp-button-1 sp-button-sm",
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })])
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
      staticStyle: {
        "line-height": "0.8"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('addProductItemToGroup', 'productitemgroup', pg)
        }
      }
    }, [_vm._v(" Add New Item")])], 2)]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.product_details.addProductItemToGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {
      staticClass: "row col-md-12"
    }, [(_vm.product.product_service == 'S') ? _c('div', {
      staticClass: "col-md-4 col-xs-3"
    }, [_c('label', [_vm._v(" Service Tag\r\n                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_service_tag),
        expression: "product.product_item_service_tag"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_service_tag)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_service_tag = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 col-xs-3"
    }, [_c('label', [_vm._v(" Price\r\n                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_price),
        expression: "product.product_item_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "value": "",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_price = $event.target.value
        }
      }
    })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "col-md-3 col-xs-3"
    }, [_c('label', [_vm._v(" Weight(KG)\r\n                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_weight),
        expression: "product.product_item_weight"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "step": "any",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_weight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_weight = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 col-xs-3"
    }, [_c('label', [_vm._v(" Quantity\r\n                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_quantity),
        expression: "product.product_item_quantity"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_quantity = $event.target.value
        }
      }
    })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "col-md-3 col-xs-3"
    }, [_c('label', [_vm._v("Attributes (eg: Size, Plan, Length etc,)\r\n                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_size),
        expression: "product.product_item_size"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_size)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_size = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('p', {
      staticClass: "data-error-message"
    }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
      staticClass: "data-success-message"
    }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      staticStyle: {
        "background": "#e7e8e9"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": _vm.addProductItem
      }
    }, [_vm._v("Add Item")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _vm._e()])
  })) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have not set any product item variation")])]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("add other variations like groups or types of this product eg. colors, materials, plans, sizes etc")]), _vm._v(" "), (_vm.product.product_set_groups == 0) ? _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(_vm.product.product_groups_set_name))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "line-height": "0.8"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductSettings', '', '')
      }
    }
  }, [_vm._v(" Change this Name")])])]) : _vm._e(), _vm._v(" "), (!_vm.product_details.addProductItemPanel) ? _c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('addProductItemPanel', '', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Product Variation")]) : _c('div', [(_vm.product_details.addProductItemPanel) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h6', [_vm._v("Add New Variation "), (_vm.product.product_groups_set_name) ? _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("(Set " + _vm._s(_vm.product.product_groups_set_name) + ")")]) : _vm._e()]), _vm._v(" "), _c('form', {
    staticClass: "sp-form",
    staticStyle: {
      "margin-top": "1em",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.product.product_set_groups > 0) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showProductItemGroups),
      expression: "showProductItemGroups"
    }],
    staticStyle: {
      "height": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "showtrue"
    },
    domProps: {
      "checked": _vm._q(_vm.showProductItemGroups, "showtrue")
    },
    on: {
      "__c": function($event) {
        _vm.showProductItemGroups = "showtrue"
      }
    }
  }), _vm._v(" "), _vm._v("\r\n                                               Add new Items to "), _c('span', [_vm._v(_vm._s(_vm.product.product_groups_set_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showProductItemGroups),
      expression: "showProductItemGroups"
    }],
    staticStyle: {
      "height": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "showfalse"
    },
    domProps: {
      "checked": _vm._q(_vm.showProductItemGroups, "showfalse")
    },
    on: {
      "__c": function($event) {
        _vm.showProductItemGroups = "showfalse"
      }
    }
  }), _vm._v("\r\n                                                   Or Add new " + _vm._s(_vm.product.product_groups_set_name) + "\r\n                                           ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.showProductItemGroups == 'showtrue') ? _c('div', [((_vm.product.product_item_groups.length && _vm.product.product_item_groups.length > 0)) ? _c('div', {
    staticClass: "row col-md-12",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._l((_vm.product.product_item_groups), function(pg, pgdex) {
    return _c('div', {
      key: pgdex,
      staticClass: "col-xs-2"
    }, [_c('div', {
      staticStyle: {
        "padding": "5px",
        "margin-bottom": "5px",
        "width": "10%"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": pg.product_item_group_name
      },
      on: {
        "click": function($event) {
          _vm.setInnerComponent('set-product-item-group', pg.product_item_group_id)
        }
      }
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', [_c('div', {
      staticClass: "box-color-cube"
    }, [_c('img', {
      staticClass: "product-item-group sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image,
        "id": pg.product_item_group_id + 'PRTGR'
      }
    })])]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "product-item-group",
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    }, [_c('div', {
      staticClass: "box-color-cube",
      staticStyle: {
        "height": "3em",
        "width": "85%"
      },
      style: ({
        background: pg.product_item_group_color
      })
    })])]) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-weight": "bold",
        "font-size": "12px",
        "line-height": "1.2"
      }
    }, [_vm._v("Add to " + _vm._s(pg.product_item_group_name) + " ")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showProductItemGroups == 'showfalse') ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name of new " + _vm._s(_vm.product.product_groups_set_name) + "\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_group_name),
      expression: "product.product_item_group_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_item_group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_group_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {}, [_c('label', [_vm._v(" Pick Colour or Pick from uploaded Images to match the colour you are adding")])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(" Pick Colour\r\n                                                       "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_group_color),
      expression: "product.product_item_group_color"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "4em"
    },
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.product.product_item_group_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_group_color = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "border": "1px dashed #eeccee",
      "padding": "1em"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(" Or Pick Media")]), _vm._v(" "), _c('div', {
    staticClass: "row img-row"
  }, _vm._l((_vm.product.product_images), function(img, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-1",
      staticStyle: {
        "height": "50px",
        "width": "70px"
      },
      attrs: {
        "id": "groupImage"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setInnerComponent('set-product-item-group-image', img.product_image_id)
        }
      }
    }, [_c('img', {
      staticClass: "product-item-group-image sp-prd-img",
      attrs: {
        "id": img.product_image_id + 'PRTG',
        "src": img.product_image,
        "alt": ""
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "z-index": "9"
    }
  }, [_c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v(_vm._s(_vm.max_media_info))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    staticStyle: {
      "line-height": "0.4",
      "font-size": "14px"
    }
  }, [_vm._v("Or Add new Image or Video ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "video/*,image/*",
      "capture": ""
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeProductItems($event, 'products', _vm.product.product_id)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_media_error_message))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('br')]), _vm._v(" "), ((_vm.showProductItemGroups == 'showtrue') || (_vm.showProductItemGroups == 'showfalse')) ? _c('div', {
    staticClass: "row col-md-12"
  }, [(_vm.product.product_service == 'S') ? _c('div', {
    staticClass: "col-md-4 col-xs-3"
  }, [_c('label', [_vm._v(" Service Tag\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_service_tag),
      expression: "product.product_item_service_tag"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_service_tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_service_tag = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v(" Price\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v(" Weight(KG)\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v(" Quantity\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v("Attributes (eg: Size, Plan, Length etc,)\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_size),
      expression: "product.product_item_size"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_size = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticClass: "data-success-message"
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "background": "#e7e8e9"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProductItem
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('h6', [_vm._v("DISCOUNTS AND COUPONS")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.product_details.setProductDiscount || _vm.product_details.setProductItemDiscount) ? _c('div', [_c('div', {
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.product_details.setProductDiscount) ? _c('label', [_vm._v("Set Product Coupon Or Discount")]) : _vm._e(), _vm._v(" "), (_vm.product_details.setProductItemDiscount) ? _c('label', [_vm._v("Set Product Item Coupon Or Discount")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.is_discount_coupon),
      expression: "discount_coupon.is_discount_coupon"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.is_discount_coupon = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Discount")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Coupon")])])]), _vm._v(" "), (((_vm.product.product_discounts_active == 1) || (_vm.product_item.product_item_discounts_active == 1))) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have an active Discount")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "line-height": "1.2"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setDiscountsAndCoupons()
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _vm._m(75)]) : _vm._e(), _vm._v(" "), (_vm.product_details.editDiscount) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Edit Discount")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date: " + _vm._s(_vm.discount_coupon.discount_start_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date: " + _vm._s(_vm.discount_coupon.discount_end_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "line-height": "2em"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editDiscountsAndCoupons()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), (!(_vm.product_details.setProductDiscount || _vm.product_details.setProductItemDiscount) && !_vm.product_details.editDiscount) ? _c('div', [_c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('viewProductDiscounts', '', '')
      }
    }
  }, [_vm._v("View Product Discounts and Coupons")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('viewProductItemsDiscounts', '', '')
      }
    }
  }, [_vm._v("View Product Items Discounts and Coupons")])]) : _vm._e(), _vm._v(" "), (_vm.product_details.viewCoupons) ? _c('div', {
    staticStyle: {
      "margin-top": "2em",
      "border": "#e9e6e6 dashed 1px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('h6', {
    staticClass: "pull-left",
    staticStyle: {
      "text-transform": "uppercase",
      "font-size": "14px"
    }
  }, [_vm._v("Item Coupons and Discounts")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm pull-right",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "items-list-tiny",
    staticStyle: {
      "display": "inline"
    }
  }, [(_vm.product_item.product_item_group_is_color_image == 'IMG') ? _c('li', [((_vm.product_item.product_item_group_image && (_vm.product_item.product_item_group_image != 'error'))) ? _c('img', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "src": _vm.product_item.product_item_group_image
    }
  }) : _c('img', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.product_item.product_item_group_is_color_image == 'COL') ? _c('li', [_c('a', {
    staticClass: "btn box-color-cube",
    style: ({
      background: _vm.product_item.product_item_group_color
    })
  })]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P' && (_vm.product_item.product_item_size)) ? _c('li', {
    staticClass: "box-wrap"
  }, [_vm._v(_vm._s(_vm.product_item.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (_vm.product_item.product_item_service_tag)) ? _c('li', {
    staticClass: "box-wrap"
  }, [_vm._v(_vm._s(_vm.product_item.product_item_service_tag))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', [_c('span', [_vm._v("w(kg):")]), _vm._v(_vm._s(_vm.product_item.product_item_weight))]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(_vm.product_item.product_item_actual_price))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Qty:")]), _vm._v(_vm._s(_vm.product_item.product_item_quantity))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]), _vm._v(" "), _vm._l((_vm.product_item.product_item_discounts), function(dc) {
    return _c('div', [(dc.discount_type == 5) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "#d1ddf1",
        "text-align": "center"
      }
    }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('editDiscount', '', dc)
        }
      }
    }, [_vm._v("\r\n                                  Edit Discount")]), _vm._v("    \r\n                                "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('deactivateDiscount', _vm.product_item, dc)
        }
      }
    }, [_vm._v("\r\n                                  Deactivate Discount")])]) : _vm._e(), (_vm.action_loading && (_vm.product_item.product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p')]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }), _vm._v(" "), _c('div', [(_vm.product_item.product_item_only_coupon_discount_count == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No set discount or coupon")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductItemDiscount', 'productitem', _vm.product_item)
      }
    }
  }, [_vm._v("Set New Item Discount Or Coupon")])])], 2) : _vm._e(), _vm._v(" "), (_vm.product_details.viewProductItemsDiscounts) ? _c('div', {
    staticStyle: {
      "margin-top": "1em",
      "border": "#0d022b dashed 1px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('h6', {
    staticClass: "pull-left",
    staticStyle: {
      "text-transform": "uppercase",
      "font-size": "14px"
    }
  }, [_vm._v("Items in this Product")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm pull-right",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._l((_vm.product.product_items), function(productItem) {
    return _c('div', {
      staticStyle: {
        "border": "dashed #d1ddf1",
        "padding": "5px",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "items-list-tiny",
      staticStyle: {
        "display": "inline"
      }
    }, [(productItem.product_item_group_is_color_image == 'IMG') ? _c('li', [((productItem.product_item_group_image && (productItem.product_item_group_image != 'error'))) ? _c('img', {
      staticStyle: {
        "height": "30px"
      },
      attrs: {
        "src": productItem.product_item_group_image
      }
    }) : _c('img', {
      staticStyle: {
        "height": "30px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (productItem.product_item_group_is_color_image == 'COL') ? _c('li', [_c('a', {
      staticClass: "btn box-color-cube",
      style: ({
        background: productItem.product_item_group_color
      })
    })]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P' && (productItem.product_item_size)) ? _c('li', {
      staticClass: "box-wrap"
    }, [_vm._v(_vm._s(productItem.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (productItem.product_item_service_tag)) ? _c('li', {
      staticClass: "box-wrap"
    }, [_vm._v(_vm._s(productItem.product_item_service_tag))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', [_c('span', [_vm._v("w(kg):")]), _vm._v(_vm._s(productItem.product_item_weight))]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(productItem.product_item_actual_price))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Qty:")]), _vm._v(_vm._s(productItem.product_item_quantity))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (_vm.product_details.viewCoupons && (productItem.product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
      staticStyle: {
        "display": "none"
      }
    }, [_c('div', [_c('button', {
      staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
      staticStyle: {
        "line-height": "1.2"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
      staticStyle: {
        "line-height": "1.2"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('setProductItemDiscount', 'productitem', productItem)
        }
      }
    }, [_vm._v("Set New Item Discount Or Coupon")])]), _vm._v(" "), _vm._l((productItem.product_item_discounts), function(dc) {
      return _c('div', [_c('div', [((dc.discount_type == 5)) ? _c('p', [_c('b', [_vm._v("Product Item Discount")])]) : _vm._e(), _vm._v(" "), ((dc.discount_type == 4)) ? _c('p', [_c('b', [_vm._v("General Product Discount")])]) : _vm._e(), _vm._v(" "), (!(dc.discount_type == 4) && !(dc.discount_type == 5)) ? _c('p', [_c('b', [_vm._v("General Sellpoint Discount")])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticStyle: {
          "background": "#d1ddf1",
          "text-align": "center"
        }
      }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
        staticStyle: {
          "cursor": "pointer",
          "text-decoration": "underline",
          "font-size": "13px",
          "color": "#448aff"
        },
        attrs: {
          "title": "Edit"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('editDiscount', '', dc)
          }
        }
      }, [_vm._v("\r\n                                    Edit Discount")]), _vm._v("    \r\n                                  "), _c('a', {
        staticStyle: {
          "cursor": "pointer",
          "text-decoration": "underline",
          "font-size": "13px",
          "color": "#448aff"
        },
        attrs: {
          "title": "De-Activate"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('deactivateDiscount', productItem, dc)
          }
        }
      }, [_vm._v("\r\n                                    Deactivate Discount")])]) : _vm._e(), (_vm.action_loading && (productItem.product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e(), _vm._v(" "), _c('p')]) : _c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Edit/Deactivate at Business Settings")]), _vm._v(" "), _c('hr')])])
    }), _vm._v(" "), _c('div', [(productItem.product_item_discounts && _vm.product_item.product_item_discounts.length == 0) ? _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("No set discount or coupon")]) : _vm._e()])], 2) : _c('button', {
      staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
      staticStyle: {
        "line-height": "2em"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('viewCoupons', 'productitem', productItem)
        }
      }
    }, [_vm._v("View Coupons and Discounts")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.product_details.viewProductDiscounts) ? _c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [(_vm.product.product_items[0]) ? _c('div', [_c('div', {
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('h6', {
    staticClass: "pull-left",
    staticStyle: {
      "text-transform": "uppercase",
      "font-size": "14px"
    }
  }, [_vm._v("Product Coupons and Discounts")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm pull-right",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._l((_vm.product.product_items[0].product_item_discounts), function(dc) {
    return _c('div', [((dc.discount_type == 4)) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "#d1ddf1",
        "text-align": "center"
      }
    }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('editDiscount', '', dc)
        }
      }
    }, [_vm._v("\r\n                                    Edit Discount")]), _vm._v("    \r\n                                  "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('deactivateDiscount', _vm.product.product_items[0], dc)
        }
      }
    }, [_vm._v("\r\n                                    Deactivate Discount")])]) : _vm._e(), (_vm.action_loading && (_vm.product.product_items[0].product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p')]) : _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Edit/Deactivate at Business Settings")]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }), _vm._v(" "), (_vm.product.product_only_coupon_discount_count == 0) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No set discount or coupon")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductDiscount', '', '')
      }
    }
  }, [_vm._v("Set New Product Discount Or Coupon")])]) : _vm._e()]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('div', [_c('h6', [_vm._v("DELIVERY & RETURNS INFORMATION")]), _vm._v(" "), (_vm.product_details.edit_product_delivery) ? _c('div', {}, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_delivery_returns),
      expression: "product.product_delivery_returns"
    }],
    domProps: {
      "value": (_vm.product.product_delivery_returns)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_delivery_returns = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setProductDelivery()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("submit")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" cancel")])])]) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000",
      "line-height": "1.2",
      "font-size": "13px"
    }
  }, [_vm._v("Set delivery and returns information for this product, Note that this is different from setting delivery places\r\n                      "), (_vm.product.product_delivery_returns) ? _c('span', [_vm._v(_vm._s(_vm.product.product_delivery_returns))]) : _vm._e(), _c('br'), _vm._v(" "), _c('button', {
    staticStyle: {
      "font-size": "13px"
    },
    attrs: {
      "type": "btn sp-button-1",
      "title": "Edit"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('edit_product_delivery', '', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Set Delivery & Return Information")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {}, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set How Product Shipping Fee would affect Buyers Checkout Ordering")]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_set_shipping_fee_status),
      expression: "product_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "12",
      "value": "12"
    },
    domProps: {
      "checked": _vm._q(_vm.product_set_shipping_fee_status, "12")
    },
    on: {
      "click": function($event) {
        _vm.setProductShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.product_set_shipping_fee_status = "12"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Charge Product Delivery Fee only once on all Quantity of Product Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_set_shipping_fee_status),
      expression: "product_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "13",
      "value": "13"
    },
    domProps: {
      "checked": _vm._q(_vm.product_set_shipping_fee_status, "13")
    },
    on: {
      "click": function($event) {
        _vm.setProductShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.product_set_shipping_fee_status = "13"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Charge Product Delivery Fee on each Quantity of Product Ordered")])])]), _vm._v(" "), (_vm.set_shipping_fee_status_track && _vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('br'), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('h6', [_vm._v("Product Delivery Location Fees")]), _vm._v(" "), ((_vm.product.product_business_delivery_options) && (_vm.product.product_business_delivery_options.length != 0)) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have set some general delivery settings")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v("You can set a different delivery fee for this product")]), _vm._v(" "), _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" "), (delivery.business_products_delivery_fees.length > 0) ? _c('span', _vm._l((delivery.business_products_delivery_fees), function(fee, fdex) {
      return _c('span', [((fee.product_delivery_product == _vm.product.product_id)) ? _c('span', [_vm._v(" -  ₦" + _vm._s(fee.product_delivery_fee) + "\r\n                            ")]) : _vm._e()])
    })) : _c('span'), _vm._v(" "), (_vm.product_details.setProductDeliveryInformation && delivery.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery.product_delivery_fee),
        expression: "delivery.product_delivery_fee"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (delivery.product_delivery_fee)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery.product_delivery_fee = $event.target.value
        }
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Business Set Shipping Fee: ₦" + _vm._s(delivery.business_delivery_option_price))])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.product_details.setProductDeliveryInformation && _vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.setProductDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "font-size": "10px"
      },
      attrs: {
        "type": "btn",
        "title": "Set Product Delivery Fee"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('setProductDeliveryInformation', delivery)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Set Fee")])])
  })], 2) : _c('div', [_c('p', [_vm._v("You have not set your Business Delivery Locations")])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.manageLookbooks) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('h6', {
    staticStyle: {
      "margin-left": "1em",
      "margin-right": "2em"
    }
  }, [_vm._v("Lookbooks (" + _vm._s(_vm.sellpoint.business_total_gallery) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.component_view.viewLookbooks) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._l((_vm.galleria), function(gallery, gndex) {
    return _c('div', {
      staticClass: "col-md-2 col-sm-3 col-xs-3"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponentView('lookbooks', gallery, 'viewLookbook')
        }
      }
    }, [_c('div', {
      staticClass: "info-card info-card-lookbook"
    }, [_c('div', {
      staticClass: "container info-card-body"
    }, [_c('div', {
      staticClass: "info-card-row info-card-lookbook-row"
    }, [_c('div', {}, [(gallery.gallery_posts_group_posts_media.length > 0) ? _c('div', {
      staticClass: "info-card-lookbook-image",
      staticStyle: {
        "margin": "5px"
      }
    }, [(_vm.checkIfVideo(gallery.gallery_posts_group_posts_media[0].gallery_post_media)) ? _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": gallery.gallery_posts_group_posts_media[0].gallery_post_media
      }
    })]) : _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": "0.8"
      }
    }, [_c('p', [_vm._v(_vm._s(gallery.gallery_posts_group_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(gallery.gallery_posts_group_posts.length) + " posts")])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])])])])
  }), _vm._v(" "), (_vm.galleria.length == 0) ? _c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_vm._m(76)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e(), _vm._v(" "), (_vm.component_view.viewLookbook) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('lookbooks', '', 'viewLookbooks')
      }
    }
  }, [_vm._v("<< Back ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('div', [_c('h4', [_vm._v(_vm._s(_vm.lookbook.gallery_posts_group_name))]), _vm._v(" "), (_vm.lookbook.gallery_posts_group_type == 1) ? _c('p', [_vm._v("Type: Posts Lookbook")]) : _vm._e(), _vm._v(" "), (_vm.lookbook.gallery_posts_group_type == 2) ? _c('p', [_vm._v("Type: Product Lookbook")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Description: " + _vm._s(_vm.lookbook.gallery_posts_group_text))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', [_c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('editLookbook', 'lookbook', _vm.lookbook)
      }
    }
  }, [_vm._v("Edit Lookbook ")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('deleteLookbook', 'lookbook', _vm.lookbook)
      }
    }
  }, [_vm._v("Delete ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), (_vm.lookbook_details.editLookbook) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('h6', [_vm._v("Edit Post")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" Lookbook Name\r\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lookbook.gallery_posts_group_name),
      expression: "lookbook.gallery_posts_group_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.lookbook.gallery_posts_group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lookbook.gallery_posts_group_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" Details\r\n                            "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lookbook.gallery_posts_group_text),
      expression: "lookbook.gallery_posts_group_text"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.lookbook.gallery_posts_group_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lookbook.gallery_posts_group_text = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editLookbook
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.lookbook_details.deleteLookbook) ? _c('div', {
    staticClass: "row col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to delete this Lookbook?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs sp-button-1 sp-button-sm",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.deleteLookbook
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e(), _vm._v(" "), _c('hr')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-xs-12"
  }, [_c('div', {
    staticClass: "row product-detail-card"
  }, [_c('h5', {
    staticClass: "col-md-12"
  }, [_vm._v("Posts in Lookbook")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.lookbook.gallery_posts_group_posts), function(post, pndex) {
    return _c('div', {
      staticClass: "col-md-4 col-xs-4"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponentView('lookbooks', post, 'viewLookbookPost')
        }
      }
    }, [_c('div', {
      staticClass: "info-card info-card-lookbook"
    }, [_c('div', {
      staticClass: "container info-card-body"
    }, [_c('div', {
      staticClass: "info-card-row info-card-lookbook-row"
    }, [_c('div', {}, [(post.gallery_post_media && (post.gallery_post_media.length > 0)) ? _c('div', {
      staticClass: "info-card-lookbook-image",
      staticStyle: {
        "margin": "5px"
      }
    }, [(_vm.checkIfVideo(post.gallery_post_media[0].gallery_post_media)) ? _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": post.gallery_post_media[0].gallery_post_media
      }
    })]) : _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": "0.8"
      }
    }, [_c('p', [_vm._v(_vm._s(post.gallery_post_caption))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])])])])
  }), _vm._v(" "), (_vm.lookbook.gallery_posts_group_posts.length == 0) ? _c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_vm._m(77)]) : _vm._e()], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.component_view.viewLookbookPost) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('lookbooks', _vm.lookbook, 'viewLookbook')
      }
    }
  }, [_vm._v("<< Back ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.lookbook.gallery_posts_group_type == 1) ? _c('div', [_c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('editLookbookPost', 'postlookbook', _vm.lookbook_post)
      }
    }
  }, [_vm._v("Edit Post ")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('deleteLookbookPost', 'postlookbook', _vm.lookbook_post)
      }
    }
  }, [_vm._v("Delete Post ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.lookbook.gallery_posts_group_type == 2) ? _c('div', [_c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('viewProductLookbookPost', 'productlookbook', _vm.lookbook_post)
      }
    }
  }, [_vm._v("Edit Product Post")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('deleteLookbookPost', 'postlookbook', _vm.lookbook_post)
      }
    }
  }, [_vm._v("Delete Product Post ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.lookbook_post.gallery_post_caption))]), _vm._v(" "), _c('p', [_vm._v("Description: " + _vm._s(_vm.lookbook_post.gallery_post_details))]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.lookbook_details.editLookbookPost) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('h6', [_vm._v("Edit Post")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" *Post Caption\r\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lookbook_post.gallery_post_caption),
      expression: "lookbook_post.gallery_post_caption"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.lookbook_post.gallery_post_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lookbook_post.gallery_post_caption = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" *Post Details\r\n                            "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lookbook_post.gallery_post_details),
      expression: "lookbook_post.gallery_post_details"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.lookbook_post.gallery_post_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lookbook_post.gallery_post_details = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editLookbookPost
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.lookbook_details.deleteLookbookPost) ? _c('div', {
    staticClass: "row col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to delete this Post?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs sp-button-1 sp-button-sm",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.deleteLookbookPost
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("Post Images")]), _vm._v(" "), ((_vm.lookbook_post.gallery_post_media) && (_vm.lookbook_post.gallery_post_media.length > 0)) ? _c('div', {
    staticClass: "row img-row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._l((_vm.lookbook_post.gallery_post_media), function(pm) {
    return _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding": "0",
        "border": "#eeccee 1px solid"
      }
    }, [_c('div', {
      staticClass: "img-row"
    }, [(_vm.lookbook_post.gallery_post_media && (_vm.lookbook_post.gallery_post_media.length > 0)) ? _c('div', {
      staticClass: "img-column",
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('div', {
      staticClass: "col-xs-8",
      staticStyle: {
        "z-index": "1"
      }
    }, [(_vm.checkIfVideo(pm.gallery_post_media)) ? _c('div', [_c('img', {
      staticClass: "sp-prd-img",
      staticStyle: {
        "z-index": "1",
        "height": "50px",
        "width": "80px"
      },
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    })]) : _c('div', [((pm.gallery_post_media && (pm.gallery_post_media != 'error'))) ? _c('img', {
      staticClass: "img-1 sp-prd-img",
      staticStyle: {
        "z-index": "1",
        "height": "50px",
        "width": "80px"
      },
      attrs: {
        "src": pm.gallery_post_media
      }
    }) : _c('img', {
      staticStyle: {
        "z-index": "1",
        "height": "50px",
        "width": "80px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (_vm.lookbook.gallery_posts_group_type == 1) ? _c('a', {
      staticClass: "col-xs-2 btn pull-right",
      staticStyle: {
        "z-index": "9",
        "margin-top": "4em",
        "font-size": "10px",
        "padding": "6px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deletePostImage(pm.gallery_post_media_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()]) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "upload-btn",
    staticStyle: {
      "line-height": "0.6",
      "font-size": "12px"
    }
  }, [_vm._v("Add new Media")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*,video/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeLookbook($event, 'gallery_media', _vm.lookbook_post.gallery_post_id)
      }
    }
  })]), _vm._v(" "), _c('hr')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "row product-detail-card"
  }, [_c('h5', {
    staticClass: "col-md-12"
  }, [_vm._v("Other Posts in \r\n                  "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('lookbooks', _vm.lookbook, 'viewLookbook')
      }
    }
  }, [_c('u', [_vm._v(_vm._s(_vm.lookbook.gallery_posts_group_name))])]), _vm._v(" Lookbook")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.lookbook.gallery_posts_group_posts), function(post, pndex) {
    return _c('div', {
      staticClass: "col-md-6 col-xs-6"
    }, [(post.gallery_post_id != _vm.lookbook_post.gallery_post_id) ? _c('div', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponentView('lookbooks', post, 'viewLookbookPost')
        }
      }
    }, [_c('div', {
      staticClass: "info-card info-card-lookbook"
    }, [_c('div', {
      staticClass: "container info-card-body"
    }, [_c('div', {
      staticClass: "info-card-row info-card-lookbook-row"
    }, [_c('div', {}, [(post.gallery_post_media && (post.gallery_post_media.length > 0)) ? _c('div', {
      staticClass: "info-card-lookbook-image",
      staticStyle: {
        "margin": "5px"
      }
    }, [(_vm.checkIfVideo(post.gallery_post_media[0].gallery_post_media)) ? _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": post.gallery_post_media[0].gallery_post_media
      }
    })]) : _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": "0.8"
      }
    }, [_c('p', [_vm._v(_vm._s(post.gallery_post_caption))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])])])]) : _vm._e()])
  }), _vm._v(" "), (_vm.lookbook.gallery_posts_group_posts && (_vm.lookbook.gallery_posts_group_posts.length == 0)) ? _c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_vm._m(78)]) : _vm._e()], 2)])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.managePosts) ? _c('div', {
    staticClass: "container"
  }) : _vm._e(), _vm._v(" "), (_vm.manageOrders) ? _c('div', {
    staticClass: "container"
  }) : _vm._e()])]) : _vm._e()])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticStyle: {
      "float": "right",
      "color": "#000000",
      "font-size": "24px",
      "cursor": "pointer",
      "padding-top": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "src": "/static/assets/images/dummy-image.png",
      "width": "50",
      "height": "50"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Orders")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("your orders from stores")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Sellpoints")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("your Businesses sellpoints")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Buypoints")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("your Buying Interests and settings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Sidehustle")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("your Agent/Sidehhustle Businesses")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Settings")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("limits, accounts, orders, payments")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-cloud"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Storage")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("your cloud storage")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-question"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Knowledge Center")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Help, FAQs, terms, privacy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-users"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Invite a Friend")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-thumb-up-left"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-arm-alt-bottom"
  }, [_c('div', {
    staticClass: "card-analytics"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-tag"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-users"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-certificate"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Product Name"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Price"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(You can always add more images or video on this post)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-arm-alt-bottom"
  }, [_c('div', {
    staticClass: "card-analytics"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-tag"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-arm-alt-bottom"
  }, [_c('div', {
    staticClass: "card-analytics"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-tag"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Business Profile")]), _vm._v(" "), _c('p', [_vm._v("Name, About, description, etc")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Shipping / Delivery Information")]), _vm._v(" "), _c('p', [_vm._v("How you settle shipping and delivery ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Shipping / Delivery Locations")]), _vm._v(" "), _c('p', [_vm._v("Your Shipping Locations")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Discounts, Vouchers, Coupons")]), _vm._v(" "), _c('p', [_vm._v("General Business discount settings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Payments")]), _vm._v(" "), _c('p', [_vm._v("Money, Banks, Settings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Commissions")]), _vm._v(" "), _c('p', [_vm._v("General Business Commissions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Delete Business")]), _vm._v(" "), _c('p', [_vm._v("Request Business Information to be deleted")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Product Details ")]), _vm._v(" "), _c('p', [_vm._v("Product Name, Description, Prices ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Product Types / Variations ")]), _vm._v(" "), _c('p', [_vm._v("Different types and variations")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Discounts and Coupons")]), _vm._v(" "), _c('p', [_vm._v("Specific Product Discounts and Coupons")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Delivery and Return Information")]), _vm._v(" "), _c('p', [_vm._v("Shipping and Delivery Return Information and Policies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Shipping / delivery Information")]), _vm._v(" "), _c('p', [_vm._v("Specific Product Delivey Fees and Locations")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Business Settings")]), _vm._v(" - Business Details")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Business Settings")]), _vm._v(" - Business Shipping Information ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h6', [_vm._v("Your Sellpoint's Delivery Information")]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("This is the general shipping Information that would be shown to buyers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticStyle: {
      "color": "#363535",
      "font-size": "14px"
    }
  }, [_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                            If you want to end an existing discount click on \"Stop Discount\" button near the\r\n                            button.\r\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Business Settings")]), _vm._v(" - Payment Information")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Bank Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Processing Fees")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("To keep receiving Buyers Order transfers "), _c('b', [_vm._v("*directly*")]), _vm._v(" to your Bank Account, please ensure your Processing Fee\r\n                    is not zero or below")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Status:")]), _vm._v(" Paid by Me ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Status:")]), _vm._v(" Paid by My Customers")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Set your Payment Collection Gateway")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://ravepay.co",
      "target": "_blank"
    }
  }, [_vm._v("Checkout Ravepay")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('p', [_vm._v("Paystack  - Direct Personal Integration")]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("You would be directed to Paystack Website to create and set up your account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('p', [_vm._v("AfiaApp Pay Settlements")]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Your Payments would be transferred to your Bank Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('p', [_vm._v("Paypal  - Direct Personal Integration")]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("You would be directed to Paypal Website to create and set up your account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('p', [_vm._v("Suggest Another ?")]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Do you have another Platform you would like to use and collect your Payments")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Business Settings")]), _vm._v(" - Commissions")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Agent Commission")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Set a general Agent Commission for your Business "), _c('br'), _vm._v("you can still set different commisions for any product and product items")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Processing Fees")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("To keep receiving Buyers Order transfers "), _c('b', [_vm._v("*directly*")]), _vm._v(" to your Bank Account, please ensure your Processing Fee\r\n                    is not zero or below")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Status:")]), _vm._v(" Paid by Me ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Status:")]), _vm._v(" Paid by My Customers")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Product Settings")]), _vm._v(" - Product Details")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Product Settings")]), _vm._v(" - Product Items and Variations")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Select a Group from below:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Product Settings")]), _vm._v(" - Discounts And CouponsS")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#363535",
      "line-height": "1.2"
    }
  }, [_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                        If you want to end an existing discount click on \"Stop Discount\" button on the Discount.\r\n                      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Product Settings")]), _vm._v(" - Delivery & Returns Information")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Product Settings")]), _vm._v(" - Product Delivery Location Fees")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card info-card-mini"
  }, [_c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "info-card-row info-card-mini-row"
  }, [_c('p', [_vm._v("View and Update Business Details")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card info-card-mini"
  }, [_c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "info-card-row info-card-mini-row"
  }, [_c('p', [_vm._v("Set Business Delivery and Shipping Information")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card info-card-mini"
  }, [_c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "info-card-row info-card-mini-row"
  }, [_c('p', [_vm._v("Set Business Coupons and Vouchers")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card info-card-mini"
  }, [_c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "info-card-row info-card-mini-row"
  }, [_c('p', [_vm._v("Connect to your Business Payment Receival Portal")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h6', [_vm._v("Your Sellpoint's Delivery Information")]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("This is the general shipping Information that would be shown to buyers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticStyle: {
      "color": "#363535",
      "font-size": "14px"
    }
  }, [_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                                If you want to end an existing discount click on \"Stop Discount\" button near the\r\n                                button.\r\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#363535",
      "line-height": "1.2"
    }
  }, [_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                          If you want to end an existing discount click on \"Stop Discount\" button on the Discount.\r\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Your Gallery is empty, click on "), _c('b', [_vm._v("Manage")]), _vm._v(" to add Lookbooks to your gallery")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("This Lookbook is empty, click on "), _c('b', [_vm._v("Manage")]), _vm._v(" to add Posts to your lookbook")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("This Lookbook is empty, click on "), _c('b', [_vm._v("Manage")]), _vm._v(" to add Posts to your lookbook")])
}]}

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.open_request) ? _c('div', {}, [(_vm.loading) ? _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "loading-md"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px",
      "color": "#000000"
    }
  }, [_vm._v("Preparing and Checking your Sellpoint for previously added products and services")])]) : _c('form', {
    staticClass: "gw-form"
  }, [_c('h6', [_vm._v("Add a New Product Lookbook to your Gallery")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.showGalleryForm) ? _c('div', [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_name),
      expression: "gallery.gallery_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "What's the Name of your Lookbook"
    },
    domProps: {
      "value": (_vm.gallery.gallery_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_description),
      expression: "gallery.gallery_description"
    }],
    attrs: {
      "placeholder": "What's this Lookbook all about"
    },
    domProps: {
      "value": (_vm.gallery.gallery_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_description = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.products.length > 0) ? _c('div', [_c('h6', {
    staticStyle: {
      "font-size": "16px",
      "margin-bottom": "1em"
    }
  }, [_vm._v("Do you want to add from your products?")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n                        " + _vm._s(this.selected_produts) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "row sp-products-row"
  }, _vm._l((_vm.products), function(p, pdex) {
    return _c('div', {
      key: pdex,
      staticClass: "col-xs-4",
      staticStyle: {
        "padding": "5px",
        "margin": "1em",
        "width": "10%",
        "height": "6em"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": p.product_name
      },
      on: {
        "click": function($event) {
          _vm.setComponent('add-to-gallery-product', p)
        }
      }
    }, [(p.product_images[0]) ? _c('div', {
      staticClass: "box-color-cube"
    }, [_c('sup', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (p.product_checked),
        expression: "p.product_checked"
      }],
      attrs: {
        "type": "checkbox",
        "id": p.product_id + 'PRDC'
      },
      domProps: {
        "checked": Array.isArray(p.product_checked) ? _vm._i(p.product_checked, null) > -1 : (p.product_checked)
      },
      on: {
        "__c": function($event) {
          var $$a = p.product_checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (p.product_checked = $$a.concat($$v))
            } else {
              $$i > -1 && (p.product_checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            p.product_checked = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('img', {
      staticClass: "product-select sp-prd-img",
      staticStyle: {
        "height": "5em",
        "width": "95%"
      },
      attrs: {
        "src": p.product_images[0].product_image,
        "id": p.product_id + 'PRD'
      }
    })]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "9px",
        "line-height": "1.2"
      }
    }, [_c('b', [_vm._v(_vm._s(p.product_name))])])])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', [_c('hr'), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ffcc00"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('show-add-product-form', '')
      }
    }
  }, [_c('b', [(_vm.products.length > 0) ? _c('span', [_vm._v(" Or ")]) : _vm._e(), _vm._v(" Add New Product / Service")])])]), _vm._v(" "), (_vm.showProductForm) ? _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('h6', [_vm._v("Add Product / Service")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn",
    staticStyle: {
      "background": "#cc6655",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('form', {
    staticClass: "gw-form",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_vm._v("Product")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.is_product_service),
      expression: "is_product_service"
    }],
    staticClass: "sp-radio-btn",
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "type": "radio",
      "value": "product"
    },
    domProps: {
      "checked": _vm._q(_vm.is_product_service, "product")
    },
    on: {
      "__c": function($event) {
        _vm.is_product_service = "product"
      }
    }
  }), _vm._v("\n                                           \n                                     "), _c('label', [_vm._v(" Service ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.is_product_service),
      expression: "is_product_service"
    }],
    staticClass: "sp-radio-btn",
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "type": "radio",
      "value": "service"
    },
    domProps: {
      "checked": _vm._q(_vm.is_product_service, "service")
    },
    on: {
      "__c": function($event) {
        _vm.is_product_service = "service"
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sp-form-descr"
  }, [_vm._v("is this a Product or Service?")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "Name of Product / Service"
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.sellpoint_categories.length > 0) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "category-type-1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-1')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_1
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      key: category.business_category_id,
      attrs: {
        "disabled": _vm.category_type_1
      },
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [(_vm.sellpoint_categories.length > 0) ? _c('span', [_c('b', [_vm._v("Or ")])]) : _vm._e(), _vm._v(" Select from Related Categories ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main_category),
      expression: "main_category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.main_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getSubCategories(_vm.main_category)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      key: category.category_id,
      domProps: {
        "value": category
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.sub_categories.length != 0) ? _c('label', [_vm._v(" Select a Category ")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_sub_category),
      expression: "product.product_sub_category"
    }],
    staticClass: "form-control category-type-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_sub_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_2
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(category) {
    return _c('option', {
      key: category.sub_category_id,
      attrs: {
        "disabled": _vm.category_type_2
      },
      domProps: {
        "value": category.sub_category_id
      }
    }, [_vm._v(_vm._s(category.sub_category_name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_listed_category),
      expression: "product.product_listed_category"
    }],
    attrs: {
      "disabled": _vm.category_type_3,
      "type": "text",
      "placeholder": "",
      "id": "category-type-3"
    },
    domProps: {
      "value": (_vm.product.product_listed_category)
    },
    on: {
      "change": function($event) {
        _vm.trackevent('category-type-3')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_listed_category = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    attrs: {
      "placeholder": "Provide details of your product/service"
    },
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.is_product_service == 'product') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Weight(Kg)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Quantity ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.is_product_service))]), _vm._v(" Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ee87a6"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message)), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ffcc00"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "pull-left btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("Add Product")]), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn",
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.canAddGallery) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ee87a6"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.addProductPost) ? _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProductPostGallery
    }
  }, [_vm._v("Add Post to Lookbook")]) : _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addGallery
    }
  }, [_vm._v("Add Lookbook")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]) : _vm._e()])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(your product lookbook is a collection or group of products you want to keep together as posts)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Product lookbook Name "), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("Select from your Products/Services to add to Lookbook")]), _vm._v(" (scroll to view all products)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(This would also be added to products in your sellpoint)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Name"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v(" Select from My Shop Categories"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v("Or ")]), _vm._v(" Enter a specific Category")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Price"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(You can always add more images or video on this post)")])])
}]}

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('header', {
    staticClass: "site-header header-one home-page-one",
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-lg navbar-light header-navigation stricky"
  }, [_c('div', {
    staticClass: "container clearfix"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "header-name"
  }, [_vm._v(_vm._s(_vm.sellpoint.business_name))])]), _vm._v(" "), (_vm.loggedIn) ? _c('div', {
    staticClass: "right-side-box"
  }, [(_vm.edit_mode) ? _c('a', {
    staticClass: "header-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('open')
      }
    }
  }, [_vm._v("Manage")]) : _c('a', {
    staticClass: "header-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('open')
      }
    }
  }, [_vm._v("Connect")])]) : _c('div', {
    staticClass: "right-side-box"
  }, [_c('a', {
    staticClass: "header-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('open')
      }
    }
  }, [_vm._v("Connect")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-wrapper"
  }, [(_vm.sellpoint.business_banner_image != _vm.default_banner_image) ? _c('section', {
    staticClass: "banner-style-one home-page-two",
    staticStyle: {
      "margin-top": "-2em",
      "height": "100vh"
    },
    style: ({
      backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.78), rgba(0, 0, 0, 0.48)), url(' + _vm.img_sellpoint_url + _vm.sellpoint.business_banner_image + ')'
    }),
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "container gw-container"
  }, [(_vm.business_load_error_msg != '') ? _c('div', {
    staticClass: "row content-block"
  }, [_c('p', {
    staticStyle: {
      "color": "#ffc107",
      "margin": "1em"
    }
  }, [_vm._v(_vm._s(_vm.business_load_error_msg))])]) : _c('div', {
    staticClass: "row content-block"
  }, [_c('div', {
    staticClass: "col-sm-6 gw-large"
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "margin-top": "8em"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 gw-lookbook"
  }, [(_vm.edit_mode) ? _c('button', {
    staticClass: "btn btn-xs pull-right",
    staticStyle: {
      "background": "#f8ecf0",
      "color": "#161515",
      "margin-bottom": "1em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('refresh-store', '')
      }
    }
  }, [_vm._v("Refresh Lookbook")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "addPanelView"
    }
  }, [(_vm.addPanel) ? _c('div', [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff",
      "margin-bottom": "1em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.newLookbookForm) ? _c('div', [_c('add-lookbook')], 1) : _vm._e(), _vm._v(" "), (_vm.newProductLookbookForm) ? _c('div', [_c('add-product-lookbook')], 1) : _vm._e(), _vm._v(" "), (_vm.addNewPost) ? _c('div', {}, [_c('h6', [_vm._v("New Gallery Post")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Caption")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_caption),
      expression: "post.post_caption"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.post.post_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_caption = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_details),
      expression: "post.post_details"
    }],
    domProps: {
      "value": (_vm.post.post_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_details = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#e4abbe"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addPostToGallery
    }
  }, [_vm._v("Add")])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.loading) ? _c('div', [_vm._m(3)]) : _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "60vh",
      "overflow": "scroll"
    }
  }, _vm._l((_vm.galleria), function(gallery, gndex) {
    return _c('div', {
      staticClass: "folder-main col-6 col-md-4"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getPostsInGallery(gallery)
        }
      }
    }, [_c('div', {
      staticClass: "folder-inner"
    }, [(gallery.gallery_posts_group_posts_media.length > 0) ? _c('div', {
      staticClass: "folder-inner-image"
    }, [(_vm.checkIfVideo(gallery.gallery_posts_group_posts_media[0].gallery_post_media)) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": gallery.gallery_posts_group_posts_media[0].gallery_post_media
      }
    })]) : _c('div', {
      staticClass: "folder-inner-image"
    }, [_c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "folder-inner-words"
    }, [_c('h5', [_c('a', {
      on: {
        "click": function($event) {
          _vm.getPostsInGallery(gallery)
        }
      }
    }, [_vm._v(_vm._s(gallery.gallery_posts_group_name))])])])])])])
  })), _vm._v(" "), (_vm.edit_mode && _vm.can_add_more_lookbook) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "folder-main col-6 col-md-4"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-lookbook', '')
      }
    }
  }, [_vm._m(4)])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode && _vm.can_add_product_lookbook) ? _c('div', {
    staticClass: "folder-main col-6 col-md-4"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-product-lookbook', '')
      }
    }
  }, [_vm._m(5)])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _vm._m(6)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sidenav",
    attrs: {
      "id": "mobileSideNav"
    }
  }, [_c('a', {
    staticClass: "closebtn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('close')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "container sidenav-links"
  }, [_c('ul', [_vm._m(7), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "account"
    }
  }, [_vm._v("My Account")])]) : _c('li', [_c('a', {
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Login")])]), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.manageLookbook
    }
  }, [_vm._v("Go to Sellpoint")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "container sidenav-container"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "2em"
    }
  }, [(_vm.addPanel) ? _c('div', {
    attrs: {
      "id": "addPanelView"
    }
  }, [(_vm.addPanel) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "float": "right",
      "background": "#ff0055",
      "color": "#ffffff",
      "margin-bottom": "1em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.newLookbookForm) ? _c('div', [_c('add-lookbook')], 1) : _vm._e(), _vm._v(" "), (_vm.newProductLookbookForm) ? _c('div', [_c('add-product-lookbook')], 1) : _vm._e(), _vm._v(" "), (_vm.addNewPost) ? _c('div', {}, [_c('h6', [_vm._v("Add a new Post to "), _c('b', [_vm._v(_vm._s(_vm.gallery.gallery_posts_group_name))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Caption")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_caption),
      expression: "post.post_caption"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.post.post_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_caption = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_details),
      expression: "post.post_details"
    }],
    domProps: {
      "value": (_vm.post.post_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_details = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#e4abbe"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addPostToGallery
    }
  }, [_vm._v("Add")])])])]) : _vm._e()]) : _vm._e()]) : _c('div', [_c('div', {
    staticStyle: {
      "margin-right": "2em"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('div', {
    staticClass: "sidenav-banner-img"
  }, [_c('img', {
    staticClass: "sp-prd-img",
    attrs: {
      "src": _vm.sellpoint.business_banner_image
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (!_vm.edit_mode) ? _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('h5', [_vm._v("Contact Us")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "button-block"
  })]) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {}, [_c('p', [_vm._v("Welcome "), _c('b', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(", here you can set up and manage your gallery with any of these actions below")]), _vm._v(" "), (_vm.edit_mode && _vm.can_add_more_lookbook) ? _c('div', {
    staticClass: "row"
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "col-6 col-md-4"
  }, [_c('div', {
    staticClass: "gw-add-btn"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-lookbook', '')
      }
    }
  }, [_c('h5', [_vm._v("Add New Lookbook")])])])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode && _vm.can_add_product_lookbook) ? _c('div', {
    staticClass: "col-6 col-md-4"
  }, [_c('div', {
    staticClass: "gw-add-btn"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-product-lookbook', '')
      }
    }
  }, [_c('h5', [_vm._v("Add Product Lookbook")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [(!(_vm.edit_mode && _vm.can_add_more_lookbook)) ? _c('div', {
    staticClass: "col-md-6 col-sm-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "manage-action-block"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": _vm.manageLookbook
    }
  }, [_c('h5', [_vm._v("You have reached the limit of your gallery")]), _vm._v(" "), _vm._m(9)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "manage-action-block"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": _vm.manageLookbook
    }
  }, [_c('h5', [_vm._v("Manage Your Gallery on Sellpoint")]), _vm._v(" "), _c('p', [_vm._v("Once clicked you would be directed to your Sellpoint account to further set-up your page")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.manageLookbook
    }
  }, [_vm._v("Manage")])])])])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade modal-c p-modal",
    attrs: {
      "id": "quickviewModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [(_vm.place_order) ? _c('div', {
    staticClass: "modal-content"
  }, [_c('button', {
    staticClass: "pul-right close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.resetOptions
    }
  }, [_c('b', [_vm._v("close")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-20 mb-20 mb-xs-0"
  }, [(_vm.payment_successful) ? _c('div', {
    staticClass: "col-xs-12 mb-40"
  }, [_c('h3', {
    staticStyle: {
      "line-height": "1.6"
    }
  }, [_vm._v(_vm._s(this.payment_successful_message))])]) : _c('div', {
    staticClass: "col-xs-12 mb-40"
  }, [_c('h4', [_vm._v("Place Order For "), _c('b', [_vm._v(_vm._s(_vm.ordered_product.product_name) + "(₦" + _vm._s(_vm.ordered_product_item.product_item_price) + ")")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('div', {}, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_name),
      expression: "payment_payer_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.payment_payer_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_email),
      expression: "payment_payer_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.payment_payer_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_phone),
      expression: "payment_payer_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Phone (format: 09088776655)"
    },
    domProps: {
      "value": (_vm.payment_payer_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn pull-left",
    staticStyle: {
      "cursor": "pointer",
      "border-radius": "2px",
      "background": "#ffc107",
      "color": "#000"
    },
    on: {
      "click": function($event) {
        _vm.processPayment()
      }
    }
  }, [_vm._v(" Proceed")])])])])])])]) : _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [(_vm.edit_mode) ? _c('button', {
    staticClass: "btn btn-xs pull-left",
    staticStyle: {
      "background": "#f8ecf0",
      "color": "#161515",
      "margin-bottom": "1em"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.manageLookbook
    }
  }, [_vm._v("ManageLookbook")]) : _vm._e(), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.edit_mode) ? _c('div', [(_vm.gallery.gallery_posts_group_posts_total < _vm.max_plan_lookbook_posts) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0055"
    }
  }, [_vm._v("Add new Post to " + _vm._s(_vm.gallery.gallery_posts_group_name) + ", \r\n                                    "), (((_vm.gallery.gallery_posts_group_type == 2) && _vm.can_add_product_lookbook)) ? _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "background": "#ffc107",
      "padding": "5px"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-product-post', _vm.gallery)
      }
    }
  }, [_vm._v("Add")]) : _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "background": "#ffc107",
      "padding": "5px"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-post', _vm.gallery)
      }
    }
  }, [_vm._v("Add")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-size": "28px"
    }
  }, [_vm._v(_vm._s(_vm.gallery_post.gallery_post_caption) + "\r\n                                                "), (_vm.gallery_post.gallery_post_product_items) ? _c('span', [_vm._v("(₦" + _vm._s(_vm.gallery_post.gallery_post_product_items[0].product_item_price) + ")")]) : _vm._e()]), _vm._v(" "), (_vm.gallery_post_set_image.gallery_post_media != '') ? _c('div', {
    staticClass: "image",
    staticStyle: {
      "height": "250px",
      "width": "100%"
    }
  }, [(_vm.checkIfVideo(_vm.gallery_post_set_image.gallery_post_media)) ? _c('img', {
    staticClass: "rounded",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "object-fit": "contain"
    },
    attrs: {
      "src": "/static/assets/images/video-placeholder.png",
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "rounded",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "object-fit": "contain"
    },
    attrs: {
      "src": _vm.gallery_post_set_image.gallery_post_media,
      "alt": ""
    }
  }), _vm._v(" "), (_vm.gallery_post.gallery_post_media) ? _c('div', {
    staticClass: "image-overlay",
    staticStyle: {
      "top": "80px"
    }
  }, [(_vm.gallery_post.gallery_post_media.length > 1) ? _c('ul', {
    staticClass: "food-menu-list-num"
  }, _vm._l((_vm.gallery_post.gallery_post_media), function(img, imdex) {
    return _c('li', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showPostImage(img)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-circle-o"
    })])])
  })) : _vm._e()]) : _vm._e()]) : _c('div', [_c('img', {
    staticClass: "sp-prd-img",
    attrs: {
      "src": "/static/assets/images/dummy-image.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "top": "200px"
    }
  }, [_c('div', {
    staticClass: "content-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.gallery_post.gallery_post_details))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.gallery.gallery_posts_group_posts) ? _c('div', {
    staticClass: "col-xs-12 mb-40 pull-right"
  }, [(_vm.gallery.gallery_posts_group_posts.length > 1) ? _c('ol', {
    staticClass: "food-menu-list-num"
  }, _vm._l((_vm.gallery.gallery_posts_group_posts), function(post, prdex) {
    return _c('li', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showPost(post)
        }
      }
    }, [_vm._v(_vm._s(++prdex))])])
  })) : _vm._e()]) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logo-sm.png",
      "alt": "Awesome Image"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Capture your moments "), _c('br'), _vm._v(" save and organise and "), _c('br'), _vm._v(" make your work roll out like a gallery.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button-block"
  }, [_c('a', {
    staticClass: "banner-btn",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Contact Us")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "6em"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/loader.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "folder-inner"
  }, [_c('div', {
    staticClass: "folder-inner-image",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h2', {
    staticStyle: {
      "padding": "6px",
      "font-size": "24px",
      "color": "#ff0055"
    }
  }, [_vm._v("Add New Lookbook")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "folder-inner"
  }, [_c('div', {
    staticClass: "folder-inner-image",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h2', {
    staticStyle: {
      "padding": "6px",
      "font-size": "24px",
      "color": "#ff0055"
    }
  }, [_vm._v("Add New Product Lookbook")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gw-mobile",
    staticStyle: {
      "display": "none"
    }
  }, [_c('p', [_vm._v("Capture your moments "), _c('br'), _vm._v(" save and organise and "), _c('br'), _vm._v(" make your work roll out like a gallery.")]), _vm._v(" "), _c('div', {
    staticClass: "button-block"
  }, [_c('a', {
    staticClass: "banner-btn",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Contact Us")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Capture your moments "), _c('br'), _vm._v(" save and organise and "), _c('br'), _vm._v(" make your work roll out like a gallery.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("To add more lookboks to your gallery, "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Upgrade your Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "true",
      "disabled": "disabled"
    }
  }), _vm._v(" By proceeding, you agree with the "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0055",
      "font-weight": "bold"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#terms-modal",
      "href": "#"
    }
  }, [_vm._v("Terms and Conditions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "pull-right close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('b', [_vm._v("close")])])
}]}

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "timeline-cover sp-page-banner"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-contents"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left-sidebar')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('search-box'), _vm._v(" "), (!_vm.search_data != '') ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.search_data != '') ? _c('h4', {
    staticClass: "grey"
  }, [_vm._v("Products found in " + _vm._s(_vm.search_data))]) : _vm._e(), _vm._v(" "), (_vm.products.length == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("no matching products")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "friend-list"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "col-md-4 col-sm-4 col-xs-6"
    }, [((product.product_items.length != 0)) ? _c('div', {
      staticStyle: {
        "min-height": "23em",
        "max-height": "22em"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "inherit",
        "text-decoration": "none"
      },
      attrs: {
        "href": '/' + product.product_business_username + '/' + product.product_url_name
      }
    }, _vm._l((product.product_items), function(product_item, index2) {
      return _c('div', {
        staticClass: "friend-card",
        staticStyle: {
          "min-height": "22em",
          "max-height": "22em",
          "border-bottom-color": "rgb(182, 176, 176)"
        }
      }, [(index2 == 0) ? _c('div', [_c('div', {
        staticStyle: {
          "height": "10em"
        }
      }, [_c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": product_item.product_item_image,
          "alt": "photo"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "card-info"
      }, [_c('div', {
        staticClass: "friend-info"
      }, [_c('a', {
        staticClass: "pull-right text-green",
        staticStyle: {
          "font-size": "12px"
        },
        attrs: {
          "href": "#"
        }
      }, [_vm._v("@" + _vm._s(product.product_business_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', {
        staticStyle: {
          "height": "3em"
        }
      }, [_c('a', {
        staticClass: "profile-link",
        attrs: {
          "href": "#"
        }
      }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('p', [_vm._v("₦" + _vm._s(product_item.product_item_price.toLocaleString('en', {
        useGrouping: true
      })))]), _vm._v(" "), _vm._m(1, true)])])]) : _vm._e()])
    }))]) : _vm._e()])
  }))]), _vm._v(" "), _c('active-products')], 1)])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-md-offset-2 col-sm-12 col-xs-12",
    staticStyle: {
      "padding": "5em"
    }
  }, [_c('div', {
    staticClass: "wn-loader"
  }), _vm._v(" "), _c('p', [_vm._v("loading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('a', {
    staticClass: "btn text-red",
    attrs: {
      "title": "Like"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o",
    staticStyle: {
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn text-red",
    attrs: {
      "title": "Add to Cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart",
    staticStyle: {
      "font-size": "14px"
    }
  })])])
}]}

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-route sp-cart-wrap",
    staticStyle: {
      "width": "98.8%"
    },
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticStyle: {
      "border": "1px dashed #8a8787"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(!_vm.cart.length) ? _c('div', {
    staticClass: "col-md-6 col-md-offset-3 col-sm-12 chart-card",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2)]) : _c('div', {
    staticClass: "col-sm-12 chart-card"
  }, [_c('cart-widget')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 pull-left"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/images/empty-lonely-cart.gif"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', [_vm._v("I'm Lonely and Sad, please "), _c('a', {
    staticStyle: {
      "color": "rgb(252, 16, 75)"
    },
    attrs: {
      "href": "tour"
    }
  }, [_vm._v("fill me up")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 pull-right",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h5', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center"
    }
  }, [_vm._v("Your cart is sad and empty,")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "background": "rgb(252, 16, 75)",
      "color": "#ffffff"
    },
    attrs: {
      "href": "tour"
    }
  }, [_vm._v("Start Buying")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "18px",
      "margin-top": "6px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "rgb(252, 16, 75)"
    },
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Login")]), _vm._v(" to see products you added to your cart")])])
}]}

/***/ }),
/* 266 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('component-menu-bottom')], 1)
},staticRenderFns: []}

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticStyle: {
      "background": "#ffffff",
      "width": "100%",
      "height": "4.5em",
      "top": "0",
      "position": "fixed",
      "z-index": "9999"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #e7e7e7",
      "display": "inline",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "float": "left",
      "padding-left": "8px",
      "color": "#000000",
      "font-size": "32px",
      "font-weight": "500",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin": "5px 1em",
      "color": "#000000"
    }
  }, [_c('span', {
    staticStyle: {
      "text-transform": "uppercase",
      "text-align": "center",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.path))]), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticStyle: {
      "float": "right",
      "color": "#000000",
      "font-size": "24px",
      "cursor": "pointer",
      "padding-top": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v"
  })])
}]}

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "cart-btn button",
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v(" Buy Now")])])
},staticRenderFns: []}

/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gw-info-wrap",
    staticStyle: {
      "background": "#ffffff"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "col-md-6 col-md-offset-4 col-xs-12"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [(_vm.orders.set) ? _c('div', {
    staticClass: "col-sm-12 card",
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('h1', {
    staticClass: "card-title"
  }, [_vm._v("Your Orders")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "orders-panel"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Ordered From")]), _vm._v(" "), _c('th', [_vm._v("Order Total")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _vm._l((_vm.orders), function(order) {
    return _c('tr', [_c('td', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-backdrop": "false",
        "data-target": "#ordersModal"
      },
      on: {
        "click": function($event) {
          _vm.setOrder(order)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#df4d4d"
      }
    }, [_c('u', [_c('b', [_vm._v(_vm._s(order.order_no))])])]), _c('br'), _vm._v("\r\n                        " + _vm._s(order.order_date) + "\r\n                        "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "p-tiny"
    }, [_vm._v("Tap to view")])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.order_business))]), _vm._v(" "), _c('td', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(order.order_total))]), _vm._v(" "), _c('td', [_c('span', {
      style: ({
        color: order.order_payment_status_color
      })
    }, [_vm._v(_vm._s(order.order_payment_status))])])])
  })], 2)])]) : _c('p', [_vm._v("No orders yet")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "ordersModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Order No " + _vm._s(_vm.order.order_no))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_c('b', [_vm._v("Order No: ")]), _vm._v(_vm._s(_vm.order.order_no))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Date: ")]), _vm._v(_vm._s(_vm.order.order_date))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('th', [_vm._v(" ")]), _vm._v(" "), _c('th', [_vm._v("Item")]), _vm._v(" "), _vm._l((_vm.order.order_items), function(item) {
    return _c('tr', [_c('td', [_c('img', {
      attrs: {
        "src": _vm.img_product_url + item.product_item_group_image,
        "height": "50",
        "width": "50"
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.product_name) + " - " + _vm._s(item.order_delivery_city))])])
  })], 2), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Payment Mode: ")]), _c('span', {
    style: ({
      color: _vm.order.order_payment_status_color
    })
  }, [_vm._v(_vm._s(_vm.order.order_payment_status))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Status: ")]), _c('span', {
    style: ({
      color: _vm.order.order_payment_status_color
    })
  }, [_vm._v(_vm._s(_vm.order.order_payment_status))])]), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Delivery Fee Details:  ")]), _vm._v(_vm._s(_vm.order.order_delivery_not_set))])]), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Delivery Location:  ")]), _vm._v(_vm._s(_vm.order.order_delivery_city))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivery Address:  ")]), _vm._v(_vm._s(_vm.order.order_user_delivery_address))])]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Order Items")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])
}]}

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-route",
    attrs: {
      "id": "wrapRoute"
    }
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sp-prd-fixed-menu",
    attrs: {
      "id": "menuHeader"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('ul', {}, [_c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-descr', '')
      }
    }
  }, [_vm._v("DETAILS")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-reviews', '')
      }
    }
  }, [_vm._v("COMMENTS & REVIEWS")])])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10em"
    },
    attrs: {
      "id": "content"
    }
  }, [(_vm.seller_mode) ? _c('div', {
    staticClass: "edit-switch-bar",
    staticStyle: {
      "margin-top": "8em"
    }
  }, [(_vm.seller_mode) ? _c('div', {
    staticClass: "col-md-3 col-sm-12",
    staticStyle: {
      "margin-bottom": "2em",
      "background": "rgba(247, 242, 241, 0.89)",
      "padding": "1em"
    }
  }, [(_vm.edit_mode) ? _c('span', {
    staticClass: "product-num"
  }, [_vm._v("You are in "), _c('u', [_vm._v("Editing")]), _vm._v(" mode "), _c('button', {
    staticClass: "btn btn-xs btn-edit",
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Turn Off")])]) : _c('span', {
    staticClass: "product-num"
  }, [_vm._v("You are in "), _c('u', [_vm._v("Viewing")]), _vm._v(" mode "), _c('button', {
    staticClass: "btn btn-xs btn-edit",
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Turn Off")])])]) : _vm._e(), _vm._v(" "), (_vm.seller_mode) ? _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.edit_mode) ? _c('button', {
    staticClass: "btn btn-xs",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Edit Product")]) : _c('button', {
    staticClass: "btn btn-xs",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Done Editing")])]) : _vm._e(), _vm._v(" "), (_vm.new_added) ? _c('div', [_c('p', {
    staticClass: "new-added"
  }, [_vm._v("You have added this product, you can edit details and add more pictures")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('section', {
    staticClass: "padding-top-10 padding-bottom-10",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "1em"
    }
  }, [(!_vm.edit_mode) ? _c('div', {
    staticClass: "shop-detail"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card col-md-5 padding-bottom-100"
  }, [_c('h4', {
    staticClass: "hidden-md hidden-lg"
  }, [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "images-slider img-main-frame"
  }, [(_vm.product_display_image.product_image != '' && _vm.product_display_image.product_image != 'error') ? _c('img', {
    staticClass: "img-responsive sp-prd-img",
    attrs: {
      "src": _vm.img_product_url + _vm.product_display_image.product_image,
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "img-responsive sp-prd-img",
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-row"
  }, _vm._l((_vm.product.product_images), function(img) {
    return _c('div', {
      staticClass: "img-column"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-display-image', img)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + img.product_image,
        "alt": ""
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card sp-p-main col-md-6"
  }, [_c('div', {
    staticClass: "sp-prd-intro-block"
  }, [_c('h4', {
    staticClass: "hidden-sm hidden-xs"
  }, [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny"
  }, [_vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny"
  }, [_vm._v("Category: "), _c('span', [_c('b', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.redir(_vm.product.product_business_ownername)
      }
    }
  }, [_vm._v(_vm._s(_vm.product.product_category_name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "hozontal-flat-block"
  }, [_c('p', {
    staticClass: "pull-left"
  }, [_vm._v("reviews")]), _vm._v(" "), _c('p', {
    staticClass: "pull-right"
  }, [_vm._v("@"), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.redir(_vm.product.product_business_ownername)
      }
    }
  }, [_vm._v(_vm._s(_vm.product.product_business_ownername))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sp-prd-attr-block"
  }, [_c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [(_vm.product_item.product_item_actual_price != 0) ? _c('p', {
    staticClass: "attr-intro-desc prd-price prd-discounted-price"
  }, [_c('del', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_actual_price))])]) : _c('p', {
    staticClass: "attr-intro-desc prd-price"
  }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_price))])])]), _vm._v(" "), (_vm.product_item.product_item_actual_price != 0) ? _c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_c('p', {
    staticClass: "attr-intro-desc prd-discount-price"
  }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_price))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_c('p', {
    staticClass: "attr-intro-desc"
  }, [_vm._v(_vm._s(_vm.product_item.product_item_weight) + " (Kg)")])])]), _vm._v(" "), (((_vm.product.product_set_groups != 0))) ? _c('div', {
    staticClass: "info-block col-xs-12"
  }, [_c('div', {
    staticClass: "info-left col-xs-2"
  }, [(_vm.product.product_service == 'P') ? _c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Colour: ")]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Subscriptions: ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_vm._l((_vm.product.product_item_groups), function(pg) {
    return _c('div', {
      staticClass: "prd-color-block"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item-group', pg)
        }
      }
    }, [_c('div', {
      staticClass: "box-cube col-xs-2"
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', {
      staticClass: "product-item-group"
    }, [_c('div', {
      staticClass: "product-item-group",
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    }, [((pg.product_item_group_image && (pg.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', {}, [_c('div', {
      staticClass: "product-item-group box-color-cube",
      style: ({
        background: pg.product_item_group_color
      }),
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    })]) : _vm._e()])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.data_cart_group_message) ? _c('p', {
    staticClass: "p-tiny-info",
    staticStyle: {
      "margin-top": "-1em",
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.data_cart_group_message))]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (((_vm.product_item_group.product_items) && (_vm.product_item_group.product_items.length != 0))) ? _c('div', {
    staticClass: "info-block col-xs-12"
  }, [(((_vm.product.product_set_items != 0))) ? _c('div', [_c('div', {
    staticClass: "info-left col-xs-2"
  }, [(_vm.product.product_service == 'P') ? _c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Size: ")]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Plans: ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_c('div', {
    staticClass: "prd-color-block"
  }, _vm._l((_vm.product_item_group.product_items), function(pt) {
    return _c('div', {
      staticClass: "items-list-tiny",
      staticStyle: {
        "display": "inline"
      }
    }, [_c('li', {
      staticClass: "product-item",
      attrs: {
        "id": pt.product_item_id + 'PRT'
      }
    }, [(_vm.product.product_service == 'P') ? _c('a', {
      staticClass: "box-wrap",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_vm._v(_vm._s(pt.product_item_size))]) : _vm._e()]), _vm._v(" "), _c('li', {
      staticClass: "product-item",
      attrs: {
        "id": pt.product_item_id + 'PRT'
      }
    }, [(_vm.product.product_service == 'S') ? _c('a', {
      staticClass: "box-wrap",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_vm._v(_vm._s(pt.product_item_service_tag))]) : _vm._e()])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.data_cart_item_message) ? _c('p', {
    staticClass: "p-tiny-info",
    staticStyle: {
      "margin-top": "-0.1em",
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.data_cart_item_message))]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.product_item.product_item_total_discount != 0) ? _c('div', {
    staticClass: "on-sale"
  }, [_vm._v(" \r\n                        " + _vm._s(_vm.product_item.product_item_total_discount) + "% "), _c('span', [_vm._v("OFF")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "some-info"
  }, [(!_vm.edit_mode) ? _c('div', [(_vm.is_product_in_cart) ? _c('div', {
    staticStyle: {
      "border": "dotted 1px #96c5f5",
      "padding": "5px 2px"
    }
  }, [_c('p', [_vm._v("This Item is in your cart \r\n                              "), _c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "width": "12em",
      "cursor": "pointer",
      "line-height": "1.8"
    },
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _c('div', [_c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.product_item_order_quantity),
      expression: "product_item.product_item_order_quantity"
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-width": "102px"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product_item.product_item_order_quantity)
    },
    on: {
      "change": function($event) {
        _vm.checkOrderQuantity(_vm.product_item.product_item_order_quantity)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.product_item_order_quantity = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.check_order_quantity))])])]), _vm._v(" "), (_vm.product_item.product_item_quantity > 0) ? _c('ul', {
    staticClass: "col-xs-12 row"
  }, [_c('hr'), _vm._v(" "), (_vm.data_cart_message) ? _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v(_vm._s(_vm.data_cart_message))]) : _vm._e(), _vm._v(" "), (!_vm.product_is_ready_to_cart) ? _c('div', [_c('li', {
    staticClass: "col-md-4 col-xs-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('button', {
    staticClass: "cta-btn",
    on: {
      "click": _vm.prep_set_product_is_ready_to_cart
    }
  }, [_vm._v(" Buy Now")])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-4 col-xs-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('button', {
    staticClass: "cart-btn",
    on: {
      "click": _vm.prep_set_product_is_ready_to_cart
    }
  }, [_vm._v(" Add to Cart")])])]) : _c('div', [_c('li', {
    staticClass: "col-md-4 col-xs-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('product-cta-button', {
    attrs: {
      "productMain": _vm.product,
      "productItemGroup": _vm.product_item_group,
      "productItem": _vm.product_item
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "col-md-4 col-xs-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('add-to-cart-button', {
    attrs: {
      "productMain": _vm.product,
      "productItemGroup": _vm.product_item_group,
      "productItem": _vm.product_item
    }
  })], 1)])]) : _c('ul', {
    staticClass: "col-xs-12 row"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "#ff0000"
    }
  }, [_vm._v("This Item is out of Stock")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inner-info"
  }, [_c('div', {
    staticClass: "info-blocks"
  }, [_c('div', {
    staticClass: "info-block col-xs-12",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em",
      "background": "#fcf7f3"
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "info-right-2 col-xs-8"
  }, [_c('div', {
    staticClass: "tiny-notice"
  }, [(_vm.product.product_delivery_returns != ' ') ? _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.product.product_delivery_returns) + "\r\n                                ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Please note that Returns, Shipping and Delivery are handled independently by the seller.\r\n                                  Sellpoint only provides a conducive platform for both sellers and buyers, we also recommend reliable shipping \r\n                                  partners to make transactions seamless.\r\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-blocks"
  }, [_c('div', {
    staticClass: "info-block col-md-12 col-xs-12",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em",
      "background": "#fcf7f3"
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "info-right-2 col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "prd-delivery-list",
    staticStyle: {
      "display": "none"
    }
  }, [(((_vm.product.product_delivery_options) && (_vm.product.product_delivery_options.length != 0))) ? _c('div', _vm._l((_vm.product.product_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦" + _vm._s(delivery.business_delivery_option_price) + "\r\n                                    ")])
  })) : _c('div', _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦" + _vm._s(delivery.business_delivery_option_price) + " \r\n                                      ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "prd-delivery-list"
  }, _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦\r\n                                    "), (delivery.business_products_delivery_fees.length > 0) ? _c('span', _vm._l((delivery.business_products_delivery_fees), function(fee, fdex) {
      return _c('span', [((fee.product_delivery_product == _vm.product.product_id)) ? _c('span', [_vm._v(_vm._s(fee.product_delivery_fee) + "\r\n                                        ")]) : _vm._e()])
    })) : _c('span', [_vm._v("\r\n                                      " + _vm._s(delivery.business_delivery_option_price) + "\r\n                                    ")])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('h6', [_vm._v("SHARE THIS PRODUCT")]), _vm._v(" "), _c('ul', {
    staticClass: "social_icons"
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Click the Copy button below to Copy product link, paste the link anywhere you want to share to")]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-xs linky",
    staticStyle: {
      "cursor": "pointer",
      "padding": "10px 30px"
    },
    attrs: {
      "title": "Copy Link. Paste and Share Anywhere"
    },
    on: {
      "click": function($event) {
        _vm.copyLink()
      }
    }
  }, [_vm._v("Copy Link\r\n                              ")]), _vm._v(" "), (_vm.copied) ? _c('span', {
    staticStyle: {
      "background": "rgb(240, 227, 157)"
    }
  }, [_vm._v("Copied, Paste anywhere you want to share to")]) : _vm._e()])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "shop-detail"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card col-md-5 padding-bottom-100"
  }, [_c('h6', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-weight": "bold"
    }
  }, [_vm._v("Product Pictures")]), _vm._v(" "), _c('div', {
    staticClass: "img-row"
  }, _vm._l((_vm.product.product_images), function(pt) {
    return _c('div', {
      staticClass: "img-column"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + pt.product_image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "btn pull-right",
      staticStyle: {
        "margin-top": "-3em",
        "font-size": "10px",
        "padding": "6px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteProductImage(pt.product_image_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Add new Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'products', _vm.product.product_id)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card sp-p-main col-md-6"
  }, [_c('div', [(_vm.editProductPanel) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('h6', [_vm._v("Edit Product")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Product Name\r\n                                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_vm._v("Category:- " + _vm._s(_vm.product.product_category_name) + " ")]), _vm._v(" "), (_vm.sellpoint_categories.length > 0) ? _c('li', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Select from My Shop Categories\r\n                                        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    attrs: {
      "id": "category-type-1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-1')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_1
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      key: category.business_category_id,
      attrs: {
        "disabled": _vm.category_type_1
      },
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "col-md-4"
  }, [_c('label', [(_vm.sellpoint_categories.length > 0) ? _c('span', [_c('b', [_vm._v("Or ")])]) : _vm._e(), _vm._v(" Select from Related Categories\r\n                                        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main_category),
      expression: "main_category"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.main_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getSubCategories(_vm.main_category)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      key: category.category_id,
      domProps: {
        "value": category
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.sub_categories.length != 0) ? _c('label', [_vm._v(" Select a Category\r\n                                        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_sub_category),
      expression: "product.product_sub_category"
    }],
    staticClass: "category-type-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_sub_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_2
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(category) {
    return _c('option', {
      key: category.sub_category_id,
      attrs: {
        "disabled": _vm.category_type_2
      },
      domProps: {
        "value": category.sub_category_id
      }
    }, [_vm._v(_vm._s(category.sub_category_name))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "col-md-4"
  }, [_c('label', [_c('b', [_vm._v("Or ")]), _vm._v(" Enter a specific Category\r\n                                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_listed_category),
      expression: "product.product_listed_category"
    }],
    attrs: {
      "disabled": _vm.category_type_3,
      "type": "text",
      "placeholder": "",
      "id": "category-type-3"
    },
    domProps: {
      "value": (_vm.product.product_listed_category)
    },
    on: {
      "change": function($event) {
        _vm.trackevent('category-type-3')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_listed_category = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Description\r\n                                            "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProduct
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" Cancel")])])])])]) : _c('div', [_c('button', {
    staticClass: "btn btn-xs pull-right action-btn",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('edit-product', '')
      }
    }
  }, [_vm._v("Edit Product Details")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h6', [_c('b', [_vm._v("Product Name: ")]), _vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Description: ")]), _vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Category: ")]), _c('span', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.redir(_vm.product.product_business_ownername)
      }
    }
  }, [_vm._v(_vm._s(_vm.product.product_category_name))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.product.product_item_groups.length > 0) ? _c('div', [_c('h6', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-weight": "bold"
    }
  }, [_vm._v("Different Colors, Sizes, Plans Subscriptions ..etc")]), _vm._v(" "), _c('div', {
    staticClass: "img-row"
  }, _vm._l((_vm.product.product_item_groups), function(pg) {
    return _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "border-bottom": "1px solid #e9e6e6",
        "margin-bottom": "1em"
      }
    }, [_c('p', {
      staticClass: "pull-left",
      staticStyle: {
        "font-weight": "bold",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(pg.product_item_group_name))]), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [_c('button', {
      staticClass: "btn v-tiny-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-product-item_group', pg)
        }
      }
    }, [_c('i', {
      staticClass: "icon-pencil"
    }), _vm._v(" Edit")]), _vm._v(" "), (_vm.product.product_item_groups.length > 1) ? _c('button', {
      staticClass: "btn btn-xs v-tiny-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('remove-product-item_group', pg)
        }
      }
    }, [_c('i', {
      staticClass: "icon-trash"
    }), _vm._v(" Delete")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', [(_vm.editProductItemGroupPanel && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {
      staticClass: "col-sm-12 contact_form",
      attrs: {
        "id": "editProductItem"
      }
    }, [_c('h6', [_vm._v("Edit Product Item Group")]), _vm._v(" "), _c('div', [_c('li', {
      staticClass: "col-md-12"
    }, [_c('label', [_vm._v("Name\r\n                                          "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item_group.product_item_group_name),
        expression: "product_item_group.product_item_group_name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.product_item_group.product_item_group_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item_group.product_item_group_name = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('li', [_c('div', {
      staticClass: "box-cube col-xs-2"
    }, [(_vm.product_item_group.product_item_group_is_color_image == 'IMG') ? _c('div', {}, [((_vm.product_item_group.product_item_group_image && (_vm.product_item_group.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": _vm.product_item_group.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.product_item_group.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', {
      staticClass: "col-md-12"
    }, [_c('label', [_vm._v(" Pick Colour or Pick from uploaded Images to match the colour you are adding")])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', {
      staticClass: "col-md-12"
    }, [_c('label', [_vm._v(" Pick Colour\r\n                                              "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item_group.product_item_group_color_new),
        expression: "product_item_group.product_item_group_color_new"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "4em"
      },
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": (_vm.product_item_group.product_item_group_color_new)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item_group.product_item_group_color_new = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('li', {
      staticClass: "col-md-12"
    }, [_c('label', [_vm._v(" Pick Image")]), _vm._v(" "), _c('div', {
      staticClass: "img-row"
    }, _vm._l((_vm.product.product_images), function(img, index) {
      return _c('div', {
        key: index,
        staticClass: "col-xs-1",
        staticStyle: {
          "height": "80px",
          "width": "100px"
        },
        attrs: {
          "id": "groupImage"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('set-product-item-group-image', img.product_image_id)
          }
        }
      }, [_c('img', {
        staticClass: "product-item-group-image sp-prd-img",
        attrs: {
          "id": img.product_image_id + 'PRTG',
          "src": img.product_image,
          "alt": ""
        }
      })])])
    })), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "z-index": "9"
      }
    }, [_c('div', {
      staticClass: "upload-btn-wrapper",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('button', {
      staticClass: "upload-btn"
    }, [_vm._v("Or Add new Image")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "input-file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.onFileChange($event, 'products', _vm.product.product_id)
        }
      }
    })])])]), _vm._v(" "), _c('li', {
      staticClass: "col-md-12"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn col-md-4",
      staticStyle: {
        "line-height": "1.2",
        "margin-right": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.editProductItemGroup
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn col-md-4",
      staticStyle: {
        "line-height": "1.2",
        "margin-right": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_c('i', {
      staticClass: "icon-ban"
    }), _vm._v(" Cancel")])])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.removeItemGroupPanel && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('span', {
      staticClass: "pull-left col-sm-12"
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Do you really want to remove this Item Group?")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs",
      on: {
        "click": function($event) {
          _vm.removeProductItemGroup()
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs",
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "box-cube col-xs-2"
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', {}, [((pg.product_item_group_image && (pg.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8"
    }, [_c('h5', {
      staticStyle: {
        "font-size": "10px",
        "text-transform": "capitalize"
      }
    }, [(_vm.product.product_service == 'P') ? _c('span', [_vm._v("Sizes in this Colour:")]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('span', [_vm._v("Service Packages:")]) : _vm._e()]), _vm._v(" "), _vm._l((pg.product_items), function(pt) {
      return _c('div', {
        staticClass: "items-list-tiny",
        staticStyle: {
          "display": "inline"
        }
      }, [_c('div', [(_vm.product.product_service == 'P') ? _c('li', {
        staticClass: "box-wrap"
      }, [_vm._v(_vm._s(pt.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (pt.product_item_service_tag)) ? _c('li', {
        staticClass: "box-wrap"
      }, [_vm._v(_vm._s(pt.product_item_service_tag))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', [_c('span', [_vm._v("w(kg):")]), _vm._v(_vm._s(pt.product_item_weight))]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(pt.product_item_price))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Qty:")]), _vm._v(_vm._s(pt.product_item_quantity))]), _vm._v(" "), _c('li', [_c('a', {
        staticClass: "btn btn-xs v-tiny-btn",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('set-edit-product-item', pt)
          }
        }
      }, [_c('i', {
        staticClass: "icon-pencil"
      })])]), _vm._v(" "), (_vm.product.product_items.length > 1) ? _c('li', [_c('a', {
        staticClass: "btn btn-xs v-tiny-btn",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('remove-product-item', pt)
          }
        }
      }, [_c('i', {
        staticClass: "icon-trash"
      })])]) : _vm._e()]), _vm._v(" "), (_vm.editProductItemPanel && (_vm.product_item.product_item_id == pt.product_item_id)) ? _c('div', {
        staticClass: "col-sm-12 contact_form",
        attrs: {
          "id": "editProductItem"
        }
      }, [_c('h6', [_vm._v("Edit Product Item")]), _vm._v(" "), _c('form', [_c('ul', {
        staticClass: "row"
      }, [_c('li', {
        staticClass: "col-md-12"
      }, [_c('label', [_vm._v(" *"), (_vm.product.product_service == 'P') ? _c('span', [_vm._v("Product Item Size")]) : _vm._e(), (_vm.product.product_service == 'S') ? _c('span', [_vm._v("Product Item tYPE")]) : _vm._e(), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_size),
          expression: "product_item.product_item_size"
        }],
        attrs: {
          "type": "text",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_size)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_size = $event.target.value
          }
        }
      })])]), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('li', {
        staticClass: "col-md-12"
      }, [_c('label', [_vm._v(" *Service Tag\r\n                                                "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_service_tag),
          expression: "product_item.product_item_service_tag"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_service_tag)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_service_tag = $event.target.value
          }
        }
      })])]) : _vm._e(), _vm._v(" "), _c('li', {
        staticClass: "col-md-12"
      }, [_c('label', [_vm._v(" *Product Item Price\r\n                                                "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_price),
          expression: "product_item.product_item_price"
        }],
        attrs: {
          "type": "number",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_price)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_price = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('li', {
        staticClass: "col-md-12"
      }, [_c('label', [_vm._v(" *Product Item Weight\r\n                                              "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_weight),
          expression: "product_item.product_item_weight"
        }],
        attrs: {
          "type": "number",
          "step": "any",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_weight)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_weight = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('li', {
        staticClass: "col-md-12"
      }, [_c('label', [_vm._v(" *Product Item Quantity\r\n                                                  "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_quantity),
          expression: "product_item.product_item_quantity"
        }],
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_quantity)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_quantity = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('li', {
        staticClass: "col-md-12"
      }, [(_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e(), _vm._v(" "), _c('button', {
        staticClass: "btn col-md-4",
        staticStyle: {
          "line-height": "1.2",
          "margin-right": "5px"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": _vm.editProductItem
        }
      }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
        staticClass: "btn col-md-4",
        staticStyle: {
          "line-height": "1.2",
          "margin-right": "5px"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_c('i', {
        staticClass: "icon-ban"
      }), _vm._v(" Cancel")])]), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.removeItemPanel && (_vm.product_item.product_item_id == pt.product_item_id)) ? _c('span', {
        staticClass: "pull-left col-sm-12"
      }, [_c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Do you really want to remove this Item?")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs",
        on: {
          "click": function($event) {
            _vm.removeProductItem()
          }
        }
      }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs",
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })])
    })], 2), _vm._v(" "), _c('hr')])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {}, [(_vm.product.product_service == 'P') ? _c('p', [_vm._v("add other variations like colors, sizes etc")]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('p', [_vm._v("add other variations like the Service package, subscriptions and plans etc")]) : _vm._e(), _vm._v(" "), (!_vm.addProductItemPanel) ? _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('add-product-item', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Product Variation")]) : _c('div', [_c('button', {
    staticClass: "btn pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" Cancel")]), _vm._v(" "), _c('div', [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('product-item-form')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('remove-product', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete this Product")]), _vm._v(" "), (_vm.removeProductPanel) ? _c('span', {}, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to remove this Product?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": _vm.removeProduct
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])]), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "specific-detail-cards padding-top-100 padding-bottom-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-xs-12 card product-specific-cards"
  }, [(_vm.edit_mode) ? _c('div', [_c('h6', [_vm._v("ITEM DISCOUNTS")]), _vm._v(" "), _c('div', [(_vm.setDiscount) ? _c('div', [_c('div', {
    staticClass: "contact-form col-md-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setDiscountsAndCoupons()
      }
    }
  }, [_vm._v("SET")])]), _vm._v(" "), _c('li', {
    staticClass: "form-group col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _vm._m(8)]) : _vm._e(), _vm._v(" "), (_vm.editDiscount) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Edit Discount")]), _vm._v(" "), _c('div', {
    staticClass: "contact-form col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date: " + _vm._s(_vm.discount_coupon.discount_start_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.editDiscountsAndCoupons()
      }
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('li', {
    staticClass: "form-group col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _c('div', [_vm._l((_vm.product_item.product_item_discounts), function(dc) {
    return _c('div', [(dc.discount_status_id == 5) ? _c('div', [(dc.discount_product_item == _vm.product_item.product_item_id) ? _c('p', [_c('b', [_vm._v("Product Item Discount")])]) : _c('p', [_c('b', [_vm._v("General Sellpoint Discount")])]), _vm._v(" "), (dc.discount_product_item != _vm.product_item.product_item_id) ? _c('p', [_c('b', [_vm._v("Type: ")]), _vm._v(_vm._s(dc.discount_category_name))]) : _vm._e(), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), (dc.discount_product_item == _vm.product_item.product_item_id) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-discount', dc)
        }
      }
    }, [_vm._v("\r\n                                  Edit Discount")]), _vm._v("    \r\n                                "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.deactivateDiscountsAndCoupons(dc)
        }
      }
    }, [_vm._v("\r\n                                  Deactivate Discount")])]) : _vm._e(), _vm._v(" "), _c('hr')]) : _c('div', [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("You don't have an active discount")]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "2em"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-discount', '')
        }
      }
    }, [_vm._v("Set New Discount Or Coupon")])])])
  }), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You don't have an active discount")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-discount', '')
      }
    }
  }, [_vm._v("Set New Discount Or Coupon")])])], 2)]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-12 card product-specific-cards"
  }, [_c('div', [_c('h6', [_vm._v("DELIVERY & RETURNS INFORMATION")]), _vm._v(" "), (_vm.edit_mode) ? _c('div', [(_vm.details.edit_product_delivery) ? _c('div', {
    staticClass: "contact-form"
  }, [_c('li', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_delivery_returns),
      expression: "product.product_delivery_returns"
    }],
    domProps: {
      "value": (_vm.product.product_delivery_returns)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_delivery_returns = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setProductDelivery()
      }
    }
  }, [_c('i', {
    staticClass: "icon-check"
  }), _vm._v("submit")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" cancel")])])]) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Set delivery and returns information for this product, Note that this is different from setting delivery places")]), _vm._v(" "), _c('p', [(_vm.product.product_delivery_returns) ? _c('span', [_vm._v(_vm._s(_vm.product.product_delivery_returns))]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "13px"
    },
    attrs: {
      "type": "btn",
      "title": "Edit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('edit-product-delivery', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Set Delivery & Return Information")]) : _vm._e(), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), (!_vm.edit_mode) ? _c('div', {
    staticClass: "tiny-notice",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em",
      "background": "#fcf7f3"
    }
  }, [(_vm.product.product_delivery_returns != ' ') ? _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.product.product_delivery_returns) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Please note that Returns, Shipping and Delivery are handled independently by the seller.\r\n                          Sellpoint only provides a conducive platform for both sellers and buyers, we also recommend reliable shipping \r\n                          partners to make transactions seamless.\r\n                        ")])]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set How Product Shipping Fee would affect Buyers Checkout Ordering")]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_set_shipping_fee_status),
      expression: "product_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "12",
      "value": "12"
    },
    domProps: {
      "checked": _vm._q(_vm.product_set_shipping_fee_status, "12")
    },
    on: {
      "click": function($event) {
        _vm.setProductShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.product_set_shipping_fee_status = "12"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Product Charge is not on each Quantiy of Product Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_set_shipping_fee_status),
      expression: "product_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "13",
      "value": "13"
    },
    domProps: {
      "checked": _vm._q(_vm.product_set_shipping_fee_status, "13")
    },
    on: {
      "click": function($event) {
        _vm.setProductShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.product_set_shipping_fee_status = "13"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Product Charge is on each Quantiy of Product Ordered")])])]), _vm._v(" "), (_vm.set_shipping_fee_status_track && _vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-12 card product-specific-cards"
  }, [_c('div', [_c('h6', [_vm._v("PRODUCT DELIVERY LOCATIONS")]), _vm._v(" "), (_vm.edit_mode) ? _c('div', [_c('div', [_vm._l((_vm.product.product_delivery_options), function(delivery) {
    return _c('li', {
      staticStyle: {
        "display": "none"
      }
    }, [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦" + _vm._s(delivery.business_delivery_option_price) + "\r\n                            "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-delivery-option', delivery)
        }
      }
    }, [_c('i', {
      staticClass: "icon-edit"
    })]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.deleteDeliveryOption(delivery.business_delivery_option_id)
        }
      }
    }, [_c('i', {
      staticClass: "icon-close"
    })]), _vm._v(" "), (_vm.editDeliveryInformation && delivery.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('li', [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.delivery_option.business_delivery_state),
        expression: "delivery_option.business_delivery_state"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.delivery_option.business_delivery_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities(_vm.delivery_option.business_delivery_state, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state.state_id
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2)]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.delivery_option) + "\r\n                                  "), _c('label', [_vm._v("City: "), _c('b', [_vm._v(_vm._s(_vm.delivery_option.business_delivery_option))])]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.delivery_option.city),
        expression: "delivery_option.city"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.setOtherOptions(_vm.delivery_option.city, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "all"
      }
    }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city.city_id
        }
      }, [_vm._v(_vm._s(city.city_name))])
    }), _vm._v(" "), _c('option', {
      attrs: {
        "value": "other"
      }
    }, [_vm._v("Other Areas / Cities ")])], 2)]), _vm._v(" "), (_vm.edit_other_delivery_option) ? _c('li', [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.delivery_option.business_delivery_other_option),
        expression: "delivery_option.business_delivery_other_option"
      }],
      attrs: {
        "type": "text",
        "placeholder": "eg. Abuja"
      },
      domProps: {
        "value": (_vm.delivery_option.business_delivery_other_option)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.delivery_option.business_delivery_other_option = $event.target.value
        }
      }
    }), _c('br')]) : _vm._e(), _vm._v(" "), _c('li', [_c('label', [_vm._v("Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.delivery_option.business_delivery_option_price),
        expression: "delivery_option.business_delivery_option_price"
      }],
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (_vm.delivery_option.business_delivery_option_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.delivery_option.business_delivery_option_price = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('li', [_c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.editDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _vm._e()])
  }), _vm._v(" "), (_vm.product.product_business_delivery_options.length != 0) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have set some general delivery settings")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v("You can set a different delivery fee for this product")]), _c('br'), _vm._v(" "), _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦\r\n                              "), (delivery.business_products_delivery_fees.length > 0) ? _c('span', _vm._l((delivery.business_products_delivery_fees), function(fee, fdex) {
      return _c('span', [((fee.product_delivery_product == _vm.product.product_id)) ? _c('span', [_vm._v(_vm._s(fee.product_delivery_fee) + "\r\n                                  ")]) : _vm._e()])
    })) : _c('span', [_vm._v("\r\n                                " + _vm._s(delivery.business_delivery_option_price) + "\r\n                              ")]), _vm._v(" "), (_vm.setProductDeliveryInformation && delivery.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('li', [_c('label', [_vm._v("Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery.product_delivery_fee),
        expression: "delivery.product_delivery_fee"
      }],
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (delivery.product_delivery_fee)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery.product_delivery_fee = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('li', [(_vm.setProductDeliveryInformation && _vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.setProductDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "font-size": "10px"
      },
      attrs: {
        "type": "btn",
        "title": "Set Product Delivery Fee"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-delivery-option', delivery)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Set Fee")])])
  })], 2) : _c('div', [_c('p', [_vm._v("You have not set your Business Delivery Locations")])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "13px",
      "display": "none"
    },
    attrs: {
      "type": "btn",
      "title": "Edit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('add-delivery-option', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Add Product Delivery Location")]) : _vm._e(), _vm._v(" "), _c('br')], 2), _vm._v(" "), (_vm.addDeliveryInformation) ? _c('div', {
    staticClass: "contact_form col-md-12",
    staticStyle: {
      "padding-left": "0",
      "display": "none"
    }
  }, [_c('h5', [_vm._v("Add a Delivery Location and Price")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('li', [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other Areas / Cities ")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.other_delivery_option) ? _c('li', [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_other_option),
      expression: "delivery_option.delivery_other_option"
    }],
    attrs: {
      "type": "text",
      "placeholder": "eg. Abuja"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_other_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_other_option = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e(), _vm._v(" "), _c('li', [_c('label', [_vm._v("Delivery Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_price),
      expression: "delivery_option.delivery_option_price"
    }],
    attrs: {
      "type": "number",
      "placeholder": "Eg. 1000"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_option_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_option_price = $event.target.value
      }
    }
  }), _c('br')]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn col-sm-4",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": _vm.addDeliveryOption
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn col-sm-4",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.edit_mode) ? _c('div', {
    staticClass: "tiny-notice",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em",
      "background": "#fcf7f3"
    }
  }, [_c('h4', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("View Shipping Cost for different Locations")]), _vm._v(" "), _c('div', [(((_vm.product.product_delivery_options) && (_vm.product.product_delivery_options.length != 0))) ? _c('div', _vm._l((_vm.product.product_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦" + _vm._s(delivery.business_delivery_option_price) + "\r\n                            ")])
  })) : _c('div', _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦" + _vm._s(delivery.business_delivery_option_price) + " \r\n                              ")])
  }))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-12 card product-specific-cards"
  }, [_c('div', {
    staticClass: "inner-info"
  }, [_c('h6', [_vm._v("SHARE THIS PRODUCT")]), _vm._v(" "), _c('ul', {
    staticClass: "social_icons"
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Click the Copy button below to Copy product link, paste the link anywhere you want to share to")]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "linky",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "13px"
    },
    attrs: {
      "title": "Copy Link. Paste and Share Anywhere"
    },
    on: {
      "click": function($event) {
        _vm.copyLink()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  }), _vm._v("Copy Product Link and Share Anywhere\r\n                          ")]), _vm._v(" "), (_vm.copied) ? _c('span', {
    staticStyle: {
      "background": "rgb(240, 227, 157)"
    }
  }, [_vm._v("Copied, Paste anywhere you want to share to")]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row product-details-section",
    attrs: {
      "id": "productDetails"
    }
  }, [_c('div', {
    staticClass: "card item-decribe"
  }, [_c('ul', {
    staticClass: "nav nav-tabs animate fadeInUp"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-descr', '')
      }
    }
  }, [_vm._v("PRODUCT DETAILS")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-reviews', '')
      }
    }
  }, [_vm._v("COMMENTS & REVIEWS")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-information', '')
      }
    }
  }, [_vm._v("MORE INFORMATION")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content animate fadeInUp details-box"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.product_details_reviews) ? _c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [(_vm.product.product_reviews) ? _c('h6', [_vm._v(_vm._s(_vm.product.product_reviews.length) + " COMMENTS AND REVIEWS")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.product.product_reviews), function(review) {
    return _c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "media-left"
    }, [_c('div', {
      staticClass: "avatar"
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('img', {
      staticClass: "media-object",
      attrs: {
        "src": _vm.img_user_url + review.product_reviewed_by_image,
        "alt": ""
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h6', [_vm._v(_vm._s(review.product_reviewed_by)), _c('span', {
      staticClass: "pull-right"
    })]), _vm._v(" "), _c('p', {
      staticClass: "font-playfair"
    }, [_vm._v(_vm._s(review.product_review))]), _vm._v(" "), _c('h6', [_c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(review.product_review_date))])])])])
  }), _vm._v(" "), (!_vm.edit_mode) ? _c('div', [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("ADD COMMENT/REVIEW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You must have used this product to wrie a review.")]), _vm._v(" "), _c('form', [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *YOUR REVIEW\r\n                                    "), _c('span', {
    staticClass: "pull-right"
  }, [_c('label', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user_type),
      expression: "user_type"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "bo",
      "id": "bo"
    },
    domProps: {
      "checked": _vm._q(_vm.user_type, "bo")
    },
    on: {
      "__c": function($event) {
        _vm.user_type = "bo"
      }
    }
  }), _vm._v("Business Owner\r\n                                        ")]), _vm._v(" "), (!_vm.loggedIn) ? _c('label', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user_type),
      expression: "user_type"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "buyer",
      "id": "buyer"
    },
    domProps: {
      "checked": _vm._q(_vm.user_type, "buyer")
    },
    on: {
      "__c": function($event) {
        _vm.user_type = "buyer"
      }
    }
  }), _vm._v("Buyer\r\n                                        ")]) : _vm._e()]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reviews.review),
      expression: "reviews.review"
    }],
    domProps: {
      "value": (_vm.reviews.review)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reviews.review = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('li', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-dark btn-small pull-right no-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addProductReview
    }
  }, [_vm._v("POST")])])])])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.product_details_information) ? _c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_vm._l((_vm.product.product_information), function(info) {
    return _c('div', {}, [(info.product_info_type == 'image') ? _c('div', [_c('p', [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": _vm.img_product_url + info.product_info_detail,
        "alt": ""
      }
    })])]) : _vm._e(), _vm._v(" "), (info.product_info_type == 'text') ? _c('div', [_c('p', [_vm._v(_vm._s(info.product_info_detail))]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('br'), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.information.product_info_detail),
      expression: "information.product_info_detail"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter new product information"
    },
    domProps: {
      "value": (_vm.information.product_info_detail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.information.product_info_detail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": _vm.addProductInformation
    }
  }, [_vm._v("Add to Product Information")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Add an Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'product_information', _vm.product.product_id)
      }
    }
  })])])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.product_details_descr) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), _c('h6', [_vm._v("MORE DETAILS")]), _vm._v(" "), _c('ul', _vm._l((_vm.product.product_details), function(details) {
    return _c('li', [(_vm.edit_mode) ? _c('div', [(details.edit_product_detail) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (details.product_detail),
        expression: "details.product_detail"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (details.product_detail)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          details.product_detail = $event.target.value
        }
      }
    }), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": _vm.editProductDetail
      }
    }, [_c('i', {
      staticClass: "icon-check"
    })])]) : _c('p', [_vm._v(_vm._s(details.product_detail) + "\r\n                                "), (_vm.edit_mode) ? _c('span', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-product-detail', details)
        }
      }
    }, [_c('i', {
      staticClass: "icon-edit"
    })]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.deleteProductDetail(details)
        }
      }
    }, [_c('i', {
      staticClass: "icon-trash"
    })])]) : _vm._e()])]) : _c('p', [_vm._v(_vm._s(details.product_detail))])])
  })), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('br'), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details.new_product_detail),
      expression: "details.new_product_detail"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter new product detail"
    },
    domProps: {
      "value": (_vm.details.new_product_detail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details.new_product_detail = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": _vm.addProductDetail
    }
  }, [_vm._v("Add to Details")])])]) : _vm._e()]) : _vm._e()])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "light-gray-bg padding-top-50 padding-bottom-150"
  }, [_c('div', {}, [_c('div', {
    staticClass: "card"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "papular-block"
  }, _vm._l((_vm.other_products), function(o_product) {
    return _c('div', {
      staticClass: "shop-detail prd-market-block"
    }, [(_vm.product.product_id != o_product.product_id) ? _c('div', _vm._l((o_product.product_items), function(o_product_item, index2) {
      return _c('div', {
        staticClass: "row"
      }, [(index2 == 0) ? _c('div', {
        staticClass: "col-md-8 col-md-offset-2"
      }, [_c('a', {
        attrs: {
          "href": o_product.product_url_name
        }
      }, [_c('h4', [_c('a', {
        attrs: {
          "href": o_product.product_url_name
        }
      }, [_vm._v(_vm._s(o_product.product_name))])]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(o_product_item.product_item_price))]), _vm._v(" "), _c('div', {
        staticClass: "item-img"
      }, [_c('img', {
        staticClass: "sp-prd-img img-1",
        attrs: {
          "src": _vm.img_product_url + o_product_item.product_item_image,
          "alt": ""
        }
      })]), _vm._v(" "), _vm._m(11, true), _vm._v(" "), _c('ul', {
        staticClass: "item-owner"
      }, [_c('li', [_vm._v("Category:"), _c('span', [_vm._v(" " + _vm._s(o_product.product_category_name))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(o_product.product_description))])])]) : _vm._e()])
    })) : _vm._e()])
  }))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottombar",
    staticStyle: {
      "margin-top": "15em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#home"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#news"
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#contact"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Price: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Discount Price: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Weight: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Quantity:  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left-2 col-xs-2"
  }, [_c('h6', [_vm._v("DELIVERY & RETURNS INFORMATION")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left-2 col-md-2 col-xs-12"
  }, [_c('h6', [_vm._v("PRODUCT DELIVERY LOCATIONS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-form col-md-12"
  }, [_c('p', {
    staticStyle: {
      "color": "#363535"
    }
  }, [_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                              If you want to end an existing discount click on \"Stop Discount\" button near the\r\n                              button.\r\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "stars"
  }, [_c('span', [_vm._v("YOUR RATING")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading text-center"
  }, [_c('h4', [_vm._v("I ALSO HAVE THESE")]), _vm._v(" "), _c('span', [_vm._v("Check out other products found in my sellpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "on-sale"
  }, [_vm._v(" 10% "), _c('span', [_vm._v("OFF")])])
}]}

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('c-settings'), _vm._v(" "), _c('div', {
    staticClass: "page-wrapper",
    attrs: {
      "id": "topwrap"
    }
  }, [_c('component-header'), _vm._v(" "), (_vm.set_upgrade_plans) ? _c('section', {
    staticClass: "pricing-style-one",
    staticStyle: {
      "background": "#aa076b",
      "margin-top": "5em"
    },
    attrs: {
      "id": "pricing"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-5em"
    }
  }, [(!_vm.set_upgrade_plan_process) ? _c('div', {
    staticClass: "container"
  }, [(_vm.upgradable_plans.length == 0) ? _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("Sorry, no plans to upgrade to.")])]) : _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("Select a plan to upgrade")])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane show active  animated fadeInUp",
    attrs: {
      "role": "tabpanel"
    }
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.upgradable_plans), function(plan) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-6 col-sm-12"
    }, [_c('div', {
      staticClass: "single-pricing-one basic-pack"
    }, [_c('div', {
      staticClass: "top-block"
    }, [((plan.product_items && plan.product_items.length > 0)) ? _c('span', {
      staticClass: "price"
    }, [_vm._v("₦" + _vm._s(plan.product_items[0].product_item_price))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "pack-name"
    }, [_vm._v(_vm._s(plan.product_name))]), _vm._v(" "), _c('div', {
      staticClass: "line"
    })]), _vm._v(" "), (plan.product_url_name == 'plan1') ? _c('ul', {
      staticClass: "feature-lists"
    }, [_c('li', [_vm._v("Extra features")]), _vm._v(" "), _c('li', [_vm._v("Lifetime free support")]), _vm._v(" "), _c('li', [_vm._v("Upgrate options")]), _vm._v(" "), _c('li', [_vm._v("Full access")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "bottom-block"
    }, [_c('p', {
      staticClass: "sp-form-descr"
    }, [_vm._v("Your Upgrade details would be calculated appropriately when you choose plan")]), _vm._v(" "), _c('a', {
      staticClass: "price-btn",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.upgrade_plan(plan)
        }
      }
    }, [_vm._v("Purchase")])])])])
  }))])])]) : _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "10em"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "row onboarding-wrap"
  }, [(_vm.setup_error_message != '') ? _c('div', {
    staticClass: "row onboarding-head"
  }, [_c('div', {
    staticClass: "col",
    staticStyle: {
      "margin": "5em",
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#000000",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.setup_error_message) + ".")])])]) : _c('div', [_c('div', {
    staticClass: "row onboarding-body"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-xs-12 col-md-6 offset-md-4 onboarding-center"
  }, [_c('div', [_c('h6', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Upgrade Plans")]), _vm._v(" "), (_vm.selected_plan && _vm.selected_plan.product_items) ? _c('h4', [_c('b', [_vm._v(_vm._s(_vm.selected_plan.product_name) + "(₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)) + ")")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {}, [_c('div', [_vm._l((_vm.selected_plan.product_items_upgrade_details), function(details) {
    return _c('div', {}, [(_vm.selected_plan_product_service_item.product_item_id == details.subscription_new_product_item_id) ? _c('div', [_c('p', [_vm._v("Your last Subscription was on:"), _c('b', [_vm._v(_vm._s(details.subscription_subscribed_product_start_date))]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("You have "), _c('b', [_vm._v(_vm._s(details.subscription_subscribed_product_days_left))]), _vm._v(" days before your subscription expires.")]), _vm._v(" "), _c('p', [_vm._v("To upgrade to this plan, the total sum to pay is "), _c('b', [_vm._v(_vm._s(details.subscription_new_product_total_amount_to_pay))])])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {}, [_c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Subscription Duration: "), _c('b', [_vm._v(_vm._s(_vm.selected_plan_product_service_item.product_item_service_tag))])]), _c('br'), _vm._v(" "), _c('label', [_c('p', {
    staticClass: "sp-form-descr"
  }, [_c('b', [_vm._v("Total to pay: ₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)))])])])]), _vm._v(" "), (_vm.selected_plan.product_items && (_vm.selected_plan.product_items.length > 1)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "gw-btn-cta-light",
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('display-product_service_items', '')
      }
    }
  }, [_vm._v("\r\n                                                                Change Subscription Duration\r\n                                                            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "border": "#aa076b dashed",
      "margin-top": "6px",
      "padding": "5px"
    },
    attrs: {
      "id": "productServiceItems"
    }
  }, _vm._l((_vm.selected_plan.product_items), function(pt) {
    return _c('div', {
      staticClass: "radio-items"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_service_items_select),
        expression: "product_service_items_select"
      }],
      attrs: {
        "type": "radio",
        "id": pt.product_item_id
      },
      domProps: {
        "value": pt.product_item_id,
        "checked": _vm._q(_vm.product_service_items_select, pt.product_item_id)
      },
      on: {
        "click": function($event) {
          _vm.selectProductServiceItem(pt)
        },
        "__c": function($event) {
          _vm.product_service_items_select = pt.product_item_id
        }
      }
    }), _vm._v(_vm._s(pt.product_item_service_tag) + "\r\n                                                                ")])
  }))]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.payment_successful) ? _c('div', {}, [_c('h3', {
    staticStyle: {
      "color": "#7c0b0b",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.payment_successful_message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn pull-left gw-btn-cta-light",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.proceedUpgradePlan()
      }
    }
  }, [_vm._v(" Proceed")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "background": "#f0de3d",
      "cursor": "pointer",
      "color": "#000000"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(" Cancel")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2)])])])])])])])]) : _c('section', {
    staticClass: "home-page-two gw-banner-plain",
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(4)]) : _c('div', {
    staticClass: "row onboarding-wrap"
  }, [(_vm.setup_error_message != '') ? _c('div', {
    staticClass: "row onboarding-head"
  }, [_c('div', {
    staticClass: "col",
    staticStyle: {
      "margin": "5em",
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#000000",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.setup_error_message) + ".")])])]) : _c('div', [(!_vm.newBusinessForm) ? _c('div', {
    staticClass: "row onboarding-body"
  }, [_c('div', {
    staticClass: "col-6 onboarding-left"
  }, [_c('h6', [_vm._v("Purchase Plans")]), _vm._v(" "), _c('p', [_vm._v("You are about to purchase "), _c('b', [_vm._v(_vm._s(_vm.selected_plan.product_name))]), _vm._v(" plan, this would take few minutes and would lead you to creating and setting up \r\n                                        your "), _c('span', {
    staticClass: "sp-mention-inline"
  }, [_vm._v("Sellpoint")]), _vm._v(" account. We use Sellpoint to manage your acounts. \r\n                                        If you already have a Sellpoint account, you can Sign Up with your details.")]), _vm._v(" "), _c('p', [_c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.toggleDisplayFeatures
    }
  }, [_vm._v("\r\n                                            See features of " + _vm._s(_vm.selected_plan.product_name) + " "), _c('i', {
    staticClass: "fa fa-caret-down",
    staticStyle: {
      "color": "#ff0055",
      "font-size": "18px"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "features-display",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "seeFeatures"
    }
  }, [_c('div', {
    staticClass: "feature-list"
  }, [(_vm.selected_plan.product_url_name == _vm.plan1.product_url_name) ? _c('ul', [_c('li', [_vm._v("cica1")])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_url_name == _vm.plan2.product_url_name) ? _c('ul', [_c('li', [_vm._v("cica2")])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_url_name == _vm.plan3.product_url_name) ? _c('ul', [_c('li', [_vm._v("cica3")])]) : _vm._e()])]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-12 col-xs-12 col-md-6 onboarding-right"
  }, [_c('div', [_c('h6', {
    staticClass: "gw-mobile",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Purchase Plans")]), _vm._v(" "), (_vm.selected_plan && _vm.selected_plan.product_items) ? _c('h4', [_c('b', [_vm._v(_vm._s(_vm.selected_plan.product_name) + "(₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)) + ")")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {}, [(!_vm.set_up_with_existing_account) ? _c('div', [_c('div', {}, [_c('div', {
    staticClass: "gw-mobile"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn gw-btn-cta-light pu",
    staticStyle: {
      "cursor": "pointer",
      "margin-bottom": "1em",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('setup-existing', '')
      }
    }
  }, [_vm._v("Sign Up with Sellpoint")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#aa076b",
      "font-size": "14px",
      "font-weight": "500"
    }
  }, [_vm._v("Or Create a Sellpoint account to proceed.")])]), _vm._v(" "), _c('div', {
    staticClass: "gw-not-mobile"
  }, [_c('p', {
    staticClass: "pull-left",
    staticStyle: {
      "color": "#aa076b"
    }
  }, [_vm._v("Create a Sellpoint account to proceed.")]), _vm._v(" "), _c('a', {
    staticClass: "btn gw-btn-cta-light pull-right",
    staticStyle: {
      "cursor": "pointer",
      "margin-bottom": "1em",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('setup-existing', '')
      }
    }
  }, [_vm._v(" Or Sign Up with Sellpoint")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {}, [_c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Full Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_name),
      expression: "payment_payer_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your full name"
    },
    domProps: {
      "value": (_vm.payment_payer_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_email),
      expression: "payment_payer_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.payment_payer_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_phone),
      expression: "payment_payer_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Phone (format: 09088776655)"
    },
    domProps: {
      "value": (_vm.payment_payer_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_password),
      expression: "user.user_password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.user_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_password = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.selected_plan_product_service_item.product_item_service_tag) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Subscription Duration: "), _c('b', [_vm._v(_vm._s(_vm.selected_plan_product_service_item.product_item_service_tag))])]), _c('br'), _vm._v(" "), _c('label', [_c('p', {
    staticClass: "sp-form-descr"
  }, [_c('b', [_vm._v("Total to pay: ₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)))])])])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_items && (_vm.selected_plan.product_items.length > 1)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "gw-btn-cta-light",
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('display-product_service_items', '')
      }
    }
  }, [_vm._v("\r\n                                                            Change Subscription Duration\r\n                                                        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "border": "#aa076b dashed",
      "margin-top": "6px",
      "padding": "5px"
    },
    attrs: {
      "id": "productServiceItems"
    }
  }, _vm._l((_vm.selected_plan.product_items), function(pt) {
    return _c('div', {
      staticClass: "radio-items"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_service_items_select),
        expression: "product_service_items_select"
      }],
      attrs: {
        "type": "radio",
        "id": pt.product_item_id
      },
      domProps: {
        "value": pt.product_item_id,
        "checked": _vm._q(_vm.product_service_items_select, pt.product_item_id)
      },
      on: {
        "click": function($event) {
          _vm.selectProductServiceItem(pt)
        },
        "__c": function($event) {
          _vm.product_service_items_select = pt.product_item_id
        }
      }
    }), _vm._v(_vm._s(pt.product_item_service_tag) + "\r\n                                                            ")])
  }))]) : _vm._e(), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.payment_successful) ? _c('div', {}, [_c('h3', {
    staticStyle: {
      "color": "#7c0b0b",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.payment_successful_message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn pull-left gw-btn-cta-light",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.proceedNewAccount()
      }
    }
  }, [_vm._v(" Proceed")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _c('div', [_vm._m(7), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_password),
      expression: "user.user_password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.user_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Sellpoint Username or Handle")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_business),
      expression: "user.user_business"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Sellpoint Username/Handle"
    },
    domProps: {
      "value": (_vm.user.user_business)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_business = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.payment_successful) ? _c('div', {}, [_c('h3', {
    staticStyle: {
      "color": "#7c0b0b",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.payment_successful_message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn gw-btn-cta-light pull-left",
    staticStyle: {
      "cursor": "pointer",
      "border-radius": "2p",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.proceedWithAccount()
      }
    }
  }, [_vm._v(" Proceed")])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('hr'), _vm._v(" "), _c('a', {
    staticClass: "gw-btn-cta-light pull-left",
    staticStyle: {
      "cursor": "pointer",
      "margin-bottom": "1em",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('not-setup-existing', '')
      }
    }
  }, [_vm._v(" Or Create a new account")])])])])])])]) : _c('div', {
    staticClass: "row onboarding-body"
  }, [_c('div', {
    staticClass: "col-6 onboarding-left"
  }, [_c('h6', [_vm._v("Purchase Plans")]), _vm._v(" "), _c('p', [_vm._v("You are about to purchase "), _c('b', [_vm._v(_vm._s(_vm.selected_plan.product_name))]), _vm._v(" plan, this would take few minutes and would lead you to creating and setting up \r\n                                        your "), _c('span', {
    staticClass: "sp-mention-inline"
  }, [_vm._v("Sellpoint")]), _vm._v(" account. We use Sellpoint to manage your acounts. \r\n                                        If you already have a Sellpoint account, you can Sign Up with your details.")]), _vm._v(" "), _c('p', [_c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.toggleDisplayFeatures
    }
  }, [_vm._v("\r\n                                            See features of " + _vm._s(_vm.selected_plan.product_name) + " "), _c('i', {
    staticClass: "fa fa-caret-down",
    staticStyle: {
      "color": "#ff0055",
      "font-size": "18px"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "features-display",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "seeFeatures"
    }
  }, [_c('div', {
    staticClass: "feature-list"
  }, [(_vm.selected_plan.product_url_name == _vm.plan1.product_url_name) ? _c('ul', [_c('li', [_vm._v("cica1")])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_url_name == _vm.plan2.product_url_name) ? _c('ul', [_c('li', [_vm._v("cica2")])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_url_name == _vm.plan3.product_url_name) ? _c('ul', [_c('li', [_vm._v("cica3")])]) : _vm._e()])]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-12 col-xs-12 col-md-6 onboarding-right"
  }, [_vm._m(10), _vm._v(" "), _c('div', {}, [_c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Business Name  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_name),
      expression: "business.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.business.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Business Username "), (_vm.validate_user_name_error) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.validate_user_name_message))]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_user_name),
      expression: "business.business_user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.business.business_user_name)
    },
    on: {
      "change": _vm.validateUserName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Business Category Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_category_type),
      expression: "business_category_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business_category_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Services")])])]), _vm._v(" "), (_vm.business_category_type == 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select a Product Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.business_product_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.business_category_type == 2) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select a Service Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.business_service_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn gw-btn-cta-light",
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.setUpNewAccountBusiness
    }
  }, [_vm._v("Create")])])])])])])])])])])]), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "container gw-mobile"
  }, [_vm._m(11)]) : _vm._e()]), _vm._v(" "), (!_vm.$route.query.upgrade) ? _c('section', {
    staticClass: "pricing-style-one gw-mtp",
    attrs: {
      "id": "pricing"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(12), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(13)]) : _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane show active  animated fadeInUp",
    attrs: {
      "role": "tabpanel",
      "id": "monthly"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "single-pricing-one basic-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan1.product_items && _vm.plan1.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan1.product_items[0].product_item_price))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan1.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan1, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "single-pricing-one pro-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan2.product_items && _vm.plan2.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan2.product_items[0].product_item_price) + "/mo")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan2.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan2, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "single-pricing-one biz-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan3.product_items && _vm.plan3.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan3.product_items[0].product_item_price) + "/mo")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan3.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan3, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane animated fadeInUp",
    attrs: {
      "role": "tabpanel",
      "id": "yearly"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#ffffff"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "true",
      "disabled": "disabled"
    }
  }), _vm._v(" By proceeding, you agree with the "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0055",
      "font-weight": "bold"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#terms-modal",
      "href": "#"
    }
  }, [_vm._v("Terms and Conditions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "3em"
    }
  }, [_c('a', {
    staticClass: "btn gw-btn-cta-01",
    attrs: {
      "href": "#pricing"
    }
  }, [_vm._v("Checkout other plans")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "true",
      "disabled": "disabled"
    }
  }), _vm._v(" By proceeding, you agree with the "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0055",
      "font-weight": "bold"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#terms-modal",
      "href": "#"
    }
  }, [_vm._v("Terms and Conditions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('p', {
    staticClass: "pull-left",
    staticStyle: {
      "color": "#aa076b"
    }
  }, [_vm._v("Proceed with your Sellpoint Account ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "true",
      "disabled": "disabled"
    }
  }), _vm._v(" By proceeding, you agree with the "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0055",
      "font-weight": "bold"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#terms-modal",
      "href": "#"
    }
  }, [_vm._v("Terms and Conditions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "3em"
    }
  }, [_c('a', {
    staticClass: "btn gw-btn-cta-01",
    attrs: {
      "href": "#pricing"
    }
  }, [_vm._v("Checkout other plans")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gw-mobile"
  }, [_c('h6', {
    staticClass: "gw-mobile",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Setup New Sellpoint Account")]), _vm._v(" "), _c('p', {
    staticClass: "sp-form-descr"
  }, [_vm._v("Setup New Sellpoint Account......")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5 offset-sm-4",
    staticStyle: {
      "text-align": "center",
      "margin-top": "3em"
    }
  }, [_c('a', {
    staticClass: "btn gw-btn-cta-01",
    attrs: {
      "href": "#pricing"
    }
  }, [_vm._v("Checkout other plans")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#aa076b"
    }
  }, [_vm._v("Choose from these plans")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Max. 2 lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Max. of 5 posts per Lookbook")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Max. 10 Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Posts per Lookbook")]), _vm._v(" "), _c('li', [_vm._v("Free .com.ng domain")]), _vm._v(" "), _c('li', [_vm._v("*Max Storage Space of 500mb")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Unlimited Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Posts")]), _vm._v(" "), _c('li', [_vm._v("Free .com.ng domain\r\n                                            ")]), _c('li', [_vm._v("Online Store (Functionality)")]), _vm._v(" "), _c('li', [_vm._v("*Max Storage Space of 1Gb")])])
}]}

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loggedIn) ? _c('div', {
    staticClass: "hidden-sm hidden-xs"
  }, [_c('div', {
    staticClass: "profile-card"
  }, [_c('img', {
    staticClass: "profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _vm._v(" "), _c('h5', [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "timeline"
    }
  }, [_vm._v(_vm._s(_vm.user.user_name))])]), _vm._v(" "), _vm._m(0), _c('br'), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" 62 shops")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ion ion-android-person-add"
  }), _vm._v(" 1,500 friends")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav-news-feed"
  }, [_c('li', [_c('i', {
    staticClass: "icon ion-ios-paper"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tradefair Newsfeed")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon fa fa-shopping-cart"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Shops Following")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-ios-people-outline"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Friends")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-chatboxes"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Discussions / Messages")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-images"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Orders")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon fa fa-bell"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("No6ifications")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs"
  }, [_c('div', {
    staticClass: "profile-card"
  }, [_c('p', [_vm._v("Do you dream of the day you will use naijabrandtradefair2019 and really make so much sales? Like the day you will stop struggling to pay bills because sales aren’t forth coming, Or maybe you want to be your own brand influencer but your visibility keeps diminishing day by day …")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sticky-feeds"
    }
  }, [_c('h4', {
    staticClass: "grey"
  }, [_vm._v("Ongoing Activities")]), _vm._v(" "), _c('div', {
    staticClass: "feed-item"
  }, [_c('div', {
    staticClass: "live-activity"
  }, [_c('p', [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "profile-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Olu Jane Stores")]), _vm._v(" Commented on a product")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("5 mins ago")])])]), _vm._v(" "), _c('div', {
    staticClass: "feed-item"
  }, [_c('div', {
    staticClass: "live-activity"
  }, [_c('p', [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "profile-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Lami Fashion Store")]), _vm._v(" Has posted a product")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("an hour ago")])])]), _vm._v(" "), _c('div', {
    staticClass: "feed-item"
  }, [_c('div', {
    staticClass: "live-activity"
  }, [_c('p', [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "profile-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Trish Hairs")]), _vm._v(" Liked friend's product")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("4 hours ago")])])]), _vm._v(" "), _c('div', {
    staticClass: "feed-item"
  }, [_c('div', {
    staticClass: "live-activity"
  }, [_c('p', [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "profile-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("LuluBeads Crafts")]), _vm._v(" has shared a product")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("a day ago")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Tradefair Talks")]), _vm._v(" "), _c('ul', {
    staticClass: "online-users list-inline"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Cynthia Belonwu"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Jubril Sani"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Sandra Oseni"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Titilo Bass"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Jayden Ajibade"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Nonso Obi"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Efiong Dun"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Chika Nnabi"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Bolaji Adewale"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])])])])])])
}]}

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-offset-2 col-md-8",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [_c('cart-widget')], 1)])
},staticRenderFns: []}

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create-post"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 col-sm-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('img', {
    staticClass: "profile-photo-md",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_words),
      expression: "search_words"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "texts",
      "id": "exampleTextarea",
      "cols": "100",
      "rows": "1",
      "placeholder": "Search: enter name or handle or hashtag"
    },
    domProps: {
      "value": (_vm.search_words)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_words = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-left": "5em"
    }
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_type),
      expression: "search_type"
    }],
    attrs: {
      "type": "radio",
      "value": "business",
      "id": "business"
    },
    domProps: {
      "checked": _vm._q(_vm.search_type, "business")
    },
    on: {
      "__c": function($event) {
        _vm.search_type = "business"
      }
    }
  }), _vm._v("Business\n                  ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_type),
      expression: "search_type"
    }],
    attrs: {
      "type": "radio",
      "value": "product",
      "id": "product"
    },
    domProps: {
      "checked": _vm._q(_vm.search_type, "product")
    },
    on: {
      "__c": function($event) {
        _vm.search_type = "product"
      }
    }
  }), _vm._v("Product/Service\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-3"
  }, [_c('div', {
    staticClass: "tools"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.search
    }
  }, [_vm._v("Search")])])])])])
},staticRenderFns: []}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), (_vm.loggedIn) ? _c('div', {
    staticClass: "hidden-md hidden-lg"
  }, [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Your Profile")]), _vm._v(" "), _c('div', {
    staticClass: "profile-card"
  }, [_c('img', {
    staticClass: "profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _vm._v(" "), _c('h5', [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "timeline"
    }
  }, [_vm._v(_vm._s(_vm.user.user_name))])]), _vm._v(" "), _vm._m(1), _c('br'), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "suggestions",
    attrs: {
      "id": "sticky-sidebar"
    }
  }, [_c('h4', {
    staticClass: "grey"
  }, [_vm._v("Shops Followed")]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Simi Shapers")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Chris Foodstore")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Olafumi Jewellries")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Trish Hairs")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Nina Organics")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" 62 shops")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ion ion-android-person-add"
  }), _vm._v(" 1,500 friends")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav-news-feed"
  }, [_c('li', [_c('i', {
    staticClass: "icon ion-ios-paper"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tradefair Newsfeed")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon fa fa-shopping-cart"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Shops Following")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-ios-people-outline"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Friends")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-chatboxes"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Discussions / Messages")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-images"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Orders")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon fa fa-bell"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("No6ifications")])])])])
}]}

/***/ }),
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[109]);


// WEBPACK FOOTER //
// static/js/app.f15d6d2e22315c3f7821.js